$(function() {
  var archive_domains_tag_id_lists, archive_ips_lists, archive_segments, confirmed_ajax, show_notify;
  $('[data-delete-object]').on('click', function(e) {
    var action, id, name, object, self, title, title_key, url, wrapper;
    e.preventDefault();
    self = $(this);
    object = self.attr('data-delete-object');
    url = self.attr('href');
    id = self.attr('data-id');
    wrapper = self.closest("tr[data-" + object + "-id='" + id + "']");
    action = self.attr("data-action");
    if (!action) {
      action = 'delete';
    }
    name = wrapper.attr("data-" + object + "-name");
    title_key = "admin." + object + "." + action + ".confirm";
    title = (__(title_key)) + "<br>#" + (escapeHtml(id)) + " <strong>" + (escapeHtml(name)) + "</strong>";
    if (object === 'segment_definitions' && action !== 'restore') {
      archive_segments(id, url, wrapper, title);
      return;
    }
    if ((object === 'domains_lists' || object === 'tag_id_list' || object === 'publisher_id_list') && action !== 'restore') {
      archive_domains_tag_id_lists(id, url, wrapper, title, object);
      return;
    }
    if (object === 'ips_lists' && action !== 'restore') {
      archive_ips_lists(id, url, wrapper, title);
      return;
    }
    return confirmed_ajax({
      title: title,
      url: url,
      wrapper: wrapper
    });
  });
  show_notify = function(resp) {
    if ((resp.notify != null) && (resp.notify.type != null) && (resp.notify.message != null)) {
      if ((resp.notify.placement != null) && resp.notify.placement === 'top') {
        return INTENT.utils.Notify.top_message(resp.notify.message, resp.notify.type);
      } else {
        return INTENT.utils.Notify.message(resp.notify.message, resp.notify.type);
      }
    }
  };
  confirmed_ajax = function(params) {
    return show_confirm("" + params.title, function() {
      return $.ajax({
        url: params.url,
        method: 'post',
        data: {
          'id': params.id,
          'confirmation': 'Y'
        },
        beforeSend: function() {
          params.wrapper.addClass('disabled');
          return Loader.show();
        },
        error: function(xhr) {
          var modal, resp;
          Loader.hide();
          try {
            resp = JSON.parse(xhr.responseText);
            if ((resp.payload != null) && (resp.payload.modal != null)) {
              modal = {
                title: resp.payload.modal.title,
                body: resp.payload.modal.body
              };
              INTENT.utils.Modal.show(modal);
            } else if ((resp.err != null) && (resp.msg != null)) {
              modal = {
                title: __('admin.creative.confirm.title'),
                body: resp.msg
              };
              INTENT.utils.Modal.show(modal);
            } else {
              show_notify(resp);
            }
          } catch (error) {

          }
          return params.wrapper.removeClass('disabled');
        },
        success: function(resp) {
          Loader.hide();
          params.wrapper.hide();
          return show_notify(resp);
        }
      });
    });
  };
  archive_segments = function(id, url, wrapper, title) {
    return $.ajax({
      url: "/ajax/check_campaigns_w_segment?segmentId=" + id,
      method: 'get',
      beforeSend: function() {
        wrapper.addClass('disabled');
        return Loader.show();
      },
      success: function(resp) {
        var campaign, campaigns, i, len;
        Loader.hide();
        wrapper.removeClass('disabled');
        if (_.isArray(resp) && resp.length) {
          campaigns = "";
          for (i = 0, len = resp.length; i < len; i++) {
            campaign = resp[i];
            campaigns += "<a href=\"/campaigns/redirect/campaigns/edit/" + campaign.id + "\" target=\"_blank\">" + campaign.id + "</a>, ";
          }
          campaigns = campaigns.substr(0, campaigns.length - 2);
          title += "<br/><br/>" + (__('admin.segment_definitions.delete.confirm.prefix')) + ":\n<br/><div id=\"popup_msg_list\">" + campaigns + "</div>\n" + (__('admin.segment_definitions.delete.confirm.postfix'));
        }
        return confirmed_ajax({
          title: title,
          url: url,
          wrapper: wrapper
        });
      },
      error: function(xhr) {
        var resp;
        Loader.hide();
        wrapper.removeClass('disabled');
        resp = JSON.parse(xhr.responseText);
        return show_notify(resp);
      }
    });
  };
  archive_ips_lists = function(id, url, wrapper, title) {
    return $.ajax({
      url: "/ajax/check_campaigns_w_ip_list?ipListId=" + id,
      method: 'get',
      beforeSend: function() {
        wrapper.addClass('disabled');
        return Loader.show();
      },
      success: function(resp) {
        var campaign, campaigns, i, len, modal;
        Loader.hide();
        wrapper.removeClass('disabled');
        if (_.isArray(resp) && resp.length) {
          campaigns = "";
          for (i = 0, len = resp.length; i < len; i++) {
            campaign = resp[i];
            campaigns += "<a href=\"/campaigns/redirect/campaigns/edit/" + campaign.id + "\" target=\"_blank\">" + campaign.id + "</a>, ";
          }
          campaigns = campaigns.substr(0, campaigns.length - 2);
          modal = {
            title: __('admin.ips_lists.delete.confirm.prefix'),
            body: campaigns
          };
          return INTENT.utils.Modal.show(modal);
        } else {
          return confirmed_ajax({
            title: title,
            url: url,
            wrapper: wrapper
          });
        }
      },
      error: function(xhr) {
        var resp;
        Loader.hide();
        wrapper.removeClass('disabled');
        resp = JSON.parse(xhr.responseText);
        return show_notify(resp);
      }
    });
  };
  return archive_domains_tag_id_lists = function(id, url, wrapper, title, object) {
    var ajaxUrl;
    ajaxUrl = '';
    if (object === 'domains_lists') {
      ajaxUrl = "/ajax/check_campaigns_w_domain_list?domainListId=" + id;
    }
    if (object === 'tag_id_list') {
      ajaxUrl = "/ajax/check_campaigns_w_tag_id_list?tagIdListId=" + id;
    }
    if (object === 'publisher_id_list') {
      ajaxUrl = "/ajax/check_campaigns_w_publisher_id_list?publisherIdListId=" + id;
    }
    return $.ajax({
      url: ajaxUrl,
      method: 'get',
      beforeSend: function() {
        wrapper.addClass('disabled');
        return Loader.show();
      },
      success: function(resp) {
        var campaign, campaigns, i, len, modal;
        Loader.hide();
        wrapper.removeClass('disabled');
        if (_.isArray(resp) && resp.length) {
          campaigns = "";
          for (i = 0, len = resp.length; i < len; i++) {
            campaign = resp[i];
            if (object === 'domains_lists' || ((object === 'tag_id_list' || object === 'publisher_id_list') && campaign.available)) {
              campaigns += "<a href=\"/campaigns/redirect/campaigns/edit/" + campaign.id + "\" target=\"_blank\">" + campaign.id + "</a>, ";
            } else {
              campaigns += campaign.id + ", ";
            }
          }
          campaigns = campaigns.substr(0, campaigns.length - 2);
          modal = {
            title: __('admin.' + object + '.delete.confirm.prefix'),
            body: campaigns
          };
          return INTENT.utils.Modal.show(modal);
        } else {
          return confirmed_ajax({
            title: title,
            url: url,
            wrapper: wrapper
          });
        }
      },
      error: function(xhr) {
        var resp;
        Loader.hide();
        wrapper.removeClass('disabled');
        resp = JSON.parse(xhr.responseText);
        return show_notify(resp);
      }
    });
  };
});

var handle_type, init_al;

init_al = function() {
  var list_type;
  list_type = $(document).find('[data-list-type]');
  return list_type.on('change', (function(_this) {
    return function(e) {
      var type;
      type = list_type.val();
      return handle_type(type);
    };
  })(this));
};

handle_type = function(type) {
  var attrForDisabledField, list_tags, list_values;
  list_values = $(document).find('[data-list-values]');
  list_tags = $(document).find('[data-list-tags]');
  attrForDisabledField = 'disabled';
  if (list_values.attr('data-read-attr') !== void 0 && list_values.attr('data-read-attr').length > 0) {
    attrForDisabledField = list_values.attr('data-read-attr');
  }
  if (type === 'automated') {
    list_values.attr(attrForDisabledField, true);
    list_tags.attr('disabled', true);
    return list_tags.hide();
  } else {
    list_values.attr(attrForDisabledField, false);
    list_tags.attr('disabled', false);
    return list_tags.show();
  }
};

$(function() {
  return init_al();
});

$(function() {
  var get_holder_html, get_switcher_text, show_active, show_all, show_archive, switcher;
  switcher = $('[data-campaigns-list-filter-switcher]');
  show_active = function() {
    switcher.text(get_switcher_text('active'));
    $("[data-campaigns-group]").each(function() {
      var colspan, group, group_id, hidden_count;
      group = $(this);
      group.find("[data-campaigns-list-filter-hidden-holder]").remove();
      group_id = +group.attr('data-campaigns-group');
      hidden_count = 0;
      group.find('[data-campaign-wrapper]').each(function() {
        var campaign, campaign_enabled, campaign_id;
        campaign = $(this);
        campaign_id = +campaign.attr('data-campaign-id');
        campaign_enabled = +campaign.attr('data-campaign-enabled') === 1;
        if (!campaign_enabled) {
          hidden_count++;
          return campaign.addClass('hidden');
        }
      });
      if (hidden_count) {
        colspan = group.find('tbody tr').eq(0).find('td').length || 1;
        return group.find('tbody').eq(0).append(get_holder_html(group_id, hidden_count, colspan));
      }
    });
    return INTENT.utils.Tooltip.init();
  };
  show_all = function() {
    switcher.text(get_switcher_text('all'));
    $("[data-campaigns-list-filter-hidden-holder]").remove();
    return $("[data-campaign-enabled]").removeClass('hidden');
  };
  show_archive = function(url) {
    return window.location.href = "" + url;
  };
  get_switcher_text = function(action) {
    return $("[data-campaigns-list-filter-action='" + action + "']").text();
  };
  get_holder_html = function(group_id, hidden_count, colspan) {
    return "<tr data-campaigns-list-filter-hidden-holder>\n  <td colspan=\"" + colspan + "\">\n    <span class=\"badge\">" + hidden_count + "</span>\n    &nbsp;\n    <a href='#'\n       data-campaigns-list-filter-hidden-show=\"" + group_id + "\"\n       data-toggle='tooltip'\n       data-placement='right'\n       title=\"" + (__('campaigns.list.filter.hidden_show')) + "\"\n    >" + (__('campaigns.list.filter.hidden_count')) + "</a>\n  </td>\n</tr>";
  };
  $('[data-campaigns-list-filter-action]').on('click', function(e) {
    var action, self;
    e.preventDefault();
    self = $(this);
    action = self.attr('data-campaigns-list-filter-action');
    switch (action) {
      case 'active':
        return show_active();
      case 'all':
        return show_all();
      case 'archive':
        return show_archive(self.attr('data-campaigns-list-filter-url'));
    }
  });
  return $(document).on('click', '[data-campaigns-list-filter-hidden-show]', function(e) {
    var group, group_id, self;
    e.preventDefault();
    self = $(this);
    group_id = self.attr('data-campaigns-list-filter-hidden-show');
    group = $("[data-campaigns-group='" + group_id + "']").eq(0);
    group.find("[data-campaign-enabled]").removeClass('hidden');
    INTENT.utils.Tooltip.destroy(self);
    return self.closest("[data-campaigns-list-filter-hidden-holder]").remove();
  });
});

var codemirror_instances, get_cm_instance, init_codemirror, init_twig_mode, validate_js;

codemirror_instances = {};

init_twig_mode = function() {
  return CodeMirror.defineMode('htmltwig', function(config, parserConfig) {
    return CodeMirror.overlayMode(CodeMirror.getMode(config, parserConfig.backdrop || 'text/html'), CodeMirror.getMode(config, 'twig'));
  });
};

get_cm_instance = function(id) {
  if (!codemirror_instances.hasOwnProperty(id)) {
    return null;
  }
  return codemirror_instances[id];
};

validate_js = function(code, type) {
  var errors, message, title;
  if (!code) {
    return true;
  }
  type = (type ? type : "javascript");
  JSHINT(code, {
    sub: true
  });
  if (JSHINT.errors.length) {
    errors = [];
    $.each(JSHINT.errors, function(key, value) {
      if (value) {
        errors.push(key + 1 + ") " + value.reason + " (line " + value.line + ")");
      }
    });
    title = "JavaScript Errors:\n";
    if (type === "json") {
      title = "JSON Errors:\n";
    }
    message = errors.join("\n");
    return confirm(title + message + "\nContinue save?");
  }
  return true;
};

init_codemirror = function() {
  init_twig_mode();
  return $(document).find('textarea[data-codemirror]').each(function(i, checkbox) {
    var disabled, eventInitCodeMirrorEditor, height, id, init_opts, instance, language, lint, lint_err_container, readOnly, self, width;
    self = $(this);
    width = self.outerWidth();
    height = self.outerHeight();
    language = self.attr('data-codemirror');
    if (language === 'twig' || language === 'htmltwig') {
      language = {
        name: language,
        htmlMode: true
      };
    }
    lint = self.attr('data-lint');
    id = self.attr('id');
    lint_err_container = self.parent().find('.error-lint-container');
    lint_err_container.empty();
    readOnly = false;
    disabled = self.attr('disabled');
    if (disabled === 'disabled') {
      readOnly = true;
    }
    init_opts = {
      mode: language,
      lineNumbers: true,
      lineWrapping: true,
      matchBrackets: true,
      showCursorWhenSelecting: true,
      foldGutter: true,
      readOnly: readOnly,
      onKeyEvent: function() {
        instance.save();
        return self.trigger('change');
      }
    };
    if (lint) {
      $.extend(init_opts, {
        gutters: ["CodeMirror-lint-markers", "CodeMirror-linenumbers", "CodeMirror-foldgutter"],
        lint: {
          onUpdateLinting: function(annotationsNotSorted, annotations, cm) {
            if (annotationsNotSorted.length === 0) {
              lint_err_container.empty();
              return INTENT.utils.Forms.enable_submit_buttons();
            } else {
              lint_err_container.html(__('json.lint.error'));
              return INTENT.utils.Forms.disable_submit_buttons();
            }
          }
        }
      });
    }
    if (id && !codemirror_instances.hasOwnProperty(id)) {
      instance = CodeMirror.fromTextArea(this, init_opts);
      instance.setSize(width, height);
      codemirror_instances[id] = instance;
      self.data('CodeMirrorInstance', instance);
      eventInitCodeMirrorEditor = new CustomEvent("event_init_mirror_editor", {
        detail: {
          id: id
        }
      });
      return document.dispatchEvent(eventInitCodeMirrorEditor);
    } else {
      return console.log('codemirror with id ' + id + ' already inited');
    }
  });
};

var init_creative_content_tags;

init_creative_content_tags = function(select) {
  return $(select).select2({
    templateResult: (function(_this) {
      return function(state) {
        var obj, response, tooltip;
        obj = state.element;
        tooltip = $(obj).attr('tooltip') ? '<div class="select2-content-tag-tooltip">' + $(obj).attr('tooltip') + '</div>' : '';
        response = "<div>\n  " + state.text + "\n  " + tooltip + "\n</div>";
        return response;
      };
    })(this),
    templateSelection: (function(_this) {
      return function(item) {
        var obj, text, tooltip;
        obj = item.element;
        tooltip = $(obj).attr('tooltip') ? $(obj).attr('tooltip') : false;
        if (tooltip) {
          text = $('<span>' + item.text + ' </span>').append('<i class="fa fa-info-circle opacity-dynamic"></i>').tooltip({
            title: tooltip,
            container: 'body'
          });
          return text;
        } else {
          return item.text;
        }
      };
    })(this),
    escapeMarkup: (function(_this) {
      return function(m) {
        return m;
      };
    })(this)
  });
};

$(document).on('init-global-scope', (function(_this) {
  return function() {
    return init_creative_content_tags("#creative_content_tags");
  };
})(this));

$(function() {
  return $(document).on("click", "[data-change-currency]", function() {
    return $('#change_currency').modal();
  });
});

$(function() {
  var formTitle, loginTitle, resetTitle;
  loginTitle = __('account.login');
  resetTitle = __('account.reset_password');
  formTitle = $('.login__descr');
  $(document).on('ready', function() {
    if (document.location.hash.match(/#forgot/)) {
      return $('[data-auth-target-switcher]').trigger('click');
    }
  });
  $('[data-auth-target-switcher]').on('click', function(e) {
    var email;
    e.preventDefault();
    $('[data-auth-action="reset-result"]').html('');
    email = $('input[name="username"]').val();
    $('input[name="reset_email"]').val(email);
    $('[data-auth-target]').toggleClass('hidden');
    if (loginTitle === formTitle.text().trim()) {
      return formTitle.text(resetTitle);
    } else {
      return formTitle.text(loginTitle);
    }
  });
  return $('[data-auth-action="reset"]').on('click', function(e) {
    var button, button_text, lang, reset_email, result_wrapper;
    e.preventDefault();
    button = $(this);
    button_text = button.text();
    result_wrapper = $('[data-auth-action="reset-result"]');
    lang = $('html').attr('lang');
    reset_email = $('input[name="reset_email"]').val();
    return $.ajax({
      url: '/ajax/forgot_password',
      type: 'post',
      data: {
        lang: lang,
        reset_email: reset_email
      },
      dataType: "json",
      beforeSend: function() {
        result_wrapper.html('');
        return button.prop('disabled', true).html('<i class="fa fa-circle-o-notch fa-spin"></i>');
      },
      complete: function() {
        return button.text(button_text).removeClass('disabled').prop('disabled', false);
      },
      success: function(data) {
        if (data) {
          if (data.success) {
            return result_wrapper.html("<div class='info-message'>" + data.success + "</div>");
          } else if (data.error) {
            return result_wrapper.html("<div class='error-message'>" + data.error + "</div>");
          }
        }
      }
    });
  });
});

$(function() {
  return $('[data-count-characters]').each(function() {
    var area, calc, container, self;
    self = $(this);
    area = self.find('.text-container');
    container = self.find('.length-container');
    calc = function() {
      return container.text(area.val().length);
    };
    calc();
    return area.on('keyup', calc);
  });
});

$(function() {
  return $('[data-maintenance-id]').each(function() {
    var closeBtn, modeId, self;
    self = $(this);
    modeId = self.attr('data-maintenance-id');
    closeBtn = self.find('[data-dismiss]');
    return closeBtn.on('click', (function(_this) {
      return function() {
        Cookies.set('m_' + modeId, 1, {
          expires: 90
        });
        return self.slideUp();
      };
    })(this));
  });
});

var availableIntChars, availableNumbersChars, init_numbers_fields, number_only_class;

number_only_class = 'numbers-only';

availableNumbersChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", ","];

availableIntChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

init_numbers_fields = function() {
  $(document).on('keypress', "." + number_only_class, function(event) {
    var char, charArr, self, splitSymbol, strSplit;
    self = $(this);
    charArr = availableNumbersChars;
    if (self.hasClass('int-only')) {
      charArr = availableIntChars;
    }
    char = getChar(event);
    if (char != null) {
      if (!inArray(char, charArr)) {
        event.preventDefault();
      }
      if (char === "," || char === ".") {
        if (self.val() === "") {
          self.val("0");
        }
        if (self.val().indexOf(".") > 0 || self.val().indexOf(",") > 0) {
          event.preventDefault();
        }
      }
      if (self.hasClass('two-after-comma')) {
        if (event.hasOwnProperty('currentTarget') && event.currentTarget.value !== void 0 && event.currentTarget.value !== null) {
          if (event.currentTarget.value.indexOf(".") > 0 || event.currentTarget.value.indexOf(",")) {
            splitSymbol = '';
            if (event.currentTarget.value.indexOf(".") > 0) {
              splitSymbol = '.';
            } else {
              splitSymbol = ',';
            }
            if (splitSymbol !== '') {
              strSplit = event.currentTarget.value.split(splitSymbol);
              if (strSplit.length === 2 && strSplit[1].length >= 2) {
                return event.preventDefault();
              }
            }
          }
        }
      }
    }
  });
  return $(document).on('change', "." + number_only_class, function(event) {
    var current_value, self;
    self = $(this);
    self.val(self.val().replace(",", "."));
    current_value = self.val();
    if (current_value.indexOf(".") === 0) {
      self.val("0" + current_value);
    }
    if (current_value.indexOf(".") === current_value.length - 1 && current_value.length > 0) {
      return self.val(current_value + "0");
    }
  });
};

var init_radio_block;

init_radio_block = function() {
  $("[data-radio-block ]").each(function() {
    var buttons, current_value, inited, input, self;
    inited = "data-inited";
    self = $(this);
    input = self.find("[data-input]");
    buttons = self.find("[data-value]");
    if (!self.attr(inited)) {
      buttons.on("click", function() {
        var btn, result;
        buttons.removeClass("active");
        btn = $(this);
        result = btn.data("value");
        input.attr("value", result);
      });
      current_value = input.val();
      buttons.removeClass("active");
      buttons.each(function() {
        var btn, value;
        btn = $(this);
        value = btn.data("value");
        if (current_value === value) {
          btn.addClass("active");
        }
      });
      self.attr(inited, true);
    }
  });
};

$(function() {
  return init_radio_block();
});

var escape_list, init_search_dialog;

escape_list = function(list) {
  return _.map(list, function(value) {
    value.text = escapeHtml(value.text);
    return value;
  });
};

init_search_dialog = function() {
  var placeholder;
  this.INPUT_SELECTOR = '.navbar #search-dialog';
  placeholder = __('search.placeholder');
  $(this.INPUT_SELECTOR).select2({
    width: '250',
    dropdownAutoWidth: true,
    placeholder: placeholder,
    minimumInputLength: 1,
    multiple: true,
    closeOnSelect: false,
    ajax: {
      delay: 500,
      transport: function(params, success, failure) {
        var adertisersRequest, campaignGroupsRequest, campaignsRequest, creativesRequest, deferred;
        deferred = $.Deferred();
        adertisersRequest = $.get("/ajax/v2/advertisers/search", {
          q: params.data.q,
          limit: 3
        });
        campaignGroupsRequest = $.get("/ajax/v2/campaign_groups/search", {
          q: params.data.q,
          limit: 3
        });
        campaignsRequest = $.get("/ajax/v2/campaigns/search", {
          q: params.data.q,
          limit: 3
        });
        creativesRequest = $.get("/ajax/v2/creatives/search", {
          q: params.data.q,
          limit: 3
        });
        $.when(adertisersRequest, campaignGroupsRequest, campaignsRequest, creativesRequest).done(function(adertisersResponse, campaignGroupsResponse, campaignsResponse, creativesResponse) {
          var list;
          list = [];
          if (adertisersResponse[1] === 'success' && adertisersResponse[0].length) {
            list.push({
              id: 'advertisers',
              groupTitle: true,
              text: "<div class='search-result-group'>" + (__('search.result.group.advertiser')) + "</div>",
              children: escape_list(adertisersResponse[0])
            });
          }
          if (campaignGroupsResponse[1] === 'success' && campaignGroupsResponse[0].length) {
            list.push({
              id: 'campaign_groups',
              groupTitle: true,
              text: "<div class='search-result-group'>" + (__('search.result.group.campaign_groups')) + "</div>",
              children: escape_list(campaignGroupsResponse[0])
            });
          }
          if (campaignsResponse[1] === 'success' && campaignsResponse[0].length) {
            list.push({
              id: 'campaigns',
              groupTitle: true,
              text: "<div class='search-result-group'>" + (__('search.result.group.campaigns')) + "</div>",
              children: escape_list(campaignsResponse[0])
            });
          }
          if (creativesResponse[1] === 'success' && creativesResponse[0].length) {
            list.push({
              id: 'creatives',
              groupTitle: true,
              text: "<div class='search-result-group'>" + (__('search.result.group.creatives')) + "</div>",
              children: escape_list(creativesResponse[0])
            });
          }
          return deferred.resolve({
            results: list
          });
        });
        deferred.then(success);
        deferred.fail(failure);
        return deferred;
      }
    },
    dropdownCssClass: "search-dropdown",
    language: {
      inputTooShort: function() {
        return __('search.input-too-short');
      }
    },
    templateResult: function(data) {
      if (data.id && !data.groupTitle) {
        return "<a class='search-result' target='_blank' href='" + data.url + "'>" + data.text + "</a>";
      } else {
        return data.text;
      }
    },
    escapeMarkup: function(m) {
      return m;
    }
  });
  return $(this.INPUT_SELECTOR).on('select2:selecting', (function(_this) {
    return function(e) {
      return e.preventDefault();
    };
  })(this));
};

var init_select2,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

init_select2 = function() {
  this.SEARCH_RESULTS_PARENT_SELECTOR = '.select2-results__options';
  this.SEARCH_RESULTS_SELECTOR = '.select2-results__option';
  this.SEARCH_FIELD_SELECTOR = '.select2-search__field';
  this.KEYCODE_ENTER = 13;
  $.fn.select2.defaults.set('theme', 'bootstrap');
  $.fn.select2.defaults.set('width', 'style');
  $('select.select2-init').select2({
    minimumResultsForSearch: 10,
    templateResult: (function(_this) {
      return function(d) {
        var text;
        text = d.element && $(d.element.parentElement).data('escape-html') ? escapeHtml(d.text) : d.text;
        return $('<span>' + text + '</span>');
      };
    })(this),
    templateSelection: (function(_this) {
      return function(d) {
        var text;
        text = d.element && $(d.element.parentElement).data('escape-html') ? escapeHtml(d.text) : d.text;
        return $('<span>' + text + '</span>');
      };
    })(this)
  });
  this.createTag = (function(_this) {
    return function(rawTag) {
      var pattern, term;
      pattern = _this.customOptionsSelect.data('regx') || '.*?';
      term = rawTag.term.trim();
      if (term.match(new RegExp(pattern))) {
        return {
          id: term,
          text: term
        };
      } else {
        setTimeout(function() {
          return $(this.SEARCH_RESULTS_PARENT_SELECTOR + " " + this.SEARCH_RESULTS_SELECTOR).each(function(id, e) {
            if (0 === id) {
              return $(e).css('color', 'red').text(__('wrong_value')).show();
            } else if ($(this.SEARCH_RESULTS_SELECTOR).length > 2) {
              return $(e).remove();
            }
          });
        }, 0);
        return null;
      }
    };
  })(this);
  this.customOptionsSelect = $('select.select2-with-custom-options').select2({
    tags: [],
    minimumResultsForSearch: 1,
    createTag: this.createTag
  });
  $('select.select2-comma-init').select2({
    tags: [],
    tokenSeparators: [',', ';']
  });
  $('select.select2-ajax-init').removeAttr('disabled').select2({
    tags: true,
    tokenSeparators: [',', ';'],
    minimumInputLength: 0,
    ajax: {
      data: function(params) {
        return {
          q: params.term
        };
      },
      delay: 250,
      processResults: function(data) {
        return {
          results: data.items
        };
      }
    }
  });
  return $('select.select2-ajax-init-without-tags').removeAttr('disabled').select2({
    tags: false,
    tokenSeparators: [',', ';'],
    minimumInputLength: 0,
    ajax: {
      data: function(params) {
        return {
          q: params.term
        };
      },
      delay: 250,
      processResults: function(data) {
        return {
          results: data.items
        };
      }
    }
  });
};

jQuery.fn.extend({
  destroySelect2: function(params) {
    if (params == null) {
      params = {};
    }
    return this.each((function(_this) {
      return function(key, select) {
        try {
          select = $(select);
          if (select.data('select2')) {
            select.select2('destroy');
            if (params.clear) {
              return select.find('option').remove();
            }
          }
        } catch (error) {}
      };
    })(this));
  },
  select2AppendValues: function(values) {
    return this.each((function(_this) {
      return function(key, select) {
        var i, len, ref, s2, value, values_append, values_new, values_original;
        try {
          select = $(select);
          s2 = select.data('select2');
          if (s2 == null) {
            return;
          }
          values_append = values;
          if (values_append == null) {
            return;
          }
          if (!_.isArray(values_append)) {
            values_append = [values_append];
          }
          if (!values_append.length) {
            return;
          }
          values_append = _.map(values_append, function(value) {
            if (_.isObject(value)) {
              return {
                id: '' + value.id,
                text: value.text
              };
            } else {
              return {
                id: '' + value,
                text: '' + value
              };
            }
          });
          values_new = _.map(s2.data(), function(value) {
            return {
              id: '' + value.id,
              text: '' + value.text.trim()
            };
          });
          values_original = _.map(select.val(), function(value) {
            return '' + value;
          });
          for (i = 0, len = values_append.length; i < len; i++) {
            value = values_append[i];
            if (ref = value.id, indexOf.call(values_original, ref) < 0) {
              values_new.push(value);
            }
          }
          if (values_new.length > values_original.length) {
            return select.select2SetValues(values_new);
          }
        } catch (error) {}
      };
    })(this));
  },
  select2SetValues: function(values) {
    return this.each((function(_this) {
      return function(key, select) {
        var i, id, len, option, s2, text, value, values_new, values_new_ids, values_set;
        try {
          select = $(select);
          s2 = select.data('select2');
          if (s2 == null) {
            return;
          }
          values_set = values;
          if (!_.isArray(values_set)) {
            values_set = [values_set];
          }
          values_new = {};
          values_new_ids = [];
          for (i = 0, len = values_set.length; i < len; i++) {
            value = values_set[i];
            if (_.isObject(value)) {
              id = '' + value.id;
              text = '' + value.text;
            } else {
              id = '' + value;
              text = '' + value;
            }
            values_new[id] = text;
            values_new_ids.push(id);
          }
          if (select.data('tags')) {
            for (id in values_new) {
              text = values_new[id];
              if (id === '') {
                continue;
              }
              if (!select.find("option").filter(function() {
                return this.value === id;
              }).length) {
                option = $("<option>" + text + "</option>").val(id);
                select.append(option);
              }
            }
          }
          return select.val(values_new_ids).trigger('change');
        } catch (error) {}
      };
    })(this));
  }
});

(function($) {
  return $.fn.serializeObject = function() {
    var json, patterns, push_counters, self;
    self = this;
    json = {};
    push_counters = {};
    patterns = {
      validate: /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
      key: /[a-zA-Z0-9_]+|(?=\[\])/g,
      push: /^$/,
      fixed: /^\d+$/,
      named: /^[a-zA-Z0-9_]+$/
    };
    this.build = function(base, key, value) {
      base[key] = value;
      return base;
    };
    this.push_counter = function(key) {
      if (push_counters[key] === undefined) {
        push_counters[key] = 0;
      }
      return push_counters[key]++;
    };
    $.each($(this).serializeArray(), function() {
      var k, keys, merge, reverse_key;
      if (!patterns.validate.test(this.name)) {
        return;
      }
      k = void 0;
      keys = this.name.match(patterns.key);
      merge = this.value;
      reverse_key = this.name;
      while ((k = keys.pop()) !== undefined) {
        reverse_key = reverse_key.replace(new RegExp("\\[" + k + "\\]$"), "");
        if (k.match(patterns.push)) {
          merge = self.build([], self.push_counter(reverse_key), merge);
        } else if (k.match(patterns.fixed)) {
          merge = self.build([], k, merge);
        } else {
          if (k.match(patterns.named)) {
            merge = self.build({}, k, merge);
          }
        }
      }
      return json = $.extend(true, json, merge);
    });
    return json;
  };
})(jQuery);

var init_switcher;

init_switcher = function() {

  /*
    Switcher handlers
   */
  var switcher_mode, switchers;
  switchers = $(document).find('input[type="checkbox"][data-switch-target]');
  switcher_mode = function(switcher, state) {
    var controls, target_path;
    target_path = switcher.attr('data-switch-target');
    controls = $(document).find("[data-switch-handler='" + target_path + "']");
    return controls.each(function() {
      var control, inversion, switch_handler;
      control = $(this);
      switch_handler = function(state_of) {
        if (state_of) {
          control.removeClass('disabled');
          return control.removeAttr('disabled');
        } else {
          control.addClass('disabled');
          return control.attr('disabled', 'disabled');
        }
      };
      inversion = switcher.attr('data-switch-inversion');
      if (typeof inversion !== typeof void 0 && inversion !== false) {
        return switch_handler(!state);
      } else {
        return switch_handler(state);
      }
    });
  };

  /*
    for bootstrap switcher variant
   */
  switchers.filter('.on-off').each(function(i, checkbox) {
    checkbox = $(checkbox);
    checkbox.bootstrapSwitch();
    return checkbox.on('switchChange.bootstrapSwitch', function(event, state) {
      var switcher;
      switcher = $(this);
      return switcher_mode(switcher, state);
    });
  });

  /*
    for naive checkbox
   */
  return switchers.filter(':not(.on-off)').each(function(i, checkbox) {
    checkbox = $(checkbox);
    return checkbox.on("change", function() {
      var checked, inversion, state, switcher;
      switcher = $(this);
      checked = switcher.is(':checked');
      inversion = switcher.attr('data-switch-inversion');
      if (!checked) {
        state = false;
      } else {
        state = true;
      }
      return switcher_mode(switcher, state);
    });
  });
};

$(function() {
  return init_switcher();
});

$(function() {
  return $(document).on('click', '[data-table-filter-reset]', function(e) {
    var form, input;
    e.preventDefault();
    form = $(this).closest('form');
    input = form.find('input[type="text"]');
    input.val('');
    return form.submit();
  });
});

var VastPreview,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

VastPreview = (function() {
  function VastPreview(options) {
    this.check_adserver_preview_health = bind(this.check_adserver_preview_health, this);
    this.register_player_listeners = bind(this.register_player_listeners, this);
    this.hide_spinner = bind(this.hide_spinner, this);
    this.show_spinner = bind(this.show_spinner, this);
    this.destroy = bind(this.destroy, this);
    this.get_player = bind(this.get_player, this);
    this.replay_ad = bind(this.replay_ad, this);
    this.play_ad = bind(this.play_ad, this);
    this.inited = false;
    this.options = $.extend({}, {
      id: null,
      adTagUrl: '',
      adsResponse: '',
      adLabel: 'Advertisement',
      adsRenderingSettings: {},
      autoPlayAdBreaks: true,
      contribAdsSettings: {},
      debug: false,
      forceNonLinearFullSlot: true,
      locale: 'en',
      nonLinearWidth: 0,
      nonLinearHeight: 0,
      numRedirects: 10,
      showControlsForJSAds: false,
      showCountdown: true,
      vpaidAllowed: true,
      vpaidMode: google.ima.ImaSdkSettings.VpaidMode.ENABLED
    }, options);
    this.errPrefix = "VAST error:";
    this.player = videojs(this.options.id);
    this.check_adserver_preview_health();
  }

  VastPreview.prototype.play_ad = function() {
    this.check_adserver_preview_health();
    if (!this.inited) {
      return;
    }
    this.player.ima(this.options);
    this.player.ima.requestAds();
    return this.player.play();
  };

  VastPreview.prototype.replay_ad = function() {
    if (!this.inited) {
      this.play_ad();
    }
    if ('function' === (typeof this.player.ima.isInitialized) && this.player.ima.isInitialized()) {
      this.hide_spinner();
      this.player.ima.reset();
    }
    this.player.errorDisplay.close();
    this.player.off('google.ima.adsManagerLoaded');
    this.player.on('google.ima.adsManagerLoaded', (function(_this) {
      return function() {
        return _this.player.ima.start();
      };
    })(this));
    return this.play_ad();
  };

  VastPreview.prototype.get_player = function() {
    return this.player;
  };

  VastPreview.prototype.destroy = function() {
    if (!this.inited) {
      return;
    }
    this.player.ima.reset();
    return this.player.dispose();
  };

  VastPreview.prototype.show_spinner = function() {
    this.player.addClass('vjs-waiting');
    return this.player.loadingSpinner.show();
  };

  VastPreview.prototype.hide_spinner = function() {
    this.player.removeClass('vjs-waiting');
    return this.player.loadingSpinner.hide();
  };

  VastPreview.prototype.register_player_listeners = function() {
    if (this.inited) {
      return;
    }
    $(this.player.bigPlayButton.el()).on('click', (function(_this) {
      return function() {
        return _this.play_ad();
      };
    })(this));
    this.player.on('adserror', (function(_this) {
      return function(e, adErrorEvent) {
        var err, errMsg;
        _this.player.errorDisplay.close();
        _this.hide_spinner();
        if (!'getError' in adErrorEvent) {
          return _this.player.error(_this.errPrefix + " unknown");
        } else {
          $('#ima-ad-container').hide();
          err = adErrorEvent.getError();
          errMsg = err && err.getMessage() ? err.getMessage() : 'unknown';
          return _this.player.error(__(_this.errPrefix + " " + errMsg));
        }
      };
    })(this));
    return this.player.on('adtimeout', (function(_this) {
      return function() {
        return _this.player.error(__(_this.errPrefix + " Timeout exceeded"));
      };
    })(this));
  };

  VastPreview.prototype.check_adserver_preview_health = function() {
    window.aborting = true;
    return $.ajax({
      url: this.options.adTagUrl,
      async: false
    }).fail((function(_this) {
      return function() {
        return _this.player.error(__(_this.errPrefix + " Creative is in validation state, please wait"));
      };
    })(this)).done((function(_this) {
      return function() {
        $(_this.player.bigPlayButton.el()).css('z-index', 1500);
        _this.register_player_listeners();
        return _this.inited = true;
      };
    })(this)).always(function() {
      return window.aborting = false;
    });
  };

  return VastPreview;

})();


/*
  Неймспейсы!
 */
if (window.getintent == null) {
  window.getintent = {};
}

if (window.getintent.utils === void 0) {
  window.getintent.utils = {};
}

window.INTENT = {
  widgets: {},
  utils: {},
  templates: {},
  helpers: {},
  report: {}
};

var global_scope_init, initWidgets, init_once;

jQuery.hotkeys.options.filterTextInputs = false;

jQuery.hotkeys.options.filterContentEditable = false;

jQuery.hotkeys.options.filterInputAcceptingElements = false;

initWidgets = function() {
  var key, ref, results, widget;
  ref = INTENT.widgets;
  results = [];
  for (key in ref) {
    widget = ref[key];
    if (widget.ATTR_NAME != null) {
      results.push(getintent.utils.Autoinit.init(widget));
    } else {
      results.push(void 0);
    }
  }
  return results;
};

global_scope_init = function() {
  var event;
  initWidgets();
  init_select2();
  init_numbers_fields();
  init_codemirror();
  INTENT.utils.Forms.update_state_form();
  event = new CustomEvent("init-global-scope");
  return document.dispatchEvent(event);
};

init_once = function() {
  init_search_dialog();
  INTENT.utils.Forms.action_buttons_handler();
  return $('[data-show-loader-on-click]').on('click', function(e) {
    return $(e.target).blur().showLoader('disabled');
  });
};

$(function() {
  global_scope_init();
  init_once();
  return $(document).on('ajaxComplete', function(event, xhr, settings) {
    var loc;
    if (settings && settings.url) {
      loc = document.createElement('a');
      loc.href = settings.url;
      if (!($.inArray(loc.pathname, ['/ajax/get_apps', '/ajax/get_automated_domains_lists', '/ajax/get_automated_ips_lists', '/ajax/get_automated_app_lists', '/ajax/get_countries', '/ajax/available_advertisers', '/ajax/available_campaigns', '/ajax/available_contracts', '/ajax/available_sites', '/ajax/available_creatives', '/ajax/get_regions', '/ajax/get_cities', '/ajax/check_continent', '/ajax/check_daily_budget', '/ajax/validate_json', '/ajax/v2/campaigns/get_dynamic_prices', '/api/v3/fields/creatives/tns_articles', '/api/v3/fields/creatives/tns_brands', '/api/v3/fields/creatives/ktus', '/api/v3/user/analytics_auth_url']) === -1)) {
        return;
      }
    }
    global_scope_init();
  });
});


/*
  Initialize class on a dom elements.

  Search for a dom element with Class.ATTR_NAME attribute and pass it to
  the class constructor.

  Class must contains a static variable ATTR_NAME in order this to work.

  If class contains static variable ATTR_VALUE it would be used in a
  search selector.

  Also dom node must have a getintent.utils.Autoinit.ATTR_NAME attribute
  This attribute indicated that dom element can be autoinited

  @example How to use autoinit
    getintent.utils.Autoinit.init(someNs.MyClass);
    getintent.utils.Autoinit.init(someNs.MyClass, $(".someElement"));
 */
getintent.utils.Autoinit = (function() {
  function Autoinit() {}

  Autoinit.ATTR_NAME = "data-auto-init";

  Autoinit.ATTR_INITED = "data-autoinited";

  Autoinit.init = function(cl, container, initFn) {
    var inited, selector, st;
    if (!cl.ATTR_NAME) {
      throw "getintent.utils.Autoinit: ATTR_NAME in class missing!";
    }
    st = getintent.utils.Autoinit;
    if (container == null) {
      container = $("body");
    }
    if (cl.ATTR_VALUE != null) {
      selector = "[" + cl.ATTR_NAME + "='" + cl.ATTR_VALUE + "'][" + getintent.utils.Autoinit.ATTR_NAME + "]";
    } else {
      selector = "[" + cl.ATTR_NAME + "][" + getintent.utils.Autoinit.ATTR_NAME + "]";
    }
    inited = [];
    $(selector, container).each(function() {
      var el, inst;
      el = $(this);
      if (el.attr(st.ATTR_INITED) == null) {
        if (initFn != null) {
          inst = initFn(el, cl);
          st.setInitedAttr(el, cl.ATTR_NAME);
        } else {
          inst = new cl(el);
          st.setInitedAttr(el, cl.ATTR_NAME);
        }
      }
      return inited.push(inst);
    });
    return inited;
  };

  Autoinit.setInitedAttr = function(el, aName) {
    if ('init-continue' !== el.attr(aName)) {
      return el.attr(getintent.utils.Autoinit.ATTR_INITED, true);
    }
  };

  Autoinit.initAfterDom = function(cl, container, initFn) {
    return $(function() {
      return getintent.utils.Autoinit.init(cl, container);
    });
  };

  return Autoinit;

})();


/*
  CRUD Campaign template
 */
INTENT.templates.CrudCampaign = (function() {
  function CrudCampaign() {}

  CrudCampaign.get_result_container = function(result_test, alert_text, url) {
    var small;
    if (alert_text == null) {
      alert_text = '';
    }
    if (url == null) {
      url = '';
    }
    small = '';
    if (alert_text.length > 0) {
      small = "<p class=\"bg-warning fs xs\">" + alert_text + "</p>";
    }
    if (url.length > 0) {
      url = "<p>" + url + "</p>";
    }
    return "<p>" + result_test + "</p>\n" + small + "\n" + url;
  };

  CrudCampaign.get_alert_container = function(alert_text, type) {
    if (type == null) {
      type = "warning";
    }
    return "<p class=\"bg-" + type + "\">" + alert_text + "</p>";
  };

  CrudCampaign.get_text_container = function(alert_text, type) {
    if (type == null) {
      type = "info";
    }
    return "<p class=\"text-" + type + "\">" + alert_text + "</p>";
  };

  CrudCampaign.get_group_warning_overhead = function(alert_text) {
    return "<p class=\"bg-warning fs l\">" + alert_text + "</p>";
  };

  return CrudCampaign;

})();


/*
  CRUD Sites template
 */
INTENT.templates.CrudSegment = (function() {
  function CrudSegment() {}

  CrudSegment.get_terms_list = function(options, active) {
    var active_option, ex_options, ex_type, label, options_list, value;
    if (active == null) {
      active = null;
    }
    options_list = "";
    for (ex_type in options) {
      ex_options = options[ex_type];
      value = ex_type;
      label = ex_options.label || value;
      if (!active) {
        active_option = false;
      } else {
        active_option = active === value;
      }
      options_list = options_list + this.get_option_element(value, label, active_option);
    }
    return options_list;
  };

  CrudSegment.get_options_list = function(list, active) {
    var active_option, ex_key, ex_value, options_list;
    if (active == null) {
      active = null;
    }
    options_list = "";
    if (typeof active !== typeof String) {
      active = INTENT.utils.Helper.to_int_object(active);
    }
    for (ex_key in list) {
      ex_value = list[ex_key];
      if (parseInt(ex_key)) {
        ex_key = parseInt(ex_key);
      }
      if (!active) {
        active_option = false;
      } else {
        if (typeof active !== typeof String) {
          active_option = active.indexOf(ex_key) > -1;
        } else {
          active_option = active === ex_key;
        }
      }
      options_list = options_list + this.get_option_element(ex_key, ex_value, active_option);
    }
    return options_list;
  };

  CrudSegment.get_tokenizator_options_list = function(list) {
    var ex_key, ex_value, options_list;
    options_list = "";
    for (ex_key in list) {
      ex_value = list[ex_key];
      options_list = options_list + this.get_option_element(ex_value, ex_value, true);
    }
    return options_list;
  };

  CrudSegment.get_option_element = function(value, label, selected) {
    if (label == null) {
      label = null;
    }
    if (selected == null) {
      selected = true;
    }
    if (selected === true) {
      selected = " selected";
    }
    if (!label) {
      label = value;
    }
    return "<option value=\"" + (escapeHtml(value)) + "\"" + selected + ">" + (escapeHtml(label)) + "</option>";
  };

  CrudSegment.get_select_ajax_control = function(id, type, select_type, list, active, advertiser_id) {
    list = CrudSegment.get_options_list(list, active);
    return "<select name='terms[" + id + "][values][]' data-tags=\"false\" data-ajax--url=\"/ajax/available_" + select_type + "?advertiser=" + advertiser_id + "&action=" + type + "\" class=\"segments_ajax_select form-control min-w300px select2-ajax-init validate-me\" multiple>\n  " + list + "\n</select>";
  };

  CrudSegment.get_select_value_control = function(id, list, active) {
    list = CrudSegment.get_options_list(list, active);
    return "<select name='terms[" + id + "][values][]' data-escape-html=\"1\" class=\"form-control min-w300px select2-init validate-me\" multiple>\n  " + list + "\n</select>";
  };

  CrudSegment.get_select_tokenizator_value_control = function(id, list) {
    list = this.get_tokenizator_options_list(list);
    return "<select name='terms[" + id + "][values][]' class=\"form-control min-w300px select2-comma-init validate-me\" multiple>\n  " + list + "\n</select>";
  };

  CrudSegment.get_text_value_control = function(id, value) {
    value = value.join(',');
    return "<input type=\"text\" class=\"form-control min-w300px validate-me\" name='terms[" + id + "][values]' value='" + value + "'>";
  };

  CrudSegment.get_values_control = function(core, id, type, options, values) {
    var advertiser_id, current_value, default_value, input_mode, list, option, select_type;
    option = options[type] || [];
    input_mode = option.input || 'text';
    default_value = option.value || '';
    select_type = option.type || '';
    current_value = values.values || [];
    advertiser_id = core.get_advertiser_id();
    if (input_mode === 'select') {
      list = core.get_variants(select_type);
      if (select_type === 'tokenizator') {
        return this.get_select_tokenizator_value_control(id, current_value);
      } else {
        return this.get_select_value_control(id, list, current_value);
      }
    } else if (input_mode === 'select_ajax') {
      list = core.get_variants(select_type);
      return this.get_select_ajax_control(id, type, select_type, list, current_value, advertiser_id);
    } else {
      return this.get_text_value_control(id, current_value);
    }
  };

  CrudSegment.get_term = function(core, id, options, values) {
    var days, default_values, first_type, negative, negative_checkbox, negative_checked, terms_list, times, type, values_control;
    if (values == null) {
      values = {
        type: null
      };
    }
    for (first_type in options) {
      break;
    }
    type = values.type || first_type;
    if (options[type] == null) {
      return '';
    }
    negative = values.negative || false;
    if (negative) {
      negative_checked = ' checked ';
    }
    terms_list = this.get_terms_list(options, type);
    default_values = options[type]['default'] || {
      days: 1,
      times: 30
    };
    times = values.times || default_values.times;
    days = values.days || default_values.days;
    values_control = this.get_values_control(core, id, type, options, values);
    negative_checkbox = negative === true || negative === 'true' ? "<input type=\"checkbox\" name='terms[" + id + "][negative]' value='true' " + negative_checked + " style='display: none' >" : "";
    return "<tr data-widget-crud-segments-terms-id=\"" + id + "\">\n    <td class='white-column'>\n        " + negative_checkbox + "\n        <select data-widget-crud-segments-terms-type data-width='resolve' name='terms[" + id + "][type]' class=\"form-control w230px select2-init validate-me\">\n          " + terms_list + "\n        </select>\n    </td>\n    <td data-widget-crud-segments-terms-values>\n        " + values_control + "\n    </td>\n    <td class='white-column'>\n        <input type=\"text\" class=\"form-control w70px validate-me numbers-only\" name='terms[" + id + "][times]' value='" + times + "'>\n    </td>\n    <td class='white-column'>\n        <div class=\"pull-left\">\n          <input type=\"text\" class=\"form-control w70px validate-me numbers-only\" name='terms[" + id + "][days]' value='" + days + "'>\n        </div>\n        <div class=\"pull-left\">\n          <a href=\"javascript:void(0)\" class='remove-on-disabled' style=\"display:block;margin-left:40px;margin-top:8px;\" data-widget-crud-segments-terms-remove><i class=\"glyphicon glyphicon-remove\"></i></a>\n        </div>\n    </td>\n</tr>";
  };

  return CrudSegment;

})();


/*
  CRUD Sites template
 */
INTENT.templates.CrudSite = (function() {
  function CrudSite() {}

  CrudSite.get_type_list = function(options, active) {
    var active_option, ex_options, ex_type, label, options_list, value;
    if (active == null) {
      active = null;
    }
    options_list = "";
    for (ex_type in options) {
      ex_options = options[ex_type];
      value = ex_type;
      label = ex_options.label || value;
      if (!active) {
        active_option = false;
      } else {
        active_option = active === value;
      }
      options_list = options_list + this.get_option_element(value, label, active_option);
    }
    return options_list;
  };

  CrudSite.get_time_list = function(options, active) {
    var active_option, ex_options, ex_type, label, options_list, value;
    if (active == null) {
      active = null;
    }
    options_list = "";
    for (ex_type in options) {
      ex_options = options[ex_type];
      value = ex_type;
      label = ex_options.label || value;
      if (!active) {
        active_option = false;
      } else {
        active_option = active === value;
      }
      options_list = options_list + this.get_option_element(value, label, active_option);
    }
    return options_list;
  };

  CrudSite.get_option_element = function(value, label, selected) {
    if (label == null) {
      label = null;
    }
    if (selected == null) {
      selected = true;
    }
    if (selected === true) {
      selected = " selected";
    }
    if (!label) {
      label = value;
    }
    return "<option value=\"" + value + "\"" + selected + ">" + label + "</option>";
  };

  CrudSite.get_input_element = function(id, label, name, value, ex_attributes) {
    if (value == null) {
      value = '';
    }
    if (ex_attributes == null) {
      ex_attributes = '';
    }
    return "<div style='margin-bottom: 3px'>\n  <!--<span>" + label + "</span><br>-->\n  <input data-widget-crud-site-rule-additional-field " + ex_attributes + " name=\"conversion_rules[" + id + "][" + name + "]\" value=\"" + value + "\" type=\"text\" placeholder=\"" + label + "\" class=\"col-md-12 form-control\" style=\"width:100%; min-width:170px;\">\n</div>";
  };

  CrudSite.get_deduplication_window_types = function(selected_type) {
    var key, options, selected, types, value;
    if (selected_type == null) {
      selected_type = 'disabled';
    }
    types = {
      "disabled": "OFF",
      "sec": __('seconds'),
      "min": __('minutes'),
      "hour": __('hours'),
      "day": __('days')
    };
    options = "";
    for (key in types) {
      value = types[key];
      selected = key === selected_type ? "selected" : "";
      options += "<option value='" + key + "' " + selected + ">" + value + "</option>";
    }
    return options;
  };

  CrudSite.get_explicit_groups = function(selected_type) {
    var key, options, selected, types, value;
    if (selected_type == null) {
      selected_type = 'disabled';
    }
    types = {
      '': '---',
      'video_start': __('sites.conversion_rules.table.explicit_group.video_start'),
      'video_complete': __('sites.conversion_rules.table.explicit_group.video_complete'),
      'view_depth': __('sites.conversion_rules.table.explicit_group.view_depth')
    };
    options = "";
    for (key in types) {
      value = types[key];
      selected = key === selected_type ? "selected" : "";
      options += "<option value='" + key + "' " + selected + ">" + value + "</option>";
    }
    return options;
  };

  CrudSite.get_input_additional = function(id, values, fields) {
    var default_val, ex_attributes, ex_field, ex_type, label, name, result, value;
    if (fields == null) {
      fields = null;
    }
    if (!fields) {
      return "<div style='color: darkgray; margin-top: 3px'>None</div>";
    } else {
      result = "";
      for (ex_type in fields) {
        ex_field = fields[ex_type];
        name = ex_type;
        label = ex_field.label;
        default_val = ex_field["default"] || "";
        value = values[name] || default_val;
        ex_attributes = '';
        if (ex_field.allow_empty) {
          ex_attributes += 'allow-empty';
        }
        result = result + this.get_input_element(id, label, name, value, ex_attributes);
      }
      return result;
    }
  };

  CrudSite.get_conversion_rule = function(id, options, values, show_cpa_controls) {
    var additional, additional_fields, build_cpa_model, build_model, checked, deduplication_window_disabled, deduplication_window_seconds, deduplication_window_types, explicit_groups, explicit_groups_list, group, max_conversions_number, name, options_list, tr, type;
    if (values == null) {
      values = {
        type: null
      };
    }
    if (show_cpa_controls == null) {
      show_cpa_controls = false;
    }
    type = values.type || null;
    group = values.explicit_group || null;
    name = values.name || "";
    max_conversions_number = values.max_conversions_number || "";
    deduplication_window_seconds = values.deduplication_window_seconds || "";
    build_cpa_model = values.build_cpa_model || false;
    options_list = this.get_type_list(options, type);
    deduplication_window_types = this.get_deduplication_window_types(values.deduplication_window_type);
    deduplication_window_disabled = values.deduplication_window_type === 'disabled' || !values.deduplication_window_type ? 'disabled' : '';
    if (type) {
      additional_fields = options[type]['fields'];
    } else {
      tr = $(options_list).eq(0).attr("value");
      additional_fields = options[tr]['fields'];
    }
    additional = this.get_input_additional(id, values, additional_fields);
    build_model = "";
    if (show_cpa_controls) {
      checked = build_cpa_model ? 'checked="checked"' : '';
      build_model = "<input type=\"checkbox\" " + checked + " class=\"on-off build-cpa-model\" name=\"conversion_rules[" + id + "][build_cpa_model]\" value=\"true\" data-switch-target/>";
    }
    build_model = "<td>" + build_model + "</td>";
    explicit_groups = "";
    if (show_cpa_controls) {
      explicit_groups_list = this.get_explicit_groups(group);
      explicit_groups = "<td>\n  <select name=\"conversion_rules[" + id + "][explicit_group]\" class='form-control select2-init' style='width:150px'>\n    " + explicit_groups_list + "\n  </select>\n</td>";
    }
    return "<tr data-widget-crud-site-rule-id=\"" + id + "\">\n    <td class='white-column'>\n        <input " + (name ? 'readonly="readonly"' : '') + " data-widget-crud-site-rule-name name=\"conversion_rules[" + id + "][name]\" value=\"" + name + "\" type=\"text\" class=\"col-md-12 form-control " + (name ? 'disabled' : '') + "\" style='width:170px' >\n    </td>\n    <td class='white-column'>\n        <select data-widget-crud-site-rule-types name=\"conversion_rules[" + id + "][type]\" class='form-control select2-init' style='width:200px'>\n          " + options_list + "\n        </select>\n    </td>\n    <td class='white-column' data-widget-crud-site-rule-additional style='width:70%'>\n        " + additional + "\n    </td>\n    <td class='white-column'>\n      <div class='select2-input-group' style=\"width:175px\">\n        <div>\n          <input data-widget-crud-site-rule-deduplication_window_seconds\n                 name=\"conversion_rules[" + id + "][deduplication_window_seconds]\"\n                 value=\"" + deduplication_window_seconds + "\"\n                 type=\"number\" class=\"col-md-12 form-control\"\n                 " + deduplication_window_disabled + "\n                 style=\"width:80px\"/>\n        </div>\n        <div style=\"width:90px\">\n          <select class='form-control deduplication-window select2-init' name=\"conversion_rules[" + id + "][deduplication_window_type]\">\n              " + deduplication_window_types + "\n          </select>\n        </div>\n      </div>\n    </td>\n    <td class='white-column'>\n      <div>\n          <input data-widget-crud-site-rule-max_conversions_number\n                 name=\"conversion_rules[" + id + "][max_conversions_number]\"\n                 value=\"" + max_conversions_number + "\"\n                 type=\"number\" min=\"0\" step=\"1\"\n                 class=\"col-md-12 form-control\"\n                 style='width:130px'/>\n        </div>\n    </td>\n    " + explicit_groups + "\n    " + build_model + "\n    <td>\n        <a href=\"javascript:void(0)\" data-widget-crud-site-rule-remove class='remove-on-disabled'><i class=\"glyphicon glyphicon-remove\"></i></a>\n    </td>\n</tr>";
  };

  return CrudSite;

})();

$(function() {
  return $(document).on('click', '[data-collapse-all]', function(e) {
    var action, self, target;
    self = $(e.currentTarget);
    action = self.attr('data-collapse-all').toLowerCase();
    target = $(self.attr('data-target'));
    if (target.length) {
      if (action === 'collapse') {
        return target.find('.collapse').collapse('hide');
      } else if (action === 'expand') {
        return target.find('.collapse').collapse('show');
      }
    }
  });
});


/*
  Плавный скролл к элементу
 */
INTENT.utils.Forms = (function() {
  function Forms() {}

  Forms.ATTR_ACTIONS = "data-form-actions";

  Forms.ATTR_FORM = "data-form-handler";

  Forms.CLASS_SUBMIT_BUTTON = "submit-button";

  Forms.CLASS_REMOVE_ON_DISABLED = "remove-on-disabled";

  Forms.get_actions = function() {
    if (!this.form_actions) {
      this.form_actions = $("[" + this.ATTR_ACTIONS + "]");
    }
    return this.form_actions;
  };

  Forms.get_form = function() {
    if (!this.form) {
      this.form = $("form[" + this.ATTR_FORM + "]");
    }
    return this.form;
  };

  Forms.get_submit_buttons_collection = function() {
    return this.get_actions().find("." + this.CLASS_SUBMIT_BUTTON);
  };

  Forms.action_buttons_handler = function() {
    return this.get_submit_buttons_collection().each(function(key, item) {
      return $(item).click(function(e) {
        return $(e.target).blur().addClass('disabled').showLoader();
      });
    });
  };

  Forms.disable_submit_buttons_loader = function() {
    return this.get_submit_buttons_collection().each((function(_this) {
      return function(key, item) {
        return $(item).hideLoader('disabled');
      };
    })(this));
  };

  Forms.disable_submit_buttons = function() {
    return this.get_submit_buttons_collection().attr('disabled', 'disabled');
  };

  Forms.enable_submit_buttons = function() {
    return this.get_submit_buttons_collection().removeAttr('disabled');
  };

  Forms.update_codemirror_state = function(state, mode) {
    var cm_key, cm_value, results;
    if (state == null) {
      state = 'readOnly';
    }
    if (mode == null) {
      mode = true;
    }
    results = [];
    for (cm_key in codemirror_instances) {
      cm_value = codemirror_instances[cm_key];
      results.push(cm_value.setOption(state, mode));
    }
    return results;
  };

  Forms.remove_with_class = function() {
    return $("." + this.CLASS_REMOVE_ON_DISABLED).remove();
  };

  Forms.update_state_form = function() {
    var collections, form, state, switchers;
    form = this.get_form();
    collections = form.find(":input, [data-widget-tree-control]");
    state = form.attr(this.ATTR_FORM);
    if (!state) {
      return false;
    }
    this.remove_with_class();
    this.update_codemirror_state();
    switchers = $('input[type="checkbox"].on-off');
    if (state === 'disabled') {
      switchers.bootstrapSwitch('toggleDisabled');
      collections.attr('disabled', 'disabled');
      collections.filter('[data-widget-tree-control]').addClass('disabled');
    }
    if (state === 'read-only') {
      switchers.bootstrapSwitch('toggleReadonly');
      collections.attr('readonly', 'readonly');
      return collections.filter('[data-widget-tree-control]').addClass('readonly');
    }
  };

  return Forms;

})();

INTENT.utils.Helper = (function() {
  function Helper() {}


  /*
  Проходит по цилку и приводит все цифры к типу number
   */

  Helper.to_int_object = function(source) {
    var ex_key, ex_value, new_stack;
    new_stack = [];
    for (ex_key in source) {
      ex_value = source[ex_key];
      if (parseInt(ex_value)) {
        ex_value = parseInt(ex_value);
      }
      new_stack.push(ex_value);
    }
    return new_stack;
  };

  Helper.ucfirst = function(source) {
    return source.charAt(0).toLocaleUpperCase() + source.substr(1).toLocaleLowerCase();
  };

  return Helper;

})();


/*
  Show Bootstrap modal
 */
INTENT.utils.Modal = (function() {
  function Modal() {}

  Modal.settings = {
    title: '',
    size: "normal",
    buttons: [
      {
        attr: {
          "class": "btn btn-link",
          type: "button",
          'data-dismiss': "modal"
        },
        click: function() {},
        text: INTENT.utils.Helper.ucfirst(__('help.close'))
      }
    ]
  };

  Modal.SELECTOR_TEMPLATE_ID = "#utils_modal";

  Modal.init = function() {
    this.bs_modal = $("" + this.SELECTOR_TEMPLATE_ID);
    this.bs_modal_title = this.bs_modal.find(".modal-title");
    return this.bs_modal_body = this.bs_modal.find(".modal-body");
  };

  Modal.set_size = function(size) {
    var sizes;
    sizes = {
      small: "modal-sm",
      normal: "",
      large: "modal-lg"
    };
    if (void 0 === sizes[size]) {
      size = 'normal';
    }
    return Modal.bs_modal.find(".modal-dialog").removeClass("modal-sm modal-lg").addClass(sizes[size]);
  };

  Modal.set_title = function(title) {
    if (title == null) {
      title = '';
    }
    if (title instanceof jQuery) {
      Modal.bs_modal_title.html(title.text());
      return;
    }
    return Modal.bs_modal_title.html(title);
  };

  Modal.set_body = function(body) {
    if (body == null) {
      body = '';
    }
    if (body instanceof jQuery) {
      Modal.bs_modal_body.html(body.get(0).outerHTML);
      return;
    }
    return Modal.bs_modal_body.html(body);
  };

  Modal.update_buttons = function(buttons) {
    var btn, footer, i, len, results;
    if (buttons == null) {
      buttons = Modal.settings.buttons;
    }
    footer = Modal.bs_modal.find(".modal-footer").html("");
    results = [];
    for (i = 0, len = buttons.length; i < len; i++) {
      btn = buttons[i];
      results.push(($("<button/>", btn)).prependTo(footer));
    }
    return results;
  };

  Modal.show = function(settings) {
    var btn, btns, i, j, len, len1, ref, ref1, s;
    if (settings == null) {
      settings = {};
    }
    btns = [];
    if ('buttons' in settings && settings.buttons.length) {
      ref = settings.buttons;
      for (i = 0, len = ref.length; i < len; i++) {
        btn = ref[i];
        btns.push(btn);
      }
      delete settings.buttons;
    }
    ref1 = Modal.settings.buttons;
    for (j = 0, len1 = ref1.length; j < len1; j++) {
      btn = ref1[j];
      btns.push(btn);
    }
    s = $.extend({}, Modal.settings, settings);
    s.buttons = btns;
    Modal.bs_modal.off('hide.bs.modal');
    if ('function' === typeof s.onClose) {
      Modal.bs_modal.on('hide.bs.modal', function() {
        return s.onClose(this.bs_modal);
      });
    }
    if (!s.title && !s.body) {
      console.error("No reason to show empty modal");
      return;
    }
    Modal.clear_contents();
    Modal.update_buttons(s.buttons);
    Modal.set_title(s.title);
    Modal.set_body(s.body);
    Modal.set_size(s.size);
    return Modal.bs_modal.modal("show");
  };

  Modal.close = function() {
    return Modal.bs_modal.modal('hide');
  };

  Modal.clear_contents = function() {
    Modal.bs_modal.find(".modal-body").html("");
    return Modal.bs_modal.find(".modal-title").html("");
  };

  $(function() {
    return INTENT.utils.Modal.init();
  });

  return Modal;

})();


/*
  Показывает всплывающее сообщение
 */
INTENT.utils.Notify = (function() {
  function Notify() {}

  Notify.default_options = {
    auto_hide: true,
    closable: true,
    fadeOut: {
      enabled: true,
      delay: 3000
    },
    type: 'info',
    classElement: '.notifications.bottom-right-col',
    message: {
      html: '...'
    }
  };

  Notify.message = function(text, type, options) {
    if (options == null) {
      options = {};
    }
    options = $.extend({}, Notify.default_options, options);
    options.message.html = text.split("\n").join('<br>');
    options.type = type;
    if (!options.auto_hide) {
      options.fadeOut.enabled = false;
      delete options.auto_hide;
    }
    return $(options.classElement).notify(options).show();
  };

  Notify.top_message = function(text, type) {
    var alert, container;
    text = text.split("\n").join('<br>');
    alert = "<div class=\"alert alert-dismissible alert-no-dismiss alert-" + type + " generated-top-alert\">\n  <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button>\n  " + text + "\n</div>";
    container = $('.main .container-fluid');
    container.find('.generated-top-alert').remove();
    return container.prepend(alert);
  };

  Notify.success = function(text, options) {
    if (options == null) {
      options = {};
    }
    return this.message(text, 'success', options);
  };

  Notify.info = function(text, options) {
    if (options == null) {
      options = {};
    }
    return this.message(text, 'info', options);
  };

  Notify.warning = function(text, options) {
    if (options == null) {
      options = {};
    }
    return this.message(text, 'warning', options);
  };

  Notify.danger = function(text, options) {
    if (options == null) {
      options = {};
    }
    return this.message(text, 'danger', options);
  };

  Notify.error = function(text, options) {
    if (options == null) {
      options = {};
    }
    return this.danger(text, options);
  };

  return Notify;

})();


/*
  Плавный скролл к элементу
 */
INTENT.utils.Scroller = (function() {
  function Scroller() {}

  Scroller.to = function(target, speed, callback, correct) {
    var offset;
    if (speed == null) {
      speed = 300;
    }
    if (callback == null) {
      callback = void 0;
    }
    if (correct == null) {
      correct = 0;
    }
    offset = $(target).offset().top - correct;
    return $("html, body").animate({
      scrollTop: offset
    }, speed, callback);
  };

  return Scroller;

})();


/*
  Hideable and slideable tab panel (ex.: creatives moderation status)
 */
INTENT.utils.TabPanel = (function() {
  var isHideable, options;

  function TabPanel() {}

  TabPanel.currentTab = null;

  options = isHideable = true;

  TabPanel.init = function(target) {
    var panel;
    panel = $(target);
    if (target != null) {
      $(document).on('click', target + ".panel.with-nav-tabs .panel-heading span.collapse-button", (function(_this) {
        return function() {
          if (!panel.find('.collapse-button').hasClass('panel-collapsed')) {
            return _this.hidePanel(panel);
          } else {
            panel.find('.panel-heading .nav li:eq(1)').addClass('active');
            return _this.showPanel(panel);
          }
        };
      })(this));
      $(document).on('click', target + ".panel.with-nav-tabs .panel-heading .nav-tabs li a", (function(_this) {
        return function(e) {
          var selectedTab;
          selectedTab = $(e.target).parent('a').attr('href') || $(e.target).attr('href');
          if (!panel.find('.collapse-button').hasClass('panel-collapsed') && _this.currentTab === selectedTab) {
            return _this.hidePanel(panel);
          } else {
            _this.showPanel(panel);
            return _this.currentTab = selectedTab;
          }
        };
      })(this));
      return $(document).on('click', target + ".panel.with-nav-tabs .panel-heading", (function(_this) {
        return function(e) {
          if (!$(e.target).hasClass('panel-heading')) {

          } else if (!panel.find('.collapse-button').hasClass('panel-collapsed') && panel.find('li.active').length) {
            return _this.hidePanel(panel);
          }
        };
      })(this));
    }
  };

  TabPanel.showPanel = function(panel) {
    panel.removeClass('panel-hidden');
    panel.find('.panel-body').slideDown(250);
    panel.find('.collapse-button').removeClass('panel-collapsed');
    return panel.find('.collapse-button i').removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
  };

  TabPanel.hidePanel = function(panel) {
    panel.find('.panel-body').slideUp(250, function() {
      panel.find('.panel-heading .nav li').removeClass('active');
      panel.find('.panel-body .tab-pane').removeClass('active').removeClass('in');
      panel.find('.panel-heading .nav li a').blur();
      return panel.addClass('panel-hidden');
    });
    panel.find('.collapse-button').addClass('panel-collapsed');
    panel.find('.collapse-button i').find('i').removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
    return this.currentTab = null;
  };

  return TabPanel;

})();

(function() {
  var get_tab_code_by_hash, set_tab_code_to_hash, show_tab;
  get_tab_code_by_hash = function() {
    var hash, tab_code;
    hash = window.location.hash.match(/tab=([^&]+)/);
    tab_code = null;
    if (_.isArray(hash) && (hash[1] != null)) {
      tab_code = hash[1];
    }
    return tab_code;
  };
  set_tab_code_to_hash = function(tab_code) {
    var current_hash, new_hash;
    if (!tab_code) {
      return;
    }
    current_hash = window.location.hash.substr(1);
    if (!current_hash) {
      new_hash = "tab=" + tab_code;
    } else if (current_hash.match(/tab=([^&]+)/)) {
      new_hash = current_hash.replace(/tab=([^&]+)/, "tab=" + tab_code);
    } else {
      new_hash = current_hash + ("&tab=" + tab_code);
    }
    if (new_hash != null) {
      return setTimeout((function() {
        return window.location.replace('#' + new_hash);
      }), 0);
    }
  };
  show_tab = function(tab_code) {
    var tab_switcher;
    if (tab_code) {
      tab_switcher = $("[data-toggle='tab'][href='#" + tab_code + "']");
      if (tab_switcher.length && !tab_switcher.attr('data-disable-tab-redirect')) {
        return tab_switcher.tab('show');
      }
    }
  };
  return $(function() {
    show_tab(get_tab_code_by_hash());
    return $(document).on('shown.bs.tab', function(e) {
      var code, tab;
      tab = $(e.target);
      if (tab.attr('data-set-hash')) {
        code = tab.attr('aria-controls');
        return set_tab_code_to_hash(code);
      }
    });
  });
})();

INTENT.utils.Template = (function() {
  function Template() {}

  Template.get_table = function(headrows, bodyrows) {
    if (headrows == null) {
      headrows = '';
    }
    if (bodyrows == null) {
      bodyrows = '';
    }
    return "<table class=\"table table-stripped table-condensed\">\n  <thead>\n    <tr>\n      " + headrows + "\n    </tr>\n  </thead>\n  <tbody>\n      " + bodyrows + "\n  </tbody>\n</table>";
  };

  Template.get_tr_row = function(value, _class) {
    if (_class == null) {
      _class = '';
    }
    _class = this.get_class_attr(_class);
    return "<tr" + _class + ">" + value + "</tr>";
  };

  Template.get_th_row = function(value) {
    return "<th>" + value + "</th>";
  };

  Template.get_td_row = function(value, attrs) {
    if (attrs == null) {
      attrs = {};
    }
    attrs = this.get_attrs(attrs);
    return "<td" + attrs + ">" + value + "</td>";
  };

  Template.wrap_in_p = function(value, attrs) {
    if (attrs == null) {
      attrs = {};
    }
    attrs = this.get_attrs(attrs);
    return "<p" + attrs + ">" + value + "</p>";
  };

  Template.wrap_in_div = function(value) {
    return "<div>" + value + "</div>";
  };

  Template.btn = function(attrs) {
    if (attrs == null) {
      attrs = {};
    }
    return $("<button/>", attrs)[0].outerHTML;
  };

  Template.wrap_link = function(url, name, _class, _target) {
    if (name == null) {
      name = '';
    }
    if (_class == null) {
      _class = '';
    }
    if (_target == null) {
      _target = '';
    }
    _class = Template.get_class_attr(_class);
    if (_target) {
      _target = " target='" + _target + "'";
    }
    return "<a" + _class + " href='" + url + "'" + _target + ">" + name + "</a>";
  };

  Template.get_class_attr = function(_class) {
    if (_class == null) {
      _class = '';
    }
    if (_class !== '') {
      _class = " class='" + _class + "'";
    }
    return _class;
  };

  Template.get_attrs = function(attrs) {
    var result;
    if (attrs == null) {
      attrs = {};
    }
    result = '';
    $.each(attrs, function(an, av) {
      return result += " " + an + "='" + av + "'";
    });
    return result;
  };

  return Template;

})();


/*
  Показывает подсказки
 */
INTENT.utils.Tooltip = (function() {
  var options;

  function Tooltip() {}

  options = {
    trigger: "hover",
    html: true
  };

  Tooltip.init = function(target) {
    if (target != null) {
      return $(target).tooltip(options);
    } else {
      return $("[data-toggle=tooltip]").tooltip(options);
    }
  };

  Tooltip.destroy = function(target) {
    return $(target).tooltip('destroy');
  };

  return Tooltip;

})();

$(function() {
  return INTENT.utils.Tooltip.init();
});

INTENT.utils.Url = (function() {
  function Url() {}

  Url.asObject = function() {
    return _.object(_.compact(_.map(location.search.slice(1).split('&'), function(item) {
      if (item) {
        return item.split('=');
      }
    })));
  };

  Url.hasParam = function(param) {
    return param in Url.getAsObject();
  };

  Url.getParam = function(param, _default) {
    var get;
    if (_default == null) {
      _default = null;
    }
    get = Url.getAsObject();
    if (param in get) {
      return get[param];
    } else {
      return _default;
    }
  };

  Url.asString = function(queryObject) {
    var url;
    if (queryObject == null) {
      queryObject = {};
    }
    url = [];
    _.each(queryObject, function(v, k) {
      return url.push(_.map([k, v], encodeURIComponent).join('='));
    });
    return "?" + (url.join('&'));
  };

  return Url;

})();

var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  hasProp = {}.hasOwnProperty;

INTENT.widgets.CreativeViewer = (function() {
  CreativeViewer.KEY_CODE_ESC = 27;

  CreativeViewer.OFFSET_HEIGHT = 200;

  CreativeViewer.CREATIVE_PREVIEW_URL = preview_domain + "/creative_preview";

  CreativeViewer.CREATIVE_CLICK_URL = preview_domain + "/p/3click";

  CreativeViewer.CREATIVE_3SERVE_URL = "px.adhigh.net/creative_preview";

  CreativeViewer.FIELD_CODE_CAMPAIGN = 'cmp';

  CreativeViewer.FIELD_CODE_CREATIVE = 'c';

  CreativeViewer.SELECTER_LOCKER = "#screen-locker";

  CreativeViewer.ATTR_NAME = "data-widget-creative-viewer";

  CreativeViewer.ATTR_FIELD = CreativeViewer.ATTR_NAME + "-field";

  CreativeViewer.ATTR_FIELD_SIZE = CreativeViewer.ATTR_FIELD + "-size";

  CreativeViewer.ATTR_FIELD_NOSSL = CreativeViewer.ATTR_FIELD + "-nossl";

  CreativeViewer.ATTR_FIELD_TYPE = CreativeViewer.ATTR_FIELD + "-type";

  CreativeViewer.ATTR_FIELD_VIDEO_URL = CreativeViewer.ATTR_FIELD + "-video-url";

  CreativeViewer.ATTR_FIELD_SIZE_WIDTH = CreativeViewer.ATTR_FIELD_SIZE + "-width";

  CreativeViewer.ATTR_FIELD_SIZE_HEIGHT = CreativeViewer.ATTR_FIELD_SIZE + "-height";

  CreativeViewer.ATTR_HEADER = CreativeViewer.ATTR_NAME + "-header";

  CreativeViewer.ATTR_CONTENT = CreativeViewer.ATTR_NAME + "-content";

  CreativeViewer.ATTR_FOOTER = CreativeViewer.ATTR_NAME + "-footer";

  CreativeViewer.ATTR_CONTENT_CONTAINER = CreativeViewer.ATTR_CONTENT + "-container";

  CreativeViewer.ATTR_CREATIVE_URL_PREVIEW = CreativeViewer.ATTR_NAME + "-creative-url-preview";

  CreativeViewer.ATTR_CREATIVE_URL_CLICK = CreativeViewer.ATTR_NAME + "-creative-url-click";

  CreativeViewer.ATTR_CREATIVE_CODE = CreativeViewer.ATTR_NAME + "-creative-code";

  CreativeViewer.ATTR_BTN = CreativeViewer.ATTR_NAME + "-btn";

  CreativeViewer.ATTR_BTN_CLOSE = CreativeViewer.ATTR_BTN + "-close";

  CreativeViewer.ATTR_BTN_RELOAD = CreativeViewer.ATTR_BTN + "-reload";

  CreativeViewer.ATTR_AUTO_BINDER_PREVIEW = "data-preview-creative";

  CreativeViewer.ATTR_ADVERTISER_ID = "data-preview-advertiser-id";

  CreativeViewer.ATTR_PREVIEW_SIZE = CreativeViewer.ATTR_AUTO_BINDER_PREVIEW + "-size";

  CreativeViewer.ATTR_PREVIEW_NOSSL = CreativeViewer.ATTR_AUTO_BINDER_PREVIEW + "-nossl";

  CreativeViewer.ATTR_PREVIEW_TYPE = CreativeViewer.ATTR_AUTO_BINDER_PREVIEW + "-type";

  CreativeViewer.ATTR_PREVIEW_VIDEO_URL = CreativeViewer.ATTR_AUTO_BINDER_PREVIEW + "-video-url";

  CreativeViewer.ATTR_PREVIEW_SWF = CreativeViewer.ATTR_AUTO_BINDER_PREVIEW + "-swf";

  CreativeViewer.ATTR_PREVIEW_CAMPAIGNS_DATA = CreativeViewer.ATTR_AUTO_BINDER_PREVIEW + "-campaigns-data";

  CreativeViewer.ATTR_PREVIEW_ONE_CLICK = CreativeViewer.ATTR_AUTO_BINDER_PREVIEW + "-click";

  CreativeViewer.preview_url_state = 'initial';

  function CreativeViewer(el) {
    this.el = el;
    this.get_values = bind(this.get_values, this);
    this.get_3serve_query_url = bind(this.get_3serve_query_url, this);
    this.get_click_query_url = bind(this.get_click_query_url, this);
    this.get_print_query_url = bind(this.get_print_query_url, this);
    this.get_query_url = bind(this.get_query_url, this);
    this.stopVideo = bind(this.stopVideo, this);
    this.popup_close = bind(this.popup_close, this);
    this.popup_display = bind(this.popup_display, this);
    this.prepare_form = bind(this.prepare_form, this);
    this.get_width = bind(this.get_width, this);
    this.get_height = bind(this.get_height, this);
    this.set_size = bind(this.set_size, this);
    this.manage_iframe_loader = bind(this.manage_iframe_loader, this);
    this.render_preview = bind(this.render_preview, this);
    this.prepare_video_player = bind(this.prepare_video_player, this);
    this.get_iframe_html = bind(this.get_iframe_html, this);
    this.bind_close_action = bind(this.bind_close_action, this);
    this.bind_preview_action = bind(this.bind_preview_action, this);
    this.preview_from_self = bind(this.preview_from_self, this);
    this.set_video_url = bind(this.set_video_url, this);
    this.get_video_url = bind(this.get_video_url, this);
    this.set_creative_type = bind(this.set_creative_type, this);
    this.get_creative_type = bind(this.get_creative_type, this);
    this.get_nossl_field = bind(this.get_nossl_field, this);
    this.set_nossl_field = bind(this.set_nossl_field, this);
    this.get_creative_id = bind(this.get_creative_id, this);
    this.set_creative_id = bind(this.set_creative_id, this);
    this.preview_creative = bind(this.preview_creative, this);
    this.perform_window_size = bind(this.perform_window_size, this);
    this.s = this.constructor;
    this.locker = $(this.s.SELECTER_LOCKER);
    this.header = this.el.find("[" + this.s.ATTR_HEADER + "]");
    this.content = this.el.find("[" + this.s.ATTR_CONTENT + "]");
    this.footer = this.el.find("[" + this.s.ATTR_FOOTER + "]");
    this.container = this.content.find("[" + this.s.ATTR_CONTENT_CONTAINER + "]");
    this.btn_close = this.el.find("[" + this.s.ATTR_BTN_CLOSE + "]");
    this.btn_reload = this.el.find("[" + this.s.ATTR_BTN_RELOAD + "]");
    this.size_width_field = this.header.find("[" + this.s.ATTR_FIELD_SIZE_WIDTH + "]");
    this.size_height_field = this.header.find("[" + this.s.ATTR_FIELD_SIZE_HEIGHT + "]");
    this.nossl_field = this.header.find("[" + this.s.ATTR_FIELD_NOSSL + "]");
    this.creative_type_field = this.header.find("[" + this.s.ATTR_FIELD_TYPE + "]");
    this.video_url_field = this.header.find("[" + this.s.ATTR_FIELD_VIDEO_URL + "]");
    this.campaign_field = this.header.find("[" + this.s.ATTR_FIELD + "='" + this.s.FIELD_CODE_CAMPAIGN + "']");
    this.creative_field = this.header.find("[" + this.s.ATTR_FIELD + "='" + this.s.FIELD_CODE_CREATIVE + "']");
    this.creative_url_preview = this.el.find("[" + this.s.ATTR_CREATIVE_URL_PREVIEW + "]");
    this.creative_url_click = this.el.find("[" + this.s.ATTR_CREATIVE_URL_CLICK + "]");
    this.creative_code = this.el.find("[" + this.s.ATTR_CREATIVE_CODE + "]");
    this.bind_close_action();
    this.bind_preview_action();
    this.el.on('hidden.bs.modal', (function(_this) {
      return function() {
        _this.s.preview_url_state = 'initial';
        return _this.stopVideo();
      };
    })(this));
  }

  CreativeViewer.prototype.perform_window_size = function() {
    var height, max_height, window_height;
    height = this.get_height();
    window_height = $(window).height();
    if (this.get_creative_type() === 'native_creatives') {
      max_height = parseFloat(window_height) - this.s.OFFSET_HEIGHT;
      return this.content.css('max-height', max_height);
    } else {
      return this.content.css({
        'max-height': 'auto'
      });
    }
  };

  CreativeViewer.prototype.preview_creative = function(creative_id, size, nossl, type, video_url) {
    this.prepare_form(creative_id, size, nossl, type, video_url);
    this.render_preview();
    this.el.find('iframe').trigger('loading');
    return this.popup_display();
  };

  CreativeViewer.prototype.set_creative_id = function(creative_id) {
    return this.creative_field.val(creative_id);
  };

  CreativeViewer.prototype.get_creative_id = function() {
    return this.creative_field.val();
  };

  CreativeViewer.prototype.set_nossl_field = function(nossl) {
    return this.nossl_field.val(nossl);
  };

  CreativeViewer.prototype.get_nossl_field = function() {
    return this.nossl_field.val() * 1;
  };

  CreativeViewer.prototype.get_creative_type = function() {
    return this.creative_type_field.val();
  };

  CreativeViewer.prototype.set_creative_type = function(type) {
    return this.creative_type_field.val(type);
  };

  CreativeViewer.prototype.get_video_url = function() {
    return this.video_url_field.val();
  };

  CreativeViewer.prototype.set_video_url = function(type) {
    return this.video_url_field.val(type);
  };

  CreativeViewer.prototype.preview_from_self = function(self) {
    var advertiser_id, id, is_swf, nossl, size, type, video_url;
    id = self.attr(this.s.ATTR_AUTO_BINDER_PREVIEW);
    advertiser_id = self.attr(this.s.ATTR_ADVERTISER_ID);
    size = self.attr(this.s.ATTR_PREVIEW_SIZE);
    nossl = self.attr(this.s.ATTR_PREVIEW_NOSSL);
    type = self.attr(this.s.ATTR_PREVIEW_TYPE);
    video_url = self.attr(this.s.ATTR_PREVIEW_VIDEO_URL);
    is_swf = 1 * self.attr(this.s.ATTR_PREVIEW_SWF);
    this.campaign_field.html('');
    this.campaign_field.attr('disabled', true);
    $.ajax({
      url: '/ajax/get_creative_campaigns',
      method: 'post',
      data: {
        creativeId: id,
        advertiserId: advertiser_id
      },
      success: (function(_this) {
        return function(data, textStatus, jqXH) {
          var campaignsData, group_i, group_label, group_row, i, optionsAsString, row;
          if (jqXH.status === 200 && data.status) {
            campaignsData = data.msg;
            if (campaignsData) {
              optionsAsString = "<option value=''> — </option>";
              for (group_i in campaignsData) {
                group_row = campaignsData[group_i];
                group_label = __('campaigns.off');
                if (parseInt(group_i) === 1) {
                  group_label = __('campaigns.on');
                }
                optionsAsString += '<optgroup label="' + group_label + '">';
                for (i in group_row) {
                  row = group_row[i];
                  if (!is_swf || !row.for_mobile_device) {
                    optionsAsString += "<option value='" + i + "'> [" + i + "] " + escapeHtml(row.name) + "</option>";
                  }
                }
                optionsAsString += '</optgroup>';
              }
              _this.campaign_field.html(optionsAsString);
              return _this.campaign_field.removeAttr('disabled');
            }
          } else {
            return INTENT.utils.Notify.error(__('general.ajax.error'));
          }
        };
      })(this)
    });
    return this.preview_creative(id, size, nossl, type, video_url);
  };

  CreativeViewer.prototype.bind_preview_action = function() {
    this.campaign_field.on('change', (function(_this) {
      return function() {
        _this.s.preview_url_state = 'changed';
        return _this.render_preview();
      };
    })(this));
    this.btn_reload.on('click', (function(_this) {
      return function() {
        return _this.render_preview();
      };
    })(this));
    $(document).on('dblclick', "[" + this.s.ATTR_AUTO_BINDER_PREVIEW + "]:not([" + this.s.ATTR_PREVIEW_ONE_CLICK + "])", (function(_this) {
      return function(e) {
        var self;
        self = $(e.currentTarget);
        _this.locker.show();
        return _this.preview_from_self(self);
      };
    })(this));
    return $(document).on('click', "[" + this.s.ATTR_PREVIEW_ONE_CLICK + "]", (function(_this) {
      return function(e) {
        var self;
        self = $(e.currentTarget);
        _this.locker.show();
        return _this.preview_from_self(self);
      };
    })(this));
  };

  CreativeViewer.prototype.bind_close_action = function() {
    this.btn_close.on('click', (function(_this) {
      return function() {
        return _this.popup_close();
      };
    })(this));
    return $(document).keyup((function(_this) {
      return function(e) {
        if (e.keyCode === _this.s.KEY_CODE_ESC) {
          return _this.popup_close();
        }
      };
    })(this));
  };

  CreativeViewer.prototype.get_iframe_html = function(src, width, height) {
    return "<iframe src=\"" + src + "\" width=\"" + width + "\" height=\"" + height + "\" marginheight=\"0\" marginwidth=\"0\" frameborder=\"0\" scrolling=\"no\" style=\"overflow:hidden;\"></iframe>";
  };

  CreativeViewer.prototype.prepare_video_player = function() {
    return setTimeout(function() {
      return $('#video-popup').get(0).play();
    }, 2000);
  };

  CreativeViewer.prototype.render_preview = function() {
    var height, html, iframe, iframe_height, iframe_width, src, src_3serve, src_click, src_print, width;
    src = this.get_query_url();
    src_print = this.get_print_query_url();
    src_click = this.get_click_query_url();
    src_3serve = this.get_3serve_query_url();
    width = this.get_width();
    height = this.get_height();
    this.el.off('hide.bs.modal');
    if (this.get_creative_type() === "video" || this.get_creative_type() === "smart_tv") {
      width = 640;
      height = 320;
      html = '<video id="video-popup" width="' + width + '" height="' + height + '" controls><source src="' + this.get_video_url() + '"/></video>';
      this.container.html(html);
    } else if (this.get_nossl_field()) {
      html = '<p>' + __('creatives.nossl_link') + '</p><a target="preview" href="' + src + '">' + src + '</a>';
      this.container.html(html);
    } else if (this.get_creative_type() === "native_creatives") {
      iframe_width = 400;
      iframe_height = parseFloat($(window).height()) - 300;
      if (iframe_height < 500) {
        iframe_height = 500;
      }
      iframe = this.get_iframe_html(src, iframe_width, iframe_height);
      this.container.html(iframe);
    } else {
      iframe = this.get_iframe_html(src, width, height);
      this.container.html(iframe);
    }
    if (this.creative_url_preview.length > 0) {
      this.creative_url_preview.attr('href', src_print);
    }
    if (this.creative_url_click.length > 0) {
      this.creative_url_click.attr('href', src_click);
    }
    if (this.creative_code.length > 0) {
      this.creative_code.val("<iframe width='" + width + "' height='" + height + "' src='" + src_3serve + "' frameborder='0' scrolling='no'>");
    }
    this.perform_window_size();
    if (this.get_creative_type() === "3rdparty_video" && !this.get_nossl_field()) {
      this.el.on('hide.bs.modal', (function(_this) {
        return function() {
          return _this.container.find('iframe').remove();
        };
      })(this));
      iframe = this.get_iframe_html("" + (this.get_video_url()), 640, 480);
      this.container.html(iframe);
    } else if (this.get_creative_type() === "video" || this.get_creative_type() === "smart_tv") {
      this.prepare_video_player();
    }
    if (this.get_creative_type() !== "3rdparty_video") {
      return this.el.find('iframe').on('load', (function(_this) {
        return function() {
          return _this.manage_iframe_loader(true);
        };
      })(this)).on('loading', (function(_this) {
        return function() {
          return _this.manage_iframe_loader();
        };
      })(this));
    }
  };

  CreativeViewer.prototype.manage_iframe_loader = function(remove) {
    remove = remove || false;
    if (!$('#iframe-loader').length && !remove) {
      return this.container.append($("<div id='iframe-loader' style='position:absolute;top:48%;left:48%;'><i class='fa fa-circle-o-notch fa-spin green'/></div>"));
    } else if (remove) {
      return $('#iframe-loader').remove();
    }
  };

  CreativeViewer.prototype.set_size = function(size) {
    size = size + '';
    size = size.split(/x/i);
    this.size_width_field.val(size[0]);
    return this.size_height_field.val(size[1]);
  };

  CreativeViewer.prototype.get_height = function() {
    return this.size_height_field.val();
  };

  CreativeViewer.prototype.get_width = function() {
    return this.size_width_field.val();
  };

  CreativeViewer.prototype.prepare_form = function(creative_id, size, nossl, type, video_url) {
    this.set_size(size);
    this.set_creative_id(creative_id);
    this.set_nossl_field(nossl);
    this.set_creative_type(type);
    this.set_video_url(video_url);
    if (this.get_nossl_field()) {
      return this.btn_reload.hide();
    } else {
      return this.btn_reload.show();
    }
  };

  CreativeViewer.prototype.popup_display = function() {
    this.el.modal('show');
    return this.locker.fadeOut();
  };

  CreativeViewer.prototype.popup_close = function() {
    this.container.find('iframe').remove();
    this.stopVideo();
    this.el.modal('hide');
    return this.locker.fadeOut();
  };

  CreativeViewer.prototype.stopVideo = function() {
    var video_popup;
    video_popup = $('#video-popup');
    if (video_popup.length) {
      video_popup.get(0).pause();
      return video_popup.get(0).currentTime = 0;
    }
  };

  CreativeViewer.prototype.get_query_url = function() {
    var key, params, query_string, value;
    params = this.get_values();
    query_string = '';
    for (key in params) {
      if (!hasProp.call(params, key)) continue;
      value = params[key];
      query_string += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
    }
    if (query_string.length > 0) {
      query_string = '?' + query_string.substring(0, query_string.length - 1);
    }
    if (this.get_nossl_field()) {
      return "http://" + this.s.CREATIVE_PREVIEW_URL + ("" + query_string);
    } else {
      return "//" + this.s.CREATIVE_PREVIEW_URL + ("" + query_string);
    }
  };

  CreativeViewer.prototype.get_print_query_url = function() {
    var key, params, query_string, value;
    params = this.get_values();
    query_string = '';
    for (key in params) {
      if (!hasProp.call(params, key)) continue;
      value = params[key];
      query_string += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
    }
    if (query_string.length > 0) {
      query_string = '?' + query_string.substring(0, query_string.length - 1);
    }
    if (this.get_nossl_field()) {
      return "http://" + this.s.CREATIVE_PREVIEW_URL + ("" + query_string);
    } else {
      return "https://" + this.s.CREATIVE_PREVIEW_URL + ("" + query_string);
    }
  };

  CreativeViewer.prototype.get_click_query_url = function() {
    var key, params, query_string, value;
    params = this.get_values();
    query_string = '';
    for (key in params) {
      if (!hasProp.call(params, key)) continue;
      value = params[key];
      query_string += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
    }
    if (query_string.length > 0) {
      query_string = '?' + query_string.substring(0, query_string.length - 1);
    }
    if (this.get_nossl_field()) {
      return "http://" + this.s.CREATIVE_CLICK_URL + ("" + query_string);
    } else {
      return "https://" + this.s.CREATIVE_CLICK_URL + ("" + query_string);
    }
  };

  CreativeViewer.prototype.get_3serve_query_url = function() {
    var key, params, query_string, value;
    params = this.get_values();
    query_string = '';
    for (key in params) {
      if (!hasProp.call(params, key)) continue;
      value = params[key];
      query_string += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
    }
    if (query_string.length > 0) {
      query_string = '?' + query_string.substring(0, query_string.length - 1);
    }
    if (this.get_nossl_field()) {
      return "http://" + this.s.CREATIVE_3SERVE_URL + ("" + query_string);
    } else {
      return "https://" + this.s.CREATIVE_3SERVE_URL + ("" + query_string);
    }
  };

  CreativeViewer.prototype.get_values = function(field_name) {
    var field_attr, fields, param_bag, url_state;
    if (field_name == null) {
      field_name = null;
    }
    param_bag = {};
    field_attr = this.s.ATTR_FIELD;
    fields = this.header.find("[" + field_attr + "]");
    url_state = this.s.preview_url_state;
    fields.each(function() {
      var key, self, val;
      self = $(this);
      if (self.val()) {
        key = self.attr(field_attr);
        if (url_state === 'initial' && 'cmp' === key) {
          return;
        }
        val = self.val();
        return param_bag[key] = val;
      }
    });
    if (!field_name) {
      return param_bag;
    } else {
      return param_bag[field_name];
    }
  };

  return CreativeViewer;

})();

INTENT.widgets.AdvancedTracking = (function() {
  AdvancedTracking.ATTR_NAME = "data-widget-advanced-tracking";

  AdvancedTracking.ATTR_CONTAINER = AdvancedTracking.ATTR_NAME + "-container";

  AdvancedTracking.ATTR_FIELD = AdvancedTracking.ATTR_NAME + "-field";

  AdvancedTracking.ATTR_FIELD_ADD = AdvancedTracking.ATTR_FIELD + "-add";

  AdvancedTracking.ATTR_FIELD_REMOVE = AdvancedTracking.ATTR_FIELD + "-remove";

  AdvancedTracking.ATTR_FIELD_TYPE = AdvancedTracking.ATTR_FIELD + "-type";

  AdvancedTracking.NODE_NAME = "advanced_tracking";

  function AdvancedTracking(el1) {
    var field_add, field_remove, select_type;
    this.el = el1;
    this.s = this.constructor;
    this.container = this.el.find("[" + this.s.ATTR_CONTAINER + "]");
    field_add = this.el.find("[" + this.s.ATTR_FIELD_ADD + "]");
    field_remove = this.el.find("[" + this.s.ATTR_FIELD_REMOVE + "]");
    select_type = this.el.find("[" + this.s.ATTR_FIELD_TYPE + "]");
    field_add.on('click', (function(_this) {
      return function(el) {
        return _this.add_field(el);
      };
    })(this));
    field_remove.on('click', (function(_this) {
      return function(el) {
        return _this.remove_field(el);
      };
    })(this));
    select_type.on('change', (function(_this) {
      return function(el) {
        return _this.change_input_type(el);
      };
    })(this));
  }

  AdvancedTracking.prototype.add_field = function(el) {
    var new_field;
    new_field = $(this.get_field_template());
    this.init_new_field(new_field);
    return this.container.append(new_field);
  };

  AdvancedTracking.prototype.remove_field = function(el) {
    return $(el.target).parents("[" + this.s.ATTR_FIELD + "]").remove();
  };

  AdvancedTracking.prototype.init_new_field = function(field) {
    var field_remove, select_type;
    field_remove = field.find("[" + this.s.ATTR_FIELD_REMOVE + "]");
    select_type = field.find(".select2-init");
    field_remove.on('click', (function(_this) {
      return function(el) {
        return _this.remove_field(el);
      };
    })(this));
    select_type.on('change', (function(_this) {
      return function(el) {
        return _this.change_input_type(el);
      };
    })(this));
    return select_type.select2({
      minimumResultsForSearch: -1
    });
  };

  AdvancedTracking.prototype.change_input_type = function(el) {
    var element, field, type;
    element = $(el.target);
    field = element.parents("[" + this.s.ATTR_FIELD + "]");
    type = element.val();
    return field.find("input").attr('name', this.s.NODE_NAME + "[" + type + "][]");
  };

  AdvancedTracking.prototype.get_field_template = function() {
    return "<tr data-widget-advanced-tracking-field>\n    <td>\n        <select class=\"form-control select2-init\" data-widget-advanced-tracking-field-type>\n            <option selected value=\"start\">start</option>\n            <option value=\"firstQuartile\">1st quartile</option>\n            <option value=\"midpoint\">midpoint</option>\n            <option value=\"thirdQuartile\">3rd quartile</option>\n            <option value=\"complete\">complete</option>\n        </select>\n    </td>\n    <td>\n        <input type=\"text\" class=\"col-md-12 form-control\" name=\"" + this.s.NODE_NAME + "[start][]\" value=\"\">\n    </td>\n    <td>\n        <a href=\"javascript:void(0)\" data-widget-advanced-tracking-field-remove>\n            <i class=\"glyphicon glyphicon-remove\"></i>\n        </a>\n    </td>\n</tr>";
  };

  return AdvancedTracking;

})();


/*
  Campaigns widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.Advertiser = (function() {
  Advertiser.ATTR_NAME = "data-widget-advertiser";

  Advertiser.ATTR_FIELD = Advertiser.ATTR_NAME + "-field";

  function Advertiser(el) {
    this.el = el;
    this.toggle_max_daily_budget = bind(this.toggle_max_daily_budget, this);
    this.update_creaters_states = bind(this.update_creaters_states, this);
    this.s = this.constructor;
    this.fields = this.el.find("[" + this.s.ATTR_FIELD + "]");
    this.field_create_site = this.fields.filter("[" + this.s.ATTR_FIELD + "='create_site']");
    this.field_create_segments = this.fields.filter("[" + this.s.ATTR_FIELD + "='create_segments']");
    this.update_creaters_states();
    this.fields.on("click", (function(_this) {
      return function() {
        return _this.update_creaters_states();
      };
    })(this));
    $('#is_postpaid').on('change', (function(_this) {
      return function() {
        return _this.toggle_max_daily_budget();
      };
    })(this));
  }

  Advertiser.prototype.update_creaters_states = function() {
    var checked;
    checked = this.field_create_site.filter(':checked').val();
    if (!checked) {
      return this.field_create_segments.attr('disabled', 'disabled');
    } else {
      return this.field_create_segments.removeAttr('disabled');
    }
  };

  Advertiser.prototype.toggle_max_daily_budget = function() {
    var enabled, form_group, max_daily_budget;
    max_daily_budget = $('#max_daily_budget');
    enabled = $('#is_postpaid').is(':checked');
    max_daily_budget.attr('disabled', !enabled);
    form_group = max_daily_budget.parents('.form-group');
    if (enabled) {
      return form_group.removeClass('hidden');
    } else {
      return form_group.addClass('hidden');
    }
  };

  return Advertiser;

})();


/*
  Init bootstrap affix on document.ready
  You can use data-spy="affix" instead
  http://getbootstrap.com/javascript/#affix
 */
INTENT.widgets.Affix = (function() {
  Affix.ATTR_NAME = "data-widget-affix";

  function Affix(el) {
    var offset_bottom, offset_top, options;
    this.el = el;
    this.s = this.constructor;
    options = {};
    offset_top = this.el.attr(this.s.ATTR_NAME + "-offset-top");
    offset_bottom = this.el.attr((this.s.ATTR_NAME + "-offset-bottom") || offset_top);
    if (offset_top != null) {
      options.offset = {
        top: offset_top,
        bottom: offset_bottom
      };
    } else {
      options.offset = {
        top: this.el.offset().top,
        bottom: 0
      };
    }
    this.el.affix(options);
  }

  return Affix;

})();


/*
  Autosize widget
 */
INTENT.widgets.Autosize = (function() {
  Autosize.ATTR_NAME = "data-widget-autosize";

  function Autosize(el) {
    this.el = el;
    this.s = this.constructor;
    this.el.addClass('dynamic-height');
    autosize(this.el);
  }

  return Autosize;

})();


/*
  BillingList widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.BillingList = (function() {
  BillingList.ATTR_NAME = "data-widget-billing-list";

  BillingList.ATTR_FORM = BillingList.ATTR_NAME + "-form";

  BillingList.ATTR_FIELD = BillingList.ATTR_NAME + "-field";

  function BillingList(el) {
    this.el = el;
    this.init_select2 = bind(this.init_select2, this);
    this.s = this.constructor;
    this.init_select2();
    this.form = this.el.find("[" + this.s.ATTR_FORM + "]");
    this.fields = this.el.find("[" + this.s.ATTR_FIELD + "]");
    this.field_advertiser = this.fields.filter("[name='advertiser_id']");
    this.field_currency = this.fields.filter("[name='currency']");
    this.field_sum = this.fields.filter("[name='sum']");
    this.form.on("submit", (function(_this) {
      return function() {
        var adv;
        adv = parseInt(_this.field_advertiser.val());
        if (adv <= 0) {
          alert("First of all select advertiser");
          return false;
        }
        if (!_this.field_sum.val().length) {
          alert("Sum must be valid");
          return false;
        }
      };
    })(this));
    this.field_advertiser.on("change", (function(_this) {
      return function(e) {
        var currency, option, self, val;
        self = $(e.target);
        val = self.val();
        option = _this.field_advertiser.find("option[value='" + val + "']");
        currency = option.attr('data-additional');
        return _this.field_currency.attr('value', currency);
      };
    })(this));
    this.field_advertiser.change();
  }

  BillingList.prototype.init_select2 = function() {
    return this.el.find('select').select2();
  };

  return BillingList;

})();

var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.BqPerformance = (function() {
  BqPerformance.ATTR_NAME = "data-widget-bq-journal-performance";

  function BqPerformance(el1) {
    this.el = el1;
    this.showPerformancePopup = bind(this.showPerformancePopup, this);
    this.s = this.constructor;
    this.el.on('click', (function(_this) {
      return function() {
        return _this.showPerformancePopup();
      };
    })(this));
  }

  BqPerformance.prototype.showPerformancePopup = function() {
    var el, hLoader, s;
    this.el.showLoader();
    el = this.el;
    s = this.s;
    hLoader = function() {
      el.hideLoader();
      return $("[" + s.ATTR_NAME + "]").tooltip('hide');
    };
    return $.post("/admin/journal/performance_popup", {
      id: this.el.parents('tr').data('id')
    }).always(function() {
      return hLoader();
    }).done((function(_this) {
      return function(resp) {
        var modalSettings;
        hLoader();
        if (!resp.success) {
          INTENT.utils.Notify.danger(__("bq.performance_popup_error"));
          return;
        }
        modalSettings = {
          title: __('bq.performance_log'),
          body: resp.value,
          size: "large",
          onClose: hLoader
        };
        return INTENT.utils.Modal.show(modalSettings);
      };
    })(this)).fail(function() {
      hLoader();
      return INTENT.utils.Notify.danger(__("bq.performance_popup_error"));
    });
  };

  return BqPerformance;

})();

var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  hasProp = {}.hasOwnProperty;

INTENT.widgets.CampaignGroupFillLimits = (function() {
  var fillDailyClickLimit, fillDailyImpressionLimit;

  CampaignGroupFillLimits.ATTR_NAME = "data-widget-fill-limits";

  fillDailyImpressionLimit = false;

  fillDailyClickLimit = false;

  function CampaignGroupFillLimits(el1) {
    var valDailyClickLimit, valDailyImpLimit;
    this.el = el1;
    this.checkFills = bind(this.checkFills, this);
    this.s = this.constructor;
    this.inputDailyImpLimit = $(document).find('[name="daily_impression_limit"]');
    valDailyImpLimit = this.inputDailyImpLimit.val();
    if (valDailyImpLimit !== '' && parseInt(valDailyImpLimit) > 0) {
      fillDailyImpressionLimit = true;
    } else {
      fillDailyImpressionLimit = false;
    }
    this.inputDailyClickLimit = $(document).find('[name="daily_click_limit"]');
    valDailyClickLimit = this.inputDailyClickLimit.val();
    if (valDailyClickLimit !== '' && parseInt(valDailyClickLimit) > 0) {
      fillDailyClickLimit = true;
    } else {
      fillDailyClickLimit = false;
    }
    this.checkFills();
    $(document).on("keyup", '[name="daily_impression_limit"]', (function(_this) {
      return function(e) {
        var el;
        el = e.currentTarget;
        if (el.value !== '' && parseInt(el.value) > 0) {
          fillDailyImpressionLimit = true;
        } else {
          fillDailyImpressionLimit = false;
        }
        return _this.checkFills();
      };
    })(this));
    $(document).on("keyup", '[name="daily_click_limit"]', (function(_this) {
      return function(e) {
        var el;
        el = e.currentTarget;
        if (el.value !== '' && parseInt(el.value) > 0) {
          fillDailyClickLimit = true;
        } else {
          fillDailyClickLimit = false;
        }
        return _this.checkFills();
      };
    })(this));
    $(document).on("click", '[id="campaigns_list_in_groups_show"]', (function(_this) {
      return function(e) {
        var blockISymbol, blockWithList, elC;
        elC = e.currentTarget;
        blockWithList = $(document).find("#campaigns_list_in_groups");
        blockISymbol = $(elC).find('i');
        if ($(elC).hasClass('hidden_list')) {
          $(elC).removeClass('hidden_list');
          blockISymbol.removeClass('glyphicon-chevron-right').addClass('glyphicon-chevron-down');
          blockWithList.show(400);
        } else {
          $(elC).addClass('hidden_list');
          blockISymbol.removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-right');
          blockWithList.hide(400);
        }
        return e.preventDefault();
      };
    })(this));
    this.objectGroupIdInput = $(document).find('[id="object_group_id"]');
    this.notificationStatusBlock = $(document).find('[id="campaign-groups-progress-block"]');
    this.notificationLoadingBlock = $(document).find('[id="campaign-groups-loading-block"]');
    $.ajax({
      url: '/api/v3/campaigns/forecast_groups/' + this.objectGroupIdInput.val(),
      method: 'get',
      success: (function(_this) {
        return function(data, textStatus, jqXH) {
          var countAllGroupCampaign, dailyLimitExceededCampaigns, html, idCampaign, idCampaignEx, oneManyCount, oneManyStart, oneManyStoped, ref, value, valueEx;
          dailyLimitExceededCampaigns = [];
          countAllGroupCampaign = 0;
          if (data.hasOwnProperty('campaigns')) {
            ref = data.campaigns;
            for (idCampaign in ref) {
              if (!hasProp.call(ref, idCampaign)) continue;
              value = ref[idCampaign];
              countAllGroupCampaign++;
              if (value.status === 'DAILY_IMPRESSION_LIMIT_EXCEEDED' || value.status === 'DAILY_CLICK_LIMIT_EXCEEDED') {
                dailyLimitExceededCampaigns.push({
                  'id': idCampaign,
                  'name': value.name,
                  'advertiser_id': value.advertiser_id
                });
              }
            }
          }
          if (dailyLimitExceededCampaigns.length > 0) {
            if (dailyLimitExceededCampaigns.length === countAllGroupCampaign) {
              _this.notificationStatusBlock.html('<p>' + __('campaigns.group.message.daily-limit-warn') + '</p>');
              return _this.notificationStatusBlock.css('display', 'block');
            } else {
              oneManyCount = __('campaigns.group.message.daily-limit-warn.some_exceeded.one_company');
              oneManyStart = __('campaigns.group.message.daily-limit-warn.some_exceeded.one_company_start');
              oneManyStoped = __('campaigns.group.message.daily-limit-warn.some_exceeded.one_company_stop');
              if (dailyLimitExceededCampaigns.length > 1) {
                oneManyCount = __('campaigns.group.message.daily-limit-warn.some_exceeded.many_company');
                oneManyStart = __('campaigns.group.message.daily-limit-warn.some_exceeded.many_company_start');
                oneManyStoped = __('campaigns.group.message.daily-limit-warn.some_exceeded.many_company_stop');
              }
              html = "<p>" + __('campaigns.group.message.daily-limit-warn.some_exceeded', {
                ':stoped': oneManyStoped,
                ':count_exceed': dailyLimitExceededCampaigns.length,
                ':count_all': countAllGroupCampaign,
                ':one_many_company': oneManyCount
              }) + " " + oneManyStart + "</p>";
              html += '<div><span style="cursor: pointer;"><a class="with-glyph hidden_list" id="campaigns_list_in_groups_show" href="javascript:void(0)"><i class="glyphicon glyphicon-chevron-right"></i>&nbsp;' + __('campaigns.group.message.daily-limit-warn.show.list_exceed_company') + '</a></span></div>';
              html += '<div style="display: none;" id="campaigns_list_in_groups">';
              for (idCampaignEx in dailyLimitExceededCampaigns) {
                if (!hasProp.call(dailyLimitExceededCampaigns, idCampaignEx)) continue;
                valueEx = dailyLimitExceededCampaigns[idCampaignEx];
                html += '<p style="margin:10px 0 0 30px;"><a href="/campaigns/advertisers/' + valueEx.advertiser_id + '/campaigns/edit/' + valueEx.id + '" target="_blank">' + valueEx.name + '&nbsp;(' + valueEx.id + ')' + '</a> </p>';
              }
              html += '</div>';
              _this.notificationStatusBlock.html(html);
              return _this.notificationStatusBlock.css('display', 'block');
            }
          }
        };
      })(this),
      error: (function(_this) {
        return function(jqXHR, textStatus, errorThrown) {
          _this.notificationStatusBlock.css('display', 'block');
          return _this.notificationStatusBlock.html('<p>' + jqXHR.responseJSON.error + '</p>');
        };
      })(this),
      complete: (function(_this) {
        return function() {
          return _this.notificationLoadingBlock.css('display', 'none');
        };
      })(this)
    });
  }

  CampaignGroupFillLimits.prototype.checkFills = function() {
    if (fillDailyImpressionLimit || fillDailyClickLimit) {
      return $('#fill-daily-limits').css('display', 'block');
    } else {
      return $('#fill-daily-limits').css('display', 'none');
    }
  };

  return CampaignGroupFillLimits;

})();


/*
  Tooltip widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.CampaignIncrease = (function() {
  CampaignIncrease.MESSAGE_ID = "campaign_increase_alert";

  CampaignIncrease.ATTR_NAME = "data-widget-campaign-increase";

  CampaignIncrease.ATTR_INPUT = CampaignIncrease.ATTR_NAME + "-input";

  CampaignIncrease.ATTR_ALERT = CampaignIncrease.ATTR_NAME + "-alert";

  function CampaignIncrease(el) {
    this.el = el;
    this.get_template_alert = bind(this.get_template_alert, this);
    this.get_message_alert = bind(this.get_message_alert, this);
    this.get_budget = bind(this.get_budget, this);
    this.s = this.constructor;
    this.input = $(document).find("[" + this.s.ATTR_INPUT + "]");
    this.tab = $('[data-toggle="tab"][href="#basic"]');
    this.el.on("click", (function(_this) {
      return function() {
        var wrapper;
        _this.tab.tab('show');
        _this.input.val(_this.get_budget());
        _this.input.showWarning();
        wrapper = _this.input.closest(".form-group");
        INTENT.utils.Scroller.to(wrapper, null, null, 100);
        wrapper.find("#" + _this.s.MESSAGE_ID).remove();
        return wrapper.append(_this.get_template_alert());
      };
    })(this));
  }

  CampaignIncrease.prototype.get_budget = function() {
    return this.el.attr(this.s.ATTR_NAME);
  };

  CampaignIncrease.prototype.get_message_alert = function() {
    return this.el.attr(this.s.ATTR_ALERT);
  };

  CampaignIncrease.prototype.get_template_alert = function() {
    var text;
    text = this.get_message_alert();
    return "<div id=\"" + this.s.MESSAGE_ID + "\" class=\"help-block text-warning\">" + text + "</div>";
  };

  return CampaignIncrease;

})();


/*
  Campaigns widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.Campaigns = (function() {
  Campaigns.TYPE_ORIGINAL = "original";

  Campaigns.TYPE_MOBILE = "mobile";

  Campaigns.TYPE_NATIVE = "native";

  Campaigns.TYPE_VIDEO = "video";

  Campaigns.CLASS_HIDDEN = "hidden";

  Campaigns.ATTR_NAME = "data-widget-campaigns";

  Campaigns.ATTR_MOBILE = Campaigns.ATTR_NAME + "-mobile";

  Campaigns.ATTR_NATIVE = Campaigns.ATTR_NAME + "-native";

  Campaigns.ATTR_VIDEO = Campaigns.ATTR_NAME + "-video";

  Campaigns.ATTR_PREPARE = Campaigns.ATTR_NAME + "-prepare-form";

  Campaigns.ATTR_FORM = Campaigns.ATTR_NAME + "-form";

  Campaigns.ATTR_WELCOME = Campaigns.ATTR_NAME + "-welcome";

  Campaigns.ATTR_SPEND_ASAP = "#spend_asap";

  Campaigns.ATTR_KEYWORDS = "#keywords";

  Campaigns.ATTR_ADVERTISER_ID = "data-advertiser-id";

  Campaigns.ATTR_CAMPAIGN_ID = "data-object-id";

  Campaigns.ATTR_FIELD = Campaigns.ATTR_FORM + "-field";

  Campaigns.ATTR_FIELD_TYPE = Campaigns.ATTR_FIELD + "-type";

  Campaigns.ATTR_BTN_ORIGINAL = Campaigns.ATTR_NAME + "-btn-original";

  Campaigns.ATTR_BTN_MOBILE = Campaigns.ATTR_NAME + "-btn-mobile";

  Campaigns.ATTR_HEADER = Campaigns.ATTR_NAME + "-header";

  Campaigns.ATTR_AVAILABLE_INVENTORY_CALC = Campaigns.ATTR_NAME + "-ai-calc";

  Campaigns.ATTR_CTR_FIELD = Campaigns.ATTR_NAME + "-target-ctr";

  Campaigns.ATTR_MIN_CTR_FIELD = Campaigns.ATTR_NAME + "-min-ctr";

  Campaigns.ATTR_FIN_TYPE_FIELD = Campaigns.ATTR_NAME + "-fin-type";

  Campaigns.ATTR_GROUP_HANDLER = Campaigns.ATTR_NAME + "-group-handler";

  Campaigns.ATTR_MODAL_ESTIMATE = Campaigns.ATTR_NAME + "-estimate-modal";

  Campaigns.ATTR_MODAL_GROUP = Campaigns.ATTR_NAME + "-group-modal";

  Campaigns.ATTR_BUDGET_PACING = "name=budget_pacing";

  Campaigns.ATTR_BUDGET_PACING_HINT = "data-budget-pacing-hint";

  Campaigns.ATTR_DAILY_BUDGET_FIELD = "field-id-daily_budget";

  Campaigns.LOADER_SPINNER = " <i class=\"fa fa-circle-o-notch fa-spin green fa-3x\"></i> ";

  Campaigns.LOADER_SPINNER_XS = " <i class=\"fa fa-circle-o-notch fa-spin\"></i> ";

  Campaigns.MODAL = "#modal_dynamic_price";

  function Campaigns(el1) {
    var hotkay_ai, mobile_attr, native_attr, need_preapre, tabsToRedirect, video_attr;
    this.el = el1;
    this.loadDynamicPriceData = bind(this.loadDynamicPriceData, this);
    this.showModal = bind(this.showModal, this);
    this.excludeDomainsHandlerInit = bind(this.excludeDomainsHandlerInit, this);
    this.spendAsapControlInit = bind(this.spendAsapControlInit, this);
    this.targetCTRControlInit = bind(this.targetCTRControlInit, this);
    this.keywordsControlInit = bind(this.keywordsControlInit, this);
    this.onMobileClick = bind(this.onMobileClick, this);
    this.onOriginalClick = bind(this.onOriginalClick, this);
    this.switchWorkArea = bind(this.switchWorkArea, this);
    this.hideWelcomeBlock = bind(this.hideWelcomeBlock, this);
    this.displayForm = bind(this.displayForm, this);
    this.prepareMobileFields = bind(this.prepareMobileFields, this);
    this.prepareOriginFields = bind(this.prepareOriginFields, this);
    this.displayHeader = bind(this.displayHeader, this);
    this.initFieldsScope = bind(this.initFieldsScope, this);
    this.isMobileCampaign = bind(this.isMobileCampaign, this);
    this.calcAvailableInventory = bind(this.calcAvailableInventory, this);
    this.requestAvailableInventory = bind(this.requestAvailableInventory, this);
    this.requestGroupEstimate = bind(this.requestGroupEstimate, this);
    this.validateLandingPage = bind(this.validateLandingPage, this);
    this.validateDailyBudget = bind(this.validateDailyBudget, this);
    this.requestUpdateGroupLimit = bind(this.requestUpdateGroupLimit, this);
    this.needEstimationAlert = bind(this.needEstimationAlert, this);
    this.getFormSerializedJson = bind(this.getFormSerializedJson, this);
    this.submitForm = bind(this.submitForm, this);
    this.redirectToSPA = bind(this.redirectToSPA, this);
    this.s = this.constructor;
    this.bulk_edit = typeof bulk_edit !== "undefined" && bulk_edit !== null ? bulk_edit : false;
    this.advertiserId = parseInt(this.el.find("[" + this.s.ATTR_ADVERTISER_ID + "]").attr(this.s.ATTR_ADVERTISER_ID));
    this.campaignId = parseInt(this.el.find("[" + this.s.ATTR_CAMPAIGN_ID + "]").attr(this.s.ATTR_CAMPAIGN_ID));
    this.calculatingInProcess = false;
    mobile_attr = this.el.attr(this.s.ATTR_MOBILE);
    this.mobile_campaign = typeof mobile_attr !== 'undefined' && mobile_attr !== false;
    native_attr = this.el.attr(this.s.ATTR_NATIVE);
    this.native_campaign = typeof native_attr !== 'undefined' && native_attr !== false;
    video_attr = this.el.attr(this.s.ATTR_VIDEO);
    this.video_campaign = typeof video_attr !== 'undefined' && video_attr !== false;
    this.form = this.el.find("[" + this.s.ATTR_FORM + "]");
    this.welcome = this.el.find("[" + this.s.ATTR_WELCOME + "]");
    this.btnOriginal = this.el.find("[" + this.s.ATTR_BTN_ORIGINAL + "]");
    this.btnMobile = this.el.find("[" + this.s.ATTR_BTN_MOBILE + "]");
    this.btnSubmit = $('[name="update"].submit-button');
    this.headersScope = this.el.find("[" + this.s.ATTR_HEADER + "]");
    this.modalEstimate = $("[" + this.s.ATTR_MODAL_ESTIMATE + "]");
    this.estimateBtn = this.modalEstimate.find("[data-estimate]");
    this.estimateResult = this.modalEstimate.find("[data-estimate-result]");
    this.estimateAction = this.modalEstimate.find("[data-estimate-action]");
    this.handlerGroup = this.el.find("[" + this.s.ATTR_GROUP_HANDLER + "]");
    this.modalGroup = $("[" + this.s.ATTR_MODAL_GROUP + "]");
    this.groupResult = this.modalGroup.find("[data-result]");
    this.groupAction = this.modalGroup.find("[data-action]");
    this.groupWarning = this.modalGroup.find("[data-warning]");
    this.groupNameField = this.modalGroup.find("[name='name']");
    this.groupCurrentLimitField = this.modalGroup.find("[name='limit']");
    this.groupLimitField = this.modalGroup.find("[name='budget_limit']");
    this.groupMatchBudget = this.modalGroup.find("[name='match_budget']");
    this.groupIdField = this.modalGroup.find("[name='group_id']");
    this.submitNewLimitBtn = this.groupAction.find("[data-submit]");
    this.submit_btn_name = 'update';
    this.submit_btn_value = 'save';
    this.dynPriceBtn = $('#dynamic_price span');
    this.finTypeField = this.el.find("[" + this.s.ATTR_FIN_TYPE_FIELD + "]");
    this.predictTypeContainer = this.el.find("[data-widget-campaigns-predict]");
    this.dailyBudgetField = this.el.find("#field-id-daily_budget");
    this.canSubmit = false;
    this.validateEmptyTargeting = true;
    this.predictFinancigTypes = $.parseJSON(this.form.attr('data-predict-financing-types'));
    this.financigTypesWithDisabledTargetCTR = $.parseJSON(this.form.attr('data-disable-target-ctr-financing-types'));
    $("input[type=submit], button[type=submit]").click((function(_this) {
      return function(e) {
        var self;
        self = $(e.currentTarget);
        _this.submit_btn_name = self.attr("name");
        return _this.submit_btn_value = self.val();
      };
    })(this));
    this.finTypeField.on('change', (function(_this) {
      return function(e) {
        var self, val;
        self = $(e.currentTarget);
        val = self.val();
        if (jQuery.inArray(val, _this.predictFinancigTypes) !== -1) {
          return _this.predictTypeContainer.removeClass('hidden');
        } else {
          return _this.predictTypeContainer.addClass('hidden');
        }
      };
    })(this));
    this.dailyBudgetField.on('change keydown paste cut', function() {
      var el;
      el = $(this);
      return setTimeout(function() {
        var budget_pacing_campaign, budget_pacing_daily;
        budget_pacing_campaign = $("#budget_pacing_campaign");
        budget_pacing_daily = $("#budget_pacing_daily");
        if (!el.val()) {
          budget_pacing_campaign.trigger('click');
          budget_pacing_daily.attr('disabled', true);
          return budget_pacing_daily.closest('.budget-pacing-block').addClass('gray');
        } else {
          if (budget_pacing_daily.attr('disabled')) {
            budget_pacing_daily.attr('disabled', false);
            return budget_pacing_daily.closest('.budget-pacing-block').removeClass('gray');
          }
        }
      }, 100);
    });
    $('.submit-button').click((function(_this) {
      return function(e) {
        var self;
        self = _this;
        _this.btnSubmit = $(e.target);
        if ($("#spend_asap:checked").length && window.location.hash.indexOf("copied") !== -1) {
          show_confirm(__("campaigns.form.spend_asap.warn"), function() {
            return self.submitForm(self.form);
          }, function() {
            return self.btnSubmit.hideLoader('disabled');
          }, __('btn.save'), __('btn.cancel'));
          return false;
        }
        if (!_this.validateDailyBudget()) {
          show_confirm("<span id=\"daily-budget-warn\">" + (__('campaigns.message.daily-budget-warn')) + "</span>", function() {
            return self.submitForm(self.form);
          }, function() {
            return self.btnSubmit.hideLoader('disabled');
          }, __('btn.save'), __('btn.cancel'));
          return false;
        }
      };
    })(this));
    this.form.on('submit', (function(_this) {
      return function(e) {
        var btnSubmit, current, data, instance, request;
        if (_this.bulk_edit) {
          return true;
        }
        current = $(e.currentTarget);
        data = {};
        if (!_this.validateLandingPage()) {
          _this.btnSubmit.hideLoader('disabled');
          return false;
        }
        if (_this.canSubmit === true) {
          return true;
        }
        current.find('[data-widget-targeting-type]').each(function() {
          var countriesField, self, type;
          self = $(this);
          type = self.attr('data-widget-targeting-type');
          countriesField = self.find('[data-countries]');
          switch (type) {
            case 'targeting':
              return data.countries = countriesField.val();
            case 'negative_targeting':
              return data.negative_countries = countriesField.val();
            default:
              return null;
          }
        });
        request = $.ajax({
          url: '/ajax/check_continent',
          type: "POST",
          dataType: "json",
          async: true,
          data: data
        });
        instance = _this;
        btnSubmit = _this.btnSubmit;
        request.done(function(xhr) {
          var cancelSubmitAction, continueSubmitAction;
          if (xhr.valid === 1) {
            instance.canSubmit = true;
            return instance.submitForm(current);
          } else {
            continueSubmitAction = function() {
              instance.canSubmit = true;
              return instance.submitForm(current);
            };
            cancelSubmitAction = function() {
              return btnSubmit.hideLoader('disabled');
            };
            return show_confirm(xhr.message, continueSubmitAction, cancelSubmitAction, __('btn.save'), __('btn.cancel'));
          }
        });
        return false;
      };
    })(this));
    this.handlerGroup.on('change', (function(_this) {
      return function(e) {
        var current, group_id, request;
        e.preventDefault();
        current = $(e.currentTarget);
        group_id = parseInt(current.val());
        if (_this.previousBtnText) {
          _this.submitNewLimitBtn.html(_this.previousBtnText);
          _this.submitNewLimitBtn.removeAttr('disabled');
          _this.previousBtnText = void 0;
        }
        if (_this.advertiserId === 0) {
          return false;
        }
        if (_this.campaignId === 0) {
          return false;
        }
        if (group_id === 0) {
          return false;
        }
        request = _this.requestGroupEstimate(group_id, _this.campaignId, _this.advertiserId);
        return request.done(function(xhr) {
          var modal_opt;
          if (xhr.budget_diff === 0) {
            return false;
          }
          modal_opt = {
            backdrop: 'static'
          };
          _this.groupWarning.html('');
          _this.groupLimitField.parents('.form-group').removeClass('has-warning');
          _this.groupIdField.attr('value', group_id);
          _this.groupNameField.attr('value', xhr.name_full);
          _this.groupLimitField.val(xhr.limit);
          _this.groupCurrentLimitField.attr('value', xhr.limit);
          _this.groupMatchBudget.attr('value', xhr.estimate);
          if (xhr.left_budget > 0) {
            _this.groupResult.html(INTENT.templates.CrudCampaign.get_group_warning_overhead(__('campaign.group.left_budget', {
              ":budget": xhr.formatted_left_budget
            })));
            _this.modalGroup.modal(modal_opt);
          }
          if (xhr.group_overhead > 0) {
            _this.groupResult.html(INTENT.templates.CrudCampaign.get_group_warning_overhead(__('campaign.group.overhead')));
            return _this.modalGroup.modal(modal_opt);
          }
        });
      };
    })(this));
    this.submitNewLimitBtn.on('click', (function(_this) {
      return function(e) {
        var advertiser_id, budget_limit, group_id, request;
        _this.previousBtnText = _this.submitNewLimitBtn.html();
        _this.submitNewLimitBtn.html(_this.s.LOADER_SPINNER_XS);
        _this.submitNewLimitBtn.attr('disabled', 'disabled');
        group_id = parseInt(_this.groupIdField.val());
        advertiser_id = _this.advertiserId;
        budget_limit = parseFloat(_this.groupLimitField.val());
        request = _this.requestUpdateGroupLimit(group_id, budget_limit, advertiser_id);
        return request.done(function(xhr) {
          _this.submitNewLimitBtn.html(_this.previousBtnText);
          _this.submitNewLimitBtn.removeAttr('disabled');
          _this.previousBtnText = void 0;
          return _this.modalGroup.modal('hide');
        });
      };
    })(this));
    this.estimateBtn.on('click', (function(_this) {
      return function() {
        var alert_text, request;
        _this.estimateBtn.attr('disabled', 'disabled');
        request = _this.requestAvailableInventory();
        _this.estimateResult.html(_this.s.LOADER_SPINNER);
        _this.estimateAction.hide();
        alert_text = '';
        if (_this.needEstimationAlert() === true) {
          alert_text = __('campaign.available_inventory.small_alert');
        }
        return request.done(function(xhr) {
          var report_url_message;
          _this.estimateAction.hide();
          _this.estimateBtn.removeAttr('disabled');
          report_url_message = '';
          if (xhr.report_url != null) {
            report_url_message = "<p class='text-center'><br/><a target='_blank' href='" + xhr.report_url + "'>" + (__('available_inventory.report_url')) + "</a></p>";
          }
          if (xhr.error) {
            return _this.estimateResult.html(INTENT.templates.CrudCampaign.get_result_container(xhr.message, alert_text));
          } else {
            return _this.estimateResult.html(INTENT.templates.CrudCampaign.get_result_container(__('campaign.available_inventory.result', {
              ":inventory": xhr.formatted
            }), alert_text, report_url_message));
          }
        });
      };
    })(this));
    this.aiCalc = this.el.find("[" + this.s.ATTR_AVAILABLE_INVENTORY_CALC + "]");
    this.ctrField = this.el.find("[" + this.s.ATTR_CTR_FIELD + "]");
    this.minctrField = this.el.find("[" + this.s.ATTR_MIN_CTR_FIELD + "]");
    this.initFieldsScope();
    this.btnOriginal.on("click", this.onOriginalClick);
    this.btnMobile.on("click", this.onMobileClick);
    this.aiCalc.on("click", this.calcAvailableInventory);
    need_preapre = this.el.attr(this.s.ATTR_PREPARE);
    if ((need_preapre != null) && this.fieldType.length) {
      this.onMobileClick();
    }
    if (this.isMobileCampaign()) {
      this.onMobileClick();
    } else {
      this.onOriginalClick();
    }
    this.spendAsapControlInit();
    this.keywordsControlInit();
    this.targetCTRControlInit();
    this.excludeDomainsHandlerInit();
    hotkay_ai = 'ctrl+i';
    if (navigator.platform.match("Mac")) {
      hotkay_ai = 'meta+i';
    }
    $(document).on('keydown', null, hotkay_ai, this.calcAvailableInventory);
    this.modalEstimate.on('hidden.bs.modal', (function(_this) {
      return function() {
        return _this.aiCalcOnAir = false;
      };
    })(this));
    this.dynPriceBtn.on('click', (function(_this) {
      return function(e) {
        return _this.showModal();
      };
    })(this));
    $('.reload-campaigns-stats i').on('click', (function(_this) {
      return function() {
        return get_plot_chart();
      };
    })(this));
    $('#learning_budget_select').on('change', (function(_this) {
      return function(e) {
        var values;
        values = $(e.target).val().split('::');
        $('#learning_budget_type').val(values[0]);
        return $('#learning_budget_strategy').val(values[1]);
      };
    })(this));
    $(document).on('select2:open', (function(_this) {
      return function() {
        return $('.select2-results__option a').on('mouseup', function(e) {
          return e.stopPropagation();
        });
      };
    })(this));
    $(document).on('init-global-scope', (function(_this) {
      return function() {
        init_campaigns_select2($('#creatives_type').val());
        initAppTargeting("#targeting_mobile_application");
        return initAppTargeting("#negative_targeting_mobile_application");
      };
    })(this));
    $(document).on('mouseup', '.select2-option-link', (function(_this) {
      return function() {
        return $('.select2-option-link').unbind('click').on('click', function(e) {
          return e.stopPropagation();
        });
      };
    })(this));
    this.formChanged = false;
    this.form.find('input, textarea, select').on('change', (function(_this) {
      return function() {
        return _this.formChanged = true;
      };
    })(this));
    this.form.find('.segments-tree.tf-tree, #campaign-start-date, #campaign-end-date').on('click', (function(_this) {
      return function() {
        return _this.formChanged = true;
      };
    })(this));
    this.actionUrl = this.form.attr('action');
    tabsToRedirect = ['basic', 'targeting', 'other', 'extra', 'stats'];
    $('ul.nav-tabs li').on('click', (function(_this) {
      return function(e) {
        var href, tabName;
        href = $(e.currentTarget).find('a').attr('href') || null;
        if (href) {
          tabName = href.replace('#', '');
          if (tabsToRedirect.indexOf(tabName) !== -1 && !_this.bulk_edit) {
            e.stopPropagation();
            e.preventDefault();
            return _this.redirectToSPA(tabName);
          }
        }
      };
    })(this));
  }

  Campaigns.prototype.redirectToSPA = function(tabName) {
    var cancelAction, confirmAction, custom, customAction, newAction, self;
    self = this;
    if (self.actionUrl.indexOf('?') === self.actionUrl.length - 1) {
      newAction = self.actionUrl + "tab=" + tabName;
    } else if (self.actionUrl.indexOf('?') !== -1) {
      newAction = self.actionUrl + "&tab=" + tabName;
    } else {
      newAction = self.actionUrl + "?tab=" + tabName;
    }
    if (self.formChanged || self.actionUrl.indexOf("/new") !== -1) {
      confirmAction = function() {
        self.form.attr('action', newAction);
        return self.form.submit();
      };
      cancelAction = function() {};
      customAction = function() {
        return window.location.href = newAction.replace('/update/', '/edit/');
      };
      custom = self.actionUrl.indexOf("/new") !== -1 ? null : {
        name: __('tab-redirect.btn.continue-without-save'),
        action: customAction
      };
      return show_confirm(__("tab-redirect.message"), confirmAction, cancelAction, __('tab-redirect.btn.continue-and-save'), __('btn.cancel'), custom);
    } else {
      window.location.href = newAction.replace('/update/', '/edit/');
    }
  };

  Campaigns.prototype.submitForm = function(form) {
    var tmpElement;
    tmpElement = $("<input type=\"hidden\" name=\"" + this.submit_btn_name + "\" value=\"" + this.submit_btn_name + "\">");
    tmpElement.appendTo(form);
    form.submit();
    return tmpElement.remove();
  };

  Campaigns.prototype.getFormSerializedJson = function() {
    return this.form.serializeObject();
  };

  Campaigns.prototype.needEstimationAlert = function() {
    if (this.ctrField.filter(':enabled').val() && this.ctrField.val()) {
      return true;
    }
    if (this.finTypeField.val().indexOf("cpc") > -1) {
      return true;
    }
    return false;
  };

  Campaigns.prototype.requestUpdateGroupLimit = function(group_id, budget_limit, advertiser_id) {
    return $.ajax({
      url: '/ajax/update_group_limit',
      type: "POST",
      dataType: "json",
      async: true,
      data: {
        "group_id": group_id,
        "budget_limit": budget_limit,
        "advertiser_id": advertiser_id
      }
    });
  };

  Campaigns.prototype.validateDailyBudget = function() {
    var advertiserId, budget, campaignId, dailyBudget, end, request, start, status;
    dailyBudget = $("#field-id-daily_budget").val();
    budget = $("#field-id-budget").val();
    start = $("#campaign-start-date").val();
    end = $("#campaign-end-date").val();
    if ((dailyBudget == null) || (budget == null) || (start == null) || (end == null)) {
      return true;
    }
    if (dailyBudget === "" || budget === "" || start === "" || end === "") {
      return true;
    }
    campaignId = this.campaignId === 0 ? false : this.campaignId;
    advertiserId = this.advertiserId === 0 ? false : this.advertiserId;
    request = $.ajax({
      url: '/ajax/check_daily_budget',
      type: "POST",
      dataType: "json",
      async: false,
      data: {
        advertiserId: advertiserId,
        id: campaignId,
        start: start,
        end: end,
        dailyBudget: dailyBudget,
        budget: budget
      }
    });
    status = false;
    request.done(function(xhr) {
      return status = xhr.valid;
    });
    return status;
  };

  Campaigns.prototype.validateLandingPage = function() {
    var matches, url;
    url = $("#landing_page").val();
    url = url.trim();
    if (!url.match(/(https?|ftp):\/\/(-\.)?([^\s\/?\.#]+\.?)+(\/[^\s]*)?$/g)) {
      show_notification(__("campaigns.landing_page.regex"), true, "error", function() {
        $("form:input").blur();
        return $("#landing_page").focus();
      });
      return false;
    }
    matches = void 0;
    if ((matches = url.match(/(?:[^\[])(\[[^\[]*?\]\])/i)) || (matches = url.match(/(?:[^\[])(\[{3,}[^\[]*?\]\])/i)) || (matches = url.match(/(\[\[[^\]]*?\](?:[^\]]|$))/i)) || (matches = url.match(/(\[\[[^\]]*?\]{3,})/i))) {
      show_notification(__("campaigns.landing_page_macros.regex") + ": " + matches[1], true, "error", function() {
        $("form:input").blur();
        return $("#landing_page").focus();
      });
      return false;
    }
    return true;
  };

  Campaigns.prototype.requestGroupEstimate = function(group_id, campaign_id, advertiser_id) {
    var url;
    url = '/ajax/estimate_campaign_group';
    return $.ajax({
      url: url,
      type: "POST",
      dataType: "json",
      async: true,
      data: {
        "group_id": group_id,
        "campaign_id": campaign_id,
        "advertiser_id": advertiser_id
      }
    });
  };

  Campaigns.prototype.requestAvailableInventory = function() {
    var url;
    url = '/livereports/available_inventory';
    return $.ajax({
      url: url,
      type: "POST",
      dataType: "json",
      data: JSON.stringify(this.getFormSerializedJson())
    });
  };

  Campaigns.prototype.calcAvailableInventory = function() {
    if (this.aiCalcOnAir === true) {
      return false;
    }
    this.aiCalcOnAir = true;
    this.estimateResult.html('');
    this.modalEstimate.modal('show');
    if (this.needEstimationAlert() === false) {
      this.estimateBtn.click();
      this.estimateAction.hide();
    } else {
      this.estimateAction.show();
      this.estimateResult.html(INTENT.templates.CrudCampaign.get_alert_container(__('campaign.available_inventory.alert')));
    }
    return false;
  };

  Campaigns.prototype.isMobileCampaign = function() {
    return this.mobile_campaign;
  };

  Campaigns.prototype.initFieldsScope = function() {
    return this.fieldType = this.form.find("[" + this.s.ATTR_FIELD_TYPE + "]");
  };

  Campaigns.prototype.displayHeader = function(type) {
    var header;
    this.headersScope.hide();
    header = this.headersScope.filter("[" + this.s.ATTR_HEADER + "='" + type + "']");
    header.removeClass(this.s.CLASS_HIDDEN);
    header.show();
    return this;
  };

  Campaigns.prototype.prepareOriginFields = function() {
    $(".for-mobile").hide().addClass(this.s.CLASS_HIDDEN);
    return $(".for-non-mobile").show().removeClass(this.s.CLASS_HIDDEN);
  };

  Campaigns.prototype.prepareMobileFields = function() {
    $(".for-mobile").show().removeClass(this.s.CLASS_HIDDEN);
    return $(".for-non-mobile").hide().addClass(this.s.CLASS_HIDDEN);
  };

  Campaigns.prototype.displayForm = function() {
    this.form.show();
    return this;
  };

  Campaigns.prototype.hideWelcomeBlock = function() {
    this.welcome.hide();
    return this;
  };

  Campaigns.prototype.switchWorkArea = function() {
    return this.hideWelcomeBlock().displayForm();
  };

  Campaigns.prototype.onOriginalClick = function() {
    this.fieldType.remove();
    if (this.native_campaign) {
      this.displayHeader(this.s.TYPE_NATIVE);
    } else if (this.video_campaign) {
      this.displayHeader(this.s.TYPE_VIDEO);
    } else {
      this.displayHeader(this.s.TYPE_ORIGINAL);
    }
    this.prepareOriginFields();
    return this.switchWorkArea();
  };

  Campaigns.prototype.onMobileClick = function() {
    this.displayHeader(this.s.TYPE_MOBILE);
    this.prepareMobileFields();
    return this.switchWorkArea();
  };

  Campaigns.prototype.keywordsControlInit = function() {
    var keywordsRemainInfo, limit;
    if ($(this.s.ATTR_KEYWORDS).length === 0) {
      return;
    }
    limit = $(this.s.ATTR_KEYWORDS).data('keywords-limit');
    keywordsRemainInfo = $(this.s.ATTR_KEYWORDS).parents('.form-group').find('#keywords-remain');
    keywordsRemainInfo.text(limit - parseInt($(this.s.ATTR_KEYWORDS).val().split(/\r|\r\n|\n/).length));
    return $(this.s.ATTR_KEYWORDS).on('keydown', function(e) {
      var code, el, lines;
      el = $(this);
      code = e.keyCode || e.which;
      lines = el.val().split(/\r|\r\n|\n/);
      setTimeout(function() {
        var remain;
        remain = limit - el.val().split(/\r|\r\n|\n/).length;
        if (keywordsRemainInfo.text() !== remain) {
          return keywordsRemainInfo.text(remain);
        }
      }, 100);
      if (lines.length >= limit && code === 13) {
        return false;
      }
    });
  };

  Campaigns.prototype.toggleCTRSwitch = function(ctrSwitch, state) {
    if (ctrSwitch.length === 0) {
      return;
    }
    if (state === 'disable') {
      ctrSwitch.bootstrapSwitch('state', false);
      return ctrSwitch.bootstrapSwitch('readonly', true);
    } else {
      return ctrSwitch.bootstrapSwitch('readonly', false);
    }
  };

  Campaigns.prototype.targetCTRControlInit = function() {
    var ctrAlert, ctrInput, ctrSwitch, minctrInput, minctrSwitch;
    ctrAlert = $('.ctr-alert');
    if (this.finTypeField.length === 0 || ctrAlert.length === 0) {
      return;
    }
    ctrInput = this.ctrField.first();
    ctrSwitch = this.ctrField.eq(1);
    minctrInput = this.minctrField.first();
    minctrSwitch = this.minctrField.eq(1);
    return this.finTypeField.on('change', (function(_this) {
      return function(e) {
        var alertText, self, showAlert, val;
        self = $(e.currentTarget);
        val = self.val();
        if ($.inArray(val, _this.financigTypesWithDisabledTargetCTR) !== -1) {
          alertText = __('financing.messages.type.conflict', {
            ":type": self.find('option:selected').text()
          });
          ctrAlert.text(alertText).css('color', '#962020');
          showAlert = false;
          if (ctrInput.length !== 0) {
            if (!ctrInput.attr('disabled')) {
              showAlert = true;
            } else {
              ctrInput.attr('disabled', true);
            }
            _this.toggleCTRSwitch(ctrSwitch, 'disable');
          }
          if (minctrInput.length !== 0) {
            if (!minctrInput.attr('disabled')) {
              showAlert = true;
            } else {
              minctrInput.attr('disabled', true);
            }
            _this.toggleCTRSwitch(minctrSwitch, 'disable');
          }
          if (showAlert) {
            return INTENT.utils.Notify.danger(alertText, {
              auto_hide: true
            });
          }
        } else {
          ctrAlert.text('');
          _this.toggleCTRSwitch(ctrSwitch, 'enable');
          return _this.toggleCTRSwitch(minctrSwitch, 'enable');
        }
      };
    })(this));
  };

  Campaigns.prototype.spendAsapControlInit = function() {
    var checkbox, parent, warn;
    checkbox = $(this.s.ATTR_SPEND_ASAP);
    parent = checkbox.closest('div.checkbox');
    warn = $('<i id="spend_asap_warn" title="' + __('campaigns.form.spend_asap.warn') + '" class="fa fa-exclamation-circle">');
    warn.css({
      "color": "#c9302c"
    }).tooltip({
      html: true
    }).hide();
    parent.append(warn);
    if (checkbox.is(':checked')) {
      warn.show();
    }
    return checkbox.on('change', (function(_this) {
      return function(e) {
        if (e.target.checked) {
          return warn.show();
        } else {
          return warn.hide();
        }
      };
    })(this));
  };

  Campaigns.prototype.excludeDomainsHandlerInit = function() {
    var handleCheckboxes, negativeTargetControl, targetControl;
    targetControl = $('#targeting_exclude_anonymous_domains');
    negativeTargetControl = $('#negative_targeting_exclude_anonymous_domains');
    handleCheckboxes = (function(_this) {
      return function(first, second, section) {
        return first.on('change', function(e) {
          var el;
          el = e.target;
          if (el.checked) {
            return second.prop('disabled', true).attr('checked', false).closest('label').prop('title', __('campaigns.message.exclude_domains.error', {
              ':label': $(el).closest('label').text().trim(),
              ':targeting': section
            })).tooltip();
          } else {
            return second.prop('disabled', false).closest('label').attr('title', null).tooltip('destroy');
          }
        });
      };
    })(this);
    handleCheckboxes(targetControl, negativeTargetControl, __('campaigns.form.campaign.section-targeting'));
    return handleCheckboxes(negativeTargetControl, targetControl, __('campaigns.form.campaign.section-negative-targeting'));
  };

  Campaigns.prototype.showModal = function() {
    var advertiserId, campaignId;
    campaignId = this.dynPriceBtn.attr('data-campaignId');
    advertiserId = this.dynPriceBtn.attr('data-advertiserId');
    if (!this.modal) {
      this.modal = $(INTENT.widgets.Campaigns.MODAL);
      this.modal.on('shown.bs.modal', (function(_this) {
        return function() {
          return _this.loadDynamicPriceData(advertiserId, campaignId);
        };
      })(this));
    }
    return this.modal.modal();
  };

  Campaigns.prototype.loadDynamicPriceData = function(advertiserId, campaignId) {
    var table;
    table = this.modal.find('#dynamic_price_data');
    return $.ajax({
      url: "/ajax/v2/campaigns/get_dynamic_prices",
      method: 'post',
      data: {
        campaign_id: campaignId,
        advertiser_id: advertiserId
      },
      beforeSend: (function(_this) {
        return function() {
          return Loader.show({
            target: "#dynamic_price_data-wrapper"
          });
        };
      })(this),
      complete: (function(_this) {
        return function() {
          return Loader.hide({
            target: "#dynamic_price_data-wrapper"
          });
        };
      })(this),
      success: (function(_this) {
        return function(data) {
          var i, item, j, key, len, len1, ref, ref1, results, tr, value;
          if (data.data && data.data.length) {
            table.find('tbody').empty();
            ref = data.data;
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
              item = ref[i];
              tr = $('<tr>');
              ref1 = ['size', 'domain', 'device', 'os', 'browser', 'ssp'];
              for (j = 0, len1 = ref1.length; j < len1; j++) {
                key = ref1[j];
                value = item.features[key] ? item.features[key] : '';
                tr.append($('<td><input readonly class="form-control" type="text" name="' + key + '[]" value="' + value + '"/></td>'));
              }
              tr.append($('<td><input readonly class="form-control" type="text" name="price[]" value="' + item.price + '"/></td>'));
              tr.append($('<td class="action"></td>'));
              results.push(table.find('tbody').append(tr));
            }
            return results;
          }
        };
      })(this)
    });
  };

  return Campaigns;

})();


/*
  Colorpicker widget
 */
INTENT.widgets.ColorPicker = (function() {
  ColorPicker.ATTR_NAME = "data-widget-colorpicker";

  function ColorPicker(el) {
    this.el = el;
    this.s = this.constructor;
    this.el.colorpicker(this.get_options());
  }

  ColorPicker.prototype.get_options = function() {
    return {};
  };

  return ColorPicker;

})();


/*
  Confirm widget
 */
INTENT.widgets.ConfirmAction = (function() {
  ConfirmAction.ATTR_NAME = "data-widget-confirm";

  function ConfirmAction(el) {
    this.el = el;
    this.s = this.constructor;
    this.message = this.el.attr(this.s.ATTR_NAME);
    this.el.on("click", (function(_this) {
      return function() {
        event.stopPropagation();
        return confirm(_this.message);
      };
    })(this));
  }

  return ConfirmAction;

})();

var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.Creative = (function() {
  Creative.ATTR_NAME = "data-widget-creative";

  Creative.ATTR_FIELDS = Creative.ATTR_NAME + "-moderated-fields";

  Creative.APPROVE_STATUS = 'approved';

  function Creative(el) {
    var fields, name, row;
    this.el = el;
    this.cancel = bind(this.cancel, this);
    this.confirm = bind(this.confirm, this);
    this.s = this.constructor;
    this.changed = false;
    fields = jQuery.parseJSON(this.el.attr(this.s.ATTR_FIELDS));
    for (name in fields) {
      row = fields[name];
      $("[name=" + name + "]").on("change", (function(_this) {
        return function() {
          return _this.changed = true;
        };
      })(this));
    }
    this.el.on('submit', (function(_this) {
      return function() {
        var message;
        if (_this.changed) {
          message = __('creative.moderation.status');
          show_confirm(message, _this.confirm, _this.cancel);
          if (_this.el.attr(_this.s.ATTR_NAME) !== _this.s.APPROVE_STATUS) {
            return false;
          }
        }
      };
    })(this));
  }

  Creative.prototype.confirm = function() {
    this.el.attr(this.s.ATTR_NAME, this.s.APPROVE_STATUS);
    this.el.find('[name="update"]').click();
    return true;
  };

  Creative.prototype.cancel = function() {
    this.el.attr(this.s.ATTR_NAME, '');
    return false;
  };

  return Creative;

})();

var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.CreativeGoogleStatusHistory = (function() {
  CreativeGoogleStatusHistory.ATTR_NAME = "data-widget-creative-gstatus-history";

  CreativeGoogleStatusHistory.ATTR_CREATIVE_ID = "data-creative-id";

  function CreativeGoogleStatusHistory(el) {
    this.el = el;
    this.show_history = bind(this.show_history, this);
    this.s = this.constructor;
    this.creative_id = $(this.el).attr("" + this.s.ATTR_CREATIVE_ID);
    if (!this.creative_id) {
      console.error("Invalid " + this.s.ATTR_CREATIVE_ID + " attribute value");
      return;
    }
    this.el.on("click", (function(_this) {
      return function() {
        return _this.show_history();
      };
    })(this));
  }

  CreativeGoogleStatusHistory.prototype.show_history = function() {
    this.el.showLoader();
    return $.getJSON("/ajax/creative_status_history", {
      creative_id: this.creative_id
    }).done((function(_this) {
      return function(resp) {
        var bodyrows, headrows, i, j, len, len1, modalSettings, ref, ref1, row, tdKey, tdVal, tdrows, thVal;
        _this.el.hideLoader();
        modalSettings = {
          title: __('creative.status.change_history'),
          body: INTENT.utils.Template.get_table(headrows, bodyrows),
          size: "large"
        };
        if (resp.error != null) {
          INTENT.utils.Notify.error(resp.error);
        }
        if (0 === resp.rowset.length) {
          modalSettings.body = INTENT.utils.Template.wrap_in_p(__('creative.status.history_is_empty'));
          INTENT.utils.Modal.show(modalSettings);
          return;
        }
        headrows = '';
        bodyrows = '';
        ref = resp.column_names;
        for (i = 0, len = ref.length; i < len; i++) {
          thVal = ref[i];
          headrows += INTENT.utils.Template.get_th_row(INTENT.utils.Helper.ucfirst(thVal));
        }
        ref1 = resp.rowset;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          row = ref1[j];
          tdrows = '';
          for (tdKey in row) {
            tdVal = row[tdKey];
            tdrows += INTENT.utils.Template.get_td_row(tdVal);
          }
          bodyrows += INTENT.utils.Template.get_tr_row(tdrows);
        }
        modalSettings.body = INTENT.utils.Template.get_table(headrows, bodyrows);
        return INTENT.utils.Modal.show(modalSettings);
      };
    })(this)).fail((function(_this) {
      return function() {
        return _this.el.hideLoader();
      };
    })(this));
  };

  return CreativeGoogleStatusHistory;

})();


/*
  Creative Moderation crud widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

INTENT.widgets.CreativeModeration = (function(superClass) {
  extend(CreativeModeration, superClass);

  CreativeModeration.prototype.screen_lock = function() {
    return null;
  };

  CreativeModeration.prototype.screen_unlock = function() {
    return null;
  };

  CreativeModeration.prototype.popup_display = function() {
    var reason, reason_text_en, reason_text_ru, request, url;
    reason = this.reason;
    reason_text_ru = this.reason_text_ru;
    reason_text_en = this.reason_text_en;
    console.log(reason_text_ru, reason_text_en);
    url = "/ajax/get_moderation_modal?id=" + (this.get_creative_id());
    if (reason) {
      url = url + ("&reason=" + reason);
    }
    if (reason_text_ru) {
      url = url + ("&reason_text_ru=" + reason_text_ru);
    }
    if (reason_text_en) {
      url = url + ("&reason_text_en=" + reason_text_en);
    }
    request = $.ajax({
      url: url,
      type: "get",
      dataType: "html"
    });
    return request.done((function(_this) {
      return function(data) {
        _this.show_modal(data);
        return CreativeModeration.__super__.popup_display.call(_this);
      };
    })(this));
  };

  CreativeModeration.MODAL = "#modal_moderation";

  CreativeModeration.VAST_INFO_API = "/ajax/vast_info";

  CreativeModeration.ATTR_NAME = "data-widget-creative-moderation";

  CreativeModeration.ATTR_REASON = CreativeModeration.ATTR_NAME + "-reason";

  CreativeModeration.ATTR_REASON_TEXT_RU = CreativeModeration.ATTR_REASON + "-text-ru";

  CreativeModeration.ATTR_REASON_TEXT_EN = CreativeModeration.ATTR_REASON + "-text-en";

  CreativeModeration.ATTR_NAME_FORM = CreativeModeration.ATTR_NAME + "-form";

  CreativeModeration.ATTR_ONCE_CLICK = CreativeModeration.ATTR_NAME + "-one-click";

  CreativeModeration.ATTR_SHOW = CreativeModeration.ATTR_NAME + "-show";

  CreativeModeration.RECHECK_SSP_FORM = '#recheck_ssp';

  function CreativeModeration(el1) {
    this.el = el1;
    this.popup_close = bind(this.popup_close, this);
    this.success_submit_row = bind(this.success_submit_row, this);
    this.submit_row = bind(this.submit_row, this);
    this.preview_from_self = bind(this.preview_from_self, this);
    this.popup_display = bind(this.popup_display, this);
    this.screen_unlock = bind(this.screen_unlock, this);
    this.screen_lock = bind(this.screen_lock, this);
    this.s = this.constructor;
    this.el.on("submit", "form", this.submit_row);
    this.canSubmit = false;
    $(this.s.RECHECK_SSP_FORM).on('submit', (function(_this) {
      return function(e) {
        return _this.recheck_ssp(e);
      };
    })(this));
    CreativeModeration.__super__.constructor.call(this, this.el);
  }

  CreativeModeration.prototype.preview_from_self = function(self) {
    this.uncollapse = 1 * self.attr(INTENT.widgets.CreativeModeration.ATTR_SHOW);
    this.reason = self.attr(this.s.ATTR_REASON);
    this.reason_text_ru = self.attr(this.s.ATTR_REASON_TEXT_RU);
    this.reason_text_en = self.attr(this.s.ATTR_REASON_TEXT_EN);
    return CreativeModeration.__super__.preview_from_self.call(this, self);
  };

  CreativeModeration.prototype.submit_row = function(e) {
    var form, request, self;
    self = this;
    form = $(e.currentTarget);
    request = $.ajax({
      url: form.attr("action"),
      type: form.attr("method"),
      data: form.serialize(),
      dataType: "json"
    });
    request.done(function(xhr) {
      return self.success_submit_row(form, xhr);
    });
    return false;
  };

  CreativeModeration.prototype.success_submit_row = function(form, xhr) {
    var id;
    id = this.get_creative_id();
    init_creative_content_tags('select[name="content_tags\\[\\]"]');
    $('select[name="content_tags\\[\\]"]').select2('val', xhr.fields.content_tags);
    $('.creative-moderation-buttons').find("[data-widget-creative-moderation-reason][data-preview-creative=" + id + "]").removeClass('active');
    $('.creative-moderation-buttons').find("[data-widget-creative-moderation-reason][data-preview-creative=" + id + "]").each(function() {
      var self;
      self = $(this);
      if (xhr.fields.moderation_status === self.attr('data-widget-creative-moderation-reason')) {
        return self.addClass('active');
      }
    });
    $('#creative-statuses-info').replaceWith(xhr.html_line_statuses);
    $("[data-creative-moderation-status='" + xhr.id + "']").html(xhr.fields.moderation_status_text);
    if (xhr.fields.moderation_status !== 'REJECTED') {
      $("[data-creative-moderation-status='" + xhr.id + "']").removeClass('dotted');
    }
    return this.popup_close();
  };

  CreativeModeration.prototype.popup_close = function() {
    this.modal.modal('hide');
    return CreativeModeration.__super__.popup_close.call(this);
  };

  CreativeModeration.prototype.init_handlers = function() {
    init_radio_block();
    $('select.select2-init').select2({
      minimumResultsForSearch: -1
    });
    return $(document).one('init-global-scope', (function(_this) {
      return function() {
        return init_creative_content_tags('select[name="content_tags\\[\\]"]');
      };
    })(this));
  };

  CreativeModeration.prototype.update_view = function(status) {
    var elements, status_value;
    if (status == null) {
      status = null;
    }
    elements = this.modal.find("[data-show-on]");
    elements.addClass('hide');
    status_value = status.val();
    return elements.each(function() {
      var el;
      el = $(this);
      if (el.attr('data-show-on') === status_value) {
        return el.removeClass('hide');
      }
    });
  };

  CreativeModeration.prototype.prepare_view = function() {
    var status;
    status = this.modal.find("[data-status]");
    this.update_view(status);
    return this.timer = setInterval((function(_this) {
      return function() {
        return _this.update_view(status);
      };
    })(this), 100);
  };

  CreativeModeration.prototype.show_modal = function(data) {
    var form;
    clearInterval(this.timer);
    if (!this.modal) {
      this.modal = $(INTENT.widgets.CreativeModeration.MODAL);
    }
    form = this.modal.find('[' + INTENT.widgets.CreativeModeration.ATTR_NAME_FORM + ']');
    form.html(data);
    if (this.uncollapse) {
      form.find('.accordion-body').addClass('in');
    }
    this.modal.modal();
    this.init_handlers();
    return this.prepare_view();
  };

  CreativeModeration.prototype.recheck_ssp = function(e) {
    var el, instance, submitAction;
    instance = this;
    if (!instance.canSubmit) {
      el = $(e.target);
      submitAction = function(val) {
        instance.canSubmit = true;
        el.find("[name='renew_revision']").val(val);
        return el.submit();
      };
      show_confirm(__('recheck_ssp.confirmation'), function() {
        return submitAction(1);
      }, function() {
        return submitAction(0);
      }, __('btn.yes'), __('btn.no'));
      return false;
    }
    return true;
  };

  return CreativeModeration;

})(INTENT.widgets.CreativeViewer);

var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.CreativeOnArchiveWarning = (function() {
  CreativeOnArchiveWarning.ATTR_NAME = "data-widget-creative-on-archive-warn";

  CreativeOnArchiveWarning.ATTR_ARCHIVE_TARGET = "data-archive-target";

  CreativeOnArchiveWarning.ATTR_ACTIVE_CAMPAIGNS = "data-active-campaigns-with-this-creative";

  CreativeOnArchiveWarning.ATTR_ACTIVE_CAMPAIGNS_TARGET = "data-active-campaigns-with-this-creative-target";

  CreativeOnArchiveWarning.forcedArchive = false;

  CreativeOnArchiveWarning.form = null;

  function CreativeOnArchiveWarning(el) {
    var activeCampaigns;
    this.el = el;
    this.performArchiveAction = bind(this.performArchiveAction, this);
    this.initModal = bind(this.initModal, this);
    this.s = this.constructor;
    if (!this.el.is("[" + this.s.ATTR_ACTIVE_CAMPAIGNS_TARGET + "]")) {
      return;
    }
    try {
      activeCampaigns = JSON.parse($(this.el.attr("" + this.s.ATTR_ACTIVE_CAMPAIGNS_TARGET)).attr(this.s.ATTR_ACTIVE_CAMPAIGNS));
    } catch (error) {
      return;
    }
    this.el.get(0).onclick = function() {};
    if (this.el.is("[data-delete-object]")) {
      this.el.off('click');
    }
    this.el.on('click', (function(_this) {
      return function(e) {
        _this.el = $(e.currentTarget);
        if (_this.s.forcedArchive) {
          return;
        }
        e.preventDefault();
        return _this.initModal(activeCampaigns);
      };
    })(this));
    $(INTENT.utils.Modal.SELECTOR_TEMPLATE_ID).off('show.bs.modal');
    $(INTENT.utils.Modal.SELECTOR_TEMPLATE_ID).on('show.bs.modal', function() {
      return $('.archive-info').tooltip();
    });
  }

  CreativeOnArchiveWarning.prototype.initModal = function(activeCampaigns) {
    var body, creativeString, headRows, modalSettings, parent, rows, tpl, warnAboutStopCampaigns;
    rows = [];
    tpl = INTENT.utils.Template;
    warnAboutStopCampaigns = _.size(_.filter(activeCampaigns, function(item) {
      return item.is_only;
    })) > 0;
    modalSettings = {
      title: __('creative_archive_warning_title'),
      body: '',
      size: 'large',
      buttons: [
        {
          attr: {
            "class": "cr-forced-archive btn btn-danger pull-left",
            type: "button"
          },
          click: (function(_this) {
            return function() {
              _this.s.forcedArchive = true;
              $('.cr-forced-archive').showLoader();
              return _this.performArchiveAction("" + (_this.el.attr('href')) + (INTENT.utils.Url.asString({
                forced: 1
              })));
            };
          })(this),
          text: warnAboutStopCampaigns ? __('creative_archive_warning_btn') : __('archive')
        }
      ]
    };
    $.each(activeCampaigns, function(id, cmp) {
      var td;
      if ('id' in cmp && 'name' in cmp && 'ar' in cmp) {
        td = '';
        td += tpl.get_td_row("#" + cmp.id, {
          style: 'width:10%;'
        });
        td += tpl.get_td_row(tpl.wrap_link("/campaigns/advertisers/" + cmp.ar + "/campaigns/edit/" + cmp.id, cmp.name, '', '_blank'));
        td += tpl.get_td_row((cmp.is_only ? (__('yes')) + " <i title='" + (__("creative_onarchive_campaign_will_stop")) + "' class='archive-info fa fa-info-circle opacity-dynamic'></i>" : __('no')), {
          style: 'text-align:center;width:25%;'
        });
        return rows.push(tpl.get_tr_row(td));
      }
    });
    headRows = [
      tpl.get_td_row("<strong>id</strong>", {
        style: 'width:10%;'
      }), tpl.get_td_row("<strong>" + (__('name')) + "</strong>"), tpl.get_td_row("<strong>" + (__('campaigns.will_be_stopped')) + "?</strong>", {
        style: 'text-align:center;width:25%;'
      })
    ].join('');
    creativeString = '';
    parent = this.el.parents('tr');
    if (parent.length && parent.data('creativesId') && parent.data('creativesName')) {
      creativeString = "<strong>#" + (parent.data('creativesId')) + " " + (parent.data('creativesName')) + "</strong>";
    }
    body = [
      tpl.wrap_in_p(__('active_campaigns_with_creative', {
        ':creative': creativeString
      })), tpl.get_table(headRows, rows.join(''))
    ];
    modalSettings.body += body.join("");
    return INTENT.utils.Modal.show(modalSettings);
  };

  CreativeOnArchiveWarning.prototype.performArchiveAction = function(url) {
    if (-1 === url.indexOf('_ajax')) {
      window.location.href = url;
    }
    return $.ajax({
      url: url,
      method: 'POST'
    }).done((function(_this) {
      return function(resp) {
        var modal;
        _this.s.forcedArchive = false;
        $('.cr-forced-archive').hideLoader();
        INTENT.utils.Modal.close();
        try {
          if ((resp.payload != null) && (resp.payload.modal != null)) {
            modal = {
              title: resp.payload.modal.title,
              body: resp.payload.modal.body
            };
            return INTENT.utils.Modal.show(modal);
          } else if ((resp.notify != null) && (resp.notify.type != null) && (resp.notify.message != null)) {
            INTENT.utils.Notify.message(resp.notify.message, resp.notify.type, {
              fadeOut: {
                delay: 5000
              }
            });
            if (_this.el.is("[" + _this.s.ATTR_ARCHIVE_TARGET + "]")) {
              return $("" + (_this.el.attr(_this.s.ATTR_ARCHIVE_TARGET))).remove();
            }
          } else if ((resp.err != null) && (resp.msg != null)) {
            modal = {
              title: __('admin.creative.confirm.title'),
              body: resp.msg
            };
            return INTENT.utils.Modal.show(modal);
          }
        } catch (error) {

        }
      };
    })(this));
  };

  return CreativeOnArchiveWarning;

})();

var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.CreativeUpdateWarning = (function() {
  CreativeUpdateWarning.ATTR_NAME = "data-widget-creative-on-update-warn";

  CreativeUpdateWarning.ATTR_ACTIVE_CAMPAIGNS = "data-active-campaigns-with-this-creative";

  CreativeUpdateWarning.ATTR_IS_CREATIVE_MODERATOR = "data-is-creative-moderator";

  CreativeUpdateWarning.ATTR_ACTIVE_CAMPAIGNS_TARGET = "data-active-campaigns-with-this-creative-target";

  CreativeUpdateWarning.ATTR_IS_ORD_CONFIRM_TEXT = "data-update-confirm-ord-version";

  CreativeUpdateWarning.SELECTOR_EDIT_FORM = '#main_form';

  CreativeUpdateWarning.forcedUpdate = false;

  CreativeUpdateWarning.form = null;

  function CreativeUpdateWarning(el) {
    var activeCampaigns;
    this.el = el;
    this.initModal = bind(this.initModal, this);
    this.s = this.constructor;
    this.form = $(this.s.SELECTOR_EDIT_FORM);
    activeCampaigns = [];
    if (this.el.is("[" + this.s.ATTR_ACTIVE_CAMPAIGNS_TARGET + "]")) {
      activeCampaigns = JSON.parse($(this.el.attr("" + this.s.ATTR_ACTIVE_CAMPAIGNS_TARGET)).attr(this.s.ATTR_ACTIVE_CAMPAIGNS));
    }
    activeCampaigns = _.filter(activeCampaigns, function(item) {
      return item.is_only;
    });
    this.el.on('click', (function(_this) {
      return function(e) {
        var errorTextValidateCreativeForm, submitButtonName;
        submitButtonName = 'apply_data';
        if (e.currentTarget.name) {
          submitButtonName = e.currentTarget.name;
        }
        errorTextValidateCreativeForm = INTENT.utils.CreativesValidation.validateForm();
        if (errorTextValidateCreativeForm !== '') {
          INTENT.utils.Forms.disable_submit_buttons_loader();
          return;
        }
        if (_this.s.forcedUpdate) {
          return;
        }
        e.preventDefault();
        return _this.initModal(activeCampaigns, submitButtonName);
      };
    })(this));
  }

  CreativeUpdateWarning.prototype.initModal = function(activeCampaigns, submitButtonName) {
    var body, headRows, is_moderator, modalSettings, postfixConfirmTextByORD, rows, tpl;
    if (submitButtonName == null) {
      submitButtonName = 'apply_data';
    }
    rows = [];
    tpl = INTENT.utils.Template;
    is_moderator = parseInt(this.el.attr("" + this.s.ATTR_IS_CREATIVE_MODERATOR)) === 1 ? true : false;
    postfixConfirmTextByORD = parseInt(this.el.attr("" + this.s.ATTR_IS_ORD_CONFIRM_TEXT)) === 1 ? '_ord' : '_no_ord';
    modalSettings = {
      title: __('creative_update_warning_title'),
      body: tpl.wrap_in_p((is_moderator ? __('creative_update_premoderation_warning_for_moderators') : __('creative_update_premoderation_warning' + postfixConfirmTextByORD))),
      size: 'large',
      buttons: [
        {
          attr: {
            "class": "cr-forced-update btn btn-danger pull-left",
            type: "button"
          },
          click: (function(_this) {
            return function() {
              _this.forcedUpdate = true;
              $('.cr-forced-update').showLoader();
              _this.form.append($("<input/>", {
                type: 'hidden',
                name: submitButtonName,
                value: '.'
              }));
              return _this.form.submit();
            };
          })(this),
          text: __('send_to_moderation_and_stop_serve' + postfixConfirmTextByORD)
        }
      ],
      onClose: (function(_this) {
        return function() {
          return INTENT.utils.Forms.disable_submit_buttons_loader();
        };
      })(this)
    };
    if (!_.size(activeCampaigns)) {
      return INTENT.utils.Modal.show(modalSettings);
    }
    $.each(activeCampaigns, function(id, cmp) {
      var td;
      if ('id' in cmp && 'name' in cmp && 'ar' in cmp) {
        td = '';
        td += tpl.get_td_row("#" + cmp.id, {
          style: 'width:20%;'
        });
        td += tpl.get_td_row(tpl.wrap_link("/campaigns/advertisers/" + cmp.ar + "/campaigns/edit/" + cmp.id, cmp.name, '', '_blank'));
        return rows.push(tpl.get_tr_row(td));
      }
    });
    headRows = [
      tpl.get_td_row("<strong>id</strong>", {
        style: 'width:20%;'
      }), tpl.get_td_row("<strong>" + (__('name')) + "</strong>")
    ].join('');
    body = [tpl.wrap_in_p(__('active_campaigns_with_this_creative')), tpl.get_table(headRows, rows.join(''))];
    modalSettings.buttons[0].text = __('send_to_moderation_and_stop_campaigns');
    modalSettings.body += body.join("");
    return INTENT.utils.Modal.show(modalSettings);
  };

  return CreativeUpdateWarning;

})();


/*
  CRUD Segment widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.CrudSegment = (function() {
  CrudSegment.ATTR_NAME = "data-widget-crud-segments";

  CrudSegment.ATTR_ID = CrudSegment.ATTR_NAME + "-id";

  CrudSegment.ATTR_JSON = CrudSegment.ATTR_NAME + "-json";

  CrudSegment.ATTR_VALUES = CrudSegment.ATTR_NAME + "-values";

  CrudSegment.ATTR_LOADING_STATE = CrudSegment.ATTR_NAME + "-loading";

  CrudSegment.ATTR_ADVERTISER_ID = CrudSegment.ATTR_NAME + "-advertiser-id";

  CrudSegment.ATTR_MODE = CrudSegment.ATTR_NAME + "-mode";

  CrudSegment.ATTR_MODE_SWITCHER = CrudSegment.ATTR_MODE + "-switcher";

  CrudSegment.ATTR_TERM = CrudSegment.ATTR_NAME + "-terms";

  CrudSegment.ATTR_TERM_ID = CrudSegment.ATTR_TERM + "-id";

  CrudSegment.ATTR_TERMS_ADD = CrudSegment.ATTR_TERM + "-add";

  CrudSegment.ATTR_TERMS_REMOVE = CrudSegment.ATTR_TERM + "-remove";

  CrudSegment.ATTR_TERMS_VALUES = CrudSegment.ATTR_TERM + "-values";

  CrudSegment.ATTR_TERMS_TYPE = CrudSegment.ATTR_TERM + "-type";

  CrudSegment.ATTR_TERMS_CONTAINER = CrudSegment.ATTR_TERM + "-container";

  CrudSegment.CLASS_ERROR = "error-input-field";

  function CrudSegment(el1) {
    this.el = el1;
    this.add_item = bind(this.add_item, this);
    this.remove_item = bind(this.remove_item, this);
    this.get_variants = bind(this.get_variants, this);
    this.load_variants = bind(this.load_variants, this);
    this.displaying_delete = bind(this.displaying_delete, this);
    this.init_exist = bind(this.init_exist, this);
    this.get_last_id = bind(this.get_last_id, this);
    this.get_origin_values = bind(this.get_origin_values, this);
    this.update_mode_page = bind(this.update_mode_page, this);
    this.get_advertiser_id = bind(this.get_advertiser_id, this);
    this.get_json = bind(this.get_json, this);
    this.s = this.constructor;
    this.segment_id = parseInt(this.el.attr(this.s.ATTR_ID));
    this.mode_switcher = this.el.find("[" + this.s.ATTR_MODE_SWITCHER + "]");
    this.mode_pages_collection = this.el.find("[" + this.s.ATTR_MODE + "]");
    this.terms_add = this.el.find("[" + this.s.ATTR_TERMS_ADD + "]");
    this.terms_container = this.el.find("[" + this.s.ATTR_TERMS_CONTAINER + "]");
    this.terms_container.on("click", "[" + this.s.ATTR_TERMS_REMOVE + "]", this.remove_item);
    this.terms_add.on("click", this.add_item);
    this.terms_add.hide();
    this.mode_switcher.on("change", (function(_this) {
      return function() {
        return _this.update_mode_page();
      };
    })(this));
    this.form = this.el.find("form");
    this.update_mode_page();
    $(document).on("keyup", '[name$="[days]"]', (function(_this) {
      return function(e) {
        var el;
        el = e.currentTarget;
        if (parseInt(el.value) > 30) {
          return e.currentTarget.value = 30;
        }
      };
    })(this));
    this.el.on('change', "[" + this.s.ATTR_TERMS_TYPE + "]", (function(_this) {
      return function(e) {
        var container, id, parent_tr, self, tpl;
        self = $(e.currentTarget);
        parent_tr = self.parents('tr');
        container = parent_tr.find("[" + _this.s.ATTR_TERMS_VALUES + "]");
        id = parseInt(parent_tr.attr(_this.s.ATTR_TERM_ID));
        tpl = INTENT.templates.CrudSegment.get_values_control(_this, id, self.val(), _this.get_json(), _this.get_origin_values());
        container.html(tpl);
        _this.displaying_delete();
        init_numbers_fields();
        return init_select2();
      };
    })(this));
  }

  CrudSegment.prototype.get_json = function() {
    var json;
    if (!this.json) {
      json = this.el.attr(this.s.ATTR_JSON);
      this.json = jQuery.parseJSON(json);
    }
    return this.json;
  };

  CrudSegment.prototype.get_advertiser_id = function() {
    var id;
    id = this.el.attr(this.s.ATTR_ADVERTISER_ID);
    return parseInt(id);
  };

  CrudSegment.prototype.update_mode_page = function() {
    var current, inputs_others, page;
    this.mode_pages_collection.hide();
    current = this.mode_switcher.val();
    page = this.mode_pages_collection.filter("[" + this.s.ATTR_MODE + "='" + current + "']");
    inputs_others = this.mode_pages_collection.filter("[" + this.s.ATTR_MODE + "][" + this.s.ATTR_MODE + "!='" + current + "']").find("input,select");
    inputs_others.attr('disabled', 'disabled');
    page.find('input,select').removeAttr('disabled');
    page.show();
    if (current === 'standard') {
      INTENT.utils.Forms.disable_submit_buttons();
      this.el.attr(this.s.ATTR_LOADING_STATE, true);
      return this.load_variants().done((function(_this) {
        return function(list) {
          _this.init_exist();
          _this.terms_add.show();
          _this.el.removeAttr(_this.s.ATTR_LOADING_STATE);
          INTENT.utils.Forms.enable_submit_buttons();
          return _this.displaying_delete();
        };
      })(this));
    } else {
      return INTENT.utils.Forms.enable_submit_buttons();
    }
  };

  CrudSegment.prototype.get_origin_values = function() {
    var origin_values;
    if (!this.origin_values) {
      origin_values = this.el.attr(this.s.ATTR_VALUES);
      this.origin_values = jQuery.parseJSON(origin_values);
    }
    return this.origin_values;
  };

  CrudSegment.prototype.get_last_id = function() {
    var last_id;
    if (!this.terms_container.find('tr').length) {
      return 0;
    }
    last_id = parseInt(this.terms_container.find('tr:last').attr(this.s.ATTR_TERM_ID));
    return last_id + 1;
  };

  CrudSegment.prototype.init_exist = function() {
    var ex_index, ex_term, exists_terms, id, item;
    this.terms_container.empty();
    exists_terms = this.get_origin_values();
    if (exists_terms.length > 0) {
      for (ex_index in exists_terms) {
        ex_term = exists_terms[ex_index];
        id = this.get_last_id();
        item = INTENT.templates.CrudSegment.get_term(this, id, this.get_json(), ex_term);
        this.terms_container.append(item);
      }
    } else {
      this.add_item();
    }
    return init_select2();
  };

  CrudSegment.prototype.displaying_delete = function() {
    var tr_collection, tr_count;
    tr_collection = this.terms_container.find("[" + this.s.ATTR_TERMS_REMOVE + "]");
    tr_count = tr_collection.length;
    if (tr_count > 1) {
      return tr_collection.fadeIn('fast');
    } else {
      return tr_collection.fadeOut('fast');
    }
  };

  CrudSegment.prototype.load_variants = function() {
    var dfd, params;
    dfd = $.Deferred();
    params = {
      url: '/ajax/get_segment_partial',
      type: 'POST',
      dataType: 'json',
      data: {
        'advertiser_id': this.get_advertiser_id(),
        'segment_id': this.segment_id
      }
    };
    $.ajax(params).done((function(_this) {
      return function(xhr) {
        _this.variants = xhr;
        return dfd.resolve(_this.variants);
      };
    })(this));
    return dfd.promise();
  };

  CrudSegment.prototype.get_variants = function(type) {
    return this.variants[type] || [];
  };

  CrudSegment.prototype.remove_item = function(e) {
    var self;
    self = $(e.currentTarget);
    self.parents("tr").remove();
    this.displaying_delete();
    return false;
  };

  CrudSegment.prototype.add_item = function() {
    var id, item;
    id = this.get_last_id();
    item = INTENT.templates.CrudSegment.get_term(this, id, this.get_json());
    this.terms_container.append(item);
    this.displaying_delete();
    init_select2();
    init_numbers_fields();
    return false;
  };

  return CrudSegment;

})();


/*
  CRUD Sites widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.CrudSite = (function() {
  CrudSite.ATTR_NAME = "data-widget-crud-site";

  CrudSite.ATTR_JSON = CrudSite.ATTR_NAME + "-json";

  CrudSite.ATTR_VALUES = CrudSite.ATTR_NAME + "-values";

  CrudSite.ATTR_CPA_CONTROLS = CrudSite.ATTR_NAME + "-enable-cpa-controls";

  CrudSite.CLASS_ERROR = "error-input-field";

  CrudSite.ATTR_ANALYTICS = CrudSite.ATTR_NAME + "-analytics";

  CrudSite.ATTR_ANALYTICS_AUTH = CrudSite.ATTR_ANALYTICS + "-auth";

  CrudSite.ATTR_ANALYTICS_SOURCE = CrudSite.ATTR_ANALYTICS + "-source";

  CrudSite.ATTR_ANALYTICS_ADVERTISER = CrudSite.ATTR_ANALYTICS + "-advertiser";

  CrudSite.ATTR_ANALYTICS_SITE = CrudSite.ATTR_ANALYTICS + "-site";

  CrudSite.ATTR_ANALYTICS_METHOD = CrudSite.ATTR_ANALYTICS + "-method";

  CrudSite.ATTR_RULE = CrudSite.ATTR_NAME + "-rule";

  CrudSite.ATTR_RULE_ADD = CrudSite.ATTR_RULE + "-add";

  CrudSite.ATTR_RULE_REMOVE = CrudSite.ATTR_RULE + "-remove";

  CrudSite.ATTR_RULE_TYPES = CrudSite.ATTR_RULE + "-types";

  CrudSite.ATTR_RULE_NAME = CrudSite.ATTR_RULE + "-name";

  CrudSite.ATTR_RULE_MAX_CONVERSIONS_NUMBER = CrudSite.ATTR_RULE + "-max_conversions_number";

  CrudSite.ATTR_RULE_ID = CrudSite.ATTR_RULE + "-id";

  CrudSite.ATTR_RULE_ADDITIONAL = CrudSite.ATTR_RULE + "-additional";

  CrudSite.ATTR_RULE_ADDITIONAL_FIELD = CrudSite.ATTR_RULE_ADDITIONAL + "-field";

  CrudSite.ATTR_RULE_CONTAINER = CrudSite.ATTR_RULE + "-container";

  CrudSite.ATTR_GET_ORD_FEED_PRODUCT_STATUSES = CrudSite.ATTR_NAME + "-get-ord-feed-statuses";

  CrudSite.ATTR_GET_BLOCK_FOR_PRODUCT_STATUSES = CrudSite.ATTR_NAME + "-block-for-ord-feed-statuses";

  CrudSite.ATTR_GET_BLOCK_FOR_PRODUCT_STATUSES_LOADING = CrudSite.ATTR_NAME + "-get-ord-feed-statuses-loading";

  CrudSite.ATTR_GET_ORD_FEED_PRODUCT_STATUSES_SITE = CrudSite.ATTR_GET_ORD_FEED_PRODUCT_STATUSES + "-site";

  function CrudSite(el) {
    this.el = el;
    this.add_item = bind(this.add_item, this);
    this.init_exist = bind(this.init_exist, this);
    this.prevalidate_convertion_rules = bind(this.prevalidate_convertion_rules, this);
    this.remove_item = bind(this.remove_item, this);
    this.change_type = bind(this.change_type, this);
    this.get_last_id = bind(this.get_last_id, this);
    this.show_cpa_controls = bind(this.show_cpa_controls, this);
    this.get_origin_values = bind(this.get_origin_values, this);
    this.get_json = bind(this.get_json, this);
    this.open_analytics_modal = bind(this.open_analytics_modal, this);
    this.analytics_auth = bind(this.analytics_auth, this);
    this.get_ord_feed_product_statuses_func = bind(this.get_ord_feed_product_statuses_func, this);
    this.s = this.constructor;
    this.form = this.el.find("form");
    this.analytics_auth_btn = this.el.find("[" + this.s.ATTR_ANALYTICS_AUTH + "]");
    this.analytics_source = this.el.find("[" + this.s.ATTR_ANALYTICS_SOURCE + "]");
    this.analytics_advertiser = this.analytics_auth_btn.attr(this.s.ATTR_ANALYTICS_ADVERTISER);
    this.analytics_site = this.analytics_auth_btn.attr(this.s.ATTR_ANALYTICS_SITE);
    this.analytics_method = this.analytics_auth_btn.attr(this.s.ATTR_ANALYTICS_METHOD);
    this.rules_add = this.el.find("[" + this.s.ATTR_RULE_ADD + "]");
    this.rules_container = this.el.find("[" + this.s.ATTR_RULE_CONTAINER + "]");
    this.rules_container.on("click", "[" + this.s.ATTR_RULE_REMOVE + "]", this.remove_item);
    this.rules_add.on("click", this.add_item);
    this.rules_container.on("change", "[" + this.s.ATTR_RULE_TYPES + "]", this.change_type);
    this.analytics_auth_btn.on("click", this.analytics_auth);
    this.get_ord_feed_product_statuses = this.el.find("[" + this.s.ATTR_GET_ORD_FEED_PRODUCT_STATUSES + "]");
    this.get_ord_feed_product_statuses_site = this.get_ord_feed_product_statuses.attr(this.s.ATTR_GET_ORD_FEED_PRODUCT_STATUSES_SITE);
    this.get_ord_feed_product_statuses_block = this.el.find("[" + this.s.ATTR_GET_BLOCK_FOR_PRODUCT_STATUSES + "]");
    this.get_ord_feed_product_statuses_loading = this.el.find("[" + this.s.ATTR_GET_BLOCK_FOR_PRODUCT_STATUSES_LOADING + "]");
    this.get_ord_feed_product_statuses.on("click", this.get_ord_feed_product_statuses_func);
    $('.submit-button').on('click', (function(_this) {
      return function(e) {
        _this.btnSubmit = $(e.target);
        return _this.prevalidate_convertion_rules();
      };
    })(this));
    $(document).on('change', '.deduplication-window', (function(_this) {
      return function(e) {
        var disabled, input;
        input = $(e.target).parents('.select2-input-group').find('input');
        disabled = $(e.target).val() === 'disabled' ? true : false;
        return input.attr({
          'disabled': disabled
        });
      };
    })(this));
    $('#predictor-start-date').datetimepicker({
      format: "YYYY-MM-DD"
    });
    $(document).on('switchChange.bootstrapSwitch', '.build-cpa-model', (function(_this) {
      return function(e) {
        if ($('.build-cpa-model:checked').length > 2) {
          $(e.target).bootstrapSwitch('state', false);
          return INTENT.utils.Notify.error(__('sites.conversion_rules.table.build_cpa_model.error.message'));
        }
      };
    })(this));
    this.init_exist();
  }

  CrudSite.prototype.get_ord_feed_product_statuses_func = function() {
    var error_html;
    this.get_ord_feed_product_statuses_loading.css({
      display: 'block'
    });
    this.get_ord_feed_product_statuses.css({
      display: 'none'
    });
    this.get_ord_feed_product_statuses_block.html('');
    error_html = '<div id="ord-alert-danger" class="alert-danger alert-ord-notification" style="margin-top: 0px">';
    $.ajax({
      url: "/api/v3/feed_product_statuses/" + this.get_ord_feed_product_statuses_site,
      dataType: 'json',
      method: 'get',
      success: (function(_this) {
        return function(data) {
          var greenColor, html_text, ord_statuses_manual_load, padding_top, redColor, yellowColor;
          if (data.hasOwnProperty('data') && Object.keys(data.data).length > 0) {
            ord_statuses_manual_load = ['Active', 'Failed', 'Error', 'Empty'];
            redColor = '#a94442';
            greenColor = '#398339';
            yellowColor = '#dc9d00';
            padding_top = '2px';
            html_text = '<div class="alert-gray alert-ord-notification" style="margin-top: 0px">';
            if (data.data.hasOwnProperty('Active')) {
              html_text += '<div style="color: ' + greenColor + '; padding-top:' + padding_top + '">Active: ' + data.data.Active + '</div>';
            }
            if (data.data.hasOwnProperty('Failed')) {
              html_text += '<div style="color: ' + redColor + '; padding-top:' + padding_top + '">Failed: ' + data.data.Failed + '</div>';
            }
            if (data.data.hasOwnProperty('Error')) {
              html_text += '<div style="color: ' + redColor + '; padding-top: ' + padding_top + '">Error: ' + data.data.Error + '</div>';
            }
            if (data.data.hasOwnProperty('Empty')) {
              html_text += '<div style="padding-top: ' + padding_top + '">Empty: ' + data.data.Empty + '</div>';
            }
            $.each(data.data, function(key, item) {
              if (!ord_statuses_manual_load.includes(key)) {
                return html_text += '<div style="color: ' + yellowColor + '; padding-top:' + padding_top + '">' + key + ': ' + item + '</div>';
              }
            });
            html_text += '</div>';
            _this.get_ord_feed_product_statuses_block.html(html_text);
          } else {
            _this.get_ord_feed_product_statuses_block.html(error_html + __('sites.get-ord-feed-statuses.error') + '</div>');
          }
          _this.get_ord_feed_product_statuses_block.html(html_text);
          _this.get_ord_feed_product_statuses_loading.css({
            display: 'none'
          });
          return _this.get_ord_feed_product_statuses.css({
            display: 'block'
          });
        };
      })(this),
      error: (function(_this) {
        return function(jqXHR, textStatus, errorThrown) {
          if (jqXHR.hasOwnProperty('responseJSON') && jqXHR.responseJSON.hasOwnProperty('error') && jqXHR.responseJSON.error !== null && jqXHR.responseJSON.error !== 'null' && jqXHR.responseJSON.error.length > 0) {
            _this.get_ord_feed_product_statuses_block.html(error_html + jqXHR.responseJSON.error + '</div>');
          } else {
            _this.get_ord_feed_product_statuses_block.html(error_html + __('sites.get-ord-feed-statuses.error') + '</div>');
          }
          _this.get_ord_feed_product_statuses_loading.css({
            display: 'none'
          });
          return _this.get_ord_feed_product_statuses.css({
            display: 'block'
          });
        };
      })(this)
    });
    return false;
  };

  CrudSite.prototype.analytics_auth = function() {
    var action, analytics_source;
    analytics_source = this.analytics_source.val();
    action = window.location.href.indexOf("/new") !== -1 ? 'new' : 'update';
    if (action === 'new') {
      this.open_analytics_modal('', action);
      return false;
    }
    $.ajax({
      url: ("/api/v3/user/analytics_auth_url?site_id=" + this.analytics_site + "&type=" + this.analytics_method + "&source=" + analytics_source + "&callback_uri=") + window.location.href,
      dataType: 'json',
      method: 'get',
      success: (function(_this) {
        return function(data) {
          return _this.open_analytics_modal(data.url, action);
        };
      })(this),
      error: (function(_this) {
        return function(jqXHR, textStatus, errorThrown) {};
      })(this)
    });
    return false;
  };

  CrudSite.prototype.open_analytics_modal = function(url, action) {
    var modalSettings;
    modalSettings = {
      title: __('sites.analytics.modal.title'),
      body: action !== 'new' ? __('sites.analytics.modal.info') : __('sites.analytics.modal.new'),
      size: 'medium',
      buttons: action !== 'new' ? [
        {
          attr: {
            "class": "cr-forced-update btn btn-primary",
            type: "button"
          },
          click: (function(_this) {
            return function() {
              return window.location.href = url;
            };
          })(this),
          text: __('sites.analytics.modal.continue')
        }
      ] : []
    };
    return INTENT.utils.Modal.show(modalSettings);
  };

  CrudSite.prototype.get_json = function() {
    var json;
    if (!this.json) {
      json = this.el.attr(this.s.ATTR_JSON);
      this.json = jQuery.parseJSON(json);
    }
    return this.json;
  };

  CrudSite.prototype.get_origin_values = function() {
    var origin_values;
    if (!this.origin_values) {
      origin_values = this.el.attr(this.s.ATTR_VALUES);
      this.origin_values = jQuery.parseJSON(origin_values);
    }
    return this.origin_values;
  };

  CrudSite.prototype.show_cpa_controls = function() {
    var enable_cpa_controls;
    if (!this.enable_cpa_controls) {
      enable_cpa_controls = this.el.attr(this.s.ATTR_CPA_CONTROLS);
      this.enable_cpa_controls = jQuery.parseJSON(enable_cpa_controls);
    }
    return this.enable_cpa_controls;
  };

  CrudSite.prototype.get_last_id = function() {
    var last_id;
    if (!this.rules_container.find('tr').length) {
      return 0;
    }
    last_id = parseInt(this.rules_container.find('tr:last').attr(this.s.ATTR_RULE_ID));
    return last_id + 1;
  };

  CrudSite.prototype.change_type = function(e) {
    var additional_container, fields, fields_tpl, id, json, self, type;
    self = $(e.currentTarget);
    id = self.parents('tr').attr(this.s.ATTR_RULE_ID);
    additional_container = self.parents('tr').find("[" + this.s.ATTR_RULE_ADDITIONAL + "]");
    json = this.get_json();
    type = self.val();
    fields = json[type]['fields'];
    fields_tpl = INTENT.templates.CrudSite.get_input_additional(id, {}, fields);
    return additional_container.empty().append(fields_tpl);
  };

  CrudSite.prototype.remove_item = function(e) {
    var self;
    self = $(e.currentTarget);
    self.parents("tr").remove();
    return false;
  };

  CrudSite.prototype.prevalidate_convertion_rules = function() {
    var additional_fields, core, errors, inputs_names, max_conversions_numbers;
    core = this;
    errors = [];
    inputs_names = this.rules_container.find("[" + this.s.ATTR_RULE_NAME + "]");
    inputs_names.removeClass(this.s.CLASS_ERROR);
    inputs_names.each(function() {
      var self, val;
      self = $(this);
      val = self.val();
      if (!val.match(/^[^а-яА-Я\s]*$/g) && !self.is('.disabled')) {
        self.addClass(core.s.CLASS_ERROR);
        errors.push(self);
      }
      if (val.length <= 0) {
        self.addClass(core.s.CLASS_ERROR);
        return errors.push(self);
      }
    });
    max_conversions_numbers = this.rules_container.find("[" + this.s.ATTR_RULE_MAX_CONVERSIONS_NUMBER + "]");
    max_conversions_numbers.removeClass(this.s.CLASS_ERROR);
    max_conversions_numbers.each(function() {
      var self, val;
      self = $(this);
      val = self.val();
      if (val && parseInt(val) < 0) {
        self.addClass(core.s.CLASS_ERROR);
        return errors.push(self);
      }
    });
    additional_fields = this.rules_container.find("[" + this.s.ATTR_RULE_ADDITIONAL_FIELD + "]");
    additional_fields.removeClass(this.s.CLASS_ERROR);
    additional_fields.each(function() {
      var self, val;
      self = $(this);
      val = self.val();
      if (val.length <= 0 && !self.is("[allow-empty]")) {
        self.addClass(core.s.CLASS_ERROR);
        return errors.push(self);
      }
    });
    if (errors.length > 0) {
      setTimeout(((function(_this) {
        return function() {
          return core.btnSubmit.hideLoader('disabled');
        };
      })(this)), 400);
    }
    return errors.length === 0;
  };

  CrudSite.prototype.init_exist = function() {
    var ex_index, ex_rule, exists_rules, id, item;
    this.rules_container.empty();
    exists_rules = this.get_origin_values();
    for (ex_index in exists_rules) {
      ex_rule = exists_rules[ex_index];
      id = this.get_last_id();
      item = INTENT.templates.CrudSite.get_conversion_rule(id, this.get_json(), ex_rule, this.show_cpa_controls());
      this.rules_container.append(item);
    }
    init_select2();
    return init_switcher();
  };

  CrudSite.prototype.add_item = function() {
    var id, item;
    id = this.get_last_id();
    item = INTENT.templates.CrudSite.get_conversion_rule(id, this.get_json(), null, this.show_cpa_controls());
    this.rules_container.append(item);
    init_select2();
    init_switcher();
    return false;
  };

  return CrudSite;

})();


/*
  Currency widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.Currency = (function() {
  Currency.ATTR_NAME = "data-widget-currency";

  Currency.ATTR_SAVE = Currency.ATTR_NAME + "-save";

  Currency.CLASS_CURRENCY_CONTAINER = "currency-container";

  Currency.CLASS_CURRENCY_INPUT = "currency-input";

  function Currency(el) {
    this.el = el;
    this.close_modal = bind(this.close_modal, this);
    this.get_value = bind(this.get_value, this);
    this.get_action = bind(this.get_action, this);
    this.get_post_options = bind(this.get_post_options, this);
    this.get_options = bind(this.get_options, this);
    this.after_submit = bind(this.after_submit, this);
    this.update_elements = bind(this.update_elements, this);
    this.submit = bind(this.submit, this);
    this.s = this.constructor;
    this.save = this.el.find("[" + this.s.ATTR_SAVE + "]");
    this.input = this.el.find("input");
    this.advertiser_id = this.el.attr(this.s.ATTR_NAME);
    this.save.on("click", this.submit);
    $("[" + this.s.ATTR_NAME + "-open-help]").on("click", (function(_this) {
      return function() {
        _this.close_modal();
        return $('#helpForm').modal('show');
      };
    })(this));
  }

  Currency.prototype.submit = function() {
    return $.ajax(this.get_options()).done(this.after_submit);
  };

  Currency.prototype.update_elements = function(currency) {
    var containers, input_by_name, inputs_by_class;
    containers = $("." + this.s.CLASS_CURRENCY_CONTAINER);
    inputs_by_class = $("." + this.s.CLASS_CURRENCY_INPUT);
    input_by_name = $('form input[name="currency"]');
    containers.html(currency);
    inputs_by_class.val(currency);
    return input_by_name.val(currency);
  };

  Currency.prototype.after_submit = function(xhr) {
    if (!this.get_value()) {
      return false;
    }
    this.update_elements(xhr.currency);
    return this.close_modal();
  };

  Currency.prototype.get_options = function() {
    return {
      url: this.get_action(),
      type: 'POST',
      data: this.get_post_options()
    };
  };

  Currency.prototype.get_post_options = function() {
    return {
      id: this.advertiser_id,
      currency: this.get_value()
    };
  };

  Currency.prototype.get_action = function() {
    return "/ajax/update_currency";
  };

  Currency.prototype.get_value = function() {
    return this.input.filter(":checked").val();
  };

  Currency.prototype.close_modal = function() {
    return this.el.modal('hide');
  };

  return Currency;

})();


/*
  Dynamic creative widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.DynCreative = (function() {
  DynCreative.ATTR_NAME = "data-widget-dyncreative";

  DynCreative.ATTR_FORM = DynCreative.ATTR_NAME + "-form";

  DynCreative.ATTR_FIELD_SITE_LOGO = DynCreative.ATTR_FORM + "-sitelogo";

  DynCreative.ATTR_BTN = DynCreative.ATTR_NAME + "-button";

  DynCreative.ATTR_BTN_UPLOAD_SITE_LOGO = DynCreative.ATTR_BTN + "-sitelogo";

  DynCreative.ATTR_CONTAINER = DynCreative.ATTR_NAME + "-container";

  DynCreative.ATTR_CONTAINER_SITE_LOGO = DynCreative.ATTR_CONTAINER + "-sitelogo";

  DynCreative.ATTR_CONTAINER_PROGRESS = DynCreative.ATTR_CONTAINER + "-progress";

  DynCreative.ATTR_PROGRESS_BAR = DynCreative.ATTR_CONTAINER_PROGRESS + "-bar";

  DynCreative.ATTR_PROGRESS_DESCRIPTION = DynCreative.ATTR_CONTAINER_PROGRESS + "-description";

  function DynCreative(el) {
    this.el = el;
    this.on_upload_error = bind(this.on_upload_error, this);
    this.on_upload_complete = bind(this.on_upload_complete, this);
    this.on_upload_progress = bind(this.on_upload_progress, this);
    this.on_upload = bind(this.on_upload, this);
    this.on_upload_submit = bind(this.on_upload_submit, this);
    this.init_basic_file_uploader = bind(this.init_basic_file_uploader, this);
    this.set_site_logo = bind(this.set_site_logo, this);
    this.s = this.constructor;
    this.form = this.el.find("[" + this.s.ATTR_FORM + "]");
    this.field_site_logo = this.form.find("[" + this.s.ATTR_FIELD_SITE_LOGO + "]");
    this.btn_site_logo = this.el.find("[" + this.s.ATTR_BTN_UPLOAD_SITE_LOGO + "]");
    this.container_site_logo = this.el.find("[" + this.s.ATTR_CONTAINER_SITE_LOGO + "]");
    this.container_progress = this.el.find("[" + this.s.ATTR_CONTAINER_PROGRESS + "]");
    this.init_basic_file_uploader();
  }

  DynCreative.prototype.set_site_logo = function(http_file_url) {
    var image;
    INTENT.utils.Forms.enable_submit_buttons();
    image = this.container_site_logo.find('img');
    image.attr('src', http_file_url);
    return image.on('load', (function(_this) {
      return function() {
        _this.container_site_logo.fadeIn('fast');
        return image.fadeIn('fast');
      };
    })(this));
  };

  DynCreative.prototype.init_basic_file_uploader = function() {
    return this.uploader = new qq.FileUploaderBasic({
      button: this.btn_site_logo[0],
      action: '/campaigns/upload_image',
      debug: true,
      inputName: 'image',
      encoding: 'multipart',
      multiple: false,
      onSubmit: this.on_upload_submit,
      onUpload: this.on_upload,
      onProgress: this.on_upload_progress,
      onComplete: this.on_upload_complete,
      onError: this.on_upload_error
    });
  };

  DynCreative.prototype.on_upload_submit = function() {
    this.container_site_logo.fadeIn('fast');
    INTENT.utils.Forms.disable_submit_buttons();
    this.container_site_logo.find('img').hide();
    return this.container_site_logo.find('.loader').show();
  };

  DynCreative.prototype.on_upload = function(id, fileName) {};

  DynCreative.prototype.on_upload_progress = function(id, fileName, loaded, total) {
    var percent;
    percent = 0;
    if (loaded < total) {
      return percent = Math.round(loaded / total * 100);
    }
  };

  DynCreative.prototype.on_upload_complete = function(id, fileName, responseJSON) {
    var file_url, http_file_url;
    file_url = responseJSON.url;
    http_file_url = 'https://' + file_url;
    this.container_site_logo.fadeOut();
    this.set_site_logo(http_file_url);
    this.field_site_logo.attr('value', file_url);
    return this.container_site_logo.find('.loader').hide();
  };

  DynCreative.prototype.on_upload_error = function(id, name, reason, xhr) {
    INTENT.utils.Forms.enable_submit_buttons();
    this.container_site_logo.find('.loader').hide();
    return false;
  };

  return DynCreative;

})();

INTENT.widgets.EmailEventSubscriptions = (function() {
  EmailEventSubscriptions.ATTR_NAME = "data-widget-email-event-subscriptions";

  function EmailEventSubscriptions(el1) {
    var el;
    this.el = el1;
    el = this.el;
    this.el.on('switchChange.bootstrapSwitch', function(e, s) {
      var action, loaderContainer;
      if (s) {
        action = 'renewUserSubscription';
      } else {
        action = 'unsubscribeUser';
      }
      loaderContainer = $(e.target).parent().find('.bootstrap-switch-handle-' + (s ? 'off' : 'on'));
      return $.ajax({
        url: '/ajax/event_subscription',
        method: 'post',
        data: {
          event: el.data('eventId'),
          action: action
        },
        beforeSend: function() {
          $(e.target).prop('disabled', true);
          return loaderContainer.showLoader();
        }
      }).done(function(r) {
        $(e.target).prop('disabled', false);
        loaderContainer.hideLoader();
        if (r.status && 'renewUserSubscription' === action) {
          $(e.target).bootstrapSwitch('state', true);
          INTENT.utils.Notify.success(__("email_subscription.state.active"));
        }
        if (r.status && 'unsubscribeUser' === action) {
          $(e.target).bootstrapSwitch('state', false);
          INTENT.utils.Notify.success(__("email_subscription.state.disabled"));
        }
        if (!r.status) {
          $(e.target).bootstrapSwitch('state', (s ? false : true), true);
          return INTENT.utils.Notify.error(__("campaigns.internal-server-error"));
        }
      });
    });
  }

  return EmailEventSubscriptions;

})();

var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.Folding = (function() {
  Folding.ATTR_NAME = "data-widget-folding";

  Folding.ATTR_HANDLER = Folding.ATTR_NAME + "-handler";

  Folding.ATTR_CONTAINER = Folding.ATTR_NAME + "-container";

  Folding.ICON_OPEN = "glyphicon glyphicon-chevron-right";

  Folding.ICON_CLOSE = "glyphicon glyphicon-chevron-down";

  Folding.OPACITY_CLASS = "opacity-dynamic";

  Folding.SLIDER_SPEED = 500;

  function Folding(el) {
    this.el = el;
    this.update_icon = bind(this.update_icon, this);
    this.s = this.constructor;
    this.handler = this.el.find("[" + this.s.ATTR_HANDLER + "]");
    this.container = this.el.find("[" + this.s.ATTR_CONTAINER + "]");
    this.opacity = this.el.attr(this.s.ATTR_NAME) === 'opacity';
    if (!this.container.is(':visible')) {
      this.handler.addClass(this.s.OPACITY_CLASS);
    }
    this.handler.on('click', (function(_this) {
      return function() {
        _this.update_icon();
        if (_this.container.is(':visible')) {
          if (_this.opacity) {
            _this.handler.addClass(_this.s.OPACITY_CLASS);
          }
          return _this.container.slideUp(_this.s.SLIDER_SPEED);
        } else {
          if (_this.opacity) {
            _this.handler.removeClass(_this.s.OPACITY_CLASS);
          }
          return _this.container.slideDown(_this.s.SLIDER_SPEED);
        }
      };
    })(this));
  }

  Folding.prototype.update_icon = function() {
    var icon, iconClose, iconOpen;
    icon = this.handler.find("i");
    iconOpen = "glyphicon glyphicon-chevron-down";
    if (icon.attr('attr-open') !== '' && icon.attr('attr-open') !== void 0 && icon.attr('attr-open') !== null) {
      iconOpen = "glyphicon glyphicon-chevron-" + icon.attr('attr-open');
    }
    iconClose = "glyphicon glyphicon-chevron-right";
    if (icon.attr('attr-close') !== '' && icon.attr('attr-close') !== void 0 && icon.attr('attr-close') !== null) {
      iconClose = "glyphicon glyphicon-chevron-" + icon.attr('attr-close');
    }
    if (this.container.is(':visible')) {
      return icon.attr('class', iconClose);
    } else {
      return icon.attr('class', iconOpen);
    }
  };

  return Folding;

})();


/*
  Campaign frequency capping
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.FrequencyCapping = (function() {
  FrequencyCapping.ATTR_NAME = "data-widget-frequency-capping";

  FrequencyCapping.prototype.fc_types = [];

  function FrequencyCapping(el) {
    var ref, type, value;
    this.el = el;
    this.update_available_options = bind(this.update_available_options, this);
    this.add_input_group = bind(this.add_input_group, this);
    this.s = this.constructor;
    this.attr = this.s.ATTR_NAME;
    this.code = this.attr.replace('data-', '');
    this.can_edit = this.el.data(this.code + "-can-edit");
    this.fc_types = this.el.data(this.code + "-types");
    this.fc_values = this.el.data(this.code + "-values");
    if (!this.fc_values) {
      this.fc_values = {
        'hour': 2
      };
    }
    ref = this.fc_values;
    for (type in ref) {
      value = ref[type];
      this.add_input_group(type, value);
    }
    this.update_available_options();
    this.el.on('click', "[" + this.attr + "-remove]", (function(_this) {
      return function(e) {
        var group, self;
        e.preventDefault();
        self = $(e.target);
        group = self.closest("[" + _this.attr + "-group]");
        if (group.length) {
          group.find('select').destroySelect2();
          self.tooltip('destroy');
          group.remove();
          _this.update_available_options();
        }
        if (!$("[" + _this.attr + "-remove]").length) {
          return _this.toggle_strict(false);
        }
      };
    })(this));
    this.el.on('click', "[" + this.attr + "-add]", (function(_this) {
      return function(e) {
        var self;
        e.preventDefault();
        self = $(e.target);
        if (self.attr('disabled')) {
          return false;
        }
        _this.add_input_group();
        return _this.update_available_options();
      };
    })(this));
    this.el.on('change', "[" + this.attr + "-type]", (function(_this) {
      return function(e) {
        return _this.update_available_options();
      };
    })(this));
  }

  FrequencyCapping.prototype.add_input_group = function(selected_type, input_value) {
    var index, lastGroup, newGroup;
    if (selected_type == null) {
      selected_type = false;
    }
    if (input_value == null) {
      input_value = '';
    }
    index = 0;
    while (this.el.find("[" + this.attr + "-group='" + index + "']").length > 0) {
      index++;
    }
    newGroup = this.get_input_group_template(index, selected_type, input_value);
    lastGroup = this.el.find("[" + this.attr + "-group]:last");
    if (lastGroup.length) {
      lastGroup.after(newGroup);
    } else {
      this.el.prepend(newGroup);
    }
    return this.toggle_strict(true);
  };

  FrequencyCapping.prototype.update_available_options = function() {
    var add_button, fc_available, fc_used, groups_count, key, ref, ref1, type;
    fc_used = {};
    ref = this.fc_types;
    for (key in ref) {
      type = ref[key];
      fc_used[type] = false;
    }
    this.el.find("[" + this.attr + "-type]").each((function(_this) {
      return function(key, item) {
        var item_type;
        item = $(item);
        item_type = item.val();
        return fc_used[item_type] = true;
      };
    })(this));
    fc_available = [];
    ref1 = this.fc_types;
    for (key in ref1) {
      type = ref1[key];
      if (!fc_used[type]) {
        fc_available.push(type);
      }
    }
    this.el.find("[" + this.attr + "-type]").each((function(_this) {
      return function(select_key, select) {
        var select_val;
        select = $(select);
        select_val = select.val();
        return select.find('option').each(function(option_key, option) {
          var option_val;
          option = $(option);
          option_val = option.val();
          if (!option_val || option_val === select_val || fc_available.indexOf(option_val) !== -1) {
            return option.removeAttr('disabled');
          } else {
            return option.attr('disabled', 'disabled');
          }
        });
      };
    })(this));
    groups_count = $("[" + this.attr + "-group]").length;
    add_button = this.el.find("[" + this.attr + "-add]");
    if (fc_available.length && groups_count < this.fc_types.length) {
      add_button.removeClass('disabled');
    } else {
      add_button.addClass('disabled');
    }
    return init_select2();
  };

  FrequencyCapping.prototype.get_input_group_template = function(index, selected_type, input_value) {
    var action_remove;
    if (selected_type == null) {
      selected_type = false;
    }
    if (input_value == null) {
      input_value = '';
    }
    action_remove = "";
    if (this.can_edit) {
      action_remove = "<div class=\"" + this.code + "-remove\">\n  <i class=\"fa fa-times opacity-dynamic\" " + this.attr + "-remove></i>\n</div>";
    }
    return "<div class=\"" + this.code + "-group col-sm-8\" " + this.attr + "-group=\"" + index + "\">\n  <div class=\"col-sm-5\">\n    <select class=\"form-control select2-init\"\n      name=\"targeting[frequency_capping][type][" + index + "]\"\n      " + this.attr + "-type=\"" + index + "\"\n    >\n      " + (this.get_select_options_template(selected_type)) + "\n    </select>\n  </div>\n  <div class=\"col-sm-6\">\n    <input type=\"text\" class=\"form-control numbers-only\"\n      name=\"targeting[frequency_capping][value][" + index + "]\"\n      value=\"" + input_value + "\"\n      placeholder=\"" + (__('campaign.frequency-capping.input-placeholder')) + "\"\n      " + this.attr + "-value=\"" + index + "\">\n  </div>\n  " + action_remove + "\n</div>";
  };

  FrequencyCapping.prototype.get_select_options_template = function(selected_type) {
    var key, options, ref, title, type;
    if (selected_type == null) {
      selected_type = false;
    }
    options = "<option value='' selected='selected'>...</option>";
    if (!!selected_type) {
      options = "<option value=''>...</option>";
    }
    ref = this.fc_types;
    for (key in ref) {
      type = ref[key];
      title = __('campaign.frequency-capping.per.' + type);
      if (type === selected_type) {
        options += "<option value='" + type + "' selected='selected'>" + title + "</option>";
      } else {
        options += "<option value='" + type + "'>" + title + "</option>";
      }
    }
    return options;
  };

  FrequencyCapping.prototype.toggle_strict = function(show) {
    var strict;
    if (show == null) {
      show = true;
    }
    strict = $('#frequency_capping-strict').closest('.form-group');
    if (show) {
      return strict.show();
    } else {
      return strict.hide();
    }
  };

  return FrequencyCapping;

})();

INTENT.widgets.GroupEsimate = (function() {
  GroupEsimate.ATTR_NAME = "data-widget-groupestimate";

  GroupEsimate.ATTR_MATCH_BUDGET = "data-match-budget";

  GroupEsimate.ATTR_WARNING = "data-warning";

  GroupEsimate.ATTR_GROUP_LIMIT = "data-group-limit";

  function GroupEsimate(el) {
    this.el = el;
    this.s = this.constructor;
    this.groupMatchBudget = this.el.find("[" + this.s.ATTR_MATCH_BUDGET + "]");
    this.groupWarning = this.el.find("[" + this.s.ATTR_WARNING + "]");
    this.groupLimitField = this.el.find("[" + this.s.ATTR_GROUP_LIMIT + "]");
    this.groupLimitField.on('keyup', (function(_this) {
      return function(e) {
        var current, match_budget, new_budget_limit;
        current = $(e.currentTarget);
        match_budget = parseFloat(_this.groupMatchBudget.val());
        new_budget_limit = parseFloat(current.val());
        if (isNaN(new_budget_limit) || new_budget_limit === void 0 || new_budget_limit === null) {
          new_budget_limit = 0;
        }
        if (match_budget > new_budget_limit) {
          current.parents('.form-group').addClass('has-warning');
          return _this.groupWarning.html(INTENT.templates.CrudCampaign.get_text_container(__('campaign.group.warning'), 'warning'));
        } else {
          current.parents('.form-group').removeClass('has-warning');
          return _this.groupWarning.html('');
        }
      };
    })(this));
  }

  return GroupEsimate;

})();


/*
  Objects JSON validator
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  hasProp = {}.hasOwnProperty;

INTENT.widgets.JsonValidator = (function() {
  JsonValidator.ATTR_NAME = "data-widget-json-validator";

  function JsonValidator(el) {
    this.el = el;
    this.delete_empty_properties = bind(this.delete_empty_properties, this);
    this.validate_json = bind(this.validate_json, this);
    this.show_alert = bind(this.show_alert, this);
    this.s = this.constructor;
    this.el.on('click', (function(_this) {
      return function(e) {
        var cm_key, codemirror, form_data, key, object_advertiser_id, object_array, object_code, object_creative_type, object_id, object_json, self, target_form, target_raw, value;
        e.preventDefault();
        self = $(e.target);
        object_code = self.data('json-validator-object-code');
        object_id = self.data('json-validator-object-id');
        object_advertiser_id = self.data('json-validator-object-advertiser-id');
        object_creative_type = self.data('json-validator-object-creative-type');
        self.showLoader();
        if (target_raw = self.data('json-validator-target-raw')) {
          target_raw = $(target_raw).eq(0);
          if (codemirror = target_raw.data('CodeMirrorInstance')) {
            object_json = codemirror.getValue();
            return _this.validate_json(object_code, object_json, _this.el);
          }
        } else if (target_form = self.data('json-validator-target-form')) {
          target_form = $(target_form).eq(0);
          object_array = target_form.serializeObject();
          if (object_id) {
            object_array['id'] = object_id;
          }
          if (object_advertiser_id) {
            object_array['advertiser_id'] = object_advertiser_id;
          }
          if (object_creative_type || object_code === 'action_rules') {
            if (object_code !== 'action_rules') {
              object_array['creative_type'] = object_creative_type;
            }
            if (codemirror_instances) {
              for (cm_key in codemirror_instances) {
                codemirror_instances[cm_key].save();
              }
            }
            form_data = $(self).parents('form').serializeObject();
            _this.delete_empty_properties(form_data, true);
            for (key in form_data) {
              if (!hasProp.call(form_data, key)) continue;
              value = form_data[key];
              if (value) {
                object_array[key] = value;
              }
            }
          }
          return _this.validate_json(object_code, object_array, _this.el);
        }
      };
    })(this));
  }

  JsonValidator.prototype.show_alert = function(alert_type, alert_message) {
    var options;
    options = {};
    if ('danger' === alert_type) {
      options.auto_hide = false;
    }
    return INTENT.utils.Notify.message(alert_message, alert_type, options);
  };

  JsonValidator.prototype.validate_json = function(object_code, object_data, button) {
    var ajax_data;
    ajax_data = {
      'object_code': object_code
    };
    if (typeof object_data === 'string') {
      ajax_data['object_json'] = object_data;
    } else {
      ajax_data['object_array'] = object_data;
    }
    return $.ajax({
      url: '/ajax/validate_json/',
      dataType: 'json',
      method: 'post',
      data: ajax_data,
      beforeSend: (function(_this) {
        return function() {
          return button.addClass('disabled');
        };
      })(this),
      complete: (function(_this) {
        return function() {
          button.removeClass('disabled');
          return button.hideLoader();
        };
      })(this),
      success: (function(_this) {
        return function(data) {
          if (data.success) {
            return _this.show_alert('success', __('json.validation.ok'));
          } else {
            return _this.show_alert('danger', data.error);
          }
        };
      })(this),
      error: (function(_this) {
        return function(jqXHR, textStatus, errorThrown) {};
      })(this)
    });
  };

  JsonValidator.prototype.delete_empty_properties = function(object, recurse) {
    var key, value;
    for (key in object) {
      if (!hasProp.call(object, key)) continue;
      value = object[key];
      if (Array.isArray(value)) {
        object[key] = value.filter(function(item) {
          return item !== void 0;
        });
        this.delete_empty_properties(value, recurse);
      }
    }
    return object;
  };

  return JsonValidator;

})();


/*
  Native creative widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.utils.ImageUploader = (function() {
  ImageUploader.ROOT_ATTR = "data-iu";

  ImageUploader.ATTR_URL = ImageUploader.ROOT_ATTR + "-url";

  ImageUploader.ATTR_SIZE = ImageUploader.ROOT_ATTR + "-size";

  ImageUploader.ATTR_IMAGE = ImageUploader.ROOT_ATTR + "-image";

  ImageUploader.ATTR_UPLOAD = ImageUploader.ROOT_ATTR + "-upload";

  function ImageUploader(root_image) {
    this.root_image = root_image;
    this.on_upload_error = bind(this.on_upload_error, this);
    this.on_upload_complete = bind(this.on_upload_complete, this);
    this.on_upload_progress = bind(this.on_upload_progress, this);
    this.on_upload = bind(this.on_upload, this);
    this.on_upload_submit = bind(this.on_upload_submit, this);
    this.set_image = bind(this.set_image, this);
    this.s = this.constructor;
    this.container_image = this.root_image.find("[" + this.s.ATTR_IMAGE + "]");
    this.field_size = this.root_image.find("[" + this.s.ATTR_SIZE + "]");
    this.field_image = this.root_image.find("[" + this.s.ATTR_URL + "]");
    this.btn_image = this.root_image.find("[" + this.s.ATTR_UPLOAD + "]");
    this.uploader = new qq.FileUploaderBasic({
      button: this.btn_image[0],
      action: '/campaigns/upload_image',
      debug: true,
      inputName: 'image',
      encoding: 'multipart',
      multiple: false,
      onSubmit: this.on_upload_submit,
      onUpload: this.on_upload,
      onProgress: this.on_upload_progress,
      onComplete: this.on_upload_complete,
      onError: this.on_upload_error
    });
  }

  ImageUploader.prototype.set_image = function(http_file_url) {
    var image;
    INTENT.utils.Forms.enable_submit_buttons();
    image = this.container_image.find('img');
    image.attr('src', http_file_url);
    return image.on('load', (function(_this) {
      return function() {
        _this.container_image.fadeIn('fast');
        return image.fadeIn('fast');
      };
    })(this));
  };

  ImageUploader.prototype.on_upload_submit = function() {
    this.container_image.fadeIn('fast');
    INTENT.utils.Forms.disable_submit_buttons();
    this.container_image.find('img').hide();
    return this.container_image.find('.loader').show();
  };

  ImageUploader.prototype.on_upload = function(id, fileName) {};

  ImageUploader.prototype.on_upload_progress = function(id, fileName, loaded, total) {
    var percent;
    percent = 0;
    if (loaded < total) {
      return percent = Math.round(loaded / total * 100);
    }
  };

  ImageUploader.prototype.on_upload_complete = function(id, fileName, responseJSON) {
    var file_url, http_file_url;
    file_url = responseJSON.url;
    http_file_url = 'https://' + file_url;
    this.field_size.attr('value', responseJSON.size);
    this.container_image.fadeOut();
    this.set_image(http_file_url);
    this.field_image.attr('value', file_url);
    this.field_image.change();
    return this.container_image.find('.loader').hide();
  };

  ImageUploader.prototype.on_upload_error = function(id, name, reason, xhr) {
    INTENT.utils.Forms.enable_submit_buttons();
    this.container_image.find('.loader').hide();
    return false;
  };

  return ImageUploader;

})();

INTENT.widgets.NativeCreative = (function() {
  NativeCreative.ATTR_NAME = "data-widget-native-creative";

  NativeCreative.ATTR_IMAGE_ROOT = NativeCreative.ATTR_NAME + "-image-root";

  function NativeCreative(el) {
    this.el = el;
    this.s = this.constructor;
    this.root_image = this.el.find("[" + this.s.ATTR_IMAGE_ROOT + "]");
    this.root_image.each(function() {
      return new INTENT.utils.ImageUploader($(this));
    });
  }

  return NativeCreative;

})();

INTENT.widgets.UserSettings = (function() {
  UserSettings.ATTR_NAME = "data-widget-password-check";

  function UserSettings(el) {
    this.el = el;
    this.s = this.constructor;
    this.minLength = 8;
    this.input = this.el.find('input[type="password"]');
    if (!this.input.length) {
      this.input = this.el;
    }
    this.input.password({
      shortPass: __('password-checker.status.short', {
        ':count': this.minLength
      }),
      badPass: __('password-checker.status.bad'),
      goodPass: __('password-checker.status.good'),
      strongPass: __('password-checker.status.strong'),
      enterPass: '',
      showText: true,
      minimumLength: this.minLength
    });
  }

  return UserSettings;

})();


/*
    Payment widget

    Robokassa
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.PaymentRobokassa = (function() {
  PaymentRobokassa.ATTR_NAME = "data-widget-payment";

  PaymentRobokassa.ATTR_TOTAL_SUM = PaymentRobokassa.ATTR_NAME + "-total-sum-handler";

  PaymentRobokassa.ATTR_SUBMIT_BTN = PaymentRobokassa.ATTR_NAME + "-submit";

  PaymentRobokassa.CLASS_ERROR = "error-input-field";

  PaymentRobokassa.NDS_PERCENT = 1.18;

  function PaymentRobokassa(el) {
    this.el = el;
    this.submit_event = bind(this.submit_event, this);
    this.btn_status = bind(this.btn_status, this);
    this.amount_error_clear = bind(this.amount_error_clear, this);
    this.amount_error = bind(this.amount_error, this);
    this.calc_nds_sum = bind(this.calc_nds_sum, this);
    this.reset_runtime_filed = bind(this.reset_runtime_filed, this);
    this.s = this.constructor;
    this.el.on('submit', this.submit_event);
    this.inputs = this.el.find('input');
    this.total_sum_handler = this.el.find("[" + this.s.ATTR_TOTAL_SUM + "]");
    this.salt_input = this.inputs.filter("[name='SignatureValue']");
    this.invoice_input = this.inputs.filter("[name='InvId']");
    this.value_input = this.inputs.filter("[name='shp_origin_sum']");
    this.sum_input = this.inputs.filter("[name='OutSum']");
    this.amountGroup = this.value_input.parents('.form-group');
    this.min = parseFloat(this.el.attr('data-min'));
    this.max = parseFloat(this.el.attr('data-max'));
    this.btn = this.el.find("[" + this.s.ATTR_SUBMIT_BTN + "]");
    this.reset_runtime_filed();
    this.calc_nds_sum();
    this.value_input.on("change, keyup", (function(_this) {
      return function(e) {
        var self, value;
        self = $(e.currentTarget);
        value = parseFloat(self.val());
        if (isNaN(value)) {
          value = 0;
        }
        if (!isNaN(_this.min)) {
          if (value < _this.min) {
            _this.amount_error(__('payment.min', {
              ':value': _this.min
            }));
          } else {
            _this.amount_error_clear();
          }
        }
        if (!isNaN(_this.max)) {
          if (value > _this.max) {
            _this.amount_error(__('payment.max', {
              ':value': _this.max
            }));
          } else {
            _this.amount_error_clear();
          }
        }
        _this.reset_runtime_filed();
        return _this.calc_nds_sum();
      };
    })(this));
  }

  PaymentRobokassa.prototype.reset_runtime_filed = function() {
    this.salt_input.attr('value', '');
    return this.invoice_input.attr('value', '');
  };

  PaymentRobokassa.prototype.calc_nds_sum = function() {
    var val;
    val = parseFloat(this.value_input.val());
    if (isNaN(val)) {
      val = 0;
    }
    val = val * this.s.NDS_PERCENT;
    val = val.toFixed(2);
    this.sum_input.attr('value', val);
    return this.total_sum_handler.html(val);
  };

  PaymentRobokassa.prototype.amount_error = function(text) {
    this.btn_status('disabled');
    this.amountGroup.addClass('has-error');
    return this.amountGroup.find('.error').html(text);
  };

  PaymentRobokassa.prototype.amount_error_clear = function() {
    this.btn_status('enabled');
    this.amountGroup.removeClass('has-error');
    return this.amountGroup.find('.error').html('');
  };

  PaymentRobokassa.prototype.btn_status = function(status) {
    if (status == null) {
      status = 'disabled';
    }
    if (status === 'disabled') {
      return this.btn.attr('disabled', 'disabled');
    } else if (status === 'enabled') {
      return this.btn.removeAttr('disabled');
    }
  };

  PaymentRobokassa.prototype.submit_event = function() {
    var params;
    this.calc_nds_sum();
    this.value_input.removeClass(this.s.CLASS_ERROR);
    if (!parseFloat(this.value_input.val())) {
      this.value_input.addClass(this.s.CLASS_ERROR);
      return false;
    }
    if (this.salt_input.val()) {
      return true;
    }
    params = {
      url: '/processing/create_rub_payment',
      type: 'POST',
      data: this.el.serialize()
    };
    $.ajax(params).done((function(_this) {
      return function(xhr) {
        if (xhr.error) {
          return _this.amount_error(__('payment.' + xhr.type, {
            ':value': xhr.limit
          }));
        } else {
          _this.amount_error_clear();
          _this.salt_input.attr('value', xhr.salt);
          _this.invoice_input.attr('value', xhr.invoice);
          return _this.el.submit();
        }
      };
    })(this));
    return false;
  };

  return PaymentRobokassa;

})();


/*
    Stripe
 */

INTENT.widgets.PaymentStripe = (function() {
  PaymentStripe.ATTR_NAME = "data-widget-stripe";

  PaymentStripe.ATTR_SUBMIT_BTN = PaymentStripe.ATTR_NAME + "-btn";

  PaymentStripe.ATTR_SUBMIT_CANCEL_BTN = PaymentStripe.ATTR_NAME + "-cancel-btn";

  PaymentStripe.CLASS_ERROR = "error-input-field";

  PaymentStripe.COMMISSION = 1.03;

  function PaymentStripe(el) {
    this.el = el;
    this.submit_event = bind(this.submit_event, this);
    this.btn_status = bind(this.btn_status, this);
    this.process_token = bind(this.process_token, this);
    this.calc_commission_sum = bind(this.calc_commission_sum, this);
    this.make_param = bind(this.make_param, this);
    this.get_total_amount = bind(this.get_total_amount, this);
    this.get_origin = bind(this.get_origin, this);
    this.close_modal = bind(this.close_modal, this);
    this.amount_error_clear = bind(this.amount_error_clear, this);
    this.amount_error = bind(this.amount_error, this);
    this.s = this.constructor;
    this.process_finish = false;
    this.inputs = this.el.find('input');
    this.value_input = this.inputs.filter("[name='origin']");
    this.sum_input = this.inputs.filter("[name='amount']");
    this.btn = this.el.find("[" + this.s.ATTR_SUBMIT_BTN + "]");
    this.btn_cancel = this.el.find("[" + this.s.ATTR_SUBMIT_CANCEL_BTN + "]");
    this.charge_in_process = this.el.find(".charge-in-process");
    this.amountGroup = this.value_input.parents('.form-group');
    this.min = parseFloat(this.el.attr('data-min'));
    this.max = parseFloat(this.el.attr('data-max'));
    this.el.on('submit', this.submit_event);
    this.value_input.on("change, keyup", (function(_this) {
      return function(e) {
        var self, value;
        self = $(e.currentTarget);
        value = parseFloat(self.val());
        if (isNaN(value)) {
          value = 0;
        }
        if (!isNaN(_this.min)) {
          if (value < _this.min) {
            _this.amount_error(__('payment.min', {
              ':value': _this.min
            }));
          } else {
            _this.amount_error_clear();
          }
        }
        if (!isNaN(_this.max)) {
          if (value > _this.max) {
            _this.amount_error(__('payment.max', {
              ':value': _this.max
            }));
          } else {
            _this.amount_error_clear();
          }
        }
        return _this.calc_commission_sum();
      };
    })(this));
    this.handler = StripeCheckout.configure({
      key: stripe_key,
      image: '/img/logo/stripe.png',
      token: this.process_token
    });
  }

  PaymentStripe.prototype.amount_error = function(text) {
    if (this.process_finish === false) {
      this.btn_status('disabled', false, false);
    }
    this.amountGroup.addClass('has-error');
    return this.amountGroup.find('.error').html(text);
  };

  PaymentStripe.prototype.amount_error_clear = function() {
    if (this.process_finish === false) {
      this.btn_status('enabled', false, false);
    }
    this.amountGroup.removeClass('has-error');
    return this.amountGroup.find('.error').html('');
  };

  PaymentStripe.prototype.close_modal = function() {
    return $('#payment-modal').modal('hide');
  };

  PaymentStripe.prototype.get_origin = function() {
    return parseFloat(this.value_input.val());
  };

  PaymentStripe.prototype.get_total_amount = function() {
    return parseFloat(this.sum_input.val());
  };

  PaymentStripe.prototype.make_param = function(key, value) {
    var input;
    input = document.createElement('input');
    input.type = "hidden";
    input.name = key;
    input.value = value;
    return input;
  };

  PaymentStripe.prototype.calc_commission_sum = function() {
    var val;
    val = parseFloat(this.value_input.val());
    if (isNaN(val)) {
      val = 0;
    }
    val = val * this.s.COMMISSION;
    val = parseInt(val) === val ? val : val.toFixed(2);
    return this.sum_input.attr('value', val);
  };

  PaymentStripe.prototype.process_token = function(token) {
    var params;
    this.process_finish = true;
    this.btn_cancel.html(__('stripe.wait'));
    this.btn_cancel.attr('disabled', 'disabled');
    this.charge_in_process.removeClass('hidden');
    params = {
      token: token.id,
      email: token.email,
      amount: this.get_total_amount(),
      origin: this.get_origin(),
      invoiceId: this.handler_xhr.invoice,
      advertiserId: this.handler_xhr.advertiser,
      currency: this.handler_xhr.currency.toLowerCase()
    };
    return $.redirect('/payment/success', params, 'POST');
  };

  PaymentStripe.prototype.btn_status = function(status, loader, withInput) {
    if (status == null) {
      status = 'disabled';
    }
    if (loader == null) {
      loader = true;
    }
    if (withInput == null) {
      withInput = true;
    }
    if (status === 'disabled') {
      this.btn_text_buffer = this.btn.html();
      if (withInput === true) {
        this.value_input.attr('readonly', 'readonly');
      }
      this.btn.attr('disabled', 'disabled');
      if (loader === true) {
        return this.btn.html(" <i class=\"fa fa-circle-o-notch fa-spin\"></i> ");
      }
    } else if (status === 'enabled') {
      this.btn.removeAttr('disabled');
      if (withInput === true) {
        this.value_input.removeAttr('readonly');
      }
      if (this.btn_text_buffer !== void 0 && loader === true) {
        return this.btn.html(this.btn_text_buffer);
      }
    }
  };

  PaymentStripe.prototype.submit_event = function() {
    var params;
    this.value_input.removeClass(this.s.CLASS_ERROR);
    this.btn_status('disabled');
    if (!this.get_total_amount()) {
      this.value_input.addClass(this.s.CLASS_ERROR);
      return false;
    }
    params = {
      url: '/processing/create_stripe_payment',
      type: 'POST',
      data: this.el.serialize()
    };
    $.ajax(params).done((function(_this) {
      return function(xhr) {
        if (xhr.error) {
          return _this.amount_error(__('payment.' + xhr.type, {
            ':value': xhr.limit
          }));
        } else {
          _this.handler_xhr = xhr;
          return _this.handler.open({
            name: 'Getintent USA Inc',
            description: 'GetIntent DSP Invoice #' + _this.handler_xhr.invoice,
            amount: _this.get_total_amount() * 100,
            currency: _this.handler_xhr.currency.toLowerCase(),
            allowRememberMe: false,
            closed: function() {
              if (_this.process_finish === false) {
                return _this.btn_status('enabled');
              }
            }
          });
        }
      };
    })(this));
    return false;
  };

  return PaymentStripe;

})();


/*
  Permission editor
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

INTENT.widgets.PermissionEditor = (function() {
  PermissionEditor.ATTR_NAME = "data-widget-permission-editor";

  PermissionEditor.prototype.fields = {};

  PermissionEditor.prototype.values = {};

  PermissionEditor.prototype.datasets = {};

  PermissionEditor.prototype.default_group = {
    name: 'advertisers_view',
    value: null,
    params: []
  };

  PermissionEditor.prototype.wrapper = null;

  PermissionEditor.prototype.new_permissions_state = false;

  PermissionEditor.prototype.context = 'user';

  function PermissionEditor(el) {
    var group, key, ref;
    this.el = el;
    this.reload_permissions = bind(this.reload_permissions, this);
    this.permission_converter_handler = bind(this.permission_converter_handler, this);
    this.s = this.constructor;
    this.fields = this.el.data('permission-editor-fields');
    this.values = this.el.data('permission-editor-values');
    this.datasets = this.el.data('permission-editor-datasets');
    this.wrapper = this.el.find('[data-permission-editor-wrapper]').eq(0);
    if ($('[data-form-role-edit]').length) {
      this.context = 'role';
    }
    ref = this.values;
    for (key in ref) {
      group = ref[key];
      this.add_input_group(group);
    }
    this.el.on('click', '[data-permission-editor-remove]', (function(_this) {
      return function(e) {
        var input_group, self;
        e.preventDefault();
        self = $(e.currentTarget);
        input_group = self.closest('[data-permission-editor-group]').eq(0);
        if (input_group.length) {
          self.tooltip('destroy');
          input_group.find('select').destroySelect2();
          return input_group.remove();
        }
      };
    })(this));
    this.el.on('click', '[data-permission-editor-add]', (function(_this) {
      return function(e) {
        var self;
        e.preventDefault();
        _this.new_permissions_state = true;
        self = $(e.currentTarget);
        if (self.attr('disabled')) {
          return false;
        }
        _this.add_input_group(_this.default_group);
        return init_select2();
      };
    })(this));
    this.el.on('change', '[data-permission-editor-name-select]', (function(_this) {
      return function(e) {
        var group_dom, index, new_results_dom, results_dom, self;
        e.preventDefault();
        self = $(e.currentTarget);
        group_dom = self.closest('[data-permission-editor-group]').eq(0);
        index = group_dom.data('permission-editor-group');
        results_dom = _this.el.find("[data-permission-editor-results='" + index + "']").eq(0);
        _this.new_permissions_state = true;
        group = {
          name: self.val(),
          value: null,
          params: []
        };
        new_results_dom = _this.get_results_template(index, group);
        results_dom.find('select').destroySelect2();
        results_dom.replaceWith(new_results_dom);
        return init_select2();
      };
    })(this));
    this.el.on('change', '[data-permission-editor-value-select]', (function(_this) {
      return function(e) {
        var group_dom, index, name_dom, new_params_dom, params_dom, self;
        e.preventDefault();
        self = $(e.target);
        group_dom = self.closest('[data-permission-editor-group]').eq(0);
        index = group_dom.data('permission-editor-group');
        params_dom = _this.el.find("[data-permission-editor-params='" + index + "']").eq(0);
        name_dom = _this.el.find("[data-permission-editor-name='" + index + "'] [data-permission-editor-name-select]").eq(0);
        _this.new_permissions_state = true;
        group = {
          name: name_dom.val(),
          value: self.val(),
          params: []
        };
        new_params_dom = _this.get_result_params_template(index, group);
        params_dom.find('select').destroySelect2();
        params_dom.replaceWith(new_params_dom);
        return init_select2();
      };
    })(this));
    $(document).on('click', '.white-list-convert-btn', (function(_this) {
      return function(e) {
        return _this.permission_converter_handler(e, 'convert_to_whitelist');
      };
    })(this));
    $(document).on('click', '.white-list-convert-undo-btn', (function(_this) {
      return function(e) {
        return _this.permission_converter_handler(e, 'convert_to_blacklist');
      };
    })(this));
  }

  PermissionEditor.prototype.add_input_group = function(group) {
    var index, last_group, new_group;
    index = this.get_input_group_index();
    new_group = this.get_input_group_template(index, group);
    last_group = this.wrapper.find('[data-permission-editor-group]:last');
    if (last_group.length) {
      return last_group.after(new_group);
    } else {
      return this.wrapper.prepend(new_group);
    }
  };

  PermissionEditor.prototype.get_input_group_template = function(index, group) {
    var name_html, params_html;
    if (typeof group === 'undefined' || typeof this.fields[group.name] === 'undefined') {
      return '';
    }
    name_html = this.get_name_template(index, group);
    params_html = this.get_results_template(index, group);
    return "<tr class=\"permission-row\" data-permission-editor-group=\"" + index + "\">\n  " + name_html + "\n  " + params_html + "\n  <td class=\"remove-permission-icon-container\">\n    <i class=\"glyphicon glyphicon-remove remove-form-group-icon\"\n      title=\"" + (__('admin.permissions.remove-permission-icon')) + "\"\n      data-permission-editor-remove\n      data-widget-tooltip data-auto-init\n    ></i>\n  </td>\n</tr>";
  };

  PermissionEditor.prototype.get_name_template = function(index, group) {
    var item, key, options, ref, selected_name;
    if (group) {
      selected_name = group.name;
    }
    options = {};
    ref = this.fields;
    for (key in ref) {
      item = ref[key];
      options[key] = item.title;
    }
    return "<td class=\"permission-names-container col-md-4\" data-permission-editor-name=\"" + index + "\">\n  <select class=\"input-xlarge permission-name select2-init\"\n          name=\"permissions[" + index + "][name]\"\n          data-width=\"resolve\"\n          data-permission-editor-name-select\n          data-escape-html=\"1\"\n  >\n          " + (this.get_select_options_template(options, selected_name)) + "\n  </select>\n</td>";
  };

  PermissionEditor.prototype.get_results_template = function(index, group) {
    var inputs, template;
    template = '';
    if (group) {
      inputs = this.fields[group.name].inputs;
    }
    if (!inputs) {
      template = this.get_result_enabled_template();
    } else {
      template += this.get_result_template(index, group);
    }
    return "<td class=\"permission-params-and-values-container col-md-8\" data-permission-editor-results=\"" + index + "\">\n  " + template + "\n</td>";
  };

  PermissionEditor.prototype.get_result_template = function(index, group) {
    var inputs, template;
    template = '';
    if (group && this.fields[group.name]) {
      inputs = this.fields[group.name].inputs;
    }
    if (!inputs) {
      return;
    }
    if (inputs['value']) {
      template += this.get_result_value_template(index, group);
    }
    if (inputs['params']) {
      template += this.get_result_params_template(index, group);
    }
    return template;
  };

  PermissionEditor.prototype.get_result_enabled_template = function() {
    return "<div class=\"col-md-12 permission-param-container\">\n  <div class=\"permission-params-label\">\n    <label></label>\n  </div>\n  <div class=\"permission-param-input-container\">\n    <div class=\"span8 permission-param-input\">\n      <i class=\"glyphicon glyphicon-ok\"></i>\n      " + (__('admin.permissions.permission-available')) + "\n    </div>\n  </div>\n</div>";
  };

  PermissionEditor.prototype.get_result_params_template = function(index, group) {
    var attr, dataset, input, input_name, input_value, inputs, key, ref, select_name, select_options, select_settings, select_value, template;
    if (group && this.fields[group.name]) {
      inputs = this.fields[group.name].inputs;
    }
    if (inputs) {
      input = inputs['params'];
    }
    if (!input) {
      return;
    }
    template = '';
    switch (input.type) {
      case 'select':
        select_value = group.params;
        select_options = input.values;
        select_name = 'params';
        if (((ref = group.name) === 'dataset_white' || ref === 'dataset_view') && !select_options) {
          dataset = group.value;
          if (!dataset) {
            for (key in this.datasets) {
              dataset = key;
              break;
            }
          }
          if (this.datasets[dataset]) {
            select_options = this.datasets[dataset].fields;
          }
        }
        select_settings = {
          multiple: input.multiple,
          tags: input.multiple && !select_options
        };
        if (input.ajax_url) {
          select_settings['ajax--url'] = input.ajax_url;
        }
        if (input.attributes) {
          for (attr in input.attributes) {
            select_settings[attr] = input.attributes[attr];
          }
        }
        template = this.get_select_template(index, select_name, select_options, select_value, select_settings);
        if ('dataset_view' === group.name && !this.new_permissions_state) {
          template = this.append_blacklist_convert_btn(template, group.value);
        }
        break;
      case 'text':
        input_name = 'params';
        if (group.params) {
          input_value = group.params[0];
        }
        template = this.get_input_template(index, input_name, input_value);
    }
    return this.get_result_item_wrapper(index, 'params', input, template);
  };

  PermissionEditor.prototype.get_result_value_template = function(index, group) {
    var input, inputs, select_name, select_options, select_settings, select_value, template;
    if (group && this.fields[group.name]) {
      inputs = this.fields[group.name].inputs;
    }
    if (inputs) {
      input = inputs['value'];
    }
    if (!input) {
      return;
    }
    select_value = group.value;
    select_options = input.values;
    select_name = 'value';
    select_settings = {
      multiple: input.multiple,
      tags: input.multiple && !select_options
    };
    template = this.get_select_template(index, select_name, select_options, select_value, select_settings);
    return this.get_result_item_wrapper(index, 'value', input, template);
  };

  PermissionEditor.prototype.get_result_item_wrapper = function(index, block_name, input, inner_html) {
    return "<div class=\"col-md-12 permission-param-container\" data-permission-editor-" + block_name + "=\"" + index + "\">\n    <div class=\"permission-params-label\">\n        <label>\n            " + input.label + "\n        </label>\n    </div>\n    <div class=\"permission-param-input-container\">\n      " + inner_html + "\n    </div>\n</div>";
  };

  PermissionEditor.prototype.get_select_template = function(index, name, options_list, options_selected, settings) {
    var attr_name, attr_value, data_attr;
    if (settings == null) {
      settings = {};
    }
    if (!settings.width) {
      settings.width = 'resolve';
    }
    data_attr = '';
    for (attr_name in settings) {
      attr_value = settings[attr_name];
      data_attr += "data-" + attr_name + "=\"" + attr_value + "\" ";
    }
    return "<select\n  name=\"permissions[" + index + "][" + name + "][]\"\n  class=\"" + (settings['ajax--url'] ? 'select2-ajax-init' : 'select2-init') + " input-xlarge outdate\"\n  " + data_attr + "\n  " + (settings.multiple ? 'multiple="multiple"' : void 0) + "\n  data-permission-editor-" + name + "-select\n  data-escape-html=\"1\"\n>\n  " + (this.get_select_options_template(options_list, options_selected)) + "\n</select>";
  };

  PermissionEditor.prototype.get_select_options_template = function(options_list, options_selected) {
    var id, key, name, options, value;
    if (options_selected == null) {
      options_selected = [];
    }
    if (typeof options_selected !== 'object') {
      options_selected = [options_selected];
    }
    options = '';
    if (options_list) {
      for (key in options_list) {
        value = options_list[key];
        id = key;
        name = value;
        if (typeof value === 'object') {
          id = value.id;
          name = value.name;
        }
        if (indexOf.call(options_selected, id) >= 0) {
          options += "<option value='" + id + "' selected='selected'>" + (escapeHtml(name)) + "</option>";
        } else {
          options += "<option value='" + id + "'>" + (escapeHtml(name)) + "</option>";
        }
      }
    } else {
      for (key in options_selected) {
        value = options_selected[key];
        id = value;
        name = value;
        if (typeof value === 'object') {
          id = value.id;
          name = value.name;
        }
        options += "<option value='" + id + "' selected='selected'>" + (escapeHtml(name)) + "</option>";
      }
    }
    return options;
  };

  PermissionEditor.prototype.get_input_template = function(index, name, value) {
    if (value == null) {
      value = '';
    }
    return "<input\n  name=\"permissions[" + index + "][" + name + "][]\"\n  class=\"form-control input-xlarge outdate\"\n  value=\"" + value + "\"\n  data-permission-editor-" + name + "-input\n>";
  };

  PermissionEditor.prototype.get_input_group_index = function() {
    var index;
    index = 0;
    while (this.el.find('[data-permission-editor-group="' + index + '"]').length > 0) {
      index++;
    }
    return index;
  };

  PermissionEditor.prototype.append_blacklist_convert_btn = function(template, dataset) {
    var html;
    html = "<button data-dataset-name='" + dataset + "' class='white-list-convert-btn btn btn-primary btn-xs pull-right col-sm-6' style='margin-top:5px;'>" + (__('convert_to_whitelist')) + "</button>";
    if (template instanceof jQuery) {
      return template.append($(html));
    } else {
      return template + html;
    }
  };

  PermissionEditor.prototype.append_blacklist_convert_undo_btn = function(ctx, dataset) {
    return ctx.append($("<button data-dataset-name='" + dataset + "' class='white-list-convert-undo-btn btn btn-danger btn-xs pull-right col-sm-6' style='margin-top:5px;'><i class='fa fa-undo'></i> " + (__('undo_convert_to_whitelist')) + "</button>"));
  };

  PermissionEditor.prototype.permission_converter_handler = function(e, mode) {
    var appendHandler, btn, permission, self, url;
    if (mode == null) {
      mode = 'convert_to_whitelist';
    }
    self = this;
    e.preventDefault();
    btn = $(e.target);
    if ('convert_to_whitelist' === mode) {
      url = '/ajax/v2/permissions/datasets/convert_to_whitelist';
      permission = 'dataset_white';
      appendHandler = self.append_blacklist_convert_undo_btn;
    } else {
      url = '/ajax/v2/permissions/datasets/convert_to_blacklist';
      permission = 'dataset_view';
      appendHandler = self.append_blacklist_convert_btn;
    }
    return $.ajax({
      url: url,
      data: {
        dataset: btn.data('datasetName'),
        entity_id: parseInt($("[data-form-" + self.context + "-edit]").data('id')),
        context: self.context
      },
      method: 'post',
      beforeSend: function() {
        window.aborting = true;
        return btn.showLoader();
      }
    }).done(function() {
      return self.reload_permissions(function() {
        var converted, ctx, newCtx;
        btn.hideLoader();
        converted = _.filter(self.values, function(group) {
          return group.name === permission && group.value === btn.data('datasetName');
        });
        if (converted.length) {
          ctx = btn.parents('tr');
          newCtx = $(self.get_input_group_template(self.get_input_group_index(), converted[0]));
          newCtx.find('.white-list-convert-btn').remove();
          appendHandler(newCtx.find('.permission-param-input-container:last'), btn.data('datasetName'));
          $(document).trigger('permission_converted', {
            dataset: btn.data('datasetName')
          });
          return ctx.replaceWith(newCtx);
        } else {
          btn.hideLoader();
          $(document).trigger('permission_convert_error', {
            dataset: btn.data('datasetName')
          });
          return INTENT.utils.Notify.error(__('permission_was_not_changed'));
        }
      });
    }).fail(function() {
      btn.hideLoader();
      $(document).trigger('permission_convert_error', {
        dataset: btn.data('datasetName')
      });
      return INTENT.utils.Notify.error(__('permission_was_not_changed'));
    });
  };

  PermissionEditor.prototype.reload_permissions = function(next) {
    var self;
    self = this;
    return $.get(window.location.href).done(function(res) {
      var pContainer;
      pContainer = $(res).find('.permissions-table-container');
      if (pContainer.length) {
        self.fields = pContainer.data('permission-editor-fields');
        self.values = pContainer.data('permission-editor-values');
        self.datasets = pContainer.data('permission-editor-datasets');
        return next();
      }
    });
  };

  return PermissionEditor;

})();


/*
  Permission total popup
 */
INTENT.widgets.PermissionTotal = (function() {
  PermissionTotal.ATTR_NAME = "data-widget-permission-total";

  PermissionTotal.prototype.xhr = null;

  function PermissionTotal(el) {
    this.el = el;
    this.s = this.constructor;
    $(document).on('click', '[data-permission-total-show-user]', (function(_this) {
      return function(e) {
        var self, target, title;
        e.preventDefault();
        self = $(e.currentTarget);
        target = self.data('permission-total-show-user');
        title = self.data('permission-total-title');
        return _this.show_total_permissions(target, 'user', title);
      };
    })(this));
    $(document).on('click', '[data-permission-total-show-role]', (function(_this) {
      return function(e) {
        var self, target, title;
        e.preventDefault();
        self = $(e.currentTarget);
        target = self.data('permission-total-show-role');
        title = self.data('permission-total-title');
        return _this.show_total_permissions(target, 'role', title);
      };
    })(this));
    $(document).on('click', '[data-permission-total-show-form]', (function(_this) {
      return function(e) {
        var self, target, title;
        e.preventDefault();
        self = $(e.currentTarget);
        target = self.data('permission-total-show-form');
        title = self.data('permission-total-title');
        return _this.show_total_permissions(target, 'form', title);
      };
    })(this));
    this.el.on('hidden.bs.modal', (function(_this) {
      return function(e) {
        if (_this.xhr) {
          return _this.xhr.abort();
        }
      };
    })(this));
  }

  PermissionTotal.prototype.show_total_permissions = function(target, source, title) {
    var data, form, formObject;
    if (title == null) {
      title = '';
    }
    data = {};
    if (source === 'user' || source === 'role') {
      data[source] = +target;
    } else if (source === 'form') {
      form = $(target);
      if (form && form.length) {
        formObject = form.serializeObject();
        data['form'] = {
          roles: formObject.roles,
          permissions: formObject.permissions
        };
      }
    }
    if (!(data.user || data.role || data.form)) {
      return false;
    }
    return this.xhr = $.ajax('/ajax/get_user_permissions_rendered', {
      type: 'POST',
      data: data,
      dataType: 'html',
      beforeSend: (function(_this) {
        return function() {
          _this.set_modal_title(__('admin.permissions.total.title', {
            ':object': title
          }));
          _this.set_modal_content(_this.get_loader_template());
          return _this.show_modal();
        };
      })(this),
      error: (function(_this) {
        return function() {
          return _this.close_modal();
        };
      })(this),
      success: (function(_this) {
        return function(data) {
          if (data) {
            return _this.set_modal_content(data);
          } else {
            return _this.close_modal();
          }
        };
      })(this)
    });
  };

  PermissionTotal.prototype.set_modal_title = function(title) {
    return this.el.find('[data-total-permissions-modal-title]').html(title);
  };

  PermissionTotal.prototype.set_modal_content = function(html) {
    html = $(html).hide();
    this.el.find('[data-total-permissions-modal-body]').html(html);
    return html.fadeIn('medium');
  };

  PermissionTotal.prototype.show_modal = function() {
    return this.el.modal('show');
  };

  PermissionTotal.prototype.close_modal = function() {
    return this.el.modal('hide');
  };

  PermissionTotal.prototype.get_loader_template = function() {
    return "<div class=\"text-center\"><i class=\"fa fa-circle-o-notch fa-spin green fa-5x\"></i></div>";
  };

  return PermissionTotal;

})();


/*
  PopupJS crud widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.PopupJS = (function() {
  PopupJS.ATTR_NAME = "data-widget-popup";

  PopupJS.ATTR_ACCEPT_TERMS = 'data-accept-terms';

  PopupJS.ATTR_MODAL_HANDLER = 'data-modal-handler';

  PopupJS.ATTR_LOCATION = PopupJS.ATTR_NAME + "-location";

  PopupJS.ATTR_HEIGHT = PopupJS.ATTR_NAME + "-height";

  PopupJS.ATTR_WIDTH = PopupJS.ATTR_NAME + "-width";

  function PopupJS(el) {
    var modal_handler;
    this.el = el;
    this.show_popup = bind(this.show_popup, this);
    this.get_location = bind(this.get_location, this);
    this.get_width = bind(this.get_width, this);
    this.get_height = bind(this.get_height, this);
    this.get_settings = bind(this.get_settings, this);
    this.s = this.constructor;
    modal_handler = this.el.attr(this.s.ATTR_NAME);
    this.bs_modal = $("[" + this.s.ATTR_MODAL_HANDLER + "='" + modal_handler + "']");
    this.el.on("click", this.show_popup);
    if (this.bs_modal.length > 0) {
      this.bs_modal.find("[" + this.s.ATTR_ACCEPT_TERMS + "]").on('click', (function(_this) {
        return function(e) {
          var element, self;
          self = $(e.target);
          element = $(self.attr(_this.s.ATTR_ACCEPT_TERMS));
          element.prop('checked', true);
          return _this.bs_modal.modal('hide');
        };
      })(this));
    }
  }

  PopupJS.prototype.get_settings = function() {
    var height, left, top, width;
    width = this.get_width();
    height = this.get_height();
    left = (screen.width - width) / 2;
    top = (screen.height - height) / 2;
    return "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left;
  };

  PopupJS.prototype.get_height = function() {
    var h;
    h = this.el.attr(this.s.ATTR_HEIGHT);
    return h || 550;
  };

  PopupJS.prototype.get_width = function() {
    var w;
    w = this.el.attr(this.s.ATTR_WIDTH);
    return w || 900;
  };

  PopupJS.prototype.get_location = function() {
    var l;
    l = this.el.attr(this.s.ATTR_LOCATION);
    return l || this.el.attr('href');
  };

  PopupJS.prototype.show_popup = function() {
    var popup;
    if (this.bs_modal.length > 0) {
      this.bs_modal.find('.modal-body').load(this.get_location(), (function(_this) {
        return function() {
          return _this.bs_modal.modal();
        };
      })(this));
      return false;
    }
    popup = window.open(this.get_location(), 'GetIntnet', this.get_settings());
    if (window.focus) {
      popup.focus();
    }
    return false;
  };

  return PopupJS;

})();

var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.ResizableCreative = (function() {
  ResizableCreative.ATTR_NAME = "data-widget-resizable-creative";

  ResizableCreative.SIZE_FIELD = "#creative-size";

  ResizableCreative.RESIZABLE = "#resizable";

  ResizableCreative.RESIZABLE_FIELDS = "#dynamic_size";

  function ResizableCreative(el) {
    this.el = el;
    this.handleResizable = bind(this.handleResizable, this);
    this.s = this.constructor;
    $(this.s.RESIZABLE).on('change', (function(_this) {
      return function() {
        return _this.handleResizable();
      };
    })(this));
  }

  ResizableCreative.prototype.handleResizable = function() {
    var checked, resizable_fields, size_field;
    checked = $(this.s.RESIZABLE + ":checked").length;
    resizable_fields = $(this.s.RESIZABLE_FIELDS);
    size_field = $(this.s.SIZE_FIELD);
    if (checked) {
      resizable_fields.find('input').attr('disabled', false);
      resizable_fields.slideDown();
      return size_field.attr('disabled', true);
    } else {
      resizable_fields.slideUp(function() {
        return resizable_fields.find('input').attr('disabled', true);
      });
      return size_field.attr('disabled', false);
    }
  };

  return ResizableCreative;

})();


/*
  Select2 editor
  Options in attribute can be changed dynamically
  Reinit select2 to apply new options
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

INTENT.widgets.Select2Editor = (function() {
  Select2Editor.ATTR_NAME = "data-widget-select2-editor";

  function Select2Editor(el) {
    this.el = el;
    this.init_events = bind(this.init_events, this);
    this.get_popup_editor_html = bind(this.get_popup_editor_html, this);
    this.get_popup_editor_dom = bind(this.get_popup_editor_dom, this);
    this.show_popup_editor = bind(this.show_popup_editor, this);
    this.get_popup_editor_btn_html = bind(this.get_popup_editor_btn_html, this);
    this.get_select_all_btn_html = bind(this.get_select_all_btn_html, this);
    this.get_wrapper_html = bind(this.get_wrapper_html, this);
    this.get_dropdown_values = bind(this.get_dropdown_values, this);
    this.execute_action_select_all = bind(this.execute_action_select_all, this);
    this.execute_action_popup_editor = bind(this.execute_action_popup_editor, this);
    this.show_action_buttons = bind(this.show_action_buttons, this);
    this.parse_options = bind(this.parse_options, this);
    this.s = this.constructor;
    this.attr = this.s.ATTR_NAME;
    this.code = this.attr.replace('data-', '');
    this.ACTION_SELECT_ALL = 'select-all';
    this.ACTION_POPUP_EDITOR = 'popup-editor';
    this.init_events();
  }

  Select2Editor.prototype.parse_options = function() {
    return _.filter((this.el.attr(this.attr) || '').split(','));
  };

  Select2Editor.prototype.show_action_buttons = function(select) {
    var btn_popup_editor, btn_select_all, options, ref, ref1, results, s2, wrapper;
    s2 = select.data('select2');
    results = s2.$dropdown.find(".select2-results");
    if (!results.length) {
      return;
    }
    options = this.parse_options();
    wrapper = results.find("[" + this.attr + "-wrapper]");
    if (!options.length) {
      wrapper.remove();
      return;
    }
    if (wrapper.length) {
      return;
    }
    wrapper = $(this.get_wrapper_html());
    if (ref = this.ACTION_POPUP_EDITOR, indexOf.call(options, ref) >= 0) {
      btn_popup_editor = $(this.get_popup_editor_btn_html());
      btn_popup_editor.on('click', (function(_this) {
        return function(e) {
          var btn;
          btn = $(e.currentTarget);
          if (!btn.attr('disabled')) {
            return _this.execute_action_popup_editor(select, btn);
          }
        };
      })(this));
      wrapper.append(btn_popup_editor);
    }
    if (ref1 = this.ACTION_SELECT_ALL, indexOf.call(options, ref1) >= 0) {
      btn_select_all = $(this.get_select_all_btn_html());
      btn_select_all.on('click', (function(_this) {
        return function(e) {
          var btn;
          btn = $(e.currentTarget);
          if (!btn.attr('disabled')) {
            return _this.execute_action_select_all(select, btn);
          }
        };
      })(this));
      wrapper.append(btn_select_all);
    }
    return results.prepend(wrapper);
  };

  Select2Editor.prototype.execute_action_popup_editor = function(select, btn) {
    this.show_popup_editor(select);
    return select.select2('close');
  };

  Select2Editor.prototype.execute_action_select_all = function(select, btn) {
    var i, is_ajax, item, j, len, s2, values;
    select.select2('close');
    values = this.get_dropdown_values(select);
    if (!values.length) {
      return;
    }
    s2 = select.data('select2');
    is_ajax = _.isObject(s2.dataAdapter.ajaxOptions);
    if (is_ajax) {
      for (i = j = 0, len = values.length; j < len; i = ++j) {
        item = values[i];
        if (select.find("option[value='" + item.id + "']").length) {
          delete values[i];
        }
      }
    }
    return select.select2AppendValues(_.filter(values));
  };

  Select2Editor.prototype.get_dropdown_values = function(select) {
    var is_ajax, j, len, option, option_data, options, s2, search_string, values;
    values = [];
    s2 = select.data('select2');
    search_string = s2.$container.find('input.select2-search__field').val();
    is_ajax = _.isObject(s2.dataAdapter.ajaxOptions);
    options = s2.$dropdown.find('.select2-results__options .select2-results__option');
    for (j = 0, len = options.length; j < len; j++) {
      option = options[j];
      option_data = $(option).data('data');
      if (!_.isObject(option_data)) {
        continue;
      }
      if (option_data.element || is_ajax && search_string !== option_data.id) {
        values.push({
          id: option_data.id,
          text: option_data.text
        });
      }
    }
    return values;
  };

  Select2Editor.prototype.get_wrapper_html = function() {
    return "<div " + this.attr + "-wrapper\n     class='" + this.code + "-wrapper'\n></div>";
  };

  Select2Editor.prototype.get_select_all_btn_html = function() {
    return "<div " + this.attr + "-action='" + this.ACTION_SELECT_ALL + "'\n    class='btn btn-xs btn-default'\n>\n  <i class='fa fa-check-square-o'></i> " + (__('widget.select2-editor.btn.select-all')) + "\n</div>";
  };

  Select2Editor.prototype.get_popup_editor_btn_html = function() {
    return "<div " + this.attr + "-action='" + this.ACTION_POPUP_EDITOR + "'\n    class='btn btn-xs btn-default'\n>\n  <i class='fa fa-pencil'></i> " + (__('widget.select2-editor.btn.popup-editor')) + "\n</div>";
  };

  Select2Editor.prototype.show_popup_editor = function(select) {
    var popup, title, values;
    values = select.val() || [];
    if (typeof values !== 'string') {
      values = values.join('\n');
    }
    popup = this.get_popup_editor_dom();
    popup.find("[" + this.attr + "-" + this.ACTION_POPUP_EDITOR + "-popup-text]").val(values);
    title = select.data('placeholder') || '';
    popup.find("[" + this.attr + "-" + this.ACTION_POPUP_EDITOR + "-popup-title]").text(title);
    popup.find('.modal-body').css('height', ($(window).height() - 280) + 'px');
    return popup.data(this.code + "-" + this.ACTION_POPUP_EDITOR + "-popup-target", select).modal('show');
  };

  Select2Editor.prototype.get_popup_editor_dom = function() {
    var popup;
    popup = $("[" + this.attr + "-" + this.ACTION_POPUP_EDITOR + "-popup]");
    if (!popup.length) {
      popup = $(this.get_popup_editor_html());
      $('body').append(popup);
      popup.on('shown.bs.modal', (function(_this) {
        return function(e) {
          return popup.find("[" + _this.attr + "-" + _this.ACTION_POPUP_EDITOR + "-popup-text]").focus();
        };
      })(this));
      popup.find("[" + this.attr + "-" + this.ACTION_POPUP_EDITOR + "-popup-action='apply']").on('click', (function(_this) {
        return function(e) {
          var select, values;
          e.preventDefault();
          values = popup.find("[" + _this.attr + "-" + _this.ACTION_POPUP_EDITOR + "-popup-text]").val();
          values = values.split('\n');
          select = popup.data(_this.code + "-" + _this.ACTION_POPUP_EDITOR + "-popup-target");
          select.select2SetValues(values);
          return popup.modal('hide');
        };
      })(this));
    }
    return popup;
  };

  Select2Editor.prototype.get_popup_editor_html = function() {
    return "<div class=\"modal\"\n     tabindex=\"-1\"\n     role=\"dialog\"\n     " + this.attr + "-" + this.ACTION_POPUP_EDITOR + "-popup\n    >\n    <div class=\"modal-dialog widget-select2-editor-modal-dialog\" role=\"document\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                  <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <h4 class=\"modal-title\">\n                  " + (__('widget.select2-editor.popup.title')) + "\n                  <span " + this.attr + "-" + this.ACTION_POPUP_EDITOR + "-popup-title></span>\n                </h4>\n                <span class=\"text-muted\">" + (__('widget.select2-editor.popup.hint')) + "</span>\n            </div>\n            <div class=\"modal-body\">\n              <textarea class=\"form-control\"\n                        autofocus\n                        " + this.attr + "-" + this.ACTION_POPUP_EDITOR + "-popup-text></textarea>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        class=\"btn btn-primary\"\n                        " + this.attr + "-" + this.ACTION_POPUP_EDITOR + "-popup-action='apply'>\n                  " + (__('widget.select2-editor.popup.ok')) + "\n                </button>\n                <button type=\"button\"\n                        class=\"btn btn-link\"\n                        data-dismiss=\"modal\">\n                  " + (__('widget.select2-editor.popup.cancel')) + "\n                </button>\n\n            </div>\n        </div>\n    </div>\n</div>";
  };

  Select2Editor.prototype.init_events = function() {
    return this.el.on('select2:open', (function(_this) {
      return function(e) {
        return _this.show_action_buttons(_this.el);
      };
    })(this));
  };

  return Select2Editor;

})();


/*
  SmartTV Video creative widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

INTENT.widgets.SmartTvCreative = (function() {
  SmartTvCreative.ATTR_NAME = "data-widget-smart-tv-creative";

  SmartTvCreative.prototype.uploaders = {};

  SmartTvCreative.prototype.video_formats = {
    available: [],
    playable: ['mp4', 'webm']
  };

  function SmartTvCreative(el) {
    var file, i, init_files, len;
    this.el = el;
    this.update_form_buttons = bind(this.update_form_buttons, this);
    this.cancel_file_upload = bind(this.cancel_file_upload, this);
    this.init_file_uploader = bind(this.init_file_uploader, this);
    this.init_mask = bind(this.init_mask, this);
    this.render_on_error = bind(this.render_on_error, this);
    this.render_on_complete = bind(this.render_on_complete, this);
    this.render_template = bind(this.render_template, this);
    this.get_file_preview_template = bind(this.get_file_preview_template, this);
    this.get_file_load_button_template = bind(this.get_file_load_button_template, this);
    this.get_file_group_template = bind(this.get_file_group_template, this);
    this.s = this.constructor;
    this.max_file_size = +this.el.attr(this.s.ATTR_NAME + "-max-file-size");
    this.video_formats.available = this.el.attr(this.s.ATTR_NAME + "-available-video-formats").split(';');
    this.file_group_container = this.el.find("[" + this.s.ATTR_NAME + "-file-group-container]");
    this.file_group_template = this.el.find("[" + this.s.ATTR_NAME + "-file-group-template]").html();
    this.load_button_template = this.el.find("[" + this.s.ATTR_NAME + "-load-button-template]").html();
    this.loaded_link_template = this.el.find("[" + this.s.ATTR_NAME + "-loaded-link-template]").html();
    this.loaded_preview_template = this.el.find("[" + this.s.ATTR_NAME + "-loaded-preview-template]").html();
    this.btnSubmit = $('[name="update"].submit-button');
    this.btnSubmitJson = $('[name="save_raw_edit"].submit-button');
    init_files = this.el.data('widget-smart-tv-creative-init-files');
    if (init_files) {
      for (i = 0, len = init_files.length; i < len; i++) {
        file = init_files[i];
        this.add_file_group(file);
      }
    } else {
      this.add_file_group();
    }
    this.el.on('click', "[" + this.s.ATTR_NAME + "-file-group-remove]", (function(_this) {
      return function(e) {
        var eventRemoveFile, group, index, self;
        e.preventDefault();
        self = $(e.currentTarget);
        index = self.attr(_this.s.ATTR_NAME + "-file-group-remove");
        group = _this.el.find("[" + _this.s.ATTR_NAME + "-file-group='" + index + "']");
        if (group.length) {
          _this.cancel_file_upload(index);
          _this.update_form_buttons();
          self.tooltip('destroy');
          group.find('select').destroySelect2();
          if (document.getElementById('files_' + index + '_url') !== null) {
            eventRemoveFile = new CustomEvent("event_remove_video_file", {
              detail: {
                newIndex: index,
                deletedUrl: document.getElementById('files_' + index + '_url').value
              }
            });
            document.dispatchEvent(eventRemoveFile);
          }
          return group.fadeOut('fast', function() {
            return this.remove();
          });
        }
      };
    })(this));
    this.el.on('click', "[" + this.s.ATTR_NAME + "-file-group-add]", (function(_this) {
      return function(e) {
        var self;
        e.preventDefault();
        self = $(e.currentTarget);
        if (self.attr('disabled')) {
          return false;
        }
        return _this.add_file_group();
      };
    })(this));
    this.el.on('submit', "[" + this.s.ATTR_NAME + "-form]", (function(_this) {
      return function(e) {
        var data, errorTextValidateCreativeForm, extension, files, j, len1, self, valid_files_count;
        errorTextValidateCreativeForm = INTENT.utils.CreativesValidation.validateForm();
        if (errorTextValidateCreativeForm !== '') {
          INTENT.utils.Forms.disable_submit_buttons_loader();
          return;
        }
        self = $(e.currentTarget);
        data = self.serializeObject();
        files = data.files || [];
        valid_files_count = 0;
        for (j = 0, len1 = files.length; j < len1; j++) {
          file = files[j];
          if (!file) {
            continue;
          }
          extension = file.url.split('.').pop().toLowerCase();
          if (indexOf.call(_this.video_formats.available, extension) >= 0) {
            valid_files_count++;
          }
        }
        if (valid_files_count <= 0) {
          e.preventDefault();
          _this.btnSubmit.each(function(id, e) {
            self = $(e);
            if (self.hasClass('disabled')) {
              return self.text(__('btn.save')).removeClass('disabled').prop('disabled', false);
            }
          });
          _this.btnSubmitJson.each(function(id, e) {
            self = $(e);
            if (self.hasClass('disabled')) {
              return self.text(__('btn.save.json')).removeClass('disabled').prop('disabled', false);
            }
          });
          return INTENT.utils.Notify.error(__('creative.video.validator.error.required-formats'));
        }
      };
    })(this));
  }

  SmartTvCreative.prototype.add_file_group = function(data) {
    var index, last_group, new_group;
    if (data == null) {
      data = false;
    }
    index = 0;
    while (this.el.find("[" + this.s.ATTR_NAME + "-file-group='" + index + "']").length > 0) {
      index++;
    }
    new_group = jQuery(this.get_file_group_template(index, data));
    last_group = this.file_group_container.find("[" + this.s.ATTR_NAME + "-file-group]:last");
    if (last_group.length) {
      last_group.after(new_group);
    } else {
      this.file_group_container.prepend(new_group);
    }
    if (!data) {
      this.init_file_uploader(index);
    }
    this.init_mask(new_group.find("[" + this.s.ATTR_NAME + "-size]"));
    return getintent.utils.Autoinit.init(INTENT.widgets.Tooltip);
  };

  SmartTvCreative.prototype.get_file_group_template = function(index, data) {
    var template, upload_wrapper_body;
    if (data == null) {
      data = false;
    }
    if (index === void 0) {
      return false;
    }
    template = this.file_group_template;
    template = this.render_template(template, {
      index: index
    });
    if (data) {
      template = this.render_template(template, data);
    }
    if (data.url) {
      upload_wrapper_body = this.get_file_preview_template(index, data);
    } else {
      upload_wrapper_body = this.get_file_load_button_template(index);
    }
    template = template.replace(/\#\{upload_wrapper_body\}/g, upload_wrapper_body);
    return template;
  };

  SmartTvCreative.prototype.get_file_load_button_template = function(index) {
    var template;
    template = this.load_button_template;
    return template = this.render_template(template, {
      index: index
    });
  };

  SmartTvCreative.prototype.get_file_preview_template = function(index, data) {
    var extension, template;
    if (index === void 0 || !data) {
      return false;
    }
    if (data.url) {
      extension = data.url.split('.').pop().toLowerCase();
    }
    template = this.loaded_link_template;
    if (indexOf.call(this.video_formats.playable, extension) >= 0) {
      template += this.loaded_preview_template;
    }
    return template = this.render_template(template, data);
  };

  SmartTvCreative.prototype.render_template = function(template, data) {
    var name;
    if (data == null) {
      data = {};
    }
    if (!template) {
      return false;
    }
    if (data.url) {
      name = data.url.split('/').pop();
    }
    if (name != null) {
      template = template.replace(/\#\{name\}/g, name);
    }
    if (data.index != null) {
      template = template.replace(/\#\{index\}/g, data.index);
    }
    if (data.size != null) {
      template = template.replace(/\#\{size\}/g, data.size);
    }
    if (data.file_size != null) {
      template = template.replace(/\#\{file_size\}/g, data.file_size);
    }
    if (data.url != null) {
      template = template.replace(/\#\{url\}/g, data.url);
    }
    if (data.length == null) {
      template = template.replace(/\(\#\{length\}.*?\)/g, '');
    } else {
      if (data.length != null) {
        template = template.replace(/\#\{length\}/g, data.length);
      }
    }
    return template;
  };

  SmartTvCreative.prototype.render_on_complete = function(index, response) {
    var group, upload_wrapper_body;
    if (index === void 0) {
      return false;
    }
    $("[" + this.s.ATTR_NAME + "-upload-progress-loading='" + index + "']").css('display', 'none');
    if (response && response.url) {
      group = jQuery("[" + this.s.ATTR_NAME + "-file-group='" + index + "']");
      if (response.size != null) {
        group.find("#files_" + index + "_size").val(response.size);
      }
      if (response.file_size != null) {
        group.find("#files_" + index + "_file_size").val(response.file_size);
      }
      if (response.url != null) {
        group.find("#files_" + index + "_url").val(response.url);
      }
      if (response.length != null) {
        group.find("#files_" + index + "_length").val(response.length);
      }
      if (!this.el.find("#video_name").val()) {
        this.el.find("#video_name").val(response.basename);
      }
      if (!this.el.find("#video_length").val()) {
        this.el.find("#video_length").val(response.length);
      }
      upload_wrapper_body = jQuery(this.get_file_preview_template(index, response));
      return $("[" + this.s.ATTR_NAME + "-upload-wrapper='" + index + "']").html(upload_wrapper_body);
    }
  };

  SmartTvCreative.prototype.render_on_error = function(index, response) {
    if (index == null) {
      return;
    }
    if (response != null) {
      INTENT.utils.Notify.error(response.error_text, {
        fadeOut: {
          enabled: true,
          delay: 10000
        }
      });
    }
    return $("[data-widget-smart-tv-creative-upload-progress-loading='" + index + "']").css('display', 'none');
  };

  SmartTvCreative.prototype.init_mask = function(element) {
    return $(element).mask('0ZZZZZZZZZx0ZZZZZZZZZ', {
      translation: {
        'Z': {
          pattern: /[0-9]/,
          optional: true
        }
      }
    });
  };

  SmartTvCreative.prototype.init_file_uploader = function(index) {
    var accept_extensions, element, extension, i, len, ref;
    element = document.querySelector("[" + this.s.ATTR_NAME + "-upload-button='" + index + "']");
    if (element === void 0) {
      return false;
    }
    accept_extensions = [];
    ref = this.video_formats.available;
    for (i = 0, len = ref.length; i < len; i++) {
      extension = ref[i];
      accept_extensions.push('.' + extension);
    }
    accept_extensions = accept_extensions.join(',');
    return this.uploaders[index] = new qq.FileUploaderBasic({
      button: element,
      action: '/campaigns/upload_video/smart',
      debug: true,
      inputName: 'video',
      encoding: 'multipart',
      multiple: false,
      sizeLimit: this.max_file_size,
      acceptFiles: accept_extensions,
      onSubmit: this.on_upload_submit,
      onUpload: this.on_upload,
      onProgress: this.on_upload_progress,
      onComplete: this.on_upload_complete,
      onError: this.on_upload_error,
      params: {
        index: index,
        helpers: {
          cancel_file_upload: this.cancel_file_upload,
          get_file_preview_template: this.get_file_preview_template,
          render_on_complete: this.render_on_complete,
          render_on_error: this.render_on_error,
          update_form_buttons: this.update_form_buttons
        }
      },
      messages: {
        sizeError: __('creative.video.uploader.error.file-size')
      },
      showMessage: function(message) {
        if (typeof message === 'string') {
          return INTENT.utils.Notify.error(message);
        }
      }
    });
  };

  SmartTvCreative.prototype.cancel_file_upload = function(index) {
    if (index !== void 0 && this.uploaders[index]) {
      return this.uploaders[index]._handler.cancelAll();
    }
  };

  SmartTvCreative.prototype.update_form_buttons = function() {
    var in_progress, key, ref, uploader;
    in_progress = false;
    ref = this.uploaders;
    for (key in ref) {
      uploader = ref[key];
      if (uploader.getInProgress() > 0) {
        in_progress = true;
        break;
      }
    }
    if (in_progress) {
      return INTENT.utils.Forms.disable_submit_buttons();
    } else {
      return INTENT.utils.Forms.enable_submit_buttons();
    }
  };

  SmartTvCreative.prototype.on_upload_submit = function() {
    var index, proggressLoading;
    index = this.params.index;
    this.params.helpers.cancel_file_upload(index);
    this.params.helpers.update_form_buttons();
    proggressLoading = $("[data-widget-smart-tv-creative-upload-progress-loading='" + index + "']");
    proggressLoading.css('display', 'block');
    proggressLoading.find('.upload-loading-text').html(__('ffmpeg.file.uploading'));
    return $("[data-widget-smart-tv-creative-upload-button='" + index + "']").addClass('hide_upload_button');
  };

  SmartTvCreative.prototype.on_upload = function(id, fileName) {};

  SmartTvCreative.prototype.on_upload_progress = function(id, fileName, loaded, total) {
    var index, percent, progress_bar;
    percent = 100;
    if (loaded < total) {
      percent = Math.round(loaded / total * 100);
    }
    index = this.params.index;
    if (percent >= 100) {
      progress_bar = $("[data-widget-smart-tv-creative-upload-progress-loading='" + index + "']");
      return progress_bar.find('.upload-loading-text').html(__('ffmpeg.file.handling'));
    }
  };

  SmartTvCreative.prototype.on_upload_complete = function(id, fileName, responseJSON) {
    var eventAddFile, index;
    index = $(this.button).attr("data-widget-smart-tv-creative-upload-button");
    $("[data-widget-smart-tv-creative-upload-button='" + index + "']").removeClass('hide_upload_button');
    if (responseJSON.error_text != null) {
      this.params.helpers.render_on_error(index, responseJSON);
      return;
    }
    this.params.helpers.render_on_complete(index, responseJSON);
    eventAddFile = new CustomEvent("event_add_video_file", {
      detail: {
        newIndex: index
      }
    });
    document.dispatchEvent(eventAddFile);
    return this.params.helpers.update_form_buttons();
  };

  SmartTvCreative.prototype.on_upload_error = function(id, name, reason, xhr) {
    console.log('on_upload_error: id, name, reason, xhr', id, name, reason, xhr);
    return false;
  };

  return SmartTvCreative;

})();

INTENT.widgets.SwitcherGroup = (function() {
  SwitcherGroup.ATTR_NAME = "data-widget-switcher-group";

  SwitcherGroup.CLASS_CURRENT = "switch-current";

  function SwitcherGroup(el) {
    var group;
    this.el = el;
    this.s = this.constructor;
    group = this.el.attr('data-widget-switcher-group');
    if (!group) {
      this.switchers_collection = this.el.find(".on-off");
    } else {
      this.switchers_collection = this.el.find(".on-off.group-" + group);
    }
    this.switchers_collection.on('switchChange.bootstrapSwitch', (function(_this) {
      return function(e, state) {
        var current;
        current = $(e.currentTarget);
        current.addClass(_this.s.CLASS_CURRENT);
        if (state) {
          _this.switchers_collection.filter(":not(." + _this.s.CLASS_CURRENT + ")").bootstrapSwitch('state', false);
          return current.removeClass(_this.s.CLASS_CURRENT);
        }
      };
    })(this));
  }

  return SwitcherGroup;

})();


/*
  @deprecated: use INTENT.utils.Tooltip instead
  Tooltip widget
 */
INTENT.widgets.Tooltip = (function() {
  Tooltip.ATTR_NAME = "data-widget-tooltip";

  Tooltip.SELECTOR_MODAL = "#modal_container";

  function Tooltip(el) {
    this.el = el;
    this.s = this.constructor;
    this.el.tooltip(this.get_options());
  }

  Tooltip.prototype.get_options = function() {
    return {
      'animation': true,
      'placement': 'top',
      'html': true,
      'container': $('body')
    };
  };

  return Tooltip;

})();


/*
  Tooltip crud widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.TooltipCrud = (function() {
  TooltipCrud.MODAL = "#modal_container";

  TooltipCrud.ATTR_NAME = "data-widget-crud-tooltip";

  TooltipCrud.ATTR_ROW = TooltipCrud.ATTR_NAME + "-row";

  TooltipCrud.ATTR_ROW_FORM = TooltipCrud.ATTR_ROW + "-form";

  function TooltipCrud(el) {
    this.el = el;
    this.success_submit_row = bind(this.success_submit_row, this);
    this.submit_row = bind(this.submit_row, this);
    this.s = this.constructor;
    this.el.on("submit", "form[" + this.s.ATTR_ROW_FORM + "]", this.submit_row);
  }

  TooltipCrud.prototype.submit_row = function(e) {
    var form, request, self;
    self = this;
    form = $(e.currentTarget);
    request = $.ajax({
      url: form.attr("action"),
      type: form.attr("method"),
      data: form.serialize(),
      dataType: "json"
    });
    request.done(function(xhr) {
      return self.success_submit_row(form, xhr);
    });
    return false;
  };

  TooltipCrud.prototype.success_submit_row = function(form, xhr) {
    return INTENT.widgets.TooltipCrud.close_modal();
  };

  TooltipCrud.close_modal = function() {
    return this.modal.modal('hide');
  };

  TooltipCrud.show_modal = function(data) {
    if (!this.modal) {
      this.modal = $(INTENT.widgets.TooltipCrud.MODAL);
    }
    this.modal.html(data);
    return this.modal.modal();
  };

  return TooltipCrud;

})();


/*
  TooltipEditor widget
 */

INTENT.widgets.TooltipEditor = (function() {
  TooltipEditor.ATTR_NAME = "data-widget-tooltip-pop";

  function TooltipEditor(el) {
    this.el = el;
    this.get_code = bind(this.get_code, this);
    this.s = this.constructor;
    this.el.on("dblclick", (function(_this) {
      return function() {
        var request;
        request = $.ajax({
          url: "/admin/tooltips/get_modal?code=" + (_this.get_code()),
          type: "get",
          dataType: "html"
        });
        return request.done(function(data) {
          return INTENT.widgets.TooltipCrud.show_modal(data);
        });
      };
    })(this));
  }

  TooltipEditor.prototype.get_code = function() {
    return this.el.attr(this.s.ATTR_NAME);
  };

  return TooltipEditor;

})();


/*
  Dynamic creative widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.TrdPartyCreative = (function() {
  TrdPartyCreative.CM_EDITOR_ID = "3rd-party-content";

  TrdPartyCreative.ATTR_NAME = "data-widget-3rd-party-creative";

  TrdPartyCreative.ATTR_FIELD_EMPTY_TYPE = TrdPartyCreative.ATTR_NAME + "-empty-type";

  TrdPartyCreative.ATTR_FIELD_CHANGE_TYPE = TrdPartyCreative.ATTR_NAME + "-change-type";

  TrdPartyCreative.ATTR_FIELD_EDITOR_TYPE = TrdPartyCreative.ATTR_NAME + "-editor-type";

  TrdPartyCreative.ATTR_FIELD_CONTENT_JS = TrdPartyCreative.ATTR_NAME + "-content-js";

  TrdPartyCreative.ATTR_FIELD_CONTENT_HTML = TrdPartyCreative.ATTR_NAME + "-content-html";

  function TrdPartyCreative(el) {
    this.el = el;
    this.switch_type_content = bind(this.switch_type_content, this);
    this.get_cm_instance = bind(this.get_cm_instance, this);
    this.update_cm_type = bind(this.update_cm_type, this);
    this.checkCreative = bind(this.checkCreative, this);
    this.s = this.constructor;
    this.empty_type = this.el.find("[" + this.s.ATTR_FIELD_EMPTY_TYPE + "]");
    this.change_type = this.el.find("[" + this.s.ATTR_FIELD_CHANGE_TYPE + "]");
    this.editor_type = this.el.find("#" + this.s.CM_EDITOR_ID);
    this.content_js = this.el.find("[" + this.s.ATTR_FIELD_CONTENT_JS + "]");
    this.content_html = this.el.find("[" + this.s.ATTR_FIELD_CONTENT_HTML + "]");
    this.content_js_checkbox = this.content_js.find(".on-off");
    this.content_js_textarea = this.content_js.find("textarea");
    this.content_html_textarea = this.content_html.find("textarea");
    this.content_js_checkbox.on('switchChange.bootstrapSwitch', this.switch_type_content);
    this.change_type.on('change', this.update_cm_type);
    $('.submit-button').on('click', (function(_this) {
      return function(e) {
        var errorTextValidateCreativeForm;
        errorTextValidateCreativeForm = INTENT.utils.CreativesValidation.validateForm();
        if (errorTextValidateCreativeForm !== '') {
          INTENT.utils.Forms.disable_submit_buttons_loader();
          return;
        }
        return _this.checkCreative(e);
      };
    })(this));
  }

  TrdPartyCreative.prototype.checkCreative = function(e) {
    var actionName, self, value;
    self = this;
    this.btnSubmit = $(e.target);
    this.form = this.btnSubmit.parents('form#main_form');
    actionName = this.btnSubmit.attr('name');
    if (!actionName) {
      actionName = 'update';
    }
    value = this.get_cm_instance().getValue();
    if (value.indexOf('[[CLICK_PREFIX]]') === -1 && value.indexOf('[[CLICK_PREFIX_ENCODED]]') === -1 && value.indexOf('[[CLICK_TRACKING_BEACON]]') === -1) {
      show_confirm(__("creatives.click_macros_warn"), function() {
        self.form.append("<input type=\"hidden\" name=\"" + actionName + "\" value=\"true\" />");
        return self.form.submit();
      }, function() {
        return self.btnSubmit.hideLoader('disabled');
      }, __('btn.save'), __('btn.cancel'));
      return false;
    }
    if ($("#resizable:checked").length) {
      if (value.indexOf('[[WIDTH]]') === -1 || value.indexOf('[[HEIGHT]]') === -1) {
        show_notification(__("creatives.no_resizable_macros"), true, 'warning', function() {
          return self.btnSubmit.hideLoader('disabled');
        });
        return false;
      }
    }
  };

  TrdPartyCreative.prototype.update_cm_type = function() {
    var editor, label, type, unset_type, value;
    value = this.change_type.val();
    editor = this.get_cm_instance();
    label = this.el.find("label[for='" + this.s.CM_EDITOR_ID + "']");
    if (value === 'JS') {
      type = 'javascript';
      unset_type = 'HTML';
    } else {
      type = 'htmlmixed';
      unset_type = 'JS';
    }
    this.editor_type.attr('name', value);
    this.editor_type.attr('placeholder', value);
    this.empty_type.attr('name', unset_type);
    if (editor) {
      editor.setOption('mode', type);
      editor.setOption('placeholder', value);
    }
    label.html(value + '&nbsp;<span class="text-danger">*</span>');
    return this.editor_type.trigger('change');
  };

  TrdPartyCreative.prototype.get_cm_instance = function() {
    return get_cm_instance(this.s.CM_EDITOR_ID);
  };

  TrdPartyCreative.prototype.switch_type_content = function(e, state) {
    var codemirror_instances;
    if (state) {
      this.content_js.removeClass('disabled');
      this.content_html.addClass('disabled');
      this.content_js_textarea.attr('disabled', false);
      this.content_html_textarea.attr('disabled', true);
      this.empty_type.attr('name', 'HTML');
    } else {
      this.content_js.addClass('disabled');
      this.content_html.removeClass('disabled');
      this.content_js_textarea.attr('disabled', true);
      this.content_html_textarea.attr('disabled', false);
      this.empty_type.attr('name', 'JS');
    }
    codemirror_instances['3rd-party-content-js'].toTextArea();
    codemirror_instances['3rd-party-content-html'].toTextArea();
    codemirror_instances = {};
    return init_codemirror();
  };

  return TrdPartyCreative;

})();


/*
  Tree widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.TreeControl = (function() {
  TreeControl.ATTR_NAME = "data-widget-tree-control";

  function TreeControl(el) {
    this.el = el;
    this.initSegmentsTree = bind(this.initSegmentsTree, this);
    this.changeSegmentList = bind(this.changeSegmentList, this);
    this.getSegmentList = bind(this.getSegmentList, this);
    this.s = this.constructor;
    this.advertiser_id = $('#edit-campaign-form').attr('data-advertiser-id');
    this.object_id = $('#edit-campaign-form').attr('data-object-id');
    this.for_mobile = $('#edit-campaign-form').attr('data-is-mobile');
    this.json_node = this.el.closest('[data-widget-targeting-type]').attr('data-widget-targeting-type');
    this.treeRoot = this.el.find("[data-tree-container] > ul");
    this.segments_checkbox = this.el.parents('.ajax-load').find(".on-off");
    this.segments_checkbox.on('switchChange.bootstrapSwitch', this.changeSegmentList);
    if (this.treeRoot.length > 0) {
      this.initSegmentsTree();
    }
  }

  TreeControl.prototype.getSegmentList = function() {
    var data, request, self, tree_container;
    self = this;
    tree_container = this.el.find('[data-tree-container]');
    Loader.show({
      target: "[data-widget-tree-control]"
    });
    data = {
      advertiser_id: this.advertiser_id,
      object_id: this.object_id,
      json_node: this.json_node,
      for_mobile: this.for_mobile
    };
    request = $.ajax({
      url: "/ajax/get_segments",
      data: data,
      type: "get",
      dataType: "html"
    });
    return request.done(function(data) {
      self.el.addClass('ajax-load');
      tree_container.html(data);
      Loader.hide({
        target: "[data-widget-tree-control]"
      });
      return self.initSegmentsTree();
    });
  };

  TreeControl.prototype.changeSegmentList = function(e, state) {
    this.ajaxload = this.el.hasClass('ajax-load');
    if (state === true && this.ajaxload === false) {
      return this.getSegmentList();
    }
  };

  TreeControl.prototype.initSegmentsTree = function() {
    this.search = this.el.find("input.search");
    this.info = this.el.next('[data-tree-info]');
    this.treeContainer = this.el.find("[data-tree-container]");
    this.treeRoot = this.el.find("[data-tree-container] > ul");
    this.el.css({
      height: '250px'
    });
    return this.instance = new treefilter(this.treeRoot, {
      searcher: this.search,
      info: this.info,
      multiselect: true
    });
  };

  return TreeControl;

})();


/*
  Campaigns widget
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.UserlistFilter = (function() {
  UserlistFilter.ATTR_NAME = "data-widget-userlist-filter";

  function UserlistFilter(el) {
    this.el = el;
    this.init_select2 = bind(this.init_select2, this);
    this.s = this.constructor;
    this.init_select2();
  }

  UserlistFilter.prototype.init_select2 = function() {
    this.el.find('.select2-text').select2({
      tags: [],
      tokenSeparators: [",", ";"]
    });
    this.el.find('.select2-text-single').select2({
      tags: [],
      maximumSelectionSize: 1
    });
    this.el.find('.select2-select').select2({
      minimumResultsForSearch: -1
    });
    this.el.find('select').select2({
      minimumResultsForSearch: -1
    });
    return $(document).on("click", '.multiple-select2-arrow', function() {
      return open_select2(this.parent());
    });
  };

  return UserlistFilter;

})();

var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.widgets.VastInfo = (function() {
  VastInfo.ATTR_NAME = "data-widget-vast-info";

  VastInfo.VAST_INFO_API = "/ajax/vast_info";

  VastInfo.VAST_LOG_API = "/ajax/vast_scan_results";

  VastInfo.VAST_LOG_RESULT_API = "/ajax/vast_scan_info";

  VastInfo.SELECTOR_VAST_URL = "[data-vast-wrapper-url]";

  VastInfo.SELECTOR_VAST_ALERT = ".vast-alert";

  VastInfo.SELECTOR_VAST_INFO_TABLE = ".vast-info-table";

  VastInfo.SELECTOR_VAST_LOADER = ".vast-loader";

  VastInfo.SELECTOR_VAST_INFO_CONTAINER = ".vast-info-container";

  VastInfo.SELECTOR_MAIN_TABS_CONTAINER = "#creative_main_tabs";

  VastInfo.SELECTOR_VAST_TAB = "#tab-vast";

  VastInfo.SELECTOR_VAST_TAB_CONTAINER = "#vast";

  VastInfo.cache = {};

  VastInfo.schema = {};

  VastInfo.activeContainerSelector = '';

  VastInfo.drawed = false;

  VastInfo.lastError = '';

  VastInfo.dateFormat = "YYYY-MM-DD";

  VastInfo.currDate = '';

  VastInfo.creativeId = null;

  VastInfo.selectedDate = '';

  VastInfo.selectedItem = null;

  function VastInfo(el1) {
    this.el = el1;
    this.addHashParam = bind(this.addHashParam, this);
    this.getHashValue = bind(this.getHashValue, this);
    this.genHashFromUrl = bind(this.genHashFromUrl, this);
    this.toggleEmptyLogs = bind(this.toggleEmptyLogs, this);
    this.closeProxyVastTab = bind(this.closeProxyVastTab, this);
    this.proxyUrlClickHandler = bind(this.proxyUrlClickHandler, this);
    this.closeAlert = bind(this.closeAlert, this);
    this.showAlert = bind(this.showAlert, this);
    this.clearTable = bind(this.clearTable, this);
    this.getVastLog = bind(this.getVastLog, this);
    this.getVastScanResult = bind(this.getVastScanResult, this);
    this.getVastInfo = bind(this.getVastInfo, this);
    this.getTableRow = bind(this.getTableRow, this);
    this.wrapInTag = bind(this.wrapInTag, this);
    this.drawTable = bind(this.drawTable, this);
    this.drawTableWithTimeout = bind(this.drawTableWithTimeout, this);
    this.drawTableLoader = bind(this.drawTableLoader, this);
    this.initVastInfo = bind(this.initVastInfo, this);
    this.drawItem = bind(this.drawItem, this);
    this.drawLog = bind(this.drawLog, this);
    this.initVastLog = bind(this.initVastLog, this);
    this.initLatestScanLink = bind(this.initLatestScanLink, this);
    this.initState = bind(this.initState, this);
    this.s = this.constructor;
    this.s.activeContainerSelector = this.s.SELECTOR_VAST_TAB_CONTAINER;
    this.s.creativeId = $(".vast-log").data('creative-id');
    $(this.s.SELECTOR_VAST_TAB).on('shown.bs.tab', (function(_this) {
      return function(e) {
        _this.initState();
        _this.initVastInfo();
        _this.initLatestScanLink();
        return _this.initVastLog();
      };
    })(this));
  }

  VastInfo.prototype.initState = function() {
    var dateState, key, proxy;
    this.s.currDate = moment().format(this.s.dateFormat);
    dateState = this.getHashValue('date');
    key = this.getHashValue('key');
    proxy = this.getHashValue('proxy');
    if (dateState) {
      this.s.selectedDate = dateState;
    } else {
      this.s.selectedDate = this.s.currDate;
      this.addHashParam('date', this.s.selectedDate);
    }
    if (key && proxy) {
      return this.s.selectedItem = {
        key: key,
        proxy: proxy
      };
    }
  };

  VastInfo.prototype.initLatestScanLink = function() {
    var latestScan;
    if ($(this.s.SELECTOR_VAST_INFO_CONTAINER + " .panel-heading .latest-scan").length === 0) {
      latestScan = $("<i class='fa fa-reply latest-scan' title='" + (__('vast_log.latest_scan')) + "'>").tooltip({
        html: true
      });
      latestScan.on('click', (function(_this) {
        return function() {
          _this.addHashParam('key', null);
          _this.addHashParam('proxy', null);
          $('.proxy span').removeClass("selected");
          return _this.getVastInfo(_this.s.SELECTOR_VAST_TAB_CONTAINER).then(function(vastInfo) {
            return _this.drawTableWithTimeout(vastInfo, _this.s.SELECTOR_VAST_TAB_CONTAINER);
          });
        };
      })(this));
      return $(this.s.SELECTOR_VAST_INFO_CONTAINER + " .panel-heading").append(latestScan);
    }
  };

  VastInfo.prototype.initVastLog = function() {
    var hideEmpty;
    $("#period").val(this.s.selectedDate).daterangepicker({
      singleDatePicker: true,
      showDropdowns: false,
      format: this.s.dateFormat,
      locale: {
        format: this.s.dateFormat,
        applyLabel: __('daterangepicker.applyLabel'),
        cancelLabel: __('daterangepicker.cancelLabel'),
        fromLabel: __('daterangepicker.fromLabel'),
        toLabel: __('daterangepicker.toLabel'),
        customRangeLabel: __('daterangepicker.custom_range'),
        daysOfWeek: moment().lang(get_language()).lang()._weekdaysMin.slice(),
        monthNames: moment().lang(get_language()).lang()._monthsShort.slice(),
        firstDay: 1
      }
    });
    $('#period').on('apply.daterangepicker', (function(_this) {
      return function(ev, picker) {
        _this.s.selectedDate = picker.element.val();
        _this.addHashParam('date', _this.s.selectedDate);
        _this.addHashParam('key', null);
        _this.addHashParam('proxy', null);
        _this.s.logDrawed = false;
        return _this.drawLog();
      };
    })(this));
    hideEmpty = this.getHashValue('hide_empty');
    if (hideEmpty) {
      this.toggleEmptyLogs();
    }
    $('#hide_empty').prop('checked', hideEmpty).on('change', (function(_this) {
      return function(e) {
        if ($(e.target).is(":checked")) {
          _this.addHashParam('hide_empty', 'true');
          return _this.toggleEmptyLogs();
        } else {
          _this.addHashParam('hide_empty', null);
          return _this.toggleEmptyLogs(false);
        }
      };
    })(this));
    return this.drawLog(this.s.selectedDate);
  };

  VastInfo.prototype.drawLog = function(date) {
    if (date == null) {
      date = this.s.selectedDate;
    }
    if (this.s.logDrawed) {
      return;
    }
    $(".log-list").showLoader('text-center blue');
    return this.getVastLog(date).then((function(_this) {
      return function(log) {
        var item, key, li, subItem, ul;
        if (!log) {
          $(".log-list").hideLoader('text-center blue');
          $(".log-list").html($("<span class='text-center'>").text(__('log.search.empty-result')));
          return;
        }
        ul = $("<ul>");
        for (key in log) {
          item = log[key];
          li = $("<li>").append($("<span>").text(item.key + ":"));
          subItem = _this.drawItem(item);
          li.append(subItem);
          if (subItem.hasClass('empty')) {
            li.addClass('empty');
          }
          ul.append(li);
        }
        $(".log-list").hideLoader('text-center blue');
        $(".log-list").html('');
        $(".log-list").append(ul);
        if (_this.s.selectedItem) {
          if ($('.log-list .selected').length) {
            $('.log-list').scrollTop($('.log-list .selected').position().top - 150);
          }
        }
        return _this.s.logDrawed = true;
      };
    })(this));
  };

  VastInfo.prototype.drawItem = function(item) {
    var empty, fn, key, proxies, self, ul, value;
    proxies = item.proxies;
    ul = $("<ul>");
    self = this;
    empty = true;
    fn = function(ul, key, value) {
      var li, proxy, scanLink, selectedItem, xmlLink;
      proxy = key;
      scanLink = $("<span class='scan-link'>").text(__("vast_log.continent." + proxy));
      selectedItem = self.s.selectedItem;
      if (selectedItem && selectedItem.key === item.key && selectedItem.proxy === proxy) {
        scanLink.addClass('selected');
        self.selectedItem = null;
      }
      scanLink.on('click', (function(_this) {
        return function(e) {
          $('.proxy span').removeClass("selected");
          $(e.target).addClass("selected");
          return self.getVastScanResult(item.key, proxy).then(function(data) {
            return self.drawTableWithTimeout(data.summary_info, self.s.SELECTOR_VAST_TAB_CONTAINER);
          });
        };
      })(this));
      li = $("<li class='proxy'>").append(scanLink).append("&nbsp;&nbsp;");
      if (value.empty) {
        li.addClass('empty-item');
      }
      xmlLink = $("<span class='xml-link'>").append($("<a href='" + value.xml + "' target='_blank' class='fa fa-file-code-o' title='" + (__('vast_log.xml.download')) + "'>").tooltip().on('click', (function(_this) {
        return function(e) {
          return $(e.target).blur();
        };
      })(this)));
      li.append(xmlLink);
      return ul.append(li);
    };
    for (key in proxies) {
      value = proxies[key];
      if (!value.xml) {
        continue;
      }
      if (!value.empty) {
        empty = false;
      }
      fn(ul, key, value);
    }
    if (empty) {
      ul.addClass('empty');
    }
    return ul;
  };

  VastInfo.prototype.initVastInfo = function() {
    if (this.s.drawed) {
      return;
    }
    if (this.s.selectedItem) {
      return this.getVastScanResult(this.s.selectedItem.key, this.s.selectedItem.proxy).then((function(_this) {
        return function(data) {
          return _this.drawTable(data.summary_info, _this.s.SELECTOR_VAST_TAB_CONTAINER);
        };
      })(this));
    } else {
      return this.getVastInfo().then((function(_this) {
        return function(vastInfo) {
          return _this.drawTable(vastInfo);
        };
      })(this));
    }
  };

  VastInfo.prototype.drawTableLoader = function(selector) {
    if (selector == null) {
      selector = this.s.activeContainerSelector;
    }
    return $(selector + " " + this.s.SELECTOR_VAST_INFO_TABLE + " tbody").show().html('').append($("<tr>").append($("<td colspan='2' class='loader'>").html("<i class='fa fa-circle-o-notch fa-spin'></i>")));
  };

  VastInfo.prototype.drawTableWithTimeout = function(data, selector, timeout) {
    if (selector == null) {
      selector = this.s.activeContainerSelector;
    }
    if (timeout == null) {
      timeout = 500;
    }
    this.s.drawed = false;
    return setTimeout(((function(_this) {
      return function() {
        return _this.drawTable(data, selector);
      };
    })(this)), timeout);
  };

  VastInfo.prototype.drawTable = function(vastInfo, selector) {
    var colName, colValue, j, key, len, tableData, tag, type, val, value;
    if (selector == null) {
      selector = this.s.activeContainerSelector;
    }
    if (this.s.drawed) {
      return;
    }
    this.clearTable(selector);
    tableData = '';
    for (colName in vastInfo) {
      colValue = vastInfo[colName];
      if ((this.s.schema[colName] == null) || 0 === colValue.length) {
        continue;
      }
      type = this.s.schema[colName].type;
      value = colValue;
      tag = 'div';
      if (type === 'integer_array' || type === 'string_array') {
        value = '';
        for (j = 0, len = colValue.length; j < len; j++) {
          val = colValue[j];
          value += this.wrapInTag(val, 'li');
        }
        value = this.wrapInTag(value, 'ol');
      } else if (colName === 'media_file_urls' || colName === 'vast_tag_urls') {
        value = '';
        for (key in colValue) {
          val = colValue[key];
          if (val.is_proxied) {
            value += this.wrapInTag("<a href=\"" + val.url + "\" target=\"_blank\">" + val.url + "</a>\n<br/>\n<i class=\"fa fa-exclamation-triangle\" aria-hidden=\"true\"></i>\n<span class=\"proxied_url\" data-proxied-url=\"" + val.proxied_to + "\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"" + (__('vast_info.proxied_link_hint')) + "\">\n  " + (__('vast_info.proxied_to')) + ": " + val.proxied_to + "\n</span>", 'li');
          } else {
            value += this.wrapInTag("<a href='" + val.url + "' target='_blank'>" + val.url + "</a>", 'li');
          }
        }
        value = this.wrapInTag(value, 'ol');
      } else if ('boolean' === type) {
        if (colValue) {
          value = __('yes');
        } else {
          value = __('no');
        }
        value = this.wrapInTag(value, tag);
      } else {
        value = this.wrapInTag(colValue, tag);
      }
      tableData += this.getTableRow(__("vast_info.schema." + colName), value);
    }
    $(selector + " " + this.s.SELECTOR_VAST_INFO_TABLE + " tbody").show().append($(tableData)).find('.proxied_url').click((function(_this) {
      return function(e) {
        return _this.proxyUrlClickHandler(e);
      };
    })(this)).tooltip();
    this.s.drawed = true;
    return $(document).trigger("vast-info:drawed");
  };

  VastInfo.prototype.wrapInTag = function(value, tag, _class) {
    var result;
    if (_class == null) {
      _class = '';
    }
    if ('textarea' === tag) {
      result = "<" + tag + " rows=10{class}>" + value + "</" + tag + ">";
    } else {
      result = "<" + tag + "{class}>" + value + "</" + tag + ">";
    }
    if (_class) {
      return result.replace('{class}', " class='" + _class + "'");
    }
    return result.replace('{class}', '');
  };

  VastInfo.prototype.getTableRow = function(cellName, cellValue) {
    return "<tr><td class='col-sm-2'><strong>" + cellName + "</strong></td><td class='col-sm-10'>" + cellValue + "</td></tr>";
  };

  VastInfo.prototype.getVastUrl = function(selector) {
    if (selector == null) {
      selector = this.s.activeContainerSelector;
    }
    return $(selector + " " + this.s.SELECTOR_VAST_URL).data('vastWrapperUrl');
  };

  VastInfo.prototype.getVastInfo = function(selector) {
    var deferred, opts, vastUrl;
    if (selector == null) {
      selector = this.s.activeContainerSelector;
    }
    this.drawTableLoader(selector);
    vastUrl = this.getVastUrl(selector);
    deferred = $.Deferred();
    if (void 0 !== this.s.cache[vastUrl] && this.s.cache[vastUrl]) {
      this.closeAlert();
      deferred.resolve(this.s.cache[vastUrl]);
      return deferred.promise();
    } else if (this.s.lastError && false === this.s.cache[vastUrl]) {
      this.showAlert(this.s.lastError);
      $(this.s.SELECTOR_VAST_INFO_CONTAINER).hide();
      deferred.reject();
      return deferred.promise();
    }
    this.s.drawed = false;
    opts = {
      url: this.s.VAST_INFO_API,
      method: 'POST',
      data: {
        vast: vastUrl
      },
      cache: false
    };
    $.ajax(opts).done((function(_this) {
      return function(resp) {
        if (!resp.status) {
          _this.showAlert(resp.msg);
          $(_this.s.activeContainerSelector + " " + _this.s.SELECTOR_VAST_INFO_CONTAINER + " tbody").hide();
          _this.s.lastError = resp.msg;
          _this.s.cache[vastUrl] = false;
          return deferred.reject(resp.msg);
        } else {
          _this.closeAlert();
          _this.s.lastError = '';
          _this.s.schema = resp.schema;
          _this.s.cache[vastUrl] = resp.msg;
          return deferred.resolve(resp.msg);
        }
      };
    })(this)).fail((function(_this) {
      return function() {
        _this.s.lastError = __('vast_info.unable_to_parse');
        _this.showAlert(_this.s.lastError);
        return deferred.reject(_this.s.lastError);
      };
    })(this));
    return deferred.promise();
  };

  VastInfo.prototype.getVastScanResult = function(key, proxy) {
    var cacheKey, deferred, opts;
    this.drawTableLoader(this.s.SELECTOR_VAST_TAB_CONTAINER);
    this.addHashParam('key', key);
    this.addHashParam('proxy', proxy);
    cacheKey = this.s.creativeId + "-" + key + "-" + proxy;
    deferred = $.Deferred();
    if (void 0 !== this.s.cache[cacheKey] && this.s.cache[cacheKey]) {
      this.closeAlert();
      deferred.resolve(this.s.cache[cacheKey]);
      return deferred.promise();
    } else if (this.s.lastError && false === this.s.cache[cacheKey]) {
      this.showAlert(this.s.lastError);
      $(this.s.SELECTOR_VAST_INFO_TABLE + " tbody").hide();
      deferred.reject();
      return deferred.promise();
    }
    opts = {
      url: this.s.VAST_LOG_RESULT_API,
      method: 'POST',
      data: {
        creative_id: this.s.creativeId,
        date: this.s.selectedDate,
        key: key,
        proxy: proxy
      },
      cache: false
    };
    $.ajax(opts).done((function(_this) {
      return function(resp) {
        if (!resp.status) {
          _this.showAlert(resp.msg);
          $(_this.s.activeContainerSelector + " " + _this.s.SELECTOR_VAST_INFO_TABLE + " tbody").hide();
          _this.s.lastError = resp.msg;
          _this.s.cache[cacheKey] = false;
          return deferred.reject(resp.msg);
        } else {
          _this.closeAlert();
          _this.s.lastError = '';
          _this.s.cache[cacheKey] = resp.msg;
          _this.s.schema = resp.schema;
          return deferred.resolve(resp.msg);
        }
      };
    })(this)).fail((function(_this) {
      return function() {
        _this.s.lastError = __('vast_info.unable_to_parse');
        _this.showAlert(_this.s.lastError);
        $(_this.s.activeContainerSelector + " " + _this.s.SELECTOR_VAST_INFO_TABLE + " tbody").hide();
        return deferred.reject(_this.s.lastError);
      };
    })(this));
    return deferred.promise();
  };

  VastInfo.prototype.getVastLog = function(date) {
    var cacheKey, deferred, opts;
    if (!date) {
      date = this.s.currDate;
    }
    cacheKey = date + "-" + this.s.creativeId;
    deferred = $.Deferred();
    if (void 0 !== this.s.cache[cacheKey] && this.s.cache[cacheKey]) {
      deferred.resolve(this.s.cache[cacheKey]);
      return deferred.promise();
    } else if (this.s.lastError && false === this.s.cache[cacheKey]) {
      this.showAlert(this.s.lastError);
      $(".vast-log .log-list").html(__('log.search.empty-result'));
      deferred.reject();
      return deferred.promise();
    }
    opts = {
      url: this.s.VAST_LOG_API,
      method: 'POST',
      data: {
        creative_id: this.s.creativeId,
        date: date
      },
      cache: false
    };
    $.ajax(opts).done((function(_this) {
      return function(resp) {
        if (!resp.status) {
          _this.showAlert(resp.msg);
          $(".vast-log .log-list").html(__('log.search.empty-result'));
          _this.s.lastError = resp.msg;
          _this.s.cache[cacheKey] = false;
          return deferred.reject(resp.msg);
        } else {
          _this.s.lastError = '';
          _this.s.cache[cacheKey] = resp.msg;
          return deferred.resolve(resp.msg);
        }
      };
    })(this)).fail((function(_this) {
      return function() {
        _this.s.lastError = __('vast_info.unable_to_parse');
        _this.showAlert(_this.s.lastError);
        return deferred.reject(_this.s.lastError);
      };
    })(this));
    return deferred.promise();
  };

  VastInfo.prototype.clearTable = function(selector) {
    if (selector == null) {
      selector = this.s.activeContainerSelector;
    }
    this.s.drawed = false;
    return $(selector + " " + this.s.SELECTOR_VAST_INFO_TABLE + " tbody").empty();
  };

  VastInfo.prototype.showAlert = function(text) {
    $(this.s.activeContainerSelector + " " + this.s.SELECTOR_VAST_ALERT + " .alert-text").text(text);
    $(this.s.activeContainerSelector + " " + this.s.SELECTOR_VAST_ALERT).addClass('alert-danger').removeClass('hidden').show();
    return $(this.s.activeContainerSelector + " " + this.s.SELECTOR_VAST_LOADER).addClass('hidden');
  };

  VastInfo.prototype.closeAlert = function() {
    return $(this.s.activeContainerSelector + " " + this.s.SELECTOR_VAST_ALERT).addClass('hidden');
  };

  VastInfo.prototype.proxyUrlClickHandler = function(e) {
    var closeTabBtn, el, navs, newNavLi, newTab, newTabContainerID, proxiedUrl, tabLink, tabs, vastAlert, vastContainer, vastLoader;
    el = $(e.target);
    proxiedUrl = el.attr('data-proxied-url');
    newTabContainerID = "vast-proxy-tab-" + this.genHashFromUrl(proxiedUrl);
    if ($("#" + newTabContainerID).length) {
      $(this.s.SELECTOR_MAIN_TABS_CONTAINER + " .nav-tabs a[href='#" + newTabContainerID + "']").tab('show');
      return true;
    }
    navs = $(this.s.SELECTOR_MAIN_TABS_CONTAINER + " .nav-tabs");
    tabs = $(this.s.SELECTOR_MAIN_TABS_CONTAINER + " .tab-content");
    this.s.activeContainerSelector = '#' + newTabContainerID;
    closeTabBtn = $('<i>').addClass('fa fa-times opacity-dynamic close-tab').attr('aria-hidden', 'true').click((function(_this) {
      return function(e) {
        return _this.closeProxyVastTab(newTabContainerID);
      };
    })(this));
    tabLink = $('<a>').attr('href', "#" + newTabContainerID).attr('data-toggle', 'tab').html($('a#tab-vast').text()).append(closeTabBtn);
    newNavLi = $('<li>').attr('id', "nav-" + newTabContainerID).append(tabLink);
    newTab = $('<div>').addClass('tab-pane').attr('id', newTabContainerID).attr('role', 'tabpanel');
    vastLoader = $(this.s.SELECTOR_VAST_TAB_CONTAINER + " " + this.s.SELECTOR_VAST_LOADER).clone();
    vastAlert = $(this.s.SELECTOR_VAST_TAB_CONTAINER + " " + this.s.SELECTOR_VAST_ALERT).clone();
    vastAlert.hide().find('.alert-text').text('');
    vastContainer = $(this.s.SELECTOR_VAST_TAB_CONTAINER + " " + this.s.SELECTOR_VAST_INFO_CONTAINER).clone();
    vastContainer.find('.vast_url').html('').append($('<a>').attr("href", proxiedUrl).attr("target", "_blank").text(proxiedUrl));
    vastContainer.find('.latest-scan').remove();
    vastContainer.find("" + this.s.SELECTOR_VAST_INFO_TABLE).attr('data-vast-wrapper-url', proxiedUrl).find('tbody').empty();
    newTab.append(vastLoader).append(vastAlert).append(vastContainer);
    navs.append(newNavLi);
    tabs.append(newTab);
    newNavLi.find('a').tab('show');
    this.s.drawed = false;
    return this.getVastInfo().then((function(_this) {
      return function(vastInfo) {
        return _this.drawTable(vastInfo);
      };
    })(this));
  };

  VastInfo.prototype.closeProxyVastTab = function(tab) {
    var activeTab, newActiveTab;
    activeTab = $(this.s.SELECTOR_MAIN_TABS_CONTAINER + " .nav-tabs li.active a").attr('href');
    $(this.s.SELECTOR_MAIN_TABS_CONTAINER + " .nav-tabs #nav-" + tab).remove();
    $(this.s.SELECTOR_MAIN_TABS_CONTAINER + " .tab-content #" + tab).remove();
    if (activeTab === ("#" + tab)) {
      newActiveTab = $(this.s.SELECTOR_MAIN_TABS_CONTAINER + " .nav-tabs li:last-child a");
      this.s.activeContainerSelector = newActiveTab.attr('href');
      return newActiveTab.tab('show');
    }
  };

  VastInfo.prototype.toggleEmptyLogs = function(hide) {
    var logList;
    if (hide == null) {
      hide = true;
    }
    logList = $('.log-list');
    if (hide) {
      return logList.addClass('hide-empty');
    } else {
      return logList.removeClass('hide-empty');
    }
  };

  VastInfo.prototype.genHashFromUrl = function(url) {
    var chr, hash, i, j, ref;
    hash = 0;
    if (url.length === 0) {
      return hash;
    }
    for (i = j = 0, ref = url.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
      chr = url.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr;
      hash |= 0;
    }
    return hash;
  };

  VastInfo.prototype.getHashValue = function(key) {
    var matches;
    matches = location.hash.match(new RegExp(key + "=([^&]*)"));
    if (matches) {
      return decodeURIComponent(matches[1]);
    } else {
      return null;
    }
  };

  VastInfo.prototype.addHashParam = function(key, value) {
    var hash, hashData, item, j, len, newHash;
    hash = location.hash.replace('#', '').split('&');
    hashData = {};
    if (hash.length) {
      for (j = 0, len = hash.length; j < len; j++) {
        item = hash[j];
        item = item.split('=');
        if (item[0] && item[1]) {
          hashData[item[0]] = item[1];
        }
      }
    }
    if (value == null) {
      delete hashData[key];
    } else {
      hashData[key] = encodeURIComponent(value);
    }
    newHash = [];
    for (key in hashData) {
      value = hashData[key];
      newHash.push(key + "=" + value);
    }
    return location.hash = newHash.join('&');
  };

  return VastInfo;

})();


/*
  Video creative widget
  File uploader docs https://github.com/sstur/valums-file-uploader
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

INTENT.widgets.VideoCreative = (function() {
  VideoCreative.ATTR_NAME = "data-widget-video-creative";

  VideoCreative.prototype.uploaders = {};

  VideoCreative.prototype.video_formats = {
    available: [],
    playable: ['mp4', 'webm']
  };

  function VideoCreative(el) {
    var file, i, init_files, len;
    this.el = el;
    this.update_form_buttons = bind(this.update_form_buttons, this);
    this.cancel_file_upload = bind(this.cancel_file_upload, this);
    this.init_file_uploader = bind(this.init_file_uploader, this);
    this.init_mask = bind(this.init_mask, this);
    this.render_on_error = bind(this.render_on_error, this);
    this.render_on_complete = bind(this.render_on_complete, this);
    this.render_template = bind(this.render_template, this);
    this.get_file_preview_template = bind(this.get_file_preview_template, this);
    this.get_file_load_button_template = bind(this.get_file_load_button_template, this);
    this.get_file_group_template = bind(this.get_file_group_template, this);
    this.s = this.constructor;
    this.max_file_size = +this.el.attr(this.s.ATTR_NAME + "-max-file-size");
    this.video_formats.available = this.el.attr(this.s.ATTR_NAME + "-available-video-formats").split(';');
    this.file_group_container = this.el.find("[" + this.s.ATTR_NAME + "-file-group-container]");
    this.file_group_template = this.el.find("[" + this.s.ATTR_NAME + "-file-group-template]").html();
    this.load_button_template = this.el.find("[" + this.s.ATTR_NAME + "-load-button-template]").html();
    this.loaded_link_template = this.el.find("[" + this.s.ATTR_NAME + "-loaded-link-template]").html();
    this.loaded_preview_template = this.el.find("[" + this.s.ATTR_NAME + "-loaded-preview-template]").html();
    this.btnSubmit = $('[name="update"].submit-button');
    this.btnSubmitJson = $('[name="save_raw_edit"].submit-button');
    init_files = this.el.data('widget-video-creative-init-files');
    if (init_files) {
      for (i = 0, len = init_files.length; i < len; i++) {
        file = init_files[i];
        this.add_file_group(file);
      }
    } else {
      this.add_file_group();
    }
    this.el.on('click', "[" + this.s.ATTR_NAME + "-file-group-remove]", (function(_this) {
      return function(e) {
        var eventRemoveFile, group, index, self;
        e.preventDefault();
        self = $(e.currentTarget);
        index = self.attr(_this.s.ATTR_NAME + "-file-group-remove");
        group = _this.el.find("[" + _this.s.ATTR_NAME + "-file-group='" + index + "']");
        if (group.length) {
          _this.cancel_file_upload(index);
          _this.update_form_buttons();
          self.tooltip('destroy');
          group.find('select').destroySelect2();
          if (document.getElementById('files_' + index + '_url') !== null) {
            eventRemoveFile = new CustomEvent("event_remove_video_file", {
              detail: {
                newIndex: index,
                deletedUrl: document.getElementById('files_' + index + '_url').value
              }
            });
            document.dispatchEvent(eventRemoveFile);
          }
          return group.fadeOut('fast', function() {
            return this.remove();
          });
        }
      };
    })(this));
    this.el.on('click', "[" + this.s.ATTR_NAME + "-file-group-add]", (function(_this) {
      return function(e) {
        var self;
        e.preventDefault();
        self = $(e.currentTarget);
        if (self.attr('disabled')) {
          return false;
        }
        return _this.add_file_group();
      };
    })(this));
    this.el.on('submit', "[" + this.s.ATTR_NAME + "-form]", (function(_this) {
      return function(e) {
        var data, errorTextValidateCreativeForm, extension, files, j, len1, self, valid_files_count;
        errorTextValidateCreativeForm = INTENT.utils.CreativesValidation.validateForm();
        if (errorTextValidateCreativeForm !== '') {
          INTENT.utils.Forms.disable_submit_buttons_loader();
          return;
        }
        self = $(e.currentTarget);
        data = self.serializeObject();
        files = data.files || [];
        valid_files_count = 0;
        for (j = 0, len1 = files.length; j < len1; j++) {
          file = files[j];
          if (!file) {
            continue;
          }
          extension = file.url.split('.').pop().toLowerCase();
          if (indexOf.call(_this.video_formats.available, extension) >= 0) {
            valid_files_count++;
          }
        }
        if (valid_files_count <= 0) {
          e.preventDefault();
          _this.btnSubmit.each(function(id, e) {
            self = $(e);
            if (self.hasClass('disabled')) {
              return self.text(__('btn.save')).removeClass('disabled').prop('disabled', false);
            }
          });
          _this.btnSubmitJson.each(function(id, e) {
            self = $(e);
            if (self.hasClass('disabled')) {
              return self.text(__('btn.save.json')).removeClass('disabled').prop('disabled', false);
            }
          });
          return INTENT.utils.Notify.error(__('creative.video.validator.error.required-formats'));
        }
      };
    })(this));
  }

  VideoCreative.prototype.add_file_group = function(data) {
    var index, last_group, new_group;
    if (data == null) {
      data = false;
    }
    index = 0;
    while (this.el.find("[" + this.s.ATTR_NAME + "-file-group='" + index + "']").length > 0) {
      index++;
    }
    new_group = jQuery(this.get_file_group_template(index, data));
    last_group = this.file_group_container.find("[" + this.s.ATTR_NAME + "-file-group]:last");
    if (last_group.length) {
      last_group.after(new_group);
    } else {
      this.file_group_container.prepend(new_group);
    }
    if (!data) {
      this.init_file_uploader(index);
    }
    this.init_mask(new_group.find("[" + this.s.ATTR_NAME + "-size]"));
    return getintent.utils.Autoinit.init(INTENT.widgets.Tooltip);
  };

  VideoCreative.prototype.get_file_group_template = function(index, data) {
    var template, upload_wrapper_body;
    if (data == null) {
      data = false;
    }
    if (index === void 0) {
      return false;
    }
    template = this.file_group_template;
    template = this.render_template(template, {
      index: index
    });
    if (data) {
      template = this.render_template(template, data);
    }
    if (data.url) {
      upload_wrapper_body = this.get_file_preview_template(index, data);
    } else {
      upload_wrapper_body = this.get_file_load_button_template(index);
    }
    template = template.replace(/\#\{upload_wrapper_body\}/g, upload_wrapper_body);
    return template;
  };

  VideoCreative.prototype.get_file_load_button_template = function(index) {
    var template;
    template = this.load_button_template;
    return template = this.render_template(template, {
      index: index
    });
  };

  VideoCreative.prototype.get_file_preview_template = function(index, data) {
    var extension, template;
    if (index === void 0 || !data) {
      return false;
    }
    if (data.url) {
      extension = data.url.split('.').pop().toLowerCase();
    }
    template = this.loaded_link_template;
    if (indexOf.call(this.video_formats.playable, extension) >= 0) {
      template += this.loaded_preview_template;
    }
    return template = this.render_template(template, data);
  };

  VideoCreative.prototype.render_template = function(template, data) {
    var name;
    if (data == null) {
      data = {};
    }
    if (!template) {
      return false;
    }
    if (data.url) {
      name = data.url.split('/').pop();
    }
    if (name != null) {
      template = template.replace(/\#\{name\}/g, name);
    }
    if (data.index != null) {
      template = template.replace(/\#\{index\}/g, data.index);
    }
    if (data.size != null) {
      template = template.replace(/\#\{size\}/g, data.size);
    }
    if (data.file_size != null) {
      template = template.replace(/\#\{file_size\}/g, data.file_size);
    }
    if (data.url != null) {
      template = template.replace(/\#\{url\}/g, data.url);
    }
    if (data.length == null) {
      template = template.replace(/\(\#\{length\}.*?\)/g, '');
    } else {
      if (data.length != null) {
        template = template.replace(/\#\{length\}/g, data.length);
      }
    }
    return template;
  };

  VideoCreative.prototype.render_on_complete = function(index, response) {
    var group, upload_wrapper_body;
    if (index === void 0) {
      return false;
    }
    $("[" + this.s.ATTR_NAME + "-upload-progress-bar='" + index + "']").removeClass('active');
    if (response && response.url) {
      group = jQuery("[" + this.s.ATTR_NAME + "-file-group='" + index + "']");
      if (response.size != null) {
        group.find("#files_" + index + "_size").val(response.size);
      }
      if (response.file_size != null) {
        group.find("#files_" + index + "_file_size").val(response.file_size);
      }
      if (response.url != null) {
        group.find("#files_" + index + "_url").val(response.url);
      }
      if (response.length != null) {
        group.find("#files_" + index + "_length").val(response.length);
      }
      if (!this.el.find("#video_name").val()) {
        this.el.find("#video_name").val(response.basename);
      }
      if (!this.el.find("#video_length").val()) {
        this.el.find("#video_length").val(response.length);
      }
      upload_wrapper_body = jQuery(this.get_file_preview_template(index, response));
      return $("[" + this.s.ATTR_NAME + "-upload-wrapper='" + index + "']").html(upload_wrapper_body);
    }
  };

  VideoCreative.prototype.render_on_error = function(index, response) {
    var progress_bar;
    if (index == null) {
      return;
    }
    if (response != null) {
      INTENT.utils.Notify.error(response.error_text);
    }
    progress_bar = $("[data-widget-video-creative-upload-progress-bar='" + index + "']");
    progress_bar.width("0%");
    return progress_bar.removeClass('active');
  };

  VideoCreative.prototype.init_mask = function(element) {
    return $(element).mask('0ZZZZZZZZZx0ZZZZZZZZZ', {
      translation: {
        'Z': {
          pattern: /[0-9]/,
          optional: true
        }
      }
    });
  };

  VideoCreative.prototype.init_file_uploader = function(index) {
    var accept_extensions, element, extension, i, len, ref;
    element = document.querySelector("[" + this.s.ATTR_NAME + "-upload-button='" + index + "']");
    if (element === void 0) {
      return false;
    }
    accept_extensions = [];
    ref = this.video_formats.available;
    for (i = 0, len = ref.length; i < len; i++) {
      extension = ref[i];
      accept_extensions.push('.' + extension);
    }
    accept_extensions = accept_extensions.join(',');
    return this.uploaders[index] = new qq.FileUploaderBasic({
      button: element,
      action: '/campaigns/upload_video',
      debug: true,
      inputName: 'video',
      encoding: 'multipart',
      multiple: false,
      sizeLimit: this.max_file_size,
      acceptFiles: accept_extensions,
      onSubmit: this.on_upload_submit,
      onUpload: this.on_upload,
      onProgress: this.on_upload_progress,
      onComplete: this.on_upload_complete,
      onError: this.on_upload_error,
      params: {
        index: index,
        helpers: {
          cancel_file_upload: this.cancel_file_upload,
          get_file_preview_template: this.get_file_preview_template,
          render_on_complete: this.render_on_complete,
          render_on_error: this.render_on_error,
          update_form_buttons: this.update_form_buttons
        }
      },
      messages: {
        sizeError: __('creative.video.uploader.error.file-size')
      },
      showMessage: function(message) {
        return INTENT.utils.Notify.error(message);
      }
    });
  };

  VideoCreative.prototype.cancel_file_upload = function(index) {
    if (index !== void 0 && this.uploaders[index]) {
      return this.uploaders[index]._handler.cancelAll();
    }
  };

  VideoCreative.prototype.update_form_buttons = function() {
    var in_progress, key, ref, uploader;
    in_progress = false;
    ref = this.uploaders;
    for (key in ref) {
      uploader = ref[key];
      if (uploader.getInProgress() > 0) {
        in_progress = true;
        break;
      }
    }
    if (in_progress) {
      return INTENT.utils.Forms.disable_submit_buttons();
    } else {
      return INTENT.utils.Forms.enable_submit_buttons();
    }
  };

  VideoCreative.prototype.on_upload_submit = function() {
    var index;
    index = this.params.index;
    this.params.helpers.cancel_file_upload(index);
    this.params.helpers.update_form_buttons();
    $("[data-widget-video-creative-upload-progress-bar='" + index + "']").removeClass('active').width("0%");
    return $("[data-widget-video-creative-upload-progress-wrapper='" + index + "']").fadeIn('medium');
  };

  VideoCreative.prototype.on_upload = function(id, fileName) {};

  VideoCreative.prototype.on_upload_progress = function(id, fileName, loaded, total) {
    var index, percent, progress_bar;
    percent = 100;
    if (loaded < total) {
      percent = Math.round(loaded / total * 100);
    }
    index = this.params.index;
    progress_bar = $("[data-widget-video-creative-upload-progress-bar='" + index + "']");
    progress_bar.width(percent + "%");
    if (percent >= 100) {
      return progress_bar.addClass('active');
    }
  };

  VideoCreative.prototype.on_upload_complete = function(id, fileName, responseJSON) {
    var eventAddFile, index;
    index = $(this.button).attr("data-widget-video-creative-upload-button");
    if (responseJSON.error_text != null) {
      this.params.helpers.render_on_error(index, responseJSON);
      return;
    }
    this.params.helpers.render_on_complete(index, responseJSON);
    eventAddFile = new CustomEvent("event_add_video_file", {
      detail: {
        newIndex: index
      }
    });
    document.dispatchEvent(eventAddFile);
    return this.params.helpers.update_form_buttons();
  };

  VideoCreative.prototype.on_upload_error = function(id, name, reason, xhr) {
    return false;
  };

  return VideoCreative;

})();

$(function() {
  var ACTION_BUTTONS_SELECTOR, QUEUE_FINISHED, QUEUE_STARTED, QUEUE_WAITING, add_hidden, bToken, disable_buttons, enable_buttons, errorHandler, form, hideLoader, pollQueueState, showLoader, showRunningQueueState;
  QUEUE_STARTED = 'started';
  QUEUE_FINISHED = 'finished';
  QUEUE_WAITING = 'not_processed';
  ACTION_BUTTONS_SELECTOR = '[data-bulk-edit-form-action]';
  form = $('form[action*="/bulk_edit/"]');
  bToken = form.data('token');
  pollQueueState = function(token) {
    return $.ajax({
      url: '/ajax/v2/queue/poll',
      data: {
        token: token
      },
      method: 'POST'
    });
  };
  errorHandler = function(message) {
    var additional;
    if (message == null) {
      message = '';
    }
    $(ACTION_BUTTONS_SELECTOR).each(function(i, e) {
      $(e).removeAttr('disabled');
      return $(e).hideLoader();
    });
    Loader.hide();
    additional = (message ? ": <strong>" + message + "</strong>" : "");
    return INTENT.utils.Notify.danger("" + (__('bulk_edit_error')) + additional, {
      auto_hide: false
    });
  };
  showLoader = function(percents, message) {
    var progress;
    progress = $('.progress-container');
    if (progress.length) {
      $('.progress-bar').css('width', percents + "%");
      if (message !== void 0) {
        $('.progress-container .progress-text').html(message);
      }
      return progress.show();
    } else {
      if (message !== void 0) {
        return Loader.show({
          text: message
        });
      } else {
        return Loader.show();
      }
    }
  };
  add_hidden = function(value) {
    if (!$('[name="include[]"]').filter("[value='" + value + "']").length) {
      return $('<input>', {
        type: 'hidden',
        name: 'include[]',
        value: value
      }).appendTo(form);
    }
  };
  hideLoader = function() {
    var progress;
    progress = $('.progress-container');
    if (progress.length) {
      $('.progress-container .progress-text').text('');
      return progress.hide();
    } else {
      return Loader.hide();
    }
  };
  showRunningQueueState = function(resp) {
    var poll, waiting_current_poll, waiting_max_polls;
    waiting_max_polls = 20;
    waiting_current_poll = 0;
    if (resp.status) {
      return poll = setInterval(function() {
        return pollQueueState(bToken).done(function(r) {
          if (r.status) {
            if (r.state === QUEUE_STARTED && r.percents > 0) {
              form.hide();
              $('.bulk_edit__campaigns_list').hide();
              $('#subtitle').text(__('processing_please_wait'));
              return showLoader(r.percents, __('bulk_edit_processing_eta', {
                ':percents': "<strong>" + r.percents + " %</strong>",
                ':eta': r.remaining_time
              }));
            } else if (r.state === QUEUE_WAITING || (r.state === QUEUE_STARTED && r.percents === 0)) {
              $('#subtitle').text(__('processing_please_wait'));
              showLoader(0, '0 %');
              form.hide();
              waiting_current_poll += 1;
              if (waiting_current_poll > waiting_max_polls) {
                clearInterval(poll);
                hideLoader();
                return INTENT.utils.Notify.danger(__('bulk_edit_error'));
              }
            } else if (r.state === QUEUE_FINISHED) {
              clearInterval(poll);
              form.hide();
              $('.bulk_edit__campaigns_list').hide();
              $('#subtitle').text('');
              $(ACTION_BUTTONS_SELECTOR).hideLoader();
              showLoader(100, __('bulk_edit_all_done'));
              $('.progress-container .btn').show();
              return $(document).on('click', '.progress-container .btn', function(e) {
                $(e.target).showLoader();
                return window.location.href = form.prop('action').replace(/\/bulk_edit.*$/, '/list');
              });
            }
          } else {
            clearInterval(poll);
            return errorHandler(r.error);
          }
        }).fail(function() {
          clearInterval(poll);
          return errorHandler();
        });
      }, 3000);
    } else if ('error' in resp && resp.error) {
      return errorHandler(resp.error);
    }
  };
  disable_buttons = function() {
    return $(ACTION_BUTTONS_SELECTOR).attr('disabled', 'disabled');
  };
  enable_buttons = function() {
    return $(ACTION_BUTTONS_SELECTOR).removeAttr('disabled');
  };
  if (bToken) {
    pollQueueState(bToken).done(function(r) {
      if (!r.status || r.state === QUEUE_STARTED) {
        return showRunningQueueState(r);
      }
    });
  }
  return $(document).on('click', ACTION_BUTTONS_SELECTOR, function(e) {
    var action, apply, btn, campaigns, campaigns_msg, modified_campaigns;
    btn = $(e.target);
    if (btn.attr('disabled')) {
      e.preventDefault();
      return false;
    }
    disable_buttons();
    action = btn.attr('data-bulk-edit-form-action').toLowerCase();
    btn.showLoader();
    if (action === 'next') {
      return form.submit();
    } else if (action === 'apply') {
      campaigns = {};
      modified_campaigns = {};
      $('.bulk_edit__diff_campaign').each(function(key, item) {
        var id, name;
        item = $(item);
        id = item.attr('data-campaign-id');
        name = item.attr('data-campaign-name');
        add_hidden(id);
        if (item.attr('data-changed') === '1') {
          return modified_campaigns[id] = "#" + id + " <strong>" + name + "</strong>";
        } else {
          return campaigns[id] = "#" + id + " <strong>" + name + "</strong>";
        }
      });
      apply = function() {
        var campaigns_msg;
        if (_.size(campaigns) || _.size(modified_campaigns)) {
          if (!_.size(campaigns)) {
            campaigns = modified_campaigns;
          }
          campaigns_msg = "<div class='bulk_edit__alert_campaigns'>" + (_.values(campaigns).join('<br>')) + "</div>";
          return show_confirm(__('campaigns.bulk-edit.save-confirm', {
            ':campaigns': campaigns_msg
          }), function() {
            btn.showLoader();
            return $.ajax({
              url: form.attr('action'),
              method: 'POST',
              data: form.serialize()
            }).done(function(resp) {
              return showRunningQueueState(resp);
            }).fail(function() {
              return errorHandler();
            });
          }, function() {
            btn.hideLoader();
            return enable_buttons();
          });
        } else {
          btn.hideLoader();
          enable_buttons();
          return INTENT.utils.Notify.warning(__('campaigns.bulk-edit.save-confirm.empty-list'));
        }
      };
      if (_.size(modified_campaigns)) {
        campaigns_msg = "<div class='bulk_edit__alert_campaigns'>" + (_.values(modified_campaigns).join('<br>')) + "</div>";
        btn.hideLoader();
        return show_confirm(__('diff.object_was_changed.warning', {
          ':campaigns': campaigns_msg
        }), function() {
          return enable_buttons();
        }, function() {
          return apply();
        }, __('close_and_check'), __('ignore_and_continue'));
      } else {
        return apply();
      }
    }
  });
});

$(function() {
  var add_hidden, disable_group, enable_group, form, get_controls_html, get_group, get_group_holder_html, handle_learning_budget, init_editor, init_group, learning_budget_fields, set_changed_field;
  form = $('[data-bulk-edit-form]');
  learning_budget_fields = ['learning_budget[0][type]', 'learning_budget[0][strategy]'];
  init_editor = function() {
    var changed_fields, field, group, groups, i, j, len, len1;
    if (form.length <= 0) {
      return;
    }
    groups = form.find('.form-group');
    for (i = 0, len = groups.length; i < len; i++) {
      group = groups[i];
      group = $(group);
      if (group.hasClass('form-actions')) {
        continue;
      }
      init_group(group);
    }
    changed_fields = form.data('bulk-edit-changed-fields') || [];
    for (j = 0, len1 = changed_fields.length; j < len1; j++) {
      field = changed_fields[j];
      if ('learning_budget' === field) {
        field = 'temp_learning_budget_list';
      }
      enable_group($(".form-group[data-field-name='" + field + "']"));
    }
    INTENT.utils.Tooltip.init();
    return $(document).on('switchChange.bootstrapSwitch', '.on-off', function() {
      var disabledFieldInDom, disabledFieldName, el, isOn, targetFieldName;
      el = $(this);
      isOn = el.bootstrapSwitch('state');
      targetFieldName = $("[data-switch-handler='" + (el.data('switchTarget')) + "']").prop('name');
      disabledFieldName = 'bulk_edit_disabled_fields[]';
      disabledFieldInDom = form.find("input[name='" + disabledFieldName + "']").filter("[value='" + targetFieldName + "']");
      handle_learning_budget();
      if (!isOn) {
        if (!disabledFieldInDom.length && !_.contains(learning_budget_fields, targetFieldName)) {
          return add_hidden(disabledFieldName, targetFieldName);
        }
      } else {
        return disabledFieldInDom.remove();
      }
    });
  };
  handle_learning_budget = function() {
    var f, key, lb, results;
    lb = $("[name=temp_learning_budget_list]");
    if (lb.length) {
      lb.val().split('::');
      results = [];
      for (key in learning_budget_fields) {
        f = learning_budget_fields[key];
        results.push($(f).val(lb[key]));
      }
      return results;
    }
  };
  add_hidden = function(name, value) {
    return $('<input>', {
      type: 'hidden',
      name: name,
      value: value
    }).appendTo(form);
  };
  init_group = function(group) {
    var name;
    group = get_group(group);
    if (group != null) {
      name = group.attr('data-field-name');
      group.addClass('bulk_edit__form_group_off');
      group.prepend(get_controls_html(name));
      return group.prepend(get_group_holder_html());
    }
  };
  get_group = function(group) {
    if (!(group instanceof jQuery)) {
      group = $(group);
    }
    if (group.length) {
      return group;
    } else {
      return void 0;
    }
  };
  enable_group = function(group) {
    var name;
    group = get_group(group);
    if (group != null) {
      name = group.attr('data-field-name');
      set_changed_field(name, true);
      group.removeClass('bulk_edit__form_group_off');
      group.find('[data-bulk-edit-control="on"]').addClass('hidden');
      return group.find('[data-bulk-edit-control="off"]').removeClass('hidden');
    }
  };
  disable_group = function(group) {
    var name;
    group = get_group(group);
    if (group != null) {
      name = group.attr('data-field-name');
      set_changed_field(name, false);
      group.addClass('bulk_edit__form_group_off');
      group.find('[data-bulk-edit-control="on"]').removeClass('hidden');
      return group.find('[data-bulk-edit-control="off"]').addClass('hidden');
    }
  };
  set_changed_field = function(field, changed) {
    if ('temp_learning_budget_list' === field) {
      return add_hidden('bulk_edit_changed_fields[]', 'learning_budget');
    }
    return $("input[name='bulk_edit_changed_fields[]'][value='" + field + "']").prop('checked', changed);
  };
  get_group_holder_html = function() {
    return "<div class='bulk_edit__form_holder' data-bulk-edit-control='on'>\n  <div class='bulk_edit__form_holder_body'>&nbsp;</div>\n</div>";
  };
  get_controls_html = function(name) {
    return "<div class='bulk_edit__form_field_controls'>\n  <span data-bulk-edit-control='on'>\n  <i class='fa fa-fw fa-pencil opacity-dynamic'\n     title='" + (__("bulk-edit.controls.on.hint")) + "'\n     data-toggle='tooltip'></i>\n  </span>\n  <span data-bulk-edit-control='off' class='hidden'>\n    <i class='fa fa-fw fa-undo opacity-dynamic'\n       title='" + (__("bulk-edit.controls.off.hint")) + "'\n       data-toggle='tooltip'></i>\n  </span>\n  <input class='hidden'\n         type='checkbox'\n         name='bulk_edit_changed_fields[]'\n         value='" + name + "'>\n</div>";
  };
  $(document).on('click', '[data-bulk-edit-control]', function(e) {
    var action, group, self;
    e.preventDefault();
    self = $(e.currentTarget);
    action = self.attr('data-bulk-edit-control');
    group = self.closest('.form-group');
    if (action === 'on') {
      return enable_group(group);
    } else if (action === 'off') {
      return disable_group(group);
    }
  });
  return init_editor();
});

$(function() {
  var open_bulk_edit_action;
  open_bulk_edit_action = function(action, ids) {
    if (action && _.isArray(ids) && ids.length) {
      return $.ajax({
        url: "" + action,
        method: 'POST',
        data: {
          ids: "" + (ids.join(','))
        },
        dataType: 'json',
        beforeSend: function() {
          return Loader.show();
        },
        error: function() {
          return Loader.hide();
        },
        success: function(data) {
          if ((data != null) && data.redirectUrl) {
            return window.location = data.redirectUrl;
          }
        }
      });
    }
  };
  $(document).on('change', 'input[name="bulk_edit"]', function(e) {
    var checked_count, checked_type, self;
    self = $(e.currentTarget);
    checked_type = self.closest('[data-bulk-edit-unique-type]').attr('data-bulk-edit-unique-type');
    checked_count = $('input[name="bulk_edit"]:checked').length;
    $('[data-bulk-edit-selected-count]').text(checked_count);
    $('[data-bulk-edit-menu]').toggleClass('hidden', !checked_count);
    if (!checked_count) {
      return $("[data-bulk-edit-unique-type]").removeClass('invisible');
    } else {
      $("[data-bulk-edit-unique-type]").addClass('invisible');
      return $("[data-bulk-edit-unique-type='" + checked_type + "']").removeClass('invisible');
    }
  });
  $(document).on('click', '[data-bulk-edit-action]', function(e) {
    var action, ids, self, unique_type_error, unique_type_last;
    e.preventDefault();
    self = $(this);
    action = self.attr('data-bulk-edit-action');
    ids = [];
    unique_type_last = null;
    unique_type_error = false;
    $('input[name="bulk_edit"]:checked').each(function() {
      var id, input, unique_type;
      input = $(this);
      id = +input.val();
      if (id) {
        ids.push(id);
      }
      unique_type = input.closest('[data-bulk-edit-unique-type]').attr('data-bulk-edit-unique-type');
      if (unique_type_last == null) {
        unique_type_last = unique_type;
      }
      if (unique_type_last !== unique_type) {
        return unique_type_error = true;
      }
    });
    if (unique_type_error) {
      return INTENT.utils.Notify.warning(__('campaigns.bulk-edit.unique-type-error'));
    } else if (ids.length) {
      return open_bulk_edit_action(action, ids);
    }
  });
  $('[data-bulk-edit-select-cancel]').on('click', function(e) {
    e.preventDefault();
    return $('input[name="bulk_edit"]:checked').checkbox('click');
  });
  return $('[data-bulk-edit-select-all]').on('click', function(e) {
    e.preventDefault();
    return $("[data-bulk-edit-unique-type]").not('.invisible').find('input[name="bulk_edit"]').prop('checked', 'checked').trigger('change');
  });
});


/**
  * Controller binds together all the modules
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

INTENT.report.Controller = (function() {
  function Controller() {
    this.unlock_actions = bind(this.unlock_actions, this);
    this.lock_actions = bind(this.lock_actions, this);
    this.init_events = bind(this.init_events, this);
    this.transform_settings_for_datamanager = bind(this.transform_settings_for_datamanager, this);
    this.download_report = bind(this.download_report, this);
    this.show_report = bind(this.show_report, this);
    this.sort_report = bind(this.sort_report, this);
    this.get_fields_list = bind(this.get_fields_list, this);
    this.get_fields = bind(this.get_fields, this);
    this.get_field_name = bind(this.get_field_name, this);
    this.get_group_name = bind(this.get_group_name, this);
    this.get_fields_by_preset = bind(this.get_fields_by_preset, this);
    this.set_dataset_code = bind(this.set_dataset_code, this);
    this.get_dataset_code = bind(this.get_dataset_code, this);
    this.get_dataset = bind(this.get_dataset, this);
    this.get_language = bind(this.get_language, this);
    var code, dataset_orig, field_code, fields, i, key_fields, len, ref;
    this.code = 'report';
    this.attr = 'data-' + this.code;
    this.el = $("[" + this.attr + "]");
    if (!(this.el && this.el.length)) {
      return;
    }
    this.language = get_language();
    this.metadata = this.el.data(this.code + "-metadata");
    if (!this.metadata) {
      return;
    }
    this.tableData = null;
    this.fields_title = this.el.data(this.code + "-fields-title");
    this.groups_title = this.el.data(this.code + "-groups-title");
    this.dataset_select = this.el.find('select[name="dataset"]').eq(0);
    this.current_dataset_code = this.dataset_select.val();
    this.datasets = {};
    ref = this.metadata;
    for (i = 0, len = ref.length; i < len; i++) {
      dataset_orig = ref[i];
      code = dataset_orig.name;
      fields = [];
      key_fields = [];
      for (field_code in dataset_orig.key_fields) {
        key_fields.push(field_code);
      }
      for (field_code in dataset_orig.value_fields) {
        fields.push(field_code);
      }
      this.datasets[code] = {
        name: dataset_orig.display_name[this.get_language()],
        fields: fields,
        key_fields: key_fields,
        groups: dataset_orig.groups || [],
        exclude_from_default: dataset_orig.exclude_from_default || [],
        relations: dataset_orig.relations || {},
        defaults: dataset_orig.defaults || {},
        time_enabled: dataset_orig.time_enabled,
        default_timezone: dataset_orig.default_timezone,
        disable_timezone_select: dataset_orig.disable_timezone_select,
        cancel_support: dataset_orig.cancel_support || false
      };
    }
    this.init_events();
    this.renderer = new INTENT.report.Renderer(this);
    this.settingsManager = new INTENT.report.SettingsManager(this);
    this.presetManager = new INTENT.report.PresetManager(this);
    this.dataManager = new INTENT.report.DataManager(this);
  }

  Controller.prototype.get_language = function() {
    return this.language;
  };

  Controller.prototype.get_dataset = function(dataset_code) {
    dataset_code = dataset_code || this.get_dataset_code();
    return this.datasets[dataset_code];
  };

  Controller.prototype.get_dataset_code = function() {
    return this.current_dataset_code;
  };

  Controller.prototype.set_dataset_code = function(new_code) {
    var presetManager;
    if (new_code && this.current_dataset_code !== new_code) {
      this.current_dataset_code = new_code;
      presetManager = new INTENT.report.PresetManager(this);
      presetManager.reset_hash_fields();
      $(document).trigger(this.code + ":dataset_changed", this.current_dataset_code);
      return this.dataset_select.val(new_code).trigger('change');
    }
  };

  Controller.prototype.get_fields_by_preset = function(dataset_code) {
    var field, fields, fields_by_preset, i, len, presetManager, preset_fields;
    dataset_code = dataset_code || this.get_dataset_code();
    fields = this.get_dataset(dataset_code).fields;
    presetManager = new INTENT.report.PresetManager(this);
    if (presetManager != null) {
      preset_fields = presetManager.get_preset_fields(dataset_code);
      fields_by_preset = [];
      for (i = 0, len = fields.length; i < len; i++) {
        field = fields[i];
        if (indexOf.call(preset_fields, field) >= 0) {
          fields_by_preset.push(field);
        }
      }
      return fields_by_preset;
    } else {
      return fields;
    }
  };

  Controller.prototype.get_group_name = function(group_code) {
    if (group_code === '#') {
      return __('report.config_popup.groups.other');
    }
    return this.groups_title[group_code] && this.groups_title[group_code][this.language] || group_code;
  };

  Controller.prototype.get_field_name = function(field_code) {
    return this.fields_title[field_code] && this.fields_title[field_code][this.language] || field_code;
  };

  Controller.prototype.get_fields = function(dataset_code, type) {
    if (type == null) {
      type = 'key';
    }
    if (type === 'key') {
      return this.get_dataset(dataset_code).key_fields;
    } else {
      return this.get_fields_by_preset(dataset_code);
    }
  };

  Controller.prototype.get_fields_list = function(dataset_code, type) {
    var code, fields, fields_list, i, len;
    if (type == null) {
      type = 'key';
    }
    dataset_code = dataset_code || this.get_dataset_code();
    fields = type === 'key' ? this.get_dataset(dataset_code).key_fields : this.get_fields_by_preset(dataset_code);
    fields_list = [];
    for (i = 0, len = fields.length; i < len; i++) {
      code = fields[i];
      fields_list.push({
        id: code,
        text: this.get_field_name(code)
      });
    }
    return fields_list;
  };

  Controller.prototype.sort_report = function(key, direction) {
    var index, settings, sortedData;
    index = this.tableData.data.fields.indexOf(key);
    if (index === -1) {
      this.controller.show_report();
    }
    sortedData = this.tableData.data.data.sort((function(_this) {
      return function(a, b) {
        a = a[index].toString().replace(/ /g, '').replace('%', '');
        b = b[index].toString().replace(/ /g, '').replace('%', '');
        if (language === 'en') {
          a = a.replace(/,/g, '');
          b = b.replace(/,/g, '');
        } else {
          a = a.replace(',', '.');
          b = b.replace(',', '.');
        }
        if ($.isNumeric(a) && $.isNumeric(b)) {
          a = parseFloat(a);
          b = parseFloat(b);
        }
        if (a > b) {
          if (direction === 'asc') {
            return 1;
          } else {
            return -1;
          }
        }
        if (a < b) {
          if (direction === 'asc') {
            return -1;
          } else {
            return 1;
          }
        }
        return 0;
      };
    })(this));
    this.tableData.data.data = sortedData;
    this.tableData.query.order = {
      key: key,
      direction: direction
    };
    settings = this.settingsManager.get_settings();
    this.settingsManager.remember_settings(settings);
    this.transform_settings_for_datamanager(settings);
    return this.renderer.render(this.tableData);
  };

  Controller.prototype.show_report = function() {
    var presets, settings;
    presets = this.presetManager.get_preset_fields();
    settings = this.settingsManager.get_settings();
    settings.values = presets;
    this.settingsManager.remember_settings(settings);
    this.transform_settings_for_datamanager(settings);
    return this.dataManager.load_report(settings, this.renderer.render);
  };

  Controller.prototype.download_report = function() {
    var settings;
    settings = this.settingsManager.get_settings();
    this.settingsManager.remember_settings(settings);
    this.transform_settings_for_datamanager(settings);
    return this.dataManager.download_report(settings);
  };

  Controller.prototype.transform_settings_for_datamanager = function(settings) {
    delete settings.period;
    settings.start = this.settingsManager.periodManager.get_start_date();
    return settings.end = this.settingsManager.periodManager.get_end_date();
  };

  Controller.prototype.init_events = function() {
    this.dataset_select.on('change', (function(_this) {
      return function(e) {
        var new_code;
        new_code = $(e.currentTarget).val();
        if (new_code && _this.current_dataset_code !== new_code) {
          return _this.set_dataset_code(new_code);
        }
      };
    })(this));
    $(document).on('click', "[" + this.attr + "-action='show']", (function(_this) {
      return function(e) {
        return _this.show_report();
      };
    })(this));
    $(document).on('click', "[" + this.attr + "-action='download']", (function(_this) {
      return function(e) {
        return _this.download_report();
      };
    })(this));
    $(document).on('ajaxStart', (function(_this) {
      return function(e) {
        return _this.lock_actions();
      };
    })(this));
    return $(document).on('ajaxStop', (function(_this) {
      return function(e) {
        return _this.unlock_actions();
      };
    })(this));
  };

  Controller.prototype.lock_actions = function() {
    return $("[" + this.attr + "-action]").addClass('disabled').attr('disabled', 'disabled');
  };

  Controller.prototype.unlock_actions = function() {
    return $("[" + this.attr + "-action]").removeClass('disabled').removeAttr('disabled');
  };

  return Controller;

})();

$(function() {
  return new INTENT.report.Controller;
});


/**
  * Allows to request report as JSON object or Excel file
  * Callback can be used to render received JSON
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.report.DataManager = (function() {
  function DataManager(controller) {
    this.controller = controller;
    this.abortJobReqs = bind(this.abortJobReqs, this);
    this.cancel_running_job = bind(this.cancel_running_job, this);
    this.set_job_id = bind(this.set_job_id, this);
    this.init_events = bind(this.init_events, this);
    this.download_report = bind(this.download_report, this);
    this.load_report = bind(this.load_report, this);
    this.register_unload_handlers = bind(this.register_unload_handlers, this);
    this.unregister_unload_handlers = bind(this.unregister_unload_handlers, this);
    this.prepare_filters = bind(this.prepare_filters, this);
    this.show_api_link = bind(this.show_api_link, this);
    this.url_load = '/livereports/get_bigdata';
    this.url_download = '/livereports/excel';
    this.request = null;
    this.jobId = null;
    this.cancelRequests = [];
    this.cancelSupport = this.controller.get_dataset(this.controller.get_dataset_code()).cancel_support || false;
    this.cancelPressed = false;
    this.init_events();
  }

  DataManager.prototype.show_api_link = function(link) {
    var btn;
    btn = $('#api_link');
    $('.api_link_btn').each(function(id, e) {
      var self, url;
      self = $(e);
      url = link[self.data('format')] || '';
      self.off('click');
      self.on('click', (function(_this) {
        return function(e) {
          var el, err;
          e.preventDefault();
          try {
            el = document.createElement('textarea');
            el.value = url;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            return INTENT.utils.Notify.success(__('report.api_link.copy.success'));
          } catch (error) {
            err = error;
            return INTENT.utils.Notify.error(__('report.api_link.copy.error'));
          }
        };
      })(this));
      return self.find('a').attr('href', url);
    });
    btn.removeClass('hidden');
  };

  DataManager.prototype.prepare_filters = function(settings) {
    var filters;
    this.cancelSupport = this.controller.get_dataset(this.controller.get_dataset_code()).cancel_support || false;
    filters = settings.filters;
    settings.filters = [];
    settings.having = [];
    filters.map((function(_this) {
      return function(item) {
        if (_.isArray(item.values)) {
          return settings.filters.push(item);
        } else {
          return settings.having.push(item);
        }
      };
    })(this));
    return settings;
  };

  DataManager.prototype.unregister_unload_handlers = function() {
    window.onbeforeunload = function() {};
    return window.onblur = function() {};
  };

  DataManager.prototype.register_unload_handlers = function() {
    window.onbeforeunload = (function(_this) {
      return function() {
        if (_this.isRunning && _this.jobId) {
          _this.cancel_running_job();
        }
        return __('report_will_be_cancelled');
      };
    })(this);
    return window.onblur = (function(_this) {
      return function() {
        if (_this.isRunning && _this.jobId) {
          _this.cancel_running_job();
        }
        return __('report_will_be_cancelled');
      };
    })(this);
  };

  DataManager.prototype.load_report = function(settings, callback) {
    var performRequest, req, self;
    self = this;
    this.cancelPressed = false;
    performRequest = (function(_this) {
      return function(settings, callback) {
        return self.request = $.ajax({
          url: _this.url_load,
          method: 'post',
          data: {
            query: settings
          },
          dataType: 'json',
          beforeSend: function() {
            return _this.register_unload_handlers();
          },
          complete: function(xhr) {
            _this.abortJobReqs();
            _this.unregister_unload_handlers();
            Loader.hide();
            return _this.request = null;
          },
          success: function(response) {
            if (_.isObject(response)) {
              if (response.data && response.data.api_link) {
                _this.show_api_link(response.data.api_link);
              }
              if (_.isFunction(callback)) {
                return callback(response);
              }
            }
          }
        });
      };
    })(this);
    if (!this.cancelSupport) {
      Loader.show({
        buttons: ['cancel']
      });
      performRequest(settings, callback);
      return;
    }
    Loader.show();
    req = $.ajax({
      url: '/ajax/v2/report/id'
    }).always((function(_this) {
      return function(r) {
        Loader.show({
          buttons: ['cancel']
        });
        _this.jobId = r.report_id;
        settings.report_id = r.report_id;
        return performRequest(_this.prepare_filters(settings), callback);
      };
    })(this));
    return this.cancelRequests.push(req);
  };

  DataManager.prototype.download_report = function(settings, callback) {
    var performRequest, self;
    self = this;
    this.cancelPressed = false;
    performRequest = (function(_this) {
      return function(settings, callback) {
        return self.request = $.fileDownload(_this.url_download, {
          httpMethod: 'POST',
          data: {
            query: settings
          },
          prepareCallback: function(url) {
            _this.controller.lock_actions();
            _this.set_job_id();
            _this.register_unload_handlers();
            if (Cookies.get('fileDownload') != null) {
              return Cookies.remove('fileDownload');
            }
          },
          abortCallback: function(url) {
            _this.controller.unlock_actions();
            _this.abortJobReqs();
            Loader.hide();
            return _this.request = null;
          },
          failCallback: function(html, url) {
            _this.controller.unlock_actions();
            _this.request = null;
            _this.abortJobReqs();
            Loader.hide();
            if (!_this.cancelPressed) {
              return INTENT.utils.Notify.error(__('livereport.error.occurred'));
            }
          },
          successCallback: function(url) {
            _this.controller.unlock_actions();
            _this.unregister_unload_handlers();
            _this.request = null;
            _this.abortJobReqs();
            Loader.hide();
            if (_.isFunction(callback)) {
              return callback(response);
            }
          }
        });
      };
    })(this);
    if (!this.cancelSupport) {
      Loader.show({
        buttons: ['cancel']
      });
      performRequest(this.prepare_filters(settings), callback);
      return;
    }
    Loader.show();
    return $.ajax({
      url: '/ajax/v2/report/id'
    }).always((function(_this) {
      return function(r) {
        Loader.show({
          buttons: ['cancel']
        });
        _this.jobId = r.report_id;
        settings.report_id = r.report_id;
        return performRequest(_this.prepare_filters(settings), callback);
      };
    })(this));
  };

  DataManager.prototype.init_events = function() {
    return $(document).on('click', '[data-fullpage-loader-action="cancel"]', (function(_this) {
      return function() {
        if ((_this.request != null) && _.isFunction(_this.request.abort)) {
          _this.request.abort();
          return _this.cancel_running_job();
        } else {
          return Loader.hide();
        }
      };
    })(this));
  };

  DataManager.prototype.set_job_id = function(callback) {};

  DataManager.prototype.cancel_running_job = function() {
    var req;
    if (!this.cancelSupport) {
      return;
    }
    if (this.jobId) {
      req = $.ajax({
        url: '/ajax/v2/report/cancel',
        method: 'post',
        data: {
          report_id: this.jobId
        }
      });
      Cookies.set('fileDownload', 1);
      this.controller.unlock_actions();
      window.onbeforeunload = null;
      this.cancelPressed = true;
      return this.cancelRequests.push(req);
    }
  };

  DataManager.prototype.abortJobReqs = function() {
    if (!this.cancelSupport) {
      return;
    }
    this.cancelRequests.forEach(function(req) {
      return req.abort();
    });
    return this.cancelRequests = [];
  };

  return DataManager;

})();


/**
  * Allows to configure and save set of columns for each dataset
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

INTENT.report.PresetManager = (function() {
  PresetManager.datasets = {};

  PresetManager.presets = {};

  PresetManager.config_popup = null;

  function PresetManager(controller) {
    var dataset_code, dataset_fields, field_code, fields_orig, fields_parsed, i, len, preset, presets_data;
    this.controller = controller;
    this.init_events = bind(this.init_events, this);
    this.reset_hash_fields = bind(this.reset_hash_fields, this);
    this.get_group_fields_html = bind(this.get_group_fields_html, this);
    this.get_groups_html = bind(this.get_groups_html, this);
    this.get_config_popup_html = bind(this.get_config_popup_html, this);
    this.get_preset_fields = bind(this.get_preset_fields, this);
    this.set_preset_fields = bind(this.set_preset_fields, this);
    this.save_config = bind(this.save_config, this);
    this.get_default_fields = bind(this.get_default_fields, this);
    this.reset_to_defaults = bind(this.reset_to_defaults, this);
    this.refresh_config_button = bind(this.refresh_config_button, this);
    this.code = this.controller.code + '-preset';
    this.attr = this.controller.attr + '-preset';
    this.attr_popup = this.attr + '-config-popup';
    this.el = this.controller.el;
    this.datasets = this.controller.datasets;
    this.config_popup = $("[" + this.attr_popup + "]");
    if (!this.config_popup.length) {
      this.config_popup = $(this.get_config_popup_html());
      $('body').append(this.config_popup);
    }
    this.presets = {};
    presets_data = this.el.data(this.code + "-list") || {};
    for (dataset_code in presets_data) {
      if (this.datasets[dataset_code] == null) {
        continue;
      }
      dataset_fields = this.datasets[dataset_code].fields;
      preset = presets_data[dataset_code];
      fields_orig = preset.fields || [];
      fields_parsed = [];
      for (i = 0, len = fields_orig.length; i < len; i++) {
        field_code = fields_orig[i];
        if (indexOf.call(dataset_fields, field_code) >= 0) {
          fields_parsed.push(field_code);
        }
      }
      preset.fields = fields_parsed;
      this.presets[dataset_code] = preset;
    }
    this.refresh_config_button();
    this.init_events();
  }

  PresetManager.prototype.refresh_config_button = function() {
    var showing_columns, total_columns;
    total_columns = this.controller.get_dataset().fields.length;
    showing_columns = this.get_preset_fields().length || total_columns;
    return $("[" + this.attr_popup + "-open]").html('<i class="fa fa-cog"></i> ' + __('report.show_columns_count', {
      ':showing': showing_columns,
      ':total': total_columns
    })).removeClass('hidden');
  };

  PresetManager.prototype.reset_to_defaults = function() {
    var exclude_fields, i, key, len, results;
    exclude_fields = this.controller.get_dataset().exclude_from_default;
    this.config_popup.find("[" + this.attr_popup + "-checkbox]").prop('checked', true).trigger('change');
    results = [];
    for (i = 0, len = exclude_fields.length; i < len; i++) {
      key = exclude_fields[i];
      results.push(this.config_popup.find("[" + this.attr_popup + "-checkbox][name='" + key + "']").prop('checked', false).trigger('change'));
    }
    return results;
  };

  PresetManager.prototype.get_default_fields = function(dataset_code) {
    var defaults, exclude_fields, i, key, len, ref;
    exclude_fields = this.controller.get_dataset(dataset_code).exclude_from_default;
    defaults = [];
    ref = this.controller.get_dataset().fields;
    for (i = 0, len = ref.length; i < len; i++) {
      key = ref[i];
      if (indexOf.call(exclude_fields, key) < 0) {
        defaults.push(key);
      }
    }
    return defaults;
  };

  PresetManager.prototype.save_config = function(callback) {
    var field, preset_fields, preset_obj;
    preset_fields = [];
    preset_obj = this.config_popup.find('form').serializeObject();
    for (field in preset_obj) {
      preset_fields.push(field);
    }
    return $.ajax({
      url: '/livereports/save_preset/',
      method: 'post',
      data: {
        dataset: this.controller.get_dataset_code(),
        preset: {
          fields: preset_fields
        }
      },
      beforeSend: (function(_this) {
        return function() {};
      })(this),
      complete: (function(_this) {
        return function() {
          if (_.isFunction(callback)) {
            return callback();
          }
        };
      })(this),
      success: (function(_this) {
        return function(data) {
          if (data) {
            if (data.success) {
              _this.set_preset_fields(preset_fields);
              _this.refresh_config_button();
              return _this.config_popup.modal('hide');
            } else if (data.error) {
              return INTENT.utils.Notify.error(data.error);
            }
          }
        };
      })(this)
    });
  };

  PresetManager.prototype.set_preset_fields = function(preset_fields, dataset_code) {
    var preset;
    dataset_code = dataset_code || this.controller.get_dataset_code();
    preset = this.presets[dataset_code] || {};
    preset.fields = preset_fields;
    this.presets[dataset_code] = preset;
    return this.controller.settingsManager.update_key_selects(dataset_code);
  };

  PresetManager.prototype.get_preset_fields = function(dataset_code) {
    var dataset, fields, hash, hash_columns, hash_parts, i, item, key, len, param, preset, ref;
    dataset_code = dataset_code || this.controller.get_dataset_code();
    dataset = this.controller.get_dataset(dataset_code);
    preset = this.presets[dataset_code] || {};
    fields = preset.fields || this.get_default_fields(dataset_code) || [];
    hash_columns = null;
    hash = window.location.hash;
    hash_parts = hash.replace('#', '').split('&');
    for (i = 0, len = hash_parts.length; i < len; i++) {
      item = hash_parts[i];
      ref = item.split('='), key = ref[0], param = ref[1];
      if (key === 'values') {
        hash_columns = param.split(',');
      }
    }
    if (hash_columns && hash_columns.length) {
      fields = _.intersection(hash_columns, dataset.fields);
    }
    return fields;
  };

  PresetManager.prototype.get_config_popup_html = function() {
    return "<div " + this.attr_popup + " class=\"modal fade report-config-popup\" role=\"dialog\">\n  <div class=\"modal-dialog modal-lg\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"" + (__('close')) + "\"><span aria-hidden=\"true\">&times;</span></button>\n        <h4 class=\"modal-title\" " + this.attr_popup + "-title></h4>\n      </div>\n      <div class=\"modal-body\" " + this.attr_popup + "-body></div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"pull-left btn btn-default\" " + this.attr_popup + "-select-all>\n          <i class=\"fa fa-fw fa-check-square-o\"></i> " + (__('report.preset.select_all')) + "\n        </button>\n        <button type=\"button\" class=\"pull-left btn btn-default\" " + this.attr_popup + "-select-cancel>\n          <i class=\"fa fa-fw fa-square-o\"></i> " + (__('report.preset.select_none')) + "\n        </button>\n        <button type=\"button\" class=\"pull-left btn btn-default\" " + this.attr_popup + "-reset-defaults>\n          <i class=\"fa fa-fw fa-undo\"></i> " + (__('report.preset.reset_to_defaults')) + "\n        </button>\n        <button type=\"button\" class=\"btn btn-link\" data-dismiss=\"modal\">" + (__('cancel')) + "</button>\n        <button type=\"button\" class=\"btn btn-primary\" " + this.attr_popup + "-apply>" + (__('apply')) + "</button>\n      </div>\n    </div>\n  </div>\n</div>";
  };

  PresetManager.prototype.get_groups_html = function(dataset_code) {
    var dataset, fields_grouped, fields_not_grouped, group_code, group_fields, group_html, groups, groups_html;
    dataset = this.controller.get_dataset(dataset_code);
    if (!dataset) {
      return "";
    }
    groups = dataset.groups;
    fields_grouped = [];
    for (group_code in groups) {
      fields_grouped = _.union(fields_grouped, groups[group_code]);
    }
    fields_not_grouped = _.difference(dataset.fields, fields_grouped);
    if (fields_not_grouped.length) {
      groups['#'] = fields_not_grouped;
    }
    groups_html = "";
    for (group_code in groups) {
      group_fields = _.filter(groups[group_code], function(v) {
        return indexOf.call(dataset.fields, v) >= 0;
      });
      if (_.size(group_fields)) {
        group_html = this.get_group_fields_html(dataset_code, group_code, group_fields);
        if (_.keys(groups).length > 1) {
          group_html = "<div class=\"panel panel-default panel-small\">\n  <div class=\"panel-heading clearfix\">\n    <span class=\"pull-left panel-title\">\n      " + (this.controller.get_group_name(group_code)) + "\n    </span>\n    <div class=\"pull-right\">\n      <a href=\"#\"\n         title=\"" + (__('report.config_popup.groups.select_all')) + "\"\n         data-toggle=\"tooltip\"\n         class=\"btn btn-xs btn-default\"\n         " + this.attr_popup + "-group-select-all=\"" + group_code + "\">\n        <i class=\"fa fa-fw fa-check-square-o\"></i>\n      </a>\n      <a href=\"#\"\n         title=\"" + (__('report.config_popup.groups.select_none')) + "\"\n         data-toggle=\"tooltip\"\n         class=\"btn btn-xs btn-default\"\n         " + this.attr_popup + "-group-select-cancel=\"" + group_code + "\">\n        <i class=\"fa fa-fw fa-square-o\"></i>\n      </a>\n    </div>\n  </div>\n  <div class=\"panel-body\">\n    " + group_html + "\n  </div>\n</div>";
        }
        groups_html += "<div " + this.attr_popup + "-group='" + group_code + "' class='fields-group'>" + group_html + "</div>";
      }
    }
    return "<div class=\"row checkbox-table\">\n  <form>" + groups_html + "</form>\n</div>";
  };

  PresetManager.prototype.get_group_fields_html = function(dataset_code, group_code, group_fields) {
    var checked, dataset, field_code, fields_html, i, len, preset_fields;
    dataset = this.controller.get_dataset(dataset_code);
    if (!dataset) {
      return "";
    }
    if (!_.isArray(group_fields) || !group_fields.length) {
      return "";
    }
    preset_fields = this.get_preset_fields(dataset_code);
    fields_html = "";
    for (i = 0, len = group_fields.length; i < len; i++) {
      field_code = group_fields[i];
      checked = !preset_fields.length || indexOf.call(preset_fields, field_code) >= 0;
      fields_html += "<div class=\"col-sm-6 col-md-3\">\n  <div class=\"checkbox\">\n    <label>\n      <input type=\"checkbox\"\n             name=\"" + field_code + "\"\n             value=\"1\"\n             " + (checked ? 'checked="checked"' : '') + "\n             " + this.attr_popup + "-checkbox\n      >\n      " + (this.controller.get_field_name(field_code)) + "\n    </label>\n  </div>\n</div>";
    }
    return fields_html;
  };

  PresetManager.prototype.reset_hash_fields = function() {
    if (this.controller.settingsManager) {
      this.controller.settingsManager.set_watch_hash(false);
      window.location.hash = window.location.hash.replace(/&values=.+?&/, '&');
      window.location.hash = window.location.hash.replace(/&values=.+?$/, '');
      return setTimeout(((function(_this) {
        return function() {
          return _this.controller.settingsManager.set_watch_hash(true);
        };
      })(this)), 0);
    }
  };

  PresetManager.prototype.init_events = function() {
    $("[" + this.attr_popup + "-open]").on('click', (function(_this) {
      return function(e) {
        var dataset_code, dataset_name;
        e.preventDefault();
        dataset_code = _this.controller.get_dataset_code();
        dataset_name = _this.controller.get_dataset(dataset_code).name;
        _this.config_popup.find("[" + _this.attr_popup + "-title]").text(dataset_name);
        _this.config_popup.find("[" + _this.attr_popup + "-body]").html(_this.get_groups_html(dataset_code));
        _this.config_popup.modal('show');
        return INTENT.utils.Tooltip.init();
      };
    })(this));
    $("[" + this.attr_popup + "-apply]").on('click', (function(_this) {
      return function(e) {
        var self;
        e.preventDefault();
        _this.reset_hash_fields();
        self = $(e.currentTarget);
        if (self.hasClass('disabled')) {
          return;
        }
        self.showLoader('disabled');
        return _this.save_config(function() {
          return self.hideLoader('disabled');
        });
      };
    })(this));
    $(document).on(this.controller.code + ":dataset_changed", (function(_this) {
      return function(e, dataset_code) {
        return _this.refresh_config_button();
      };
    })(this));
    $(document).on('click', "[" + this.attr_popup + "-reset-defaults]", (function(_this) {
      return function(e) {
        e.preventDefault();
        _this.reset_hash_fields();
        return _this.reset_to_defaults();
      };
    })(this));
    $(document).on('click', "[" + this.attr_popup + "-select-all]", (function(_this) {
      return function(e) {
        e.preventDefault();
        return $("[" + _this.attr_popup + "-checkbox]:not(:checked)").prop('checked', true).trigger('change');
      };
    })(this));
    $(document).on('click', "[" + this.attr_popup + "-select-cancel]", (function(_this) {
      return function(e) {
        e.preventDefault();
        $("[" + _this.attr_popup + "-checkbox]:checked").prop('checked', false).trigger('change');
        return _this.reset_hash_fields();
      };
    })(this));
    $(document).on('click', "[" + this.attr_popup + "-group-select-all]", (function(_this) {
      return function(e) {
        var group, group_code, self;
        e.preventDefault();
        self = $(e.currentTarget);
        group_code = self.attr(_this.attr_popup + "-group-select-all");
        return group = $("[" + _this.attr_popup + "-group='" + group_code + "']").find("[" + _this.attr_popup + "-checkbox]:not(:checked)").prop('checked', true).trigger('change');
      };
    })(this));
    $(document).on('click', "[" + this.attr_popup + "-group-select-cancel]", (function(_this) {
      return function(e) {
        var group, group_code, self;
        e.preventDefault();
        self = $(e.currentTarget);
        group_code = self.attr(_this.attr_popup + "-group-select-cancel");
        return group = $("[" + _this.attr_popup + "-group='" + group_code + "']").find("[" + _this.attr_popup + "-checkbox]:checked").prop('checked', false).trigger('change');
      };
    })(this));
    return $(document).on('change', "[" + this.attr_popup + "-checkbox]", (function(_this) {
      return function() {
        var checked_count;
        checked_count = $("[" + _this.attr_popup + "-checkbox]:checked").length;
        return $("[" + _this.attr_popup + "-apply]").toggleClass('disabled', !checked_count);
      };
    })(this));
  };

  return PresetManager;

})();


/**
  * Allows to render JSON object as HTML table
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

INTENT.report.Renderer = (function() {
  function Renderer(controller) {
    this.controller = controller;
    this.get_report_table_body = bind(this.get_report_table_body, this);
    this.get_report_table_head = bind(this.get_report_table_head, this);
    this.get_table_html = bind(this.get_table_html, this);
    this.get_alert_html = bind(this.get_alert_html, this);
    this.render = bind(this.render, this);
    this.code = this.controller.code + '-renderer';
    this.attr = this.controller.attr + '-renderer';
  }

  Renderer.prototype.render = function(response) {
    var html;
    html = '';
    if (response.error || (response.query == null) || (response.data == null)) {
      html = this.get_alert_html('error', response.message || __('livereport.error.occurred'));
    } else if (!_.isArray(response.data.data) || !response.data.data.length) {
      html = this.get_alert_html('info', __('livereport.error.data.empty'));
    } else {
      html = this.get_table_html(response);
    }
    this.controller.tableData = response;
    $("[" + this.attr + "-wrapper]").html(html);
    return $("[" + this.attr + "-table]").multiTable();
  };

  Renderer.prototype.get_alert_html = function(type, message) {
    return "<div class=\"text-center alert alert-" + type + " alert-no-dismiss\">\n  " + message + "\n</div>";
  };

  Renderer.prototype.get_table_html = function(response) {
    var data, group_keys, left_col_count, left_col_visible, right_col_count;
    data = response.data;
    group_keys = data.group_keys || [];
    left_col_count = group_keys.length;
    right_col_count = _.difference(data.fields || [], data.group_keys || []).length;
    if (left_col_count <= right_col_count) {
      left_col_visible = Math.round((left_col_count + right_col_count) * (1 / 3));
    } else {
      left_col_visible = Math.round((left_col_count + right_col_count) * (2 / 3));
    }
    if (left_col_visible < 2) {
      left_col_visible = 2;
    }
    if (left_col_visible > left_col_count) {
      left_col_visible = left_col_count;
    }
    return "<table data-visible-left-col=\"" + left_col_visible + "\"\n       data-left-col=\"" + left_col_count + "\"\n       data-report-renderer-table\n>\n  " + (this.get_report_table_head(response)) + "\n  " + (this.get_report_table_body(response)) + "\n</table>";
  };

  Renderer.prototype.get_report_table_head = function(response) {
    var data, field, fields, html, i, len, query, ref, sorting, td_class;
    data = response.data;
    query = response.query;
    html = '';
    fields = data.fields;
    if (!fields || !fields.length) {
      return '';
    }
    sorting = {};
    if (query && _.isObject(query.order) && (query.order.key != null) && ((ref = query.order.direction) === 'asc' || ref === 'desc')) {
      sorting.key = query.order.key;
      sorting.direction = query.order.direction;
    }
    for (i = 0, len = fields.length; i < len; i++) {
      field = fields[i];
      td_class = 'sortable';
      if (field === 'advertiser_id' || field === 'campaign_id') {
        td_class += ' multi-table__name';
      }
      if (field === sorting.key) {
        td_class += ' sorted';
        td_class += sorting.direction === 'asc' ? ' ascending' : ' descending';
      }
      html += "<th class=\"" + td_class + "\"\n    data-key=\"" + field + "\">\n  <div>\n    " + (this.controller.get_field_name(field)) + "\n  </div>\n</th>";
    }
    return "<thead>\n  <tr>\n    " + html + "\n  </tr>\n</thead>";
  };

  Renderer.prototype.get_report_table_body = function(response) {
    var data, dataset, field_code, field_data, fields, html, html_total, i, index, j, k, len, len1, len2, query, row, rows, td_class, td_filter, total_row;
    data = response.data;
    query = response.query;
    fields = data.fields;
    if (!fields || !fields.length) {
      return '';
    }
    rows = data.data;
    if (!rows || !rows.length) {
      return '';
    }
    dataset = this.controller.get_dataset(query.dataset_name);
    if (!dataset) {
      return '';
    }
    html = '';
    for (i = 0, len = rows.length; i < len; i++) {
      row = rows[i];
      html += "<tr>";
      index = 0;
      for (j = 0, len1 = fields.length; j < len1; j++) {
        field_code = fields[j];
        field_data = row[index];
        index++;
        if (typeof field_data === 'undefined' || field_data === null) {
          html += "<td><div>&nbsp;</div></td>";
        } else {
          td_filter = '';
          td_class = '';
          if (indexOf.call(dataset.key_fields, field_code) >= 0) {
            td_class += 'multi-table__name';
            td_filter += "<a href=\"#\" class=\"fa fa-filter filter-by\"></a>";
          }
          html += "<td class='" + td_class + "'>\n  <div>\n    " + td_filter + "\n    " + field_data + "\n  </div>\n</td>";
        }
      }
      html += "</tr>";
    }
    html_total = '';
    total_row = response.total_row;
    if (total_row) {
      for (k = 0, len2 = fields.length; k < len2; k++) {
        field_code = fields[k];
        field_data = total_row[field_code];
        if (typeof field_data === 'undefined' || field_data === null) {
          html_total += "<td><div>&nbsp;</div></td>";
        } else {
          html_total += "<td>\n  <div>" + field_data + "</div>\n</td>";
        }
      }
    }
    return "<tbody>\n  <tr class=\"multi-table__footer\">\n    " + html_total + "\n  </tr>\n  " + html + "\n</tbody>";
  };

  return Renderer;

})();


/**
  * Encapsulates initializers for different select2 configurations
  * Used by SettingsManager
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.report.Select2Helper = (function() {
  function Select2Helper(parent) {
    this.parent = parent;
    this.init_select2_object = bind(this.init_select2_object, this);
    this.init_select2_enum = bind(this.init_select2_enum, this);
    this.init_select2_boolean = bind(this.init_select2_boolean, this);
    this.init_select2_plain = bind(this.init_select2_plain, this);
    this.init_editor = bind(this.init_editor, this);
    this.controller = this.parent.controller;
    this.select2_token_separators = [',', ' '];
    this.url_get_list = '/livereports/get_object_list';
  }

  Select2Helper.prototype.init_editor = function(select, options) {
    select.attr("data-widget-select2-editor", options);
    select.attr('data-autoinited', true);
    return new INTENT.widgets.Select2Editor(select);
  };

  Select2Helper.prototype.init_select2_plain = function(select, initial_values) {
    var options;
    select.destroySelect2({
      clear: true
    });
    options = {
      tags: true,
      tokenSeparators: this.select2_token_separators,
      minimumInputLength: 0
    };
    if (initial_values != null) {
      options.data = initial_values.map((function(_this) {
        return function(id) {
          return {
            id: id,
            text: id
          };
        };
      })(this));
    }
    select.removeAttr('disabled').select2(options);
    if (initial_values != null) {
      select.val(initial_values).trigger('change');
    }
    return this.init_editor(select, "popup-editor");
  };

  Select2Helper.prototype.init_select2_boolean = function(select, initial_values) {
    select.destroySelect2({
      clear: true
    });
    select.removeAttr('disabled').select2({
      data: [true, false, 'null']
    });
    if (initial_values != null) {
      select.val(initial_values).trigger('change');
    }
    return this.init_editor(select, "");
  };

  Select2Helper.prototype.init_select2_enum = function(select, field_code, initial_values) {
    var group, initializer, options;
    initializer = (function(_this) {
      return function(options) {
        select.destroySelect2({
          clear: true
        });
        select.removeAttr('disabled').select2(options);
        if (initial_values != null) {
          select.val(initial_values).trigger('change');
        }
        return _this.init_editor(select, "popup-editor,select-all");
      };
    })(this);
    options = {
      tags: true,
      tokenSeparators: this.select2_token_separators,
      minimumInputLength: 0
    };
    if (_.isArray(this.parent.enums[field_code])) {
      options['data'] = this.parent.enums[field_code];
      return initializer(options);
    } else {
      group = select.closest("[" + this.parent.attr + "-group]");
      return $.ajax({
        url: this.url_get_list,
        data: {
          dataset: this.controller.get_dataset_code(),
          field: field_code
        },
        dataType: 'json',
        method: 'POST',
        beforeSend: (function(_this) {
          return function() {
            select.select2();
            return select.showLoader();
          };
        })(this),
        complete: (function(_this) {
          return function() {
            return select.hideLoader();
          };
        })(this),
        success: (function(_this) {
          return function(data) {
            var i, item, len, value;
            if (_.isObject(data) && _.isArray(data.items)) {
              _this.parent.enums[field_code] = data.items;
              options['data'] = _this.parent.enums[field_code];
              if (initial_values) {
                for (i = 0, len = initial_values.length; i < len; i++) {
                  value = initial_values[i];
                  item = options['data'].find(function(o) {
                    return o.id.toString() === value.toString();
                  });
                  if (!item) {
                    options['data'].push({
                      id: value,
                      text: value
                    });
                  }
                }
              }
              return initializer(options);
            }
          };
        })(this)
      });
    }
  };

  Select2Helper.prototype.init_select2_object = function(select, field_code, initial_values) {
    var initializer;
    initializer = (function(_this) {
      return function() {
        select.removeAttr('disabled').select2({
          tags: true,
          tokenSeparators: _this.select2_token_separators,
          minimumInputLength: 0,
          ajax: {
            url: _this.url_get_list,
            data: function(params) {
              return {
                q: params.term,
                dataset: _this.controller.get_dataset_code(),
                field: field_code
              };
            },
            dataType: 'json',
            method: 'POST',
            delay: _this.search_delay,
            cache: true,
            processResults: function(data, params) {
              return {
                results: data.items
              };
            }
          }
        });
        return _this.init_editor(select, "popup-editor,select-all");
      };
    })(this);
    if (initial_values == null) {
      select.destroySelect2({
        clear: true
      });
      return initializer();
    } else {
      return $.ajax({
        url: this.url_get_list,
        data: {
          dataset: this.controller.get_dataset_code(),
          field: field_code,
          values: initial_values,
          limit: Math.max(100, initial_values.length)
        },
        dataType: 'json',
        method: 'POST',
        beforeSend: (function(_this) {
          return function() {
            select.select2();
            return select.showLoader();
          };
        })(this),
        complete: (function(_this) {
          return function() {
            return select.hideLoader();
          };
        })(this),
        success: (function(_this) {
          return function(data) {
            var i, item, j, len, len1, option, ref, value;
            if (_.isObject(data) && _.isArray(data.items)) {
              select.destroySelect2({
                clear: true
              });
              if (initial_values) {
                for (i = 0, len = initial_values.length; i < len; i++) {
                  value = initial_values[i];
                  item = data.items.find(function(o) {
                    return o.id.toString() === value.toString();
                  });
                  if (item) {
                    option = {
                      id: item.id,
                      text: item.text
                    };
                  } else {
                    option = {
                      id: value,
                      text: value
                    };
                  }
                  select.append("<option value=\"" + (encodeURIComponent(option.id)) + "\" selected=\"selected\">\n  " + option.text + "\n</option>");
                }
              } else {
                ref = data.items;
                for (j = 0, len1 = ref.length; j < len1; j++) {
                  item = ref[j];
                  select.append("<option value=\"" + (encodeURIComponent(item.id)) + "\" selected=\"selected\">\n  " + item.text + "\n</option>");
                }
              }
              return initializer();
            }
          };
        })(this)
      });
    }
  };

  return Select2Helper;

})();


/**
  * Allows user to manage settings and filters on the page
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

INTENT.report.SettingsManager = (function() {
  function SettingsManager(controller) {
    var dataset, settings;
    this.controller = controller;
    this.init_events = bind(this.init_events, this);
    this.toggle_timezone_input = bind(this.toggle_timezone_input, this);
    this.toggle_time_inputs = bind(this.toggle_time_inputs, this);
    this.get_filter_html = bind(this.get_filter_html, this);
    this.set_watch_hash = bind(this.set_watch_hash, this);
    this.remove_unavailable_filters = bind(this.remove_unavailable_filters, this);
    this.reset_settings = bind(this.reset_settings, this);
    this.remove_filters = bind(this.remove_filters, this);
    this.remove_filter = bind(this.remove_filter, this);
    this.init_values_input = bind(this.init_values_input, this);
    this.init_values_select = bind(this.init_values_select, this);
    this.init_condition_select = bind(this.init_condition_select, this);
    this.update_key_selects = bind(this.update_key_selects, this);
    this.init_key_select = bind(this.init_key_select, this);
    this.init_grouping_fields = bind(this.init_grouping_fields, this);
    this.set_defaults = bind(this.set_defaults, this);
    this.get_group = bind(this.get_group, this);
    this.get_filters = bind(this.get_filters, this);
    this.append_filter = bind(this.append_filter, this);
    this.add_filter = bind(this.add_filter, this);
    this.get_order = bind(this.get_order, this);
    this.clear_changed_fields = bind(this.clear_changed_fields, this);
    this.get_changed_field = bind(this.get_changed_field, this);
    this.unset_changed_field = bind(this.unset_changed_field, this);
    this.set_changed_field = bind(this.set_changed_field, this);
    this.set_order = bind(this.set_order, this);
    this.get_timezone = bind(this.get_timezone, this);
    this.set_timezone = bind(this.set_timezone, this);
    this.get_dates = bind(this.get_dates, this);
    this.set_dates = bind(this.set_dates, this);
    this.set_period = bind(this.set_period, this);
    this.get_grouping = bind(this.get_grouping, this);
    this.set_grouping = bind(this.set_grouping, this);
    this.set_dataset = bind(this.set_dataset, this);
    this.remember_settings = bind(this.remember_settings, this);
    this.get_settings = bind(this.get_settings, this);
    this.code = this.controller.code + '-settings';
    this.attr = this.controller.attr + '-settings';
    this.el = this.controller.el;
    this.datasets = this.controller.datasets;
    this.enums = {};
    this.defaults = {
      grouping: ['day'],
      period: 'this_month'
    };
    this.changed_fields = {};
    this.watch_hash = true;
    this.search_delay = 200;
    this.filters_container = $("[" + this.attr + "-filters]");
    this.select2_helper = new INTENT.report.Select2Helper(this);
    this.init_events();
    this.init_grouping_fields();
    this.periodManager = new INTENT.report.SettingsPeriodManager(this);
    this.parser = new INTENT.report.SettingsParser(this);
    this.renderer = new INTENT.report.Renderer(this.controller);
    settings = this.parser.parse_hash();
    if (settings.dataset_name) {
      this.parser.render_form(settings);
    } else {
      dataset = this.controller.get_dataset();
      this.add_filter();
      this.set_grouping(this.defaults.grouping);
      this.set_period(dataset.defaults.period || this.defaults.period);
    }
    this.clear_changed_fields();
    this.toggle_time_inputs();
    this.toggle_timezone_input();
  }

  SettingsManager.prototype.get_settings = function() {
    return this.parser.parse_form();
  };

  SettingsManager.prototype.remember_settings = function(settings) {
    return this.parser.render_hash(settings);
  };

  SettingsManager.prototype.set_dataset = function(dataset_code) {
    return this.controller.set_dataset_code(dataset_code);
  };

  SettingsManager.prototype.set_grouping = function(groups) {
    if (_.isArray(groups)) {
      return $("[" + this.attr + "-grouping]").val(groups).trigger('change');
    }
  };

  SettingsManager.prototype.get_grouping = function() {
    return $("[" + this.attr + "-grouping]").val();
  };

  SettingsManager.prototype.set_period = function(period) {
    return this.periodManager.set_period(period);
  };

  SettingsManager.prototype.set_dates = function(start, end) {
    this.periodManager.set_start_date(start);
    return this.periodManager.set_end_date(end);
  };

  SettingsManager.prototype.get_dates = function() {
    return {
      start: this.periodManager.get_start_date(),
      end: this.periodManager.get_end_date()
    };
  };

  SettingsManager.prototype.set_timezone = function(timezone) {
    var dataset;
    dataset = this.controller.get_dataset();
    if (dataset.disable_timezone_select) {
      timezone = dataset.default_timezone;
    }
    if (timezone != null) {
      return $("[" + this.attr + "-timezone]").val(timezone).trigger('change');
    }
  };

  SettingsManager.prototype.get_timezone = function() {
    return $("[" + this.attr + "-timezone]").val();
  };

  SettingsManager.prototype.set_order = function(key, direction) {
    return $("[" + this.attr + "-order]").val(key + "/" + direction);
  };

  SettingsManager.prototype.set_changed_field = function(field) {
    return this.changed_fields[field] = true;
  };

  SettingsManager.prototype.unset_changed_field = function(field) {
    return this.changed_fields[field] = false;
  };

  SettingsManager.prototype.get_changed_field = function(field) {
    return !!this.changed_fields[field];
  };

  SettingsManager.prototype.clear_changed_fields = function() {
    return this.changed_fields = {};
  };


  /**
   * @return {object|undefined}
   */

  SettingsManager.prototype.get_order = function() {
    var order, val;
    val = $("[" + this.attr + "-order]").val().split('/');
    if ((val[0] != null) && (val[1] != null)) {
      order = {
        key: val[0],
        direction: val[1]
      };
    }
    return order;
  };

  SettingsManager.prototype.add_filter = function(type, key, condition, initial_values) {
    var fields_list, group, group_id;
    if (type == null) {
      type = 'key';
    }
    group_id = this.filters_container.find("[" + this.attr + "-group]").last().data(this.code + "-group") + 1 || 0;
    group = $(this.get_filter_html(group_id, type));
    this.filters_container.append($(group));
    fields_list = this.controller.get_fields_list(null, type);
    this.init_key_select(group, fields_list, key, type);
    this.init_condition_select(group, condition);
    if (type === 'key') {
      return this.init_values_select(group, key, initial_values);
    } else {
      return this.init_values_input(group, key, initial_values);
    }
  };

  SettingsManager.prototype.append_filter = function(key, condition, value) {
    var last_found_group, select;
    if ((key == null) || (condition == null) || (value == null)) {
      return this.add_filter('key', key, condition, value);
    }
    last_found_group = null;
    this.filters_container.find("[" + this.attr + "-group]").each((function(_this) {
      return function(i, group) {
        var item_condition, item_key;
        group = $(group);
        item_key = group.find("[" + _this.attr + "-item-key]").val();
        item_condition = group.find("[" + _this.attr + "-item-condition]").val();
        if (item_key === key && item_condition === condition) {
          return last_found_group = group;
        }
      };
    })(this));
    if (last_found_group == null) {
      return this.add_filter('key', key, condition, _.isObject(value) ? value.id : value);
    } else {
      select = last_found_group.find("[" + this.attr + "-item-values]");
      return select.select2AppendValues(value);
    }
  };

  SettingsManager.prototype.get_filters = function() {
    var filters;
    filters = [];
    $("[" + this.attr + "-group]").each((function(_this) {
      return function(index, group) {
        var condition, key, type, values;
        group = $(group);
        type = group.attr(_this.attr + "-group-type");
        key = group.find("[" + _this.attr + "-item-key]").val();
        condition = group.find("[" + _this.attr + "-item-condition]").val();
        values = group.find("[" + _this.attr + "-item-values]").val();
        if (values === '') {
          values = null;
        }
        if ((key != null) && (condition != null) && (values != null)) {
          return filters.push({
            key: key,
            condition: condition,
            type: type,
            values: decodeURIComponent(values)
          });
        }
      };
    })(this));
    return filters;
  };

  SettingsManager.prototype.get_group = function(group) {
    if (_.isNumber(group)) {
      group = $("[" + this.attr + "-group='" + group + "']");
    }
    return group;
  };

  SettingsManager.prototype.set_defaults = function(dataset_code) {
    var dataset;
    if (!this.get_changed_field('period')) {
      dataset = this.controller.get_dataset(dataset_code);
      return this.periodManager.set_period(dataset.defaults.period || this.defaults.period);
    }
  };

  SettingsManager.prototype.init_grouping_fields = function(dataset_code) {
    var grouping_fields, select, values;
    select = $("[" + this.attr + "-grouping]");
    values = _.intersection(select.val(), this.controller.get_fields(dataset_code));
    grouping_fields = this.controller.get_fields_list(dataset_code);
    this.toggle_time_inputs();
    this.toggle_timezone_input();
    select.destroySelect2({
      clear: true
    });
    select.select2({
      data: grouping_fields
    });
    return select.val(values).trigger('change');
  };

  SettingsManager.prototype.init_key_select = function(group, key_fields_list, initial_values, type) {
    var element;
    if (type == null) {
      type = 'key';
    }
    group = this.get_group(group);
    key_fields_list.unshift({
      id: '',
      text: ''
    });
    element = group.find("[" + this.attr + "-item-key]");
    element.destroySelect2({
      clear: true
    }).select2({
      data: key_fields_list,
      placeholder: __("report.filter.item." + type + ".placeholder")
    });
    if (initial_values != null) {
      return element.val(initial_values).trigger('change');
    }
  };

  SettingsManager.prototype.update_key_selects = function(dataset_code) {
    var value_fields_list;
    this.remove_unavailable_filters(dataset_code);
    value_fields_list = this.controller.get_fields_list(dataset_code, 'value');
    return $("[" + this.attr + "-item-key]").each((function(_this) {
      return function(index, item) {
        var group, type;
        item = $(item);
        group = item.closest("[" + _this.attr + "-group]");
        type = group.attr(_this.attr + "-group-type");
        if (type === 'value') {
          return _this.init_key_select(group, value_fields_list, item.val(), 'value');
        }
      };
    })(this));
  };

  SettingsManager.prototype.init_condition_select = function(group, initial_values) {
    var element;
    group = this.get_group(group);
    element = group.find("[" + this.attr + "-item-condition]");
    element.destroySelect2({
      clear: true
    }).select2({
      minimumResultsForSearch: 2e308,
      width: 'resolve'
    });
    if (initial_values != null) {
      return element.val(initial_values).trigger('change');
    }
  };

  SettingsManager.prototype.init_values_select = function(group, field_code, initial_values) {
    var dataset, ref, ref1, ref2, relation, select;
    if ((initial_values != null) && !_.isArray(initial_values)) {
      initial_values = [initial_values];
    }
    group = this.get_group(group);
    select = group.find("select[" + this.attr + "-item-values]");
    if (!field_code) {
      select.select2();
      return;
    }
    dataset = this.controller.get_dataset();
    relation = dataset.relations[field_code];
    if (_.isObject(relation)) {
      if ((ref = relation.type) === 'enum') {
        return this.select2_helper.init_select2_enum(select, field_code, initial_values);
      } else if ((ref1 = relation.type) === 'object' || ref1 === 'geo' || ref1 === 'user' || ref1 === 'database') {
        return this.select2_helper.init_select2_object(select, field_code, initial_values);
      } else if ((ref2 = relation.type) === 'boolean') {
        return this.select2_helper.init_select2_boolean(select, initial_values);
      }
    } else {
      return this.select2_helper.init_select2_plain(select, initial_values);
    }
  };

  SettingsManager.prototype.init_values_input = function(group, field_code, initial_values) {
    var input;
    input = group.find("input[" + this.attr + "-item-values]");
    if (initial_values != null) {
      input.attr('disabled', false);
      return input.val(initial_values);
    }
  };

  SettingsManager.prototype.remove_filter = function(group) {
    group = $(group);
    group.find('select.select2-init').destroySelect2();
    return group.remove();
  };

  SettingsManager.prototype.remove_filters = function() {
    return $("[" + this.attr + "-group]").each((function(_this) {
      return function(index, group) {
        return _this.remove_filter(group);
      };
    })(this));
  };

  SettingsManager.prototype.reset_settings = function() {
    return $("[" + this.attr + "-grouping]").val([]).trigger('change');
  };

  SettingsManager.prototype.remove_unavailable_filters = function(new_dataset_code) {
    var key_fields, key_fields_list, value_fields, value_fields_list;
    key_fields = this.controller.get_fields(new_dataset_code, 'key');
    value_fields = this.controller.get_fields(new_dataset_code, 'value');
    key_fields_list = this.controller.get_fields_list(new_dataset_code, 'key');
    value_fields_list = this.controller.get_fields_list(new_dataset_code, 'value');
    return $("[" + this.attr + "-item-key]").each((function(_this) {
      return function(index, item) {
        var group, item_code, type;
        item = $(item);
        item_code = item.val();
        group = item.closest("[" + _this.attr + "-group]");
        if (!item_code) {
          type = group.attr(_this.attr + "-group-type");
          if (type === 'key') {
            return _this.init_key_select(group, key_fields_list);
          } else {
            return _this.init_key_select(group, value_fields_list, null, 'value');
          }
        } else if (indexOf.call(value_fields, item_code) >= 0) {
          _this.init_key_select(group, value_fields_list, null, 'value');
          return item.val(item_code).trigger('change');
        } else if (indexOf.call(key_fields, item_code) >= 0) {
          _this.init_key_select(group, key_fields_list);
          return item.val(item_code).trigger('change');
        } else {
          return _this.remove_filter(group);
        }
      };
    })(this));
  };

  SettingsManager.prototype.set_watch_hash = function(is_enabled) {
    return this.watch_hash = is_enabled;
  };

  SettingsManager.prototype.get_filter_html = function(index, type) {
    var input, options;
    if (index == null) {
      index = 0;
    }
    if (type == null) {
      type = 'key';
    }
    if (type === 'key') {
      options = [
        {
          name: "=",
          value: "eq"
        }, {
          name: "&ne;",
          value: "ne"
        }, {
          name: "<",
          value: "lt"
        }, {
          name: "&le;",
          value: "le"
        }, {
          name: ">",
          value: "gt"
        }, {
          name: "&ge;",
          value: "ge"
        }
      ];
      input = "<select " + this.attr + "-item-values disabled=\"disabled\" multiple=\"multiple\" data-tags=\"true\" data-token-separators=\"[';','\n','\t']\"></select>";
    } else {
      options = [
        {
          name: "<",
          value: "lt"
        }, {
          name: "&le;",
          value: "le"
        }, {
          name: ">",
          value: "gt"
        }, {
          name: "&ge;",
          value: "ge"
        }
      ];
      input = "<input " + this.attr + "-item-values type=\"text\" disabled=\"disabled\" class=\"form-control\" value=\"\"/>";
    }
    options = options.map((function(_this) {
      return function(item) {
        return "<option value=\"" + item.value + "\">" + item.name + "</option>";
      };
    })(this));
    return "<tr class=\"filter-box\" " + this.attr + "-group='" + index + "' " + this.attr + "-group-type='" + type + "'>\n    <td class=\"col-md-4\">\n        <select " + this.attr + "-item-key\n                class=\"\"\n        ></select>\n    </td>\n    <td class=\"col-md-1\">\n        <div style=\"width:65px\">\n          <select " + this.attr + "-item-condition\n                  class=\"\"\n          >\n              " + options + "\n          </select>\n        </div>\n    </td>\n    <td class=\"col-md-7\">\n        " + input + "\n    </td>\n    <td class=\"filter-remove\">\n        <span " + this.attr + "-filters-remove class=\"remove-filter\">\n            <i class=\"fa fa-times opacity-dynamic\"></i>\n        </span>\n    </td>\n</tr>";
  };

  SettingsManager.prototype.toggle_time_inputs = function() {
    var dataset;
    dataset = this.controller.get_dataset();
    if (dataset.time_enabled === false) {
      $("#period, #timezone").attr("disabled", true);
      return $(".time_row").hide();
    } else {
      $("#period, #timezone").attr("disabled", false);
      return $(".time_row").show();
    }
  };

  SettingsManager.prototype.toggle_timezone_input = function() {
    var dataset;
    dataset = this.controller.get_dataset();
    if (dataset.disable_timezone_select || dataset.time_enabled === false) {
      $("#timezone").attr("disabled", true);
      return $("#timezone").parents('.time_row').hide();
    } else {
      $("#timezone").attr("disabled", false);
      return $("#timezone").parents('.time_row').show();
    }
  };

  SettingsManager.prototype.init_events = function() {
    $(document).on("change", "#timezone", (function(_this) {
      return function(e) {
        var end_date, start_date;
        start_date = _this.periodManager.get_start_date();
        end_date = _this.periodManager.get_end_date();
        _this.periodManager = new INTENT.report.SettingsPeriodManager(_this);
        _this.periodManager.set_start_date(start_date);
        return _this.periodManager.set_end_date(end_date);
      };
    })(this));
    $(document).on(this.controller.code + ":dataset_changed", (function(_this) {
      return function(e, dataset_code) {
        _this.remove_unavailable_filters(dataset_code);
        return _this.init_grouping_fields(dataset_code);
      };
    })(this));
    $("[" + this.attr + "-period]").on('change apply.daterangepicker', (function(_this) {
      return function(e) {
        if ((e.type === 'apply') || (e.originalEvent && e.originalEvent.isTrusted)) {
          return _this.set_changed_field('period');
        }
      };
    })(this));
    $(window).on('hashchange', (function(_this) {
      return function(e) {
        var settings;
        if (!_this.watch_hash) {
          return;
        }
        _this.remove_filters();
        _this.reset_settings();
        settings = _this.parser.parse_hash();
        if (settings.dataset_name) {
          return _this.parser.render_form(settings);
        } else {
          return _this.add_filter();
        }
      };
    })(this));
    $(document).on("click", "[" + this.attr + "-filters-add]", (function(_this) {
      return function(e) {
        var target;
        target = $(e.target);
        e.preventDefault();
        target.blur();
        return _this.add_filter(target.attr('filter-type'));
      };
    })(this));
    $(document).on("click", "[" + this.attr + "-filters-remove]", (function(_this) {
      return function(e) {
        var group, self;
        e.preventDefault();
        self = $(e.currentTarget);
        group = self.closest("[" + _this.attr + "-group]");
        if (group.length) {
          return _this.remove_filter(group);
        }
      };
    })(this));
    $(document).on('click', '.filter-by', (function(_this) {
      return function(e) {
        var filter_key, filter_text, filter_value, self, td, th;
        e.preventDefault();
        self = $(e.currentTarget);
        td = self.closest('td');
        filter_text = td.text().trim();
        filter_value = td.find('[data-value]').data('value') || filter_text;
        if (typeof filter_value === 'string') {
          filter_value = filter_value.trim();
        }
        th = td.closest('table').find('th').eq(td.index());
        filter_key = th.data('key');
        if (typeof filter_key === 'string') {
          filter_key = filter_key.trim();
        }
        if (filter_key === 'segment_id') {
          filter_key = 'user_segments';
        }
        return _this.append_filter(filter_key, 'eq', {
          id: filter_value,
          text: filter_text
        });
      };
    })(this));
    $(document).on('click', 'th.sortable', (function(_this) {
      return function(e) {
        var direction, key, order, ref, self, tableData;
        e.preventDefault();
        self = $(e.currentTarget);
        key = self.attr('data-key');
        if (key != null) {
          order = _this.get_order();
          if ((order != null) && key === order.key) {
            direction = order.direction === 'desc' ? 'asc' : 'desc';
          } else {
            direction = (order != null) && ((ref = order.direction) === 'asc' || ref === 'desc') ? order.direction : 'desc';
          }
          _this.set_order(key, direction);
          tableData = _this.controller.tableData;
          if (tableData === null || !tableData.data.allowClientSort) {
            return _this.controller.show_report();
          } else {
            return _this.controller.sort_report(key, direction);
          }
        }
      };
    })(this));
    return $(document).on("select2:selecting", "[" + this.attr + "-item-key]", (function(_this) {
      return function(e) {
        var group, new_key, old_key, self;
        self = $(e.currentTarget);
        old_key = self.val();
        new_key = e.params.args.data.id;
        if (new_key && old_key !== new_key) {
          group = self.closest("[" + _this.attr + "-group]");
          group.find("input[" + _this.attr + "-item-values]").attr('disabled', false);
          if (group.length) {
            return _this.init_values_select(group, new_key);
          }
        }
      };
    })(this));
  };

  return SettingsManager;

})();


/**
  * Implements parsing hash and form to settings object, rendering settings object to hash and form
  * Used by SettingsManager
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

INTENT.report.SettingsParser = (function() {
  function SettingsParser(parent) {
    this.parent = parent;
    this.parse_hash = bind(this.parse_hash, this);
    this.render_hash = bind(this.render_hash, this);
    this.parse_form = bind(this.parse_form, this);
    this.render_form = bind(this.render_form, this);
    this.code = this.parent.code + '-parser';
    this.attr = this.parent.attr + '-parser';
    this.controller = this.parent.controller;
  }

  SettingsParser.prototype.render_form = function(settings) {
    var dataset, item, key, ref, ref1, ref2, results, type;
    this.parent.set_dataset(settings.dataset_name);
    this.parent.set_grouping(settings.keys);
    this.parent.set_timezone(settings.timezone);
    if (settings.order != null) {
      this.parent.set_order(settings.order.key, settings.order.direction);
    }
    if ((settings.start != null) && (settings.end != null)) {
      this.parent.set_dates(settings.start, settings.end);
    } else if (settings.period != null) {
      this.parent.set_period(settings.period);
    }
    dataset = this.controller.get_dataset();
    ref = settings.filters;
    results = [];
    for (key in ref) {
      item = ref[key];
      if (item.key && ((ref1 = item.key, indexOf.call(dataset.key_fields, ref1) >= 0) || (ref2 = item.key, indexOf.call(this.controller.get_fields_by_preset(), ref2) >= 0))) {
        type = item.type === 'filter' ? 'key' : 'value';
        results.push(this.parent.add_filter(type, item.key, item.condition, item.values));
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  SettingsParser.prototype.parse_form = function() {
    var dataset, dates, filters, grouping, hash_fields, order, period, settings, timezone;
    settings = {
      dataset_name: this.controller.get_dataset_code()
    };
    if (grouping = this.parent.get_grouping()) {
      settings.keys = grouping;
    }
    dataset = this.controller.get_dataset();
    if (dataset.time_enabled) {
      if (dataset.disable_timezone_select) {
        settings.timezone = dataset.default_timezone;
      } else if (timezone = this.parent.get_timezone()) {
        settings.timezone = timezone;
      }
      if (dates = this.parent.get_dates()) {
        period = this.parent.periodManager.get_period_by_dates(dates.start, dates.end);
        if ('custom_range' !== period) {
          settings.period = period;
        } else {
          settings.start = dates.start;
          settings.end = dates.end;
        }
      }
    }
    if (filters = this.parent.get_filters()) {
      settings.filters = filters;
    }
    if (order = this.parent.get_order()) {
      settings.order = order;
    }
    hash_fields = this.parse_hash().values;
    if (hash_fields.length) {
      settings.values = _.intersection(dataset.fields, hash_fields);
    }
    return settings;
  };

  SettingsParser.prototype.render_hash = function(settings) {
    var dataset, filter_type, hash, i, item, len, ref, value;
    hash = [];
    if (settings.dataset_name != null) {
      hash.push("dataset_name=" + settings.dataset_name);
    }
    if (settings.keys != null) {
      hash.push("keys=" + (settings.keys.join(',')));
    }
    if (settings.values != null) {
      hash.push("values=" + (settings.values.join(',')));
    }
    if (settings.order != null) {
      hash.push("order=" + settings.order.key + "/" + settings.order.direction);
    }
    dataset = this.controller.get_dataset();
    if (dataset.time_enabled) {
      if ((settings.timezone != null) && !dataset.disable_timezone_select) {
        hash.push("timezone=" + settings.timezone);
      }
      if (settings.period != null) {
        hash.push("period=" + settings.period);
      } else if ((settings.start != null) && (settings.end != null)) {
        hash.push("start=" + settings.start);
        hash.push("end=" + settings.end);
      }
    }
    if (_.isArray(settings.filters) && settings.filters.length) {
      ref = settings.filters;
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        filter_type = item.type === 'key' ? 'filter' : 'having';
        value = _.isArray(item.values) ? item.values.join(',') : item.values;
        hash.push(filter_type + "=" + item.condition + ":" + item.key + ":" + (encodeURIComponent(decodeURIComponent(value))));
      }
    }
    hash = hash.join('&');
    this.parent.set_watch_hash(false);
    window.location.hash = hash;
    return setTimeout(((function(_this) {
      return function() {
        return _this.parent.set_watch_hash(true);
      };
    })(this)), 0);
  };

  SettingsParser.prototype.parse_hash = function() {
    var code, condition, dataset, hash, hash_parts, i, item, key, len, param, parsed_filters, settings, type, val, value, values;
    settings = {
      filters: [],
      keys: [],
      values: []
    };
    dataset = this.controller.get_dataset();
    hash = window.location.hash;
    hash_parts = hash.replace('#', '').split('&');
    parsed_filters = {};
    for (i = 0, len = hash_parts.length; i < len; i++) {
      item = hash_parts[i];
      item = item.split('=');
      if (_.isArray(item) && item.length === 2) {
        code = item[0];
        param = item[1];
        if (code === 'timezone') {
          if (dataset.disable_timezone_select) {
            param = dataset.default_timezone;
          }
        }
        if (code === 'timezone' || code === 'period' || code === 'start' || code === 'end') {
          if (dataset.time_enabled === false) {
            param = '';
          }
        }
        if (code === 'keys' || code === 'values') {
          param = param.split(',');
        }
        if (code === 'order') {
          val = param.split('/');
          if ((val[0] != null) && (val[1] != null)) {
            param = {
              key: val[0],
              direction: val[1]
            };
          } else {
            param = void 0;
          }
        }
        if (code === 'filter' || code === 'having') {
          param = param.split(':');
          condition = decodeURIComponent(param[0]);
          key = param[1];
          values = (decodeURIComponent(param[2]) || '').split(',');
          if (!parsed_filters[code]) {
            parsed_filters[code] = {};
          }
          if (key && values && values.length) {
            if (code === 'filter') {
              if (parsed_filters[code][key] == null) {
                parsed_filters[code][key] = {};
              }
              if (!parsed_filters[code][key][condition]) {
                parsed_filters[code][key][condition] = [];
              }
              parsed_filters[code][key][condition] = parsed_filters[code][key][condition].concat(values);
            } else if (code === 'having') {
              if (parsed_filters[code][key] == null) {
                parsed_filters[code][key] = {};
              }
              parsed_filters[code][key][condition] = values[0];
            }
          }
        } else {
          settings[code] = param;
        }
      }
    }
    for (type in parsed_filters) {
      item = parsed_filters[type];
      for (key in item) {
        values = item[key];
        for (condition in values) {
          value = values[condition];
          if (value.length) {
            settings.filters.push({
              key: key,
              type: type,
              condition: condition,
              values: _.isArray(value) ? _.uniq(value) : value
            });
          }
        }
      }
    }
    return settings;
  };

  return SettingsParser;

})();


/**
  * Encapsulates interaction with daterangepicker
  * Used by SettingsManager
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

INTENT.report.SettingsPeriodManager = (function() {
  function SettingsPeriodManager(parent) {
    this.parent = parent;
    this.get_end_date = bind(this.get_end_date, this);
    this.get_start_date = bind(this.get_start_date, this);
    this.set_end_date = bind(this.set_end_date, this);
    this.set_start_date = bind(this.set_start_date, this);
    this.set_period = bind(this.set_period, this);
    this.get_period_by_dates = bind(this.get_period_by_dates, this);
    this.init_daterangepicker = bind(this.init_daterangepicker, this);
    this.get_ranges = bind(this.get_ranges, this);
    this.get_periods = bind(this.get_periods, this);
    this.code = this.parent.code + '-period';
    this.attr = this.parent.attr + '-period';
    this.controller = this.parent.controller;
    this.language = this.controller.get_language();
    this.el = $("[" + this.attr + "]");
    this.date_format = 'YYYY-MM-DD';
    this.labels = {
      'today': __('daterangepicker.today'),
      'yesterday': __('daterangepicker.yesterday'),
      'this_week_sun_this_day': __('daterangepicker.this_week_sun_this_day'),
      'this_week_mon_this_day': __('daterangepicker.this_week_mon_this_day'),
      'last_7_days': __('daterangepicker.last_7_days'),
      'last_week_sun_sat': __('daterangepicker.last_week_sun_sat'),
      'last_week_mon_sun': __('daterangepicker.last_week_mon_sun'),
      'last_week_work_mon_fri': __('daterangepicker.last_week_work_mon_fri'),
      'last_14_days': __('daterangepicker.last_14_days'),
      'last_30_days': __('daterangepicker.last_30_days'),
      'this_month': __('daterangepicker.this_month'),
      'last_month': __('daterangepicker.last_month'),
      'custom_range': __('daterangepicker.custom_range')
    };
    this.dates = {
      today: {
        label: this.labels['today'],
        value: [moment().tz($('#timezone').val()), moment().tz($('#timezone').val())]
      },
      yesterday: {
        label: this.labels['yesterday'],
        value: [moment().tz($('#timezone').val()).subtract(1, 'days'), moment().tz($('#timezone').val()).subtract(1, 'days')]
      },
      this_week_sun_this_day: {
        label: this.labels['this_week_sun_this_day'],
        value: [moment().tz($('#timezone').val()).startOf('week'), moment().tz($('#timezone').val())]
      },
      this_week_mon_this_day: {
        label: this.labels['this_week_mon_this_day'],
        value: [moment().tz($('#timezone').val()).startOf('week').add(1, 'days'), moment().tz($('#timezone').val())]
      },
      last_7_days: {
        label: this.labels['last_7_days'],
        value: [moment().tz($('#timezone').val()).subtract(6, 'days'), moment().tz($('#timezone').val())]
      },
      last_week_sun_sat: {
        label: this.labels['last_week_sun_sat'],
        value: [moment().tz($('#timezone').val()).subtract(1, 'week').startOf('week'), moment().tz($('#timezone').val()).subtract(1, 'week').endOf('week')]
      },
      last_week_mon_sun: {
        label: this.labels['last_week_mon_sun'],
        value: [moment().tz($('#timezone').val()).subtract(1, 'week').startOf('week').add(1, 'days'), moment().tz($('#timezone').val()).subtract(1, 'week').endOf('week').add(1, 'days')]
      },
      last_week_work_mon_fri: {
        label: this.labels['last_week_work_mon_fri'],
        value: [moment().tz($('#timezone').val()).subtract(1, 'week').startOf('week').add(1, 'days'), moment().tz($('#timezone').val()).subtract(1, 'week').endOf('week').subtract(1, 'days')]
      },
      last_14_days: {
        label: this.labels['last_14_days'],
        value: [moment().tz($('#timezone').val()).subtract(13, 'days'), moment().tz($('#timezone').val())]
      },
      this_month: {
        label: this.labels['this_month'],
        value: [moment().tz($('#timezone').val()).startOf('month'), moment().tz($('#timezone').val()).endOf('month')]
      },
      last_30_days: {
        label: this.labels['last_30_days'],
        value: [moment().tz($('#timezone').val()).subtract(29, 'days'), moment().tz($('#timezone').val())]
      },
      last_month: {
        label: this.labels['last_month'],
        value: [moment().tz($('#timezone').val()).subtract(1, 'month').startOf('month'), moment().tz($('#timezone').val()).subtract(1, 'month').endOf('month')]
      }
    };
    this.init_daterangepicker();
  }

  SettingsPeriodManager.prototype.get_periods = function() {
    return this.dates;
  };

  SettingsPeriodManager.prototype.get_ranges = function() {
    var code, item, ranges, ref;
    ranges = [];
    ref = this.dates;
    for (code in ref) {
      item = ref[code];
      ranges[item.label] = item.value;
    }
    return ranges;
  };

  SettingsPeriodManager.prototype.init_daterangepicker = function() {
    var e, options;
    options = {
      ranges: this.get_ranges(),
      startDate: moment().subtract(29, 'days'),
      endDate: moment(),
      timePicker: false,
      format: this.date_format,
      locale: {
        format: this.date_format,
        applyLabel: __('daterangepicker.applyLabel'),
        cancelLabel: __('daterangepicker.cancelLabel'),
        fromLabel: __('daterangepicker.fromLabel'),
        toLabel: __('daterangepicker.toLabel'),
        customRangeLabel: __('daterangepicker.custom_range'),
        daysOfWeek: moment().locale(this.language).localeData()._weekdaysMin.slice(),
        monthNames: moment().locale(this.language).localeData()._monthsShort.slice(),
        firstDay: 1
      }
    };
    try {
      return this.el.daterangepicker(options);
    } catch (error) {
      e = error;
      return console.error(e);
    }
  };

  SettingsPeriodManager.prototype.get_period_by_dates = function(start, end) {
    var period;
    period = 'custom_range';
    _.each(this.dates, (function(_this) {
      return function(pData, name) {
        var value;
        value = _.map(pData.value, function(moment) {
          return moment.tz($('#timezone').val()).format(_this.date_format);
        });
        if (_.isArray(value) && start === value[0] && end === value[1]) {
          return period = name;
        }
      };
    })(this));
    return period;
  };

  SettingsPeriodManager.prototype.set_period = function(period_code) {
    var period;
    period = this.dates[period_code];
    if ((period != null) && _.isArray(period.value)) {
      this.current_period = period_code;
      this.set_start_date(period.value[0]);
      return this.set_end_date(period.value[1]);
    }
  };

  SettingsPeriodManager.prototype.set_start_date = function(date) {
    if (date != null) {
      return this.el.data('daterangepicker').setStartDate(date);
    }
  };

  SettingsPeriodManager.prototype.set_end_date = function(date) {
    if (date != null) {
      return this.el.data('daterangepicker').setEndDate(date);
    }
  };

  SettingsPeriodManager.prototype.get_start_date = function() {
    return this.el.data('daterangepicker').startDate.format(this.date_format);
  };

  SettingsPeriodManager.prototype.get_end_date = function() {
    return this.el.data('daterangepicker').endDate.format(this.date_format);
  };

  return SettingsPeriodManager;

})();

(function($) {
  $.fn.showLoader = function(classToAdd) {
    var container, self, style_defined, text, width;
    if (classToAdd == null) {
      classToAdd = '';
    }
    self = $(this);
    if (self.data('select2')) {
      if (!self.attr('disabled')) {
        self.attr('disabled', 'disabled');
        self.data('utils-loader-attr-added', ['disabled']);
      }
      container = self.next('.select2-container');
      return container.prepend('<i data-utils-loader-icon-select2 class="fa fa-circle-o-notch fa-spin utils-loader-icon-select2"></i>');
    } else {
      style_defined = !!self.attr('style');
      if (!style_defined) {
        width = self.css('width');
        if (width) {
          self.data('loader-width-defined', true);
          self.css({
            'width': 'width',
            width: width
          });
        }
      }
      if (classToAdd) {
        self.addClass(classToAdd);
      }
      text = self.html();
      self.data('loader-original-text', text);
      return self.html('<i class="fa fa-circle-o-notch fa-spin"></i>');
    }
  };
  return $.fn.hideLoader = function(classToRemove) {
    var attr, attr_added, container, i, len, results, self, text, width_defined;
    if (classToRemove == null) {
      classToRemove = '';
    }
    self = $(this);
    if (self.data('select2')) {
      container = self.next('.select2-container');
      container.find('[data-utils-loader-icon-select2]').remove();
      attr_added = self.data('utils-loader-attr-added');
      self.data('utils-loader-attr-added', null);
      if (_.isArray(attr_added)) {
        results = [];
        for (i = 0, len = attr_added.length; i < len; i++) {
          attr = attr_added[i];
          results.push(self.removeAttr(attr));
        }
        return results;
      }
    } else {
      width_defined = self.data('loader-width-defined');
      if (width_defined) {
        self.removeData('loader-width-defined');
        self.css({
          'width': 'width',
          'auto': 'auto'
        });
      }
      if (classToRemove) {
        self.removeClass(classToRemove);
      }
      text = self.data('loader-original-text');
      self.removeData('loader-original-text');
      return self.html(text);
    }
  };
})(window.jQuery);

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

(function($) {
  return window.Loader = (function() {
    return {
      show: function(options) {
        var buttons, loader, loader_body, loader_class, loader_content, margin_left, margin_top, min_top, target;
        options = options || {};
        loader_class = 'loader';
        if (options.target != null) {
          target = options.target;
          loader_class += ' loader_inside';
        } else {
          target = '.main';
        }
        loader_body = "<i class='fa fa-circle-o-notch fa-spin'></i>";
        if (options.text) {
          loader_body = "<span class='loader_text'>" + options.text + "</span>\n<br>\n" + loader_body;
        }
        buttons = options.buttons || [];
        if (buttons.length) {
          loader_body += "<br>";
          if (indexOf.call(buttons, 'cancel') >= 0) {
            loader_body += "<a href='javascript:;' class='btn btn-link' data-fullpage-loader-action='cancel'>\n  <i class='fa fa-times'></i> " + (__('cancel')) + "\n</a>";
          }
        }
        loader = $("<div class='" + loader_class + "' data-fullpage-loader data-target=\"" + target + "\">\n  <div class='loader_content'>" + loader_body + "</div>\n</div>");
        Loader.hide(options);
        $(target).prepend(loader);
        loader_content = loader.find('.loader_content');
        margin_left = loader_content.width() / 2;
        margin_top = loader_content.height() / 2;
        min_top = $(window).height() / 2 - $('.navbar.navbar-default').height();
        if (margin_top > min_top) {
          margin_top = min_top;
        }
        return loader_content.css({
          'margin-left': -margin_left,
          'margin-top': -margin_top
        });
      },
      hide: function(options) {
        var loader, target;
        options = options || {};
        if (options.target != null) {
          target = options.target;
        } else {
          target = '.main';
        }
        loader = $('[data-fullpage-loader][data-target="' + target + '"]');
        if (loader.length) {
          return loader.remove();
        }
      },
      toggle: function(options) {
        var loader, target;
        options = options || {};
        if (options.target != null) {
          target = options.target;
        } else {
          target = '.main';
        }
        loader = $('[data-fullpage-loader][data-target="' + target + '"]');
        if (loader.length) {
          return this.hide(options);
        } else {
          return this.show(options);
        }
      }
    };
  })();
})(window.jQuery);

INTENT.utils.CreativesValidation = (function() {
  function CreativesValidation() {}

  CreativesValidation.validateForm = function() {
    var errorText;
    errorText = '';
    if ($("#kktu_codes").length > 0 && ($("#kktu_codes").val() === null || $("#kktu_codes").val().length === 0)) {
      errorText = errorText + __('creative.validate.error_verificator.ord.ktu_codes.error');
      if ($("#kktu_codes").is('[readonly]')) {
        errorText = errorText + '<br>' + __('creative.validate.error_verificator.ord.ktu_codes.error.not_admin');
      }
    }
    return errorText;
  };

  return CreativesValidation;

})();

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

INTENT.utils.InlineMessage = (function() {
  function InlineMessage() {}

  InlineMessage.code = "inline-message";

  InlineMessage.attr = "data-" + InlineMessage.code;

  InlineMessage.types = {
    error: 'error',
    warning: 'warning',
    info: 'info',
    success: 'success'
  };

  InlineMessage.icons = {
    error: 'fa-exclamation-circle',
    warning: 'fa-exclamation-circle',
    info: 'fa-exclamation-circle',
    success: 'fa-check-circle'
  };

  InlineMessage.classes = _.map(_.values(InlineMessage.types), function(value) {
    return InlineMessage.code + "-" + value;
  });

  InlineMessage.showMessage = function(element, type, text) {
    var icon, tag;
    if (indexOf.call(_.values(InlineMessage.types), type) >= 0) {
      element = $(element);
      tag = element.prop("tagName").toUpperCase();
      if (tag === 'INPUT' || tag === 'TEXTAREA') {
        InlineMessage.clearMessage(element);
        element.attr(InlineMessage.attr + "-message-type", type).removeClass(InlineMessage.classes.join(' ')).addClass(InlineMessage.code + "-" + type);
        if (text) {
          icon = $("<i " + InlineMessage.attr + "-icon\n   class='fa " + InlineMessage.icons[type] + " " + InlineMessage.code + "-icon " + InlineMessage.code + "-" + type + "'\n   data-toggle='tooltip'\n></i>");
          icon.attr('title', text);
          element.before(icon);
          return INTENT.utils.Tooltip.init(icon);
        }
      }
    }
  };

  InlineMessage.clearMessage = function(element) {
    var icon, tag;
    element = $(element);
    tag = element.prop("tagName").toUpperCase();
    if (tag === 'DIV' || tag === 'FORM') {
      return element.find("[" + InlineMessage.attr + "-message-type]").each(function(key, item) {
        return InlineMessage.clearMessage(item);
      });
    } else if (tag === 'INPUT' || tag === 'TEXTAREA') {
      icon = element.prev("[" + InlineMessage.attr + "-icon]");
      INTENT.utils.Tooltip.destroy(icon);
      icon.remove();
      return element.removeAttr(InlineMessage.attr + "-message-type").removeClass(InlineMessage.classes.join(' '));
    }
  };

  InlineMessage.hasError = function(element) {
    return InlineMessage.hasType(element, InlineMessage.types.error);
  };

  InlineMessage.hasMessage = function(element, type) {
    var has_type;
    element = $(element);
    has_type = element.attr(InlineMessage.attr + "-message-type");
    return type === has_type;
  };

  return InlineMessage;

})();


/*
  Wrapper of InlineMessage class that allows to show inline messages manually
 */
(function($) {
  return $.fn.extend({
    clearMessage: function() {
      return this.each((function(_this) {
        return function(key, element) {
          return INTENT.utils.InlineMessage.clearMessage(element);
        };
      })(this));
    },
    showError: function(text) {
      return this.each((function(_this) {
        return function(key, element) {
          return INTENT.utils.InlineMessage.showMessage(element, 'error', text);
        };
      })(this));
    },
    showWarning: function(text) {
      return this.each((function(_this) {
        return function(key, element) {
          return INTENT.utils.InlineMessage.showMessage(element, 'warning', text);
        };
      })(this));
    },
    showInfo: function(text) {
      return this.each((function(_this) {
        return function(key, element) {
          return INTENT.utils.InlineMessage.showMessage(element, 'info', text);
        };
      })(this));
    },
    showSuccess: function(text) {
      return this.each((function(_this) {
        return function(key, element) {
          return INTENT.utils.InlineMessage.showMessage(element, 'success', text);
        };
      })(this));
    }
  });
})(jQuery);


/*
  Custom error renderer for bootstrap-validator
 */
$(function() {
  $('form').on('invalid.bs.validator', function(e) {
    var message;
    e.preventDefault();
    message = _.isArray(e.detail) ? e.detail.join('<br>') : e.detail;
    return $(e.relatedTarget).showError(message);
  });
  return $('form').on('valid.bs.validator', function(e) {
    e.preventDefault();
    return $(e.relatedTarget).clearMessage();
  });
});


